function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { pvId as e, Monitor as t } from "@payment/link-monitor";
function r() {
  return "3.17.1";
}
function n(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function o(e) {
  return o = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  }, o(e);
}
function a(e) {
  var t = function (e, t) {
    if ("object" !== o(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var n = r.call(e, t || "default");
      if ("object" !== o(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === o(t) ? t : String(t);
}
function i(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, a(n.key), n);
  }
}
function s(e, t, r) {
  return t && i(e.prototype, t), r && i(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function c(e, t, r) {
  return (t = a(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function u(e, t, r, n, o, a, i) {
  try {
    var s = e[a](i),
      c = s.value;
  } catch (e) {
    return void r(e);
  }
  s.done ? t(c) : Promise.resolve(c).then(n, o);
}
function l(e) {
  return function () {
    var t = this,
      r = arguments;
    return new Promise(function (n, o) {
      var a = e.apply(t, r);
      function i(e) {
        u(a, n, o, i, s, "next", e);
      }
      function s(e) {
        u(a, n, o, i, s, "throw", e);
      }
      i(void 0);
    });
  };
}
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
function p(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e["default"] : e;
}
function d(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}
var f = d(function (e) {
  function t(r) {
    return e.exports = t = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, e.exports.__esModule = !0, e.exports["default"] = e.exports, t(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports["default"] = e.exports;
});
p(f);
var h = d(function (e) {
  var t = f["default"];
  function r() {
    e.exports = r = function r() {
      return n;
    }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
    var n = {},
      o = Object.prototype,
      a = o.hasOwnProperty,
      i = Object.defineProperty || function (e, t, r) {
        e[t] = r.value;
      },
      s = "function" == typeof Symbol ? Symbol : {},
      c = s.iterator || "@@iterator",
      u = s.asyncIterator || "@@asyncIterator",
      l = s.toStringTag || "@@toStringTag";
    function p(e, t, r) {
      return Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), e[t];
    }
    try {
      p({}, "");
    } catch (e) {
      p = function p(e, t, r) {
        return e[t] = r;
      };
    }
    function d(e, t, r, n) {
      var o = t && t.prototype instanceof v ? t : v,
        a = Object.create(o.prototype),
        s = new S(n || []);
      return i(a, "_invoke", {
        value: O(e, r, s)
      }), a;
    }
    function f(e, t, r) {
      try {
        return {
          type: "normal",
          arg: e.call(t, r)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }
    n.wrap = d;
    var h = {};
    function v() {}
    function y() {}
    function m() {}
    var g = {};
    p(g, c, function () {
      return this;
    });
    var b = Object.getPrototypeOf,
      k = b && b(b(D([])));
    k && k !== o && a.call(k, c) && (g = k);
    var w = m.prototype = v.prototype = Object.create(g);
    function C(e) {
      ["next", "throw", "return"].forEach(function (t) {
        p(e, t, function (e) {
          return this._invoke(t, e);
        });
      });
    }
    function _(e, r) {
      function n(o, i, s, c) {
        var u = f(e[o], e, i);
        if ("throw" !== u.type) {
          var l = u.arg,
            p = l.value;
          return p && "object" == t(p) && a.call(p, "__await") ? r.resolve(p.__await).then(function (e) {
            n("next", e, s, c);
          }, function (e) {
            n("throw", e, s, c);
          }) : r.resolve(p).then(function (e) {
            l.value = e, s(l);
          }, function (e) {
            return n("throw", e, s, c);
          });
        }
        c(u.arg);
      }
      var o;
      i(this, "_invoke", {
        value: function value(e, t) {
          function a() {
            return new r(function (r, o) {
              n(e, t, r, o);
            });
          }
          return o = o ? o.then(a, a) : a();
        }
      });
    }
    function O(e, t, r) {
      var n = "suspendedStart";
      return function (o, a) {
        if ("executing" === n) throw new Error("Generator is already running");
        if ("completed" === n) {
          if ("throw" === o) throw a;
          return R();
        }
        for (r.method = o, r.arg = a;;) {
          var i = r.delegate;
          if (i) {
            var s = P(i, r);
            if (s) {
              if (s === h) continue;
              return s;
            }
          }
          if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
            if ("suspendedStart" === n) throw n = "completed", r.arg;
            r.dispatchException(r.arg);
          } else "return" === r.method && r.abrupt("return", r.arg);
          n = "executing";
          var c = f(e, t, r);
          if ("normal" === c.type) {
            if (n = r.done ? "completed" : "suspendedYield", c.arg === h) continue;
            return {
              value: c.arg,
              done: r.done
            };
          }
          "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
        }
      };
    }
    function P(e, t) {
      var r = t.method,
        n = e.iterator[r];
      if (void 0 === n) return t.delegate = null, "throw" === r && e.iterator["return"] && (t.method = "return", t.arg = void 0, P(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), h;
      var o = f(n, e.iterator, t.arg);
      if ("throw" === o.type) return t.method = "throw", t.arg = o.arg, t.delegate = null, h;
      var a = o.arg;
      return a ? a.done ? (t[e.resultName] = a.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, h) : a : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
    }
    function x(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }
    function I(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }
    function S(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(x, this), this.reset(!0);
    }
    function D(e) {
      if (e) {
        var t = e[c];
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var r = -1,
            n = function t() {
              for (; ++r < e.length;) {
                if (a.call(e, r)) return t.value = e[r], t.done = !1, t;
              }
              return t.value = void 0, t.done = !0, t;
            };
          return n.next = n;
        }
      }
      return {
        next: R
      };
    }
    function R() {
      return {
        value: void 0,
        done: !0
      };
    }
    return y.prototype = m, i(w, "constructor", {
      value: m,
      configurable: !0
    }), i(m, "constructor", {
      value: y,
      configurable: !0
    }), y.displayName = p(m, l, "GeneratorFunction"), n.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === y || "GeneratorFunction" === (t.displayName || t.name));
    }, n.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, m) : (e.__proto__ = m, p(e, l, "GeneratorFunction")), e.prototype = Object.create(w), e;
    }, n.awrap = function (e) {
      return {
        __await: e
      };
    }, C(_.prototype), p(_.prototype, u, function () {
      return this;
    }), n.AsyncIterator = _, n.async = function (e, t, r, o, a) {
      void 0 === a && (a = Promise);
      var i = new _(d(e, t, r, o), a);
      return n.isGeneratorFunction(t) ? i : i.next().then(function (e) {
        return e.done ? e.value : i.next();
      });
    }, C(w), p(w, l, "Generator"), p(w, c, function () {
      return this;
    }), p(w, "toString", function () {
      return "[object Generator]";
    }), n.keys = function (e) {
      var t = Object(e),
        r = [];
      for (var n in t) {
        r.push(n);
      }
      return r.reverse(), function e() {
        for (; r.length;) {
          var n = r.pop();
          if (n in t) return e.value = n, e.done = !1, e;
        }
        return e.done = !0, e;
      };
    }, n.values = D, S.prototype = {
      constructor: S,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(I), !e) for (var t in this) {
          "t" === t.charAt(0) && a.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
        }
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var t = this;
        function r(r, n) {
          return i.type = "throw", i.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
        }
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var o = this.tryEntries[n],
            i = o.completion;
          if ("root" === o.tryLoc) return r("end");
          if (o.tryLoc <= this.prev) {
            var s = a.call(o, "catchLoc"),
              c = a.call(o, "finallyLoc");
            if (s && c) {
              if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
              if (this.prev < o.finallyLoc) return r(o.finallyLoc);
            } else if (s) {
              if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
            } else {
              if (!c) throw new Error("try statement without catch or finally");
              if (this.prev < o.finallyLoc) return r(o.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var n = this.tryEntries[r];
          if (n.tryLoc <= this.prev && a.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
            var o = n;
            break;
          }
        }
        o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
        var i = o ? o.completion : {};
        return i.type = e, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, h) : this.complete(i);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];
          if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), I(r), h;
        }
      },
      "catch": function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];
          if (r.tryLoc === e) {
            var n = r.completion;
            if ("throw" === n.type) {
              var o = n.arg;
              I(r);
            }
            return o;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, t, r) {
        return this.delegate = {
          iterator: D(e),
          resultName: t,
          nextLoc: r
        }, "next" === this.method && (this.arg = void 0), h;
      }
    }, n;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports["default"] = e.exports;
});
p(h);
var v,
  y,
  m,
  g = h(),
  b = g;
try {
  regeneratorRuntime = g;
} catch (e) {
  "object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) ? globalThis.regeneratorRuntime = g : Function("r", "regeneratorRuntime = r")(g);
}
function k(e, t) {
  if (null == e) return {};
  var r,
    n,
    o = function (e, t) {
      if (null == e) return {};
      var r,
        n,
        o = {},
        a = Object.keys(e);
      for (n = 0; n < a.length; n++) {
        r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
      }
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) {
      r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
  }
  return o;
}
function w(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function C(e, t) {
  return C = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, C(e, t);
}
function _(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && C(e, t);
}
function O(e, t) {
  if (t && ("object" === o(t) || "function" == typeof t)) return t;
  if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
  return w(e);
}
function P(e) {
  return P = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, P(e);
}
function x(e, t, r) {
  return x = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }() ? Reflect.construct.bind() : function (e, t, r) {
    var n = [null];
    n.push.apply(n, t);
    var o = new (Function.bind.apply(e, n))();
    return r && C(o, r.prototype), o;
  }, x.apply(null, arguments);
}
function I(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return I = function I(e) {
    if (null === e || (r = e, -1 === Function.toString.call(r).indexOf("[native code]"))) return e;
    var r;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, n);
    }
    function n() {
      return x(e, arguments, P(this).constructor);
    }
    return n.prototype = Object.create(e.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), C(n, e);
  }, I(e);
}
function S(e, t) {
  var r = {};
  return t.forEach(function (t) {
    e.hasOwnProperty(t) && (r[t] = e[t]);
  }), r;
}
function D(e) {
  return "[object Object]" === Object.prototype.toString.call(e);
}
function R(e) {
  return !e || !!e.nodeType || "object" !== o(e) ? e : JSON.parse(JSON.stringify(e));
}
function E(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
!function (e) {
  e.InitDataError = "1000", e.NotSupportBrowser = "1026", e.InnerSDKError = "1027", e.RenderFail = "1028", e.NotInit = "1029", e.DeviceNotSupportPaymentMethod = "1100", e.LoadChannelJsFail = "1101", e.InitResultError = "1102", e.InitTimeout = "1108", e.HTTPSRequired = "1105", e.NotInUserGesture = "1106", e.UnknownChannelClientError = "1107", e.FrequentRequest = "1904", e.NetworkError = "1109", e.InvalidChannelClient = "4110", e.InvalidNextAction = "4111", e.CreatePayClientFail = "4108", e.AbnormalTrade = "4205", e.NotSupportApi = "4206", e.CancelPayClient = "4550", e.AutoCancelAfterTimeout = "4401";
}(v || (v = {})), function (e) {
  e.InitDataError = "INIT_DATA_ERROR", e.AbnormalTrade = "TRANSACTION_ABNORMAL", e.NetworkError = "Network error", e.NotSupportBrowser = "BROWSER_VERSION_OLD", e.DeviceNotSupportPaymentMethod = "DEVICE_NOT_SUPPORT", e.CreatePayClientFail = "Failed to pull up the form", e.CancelPayClient = "The payer canceled the payment.", e.AutoCancelAfterTimeout = "The payment period has expired.", e.NotSupportApi = "The API does not support the payment method", e.LoadChannelJsFail = "LOADDING_PAYMENTMETHOD_JS_ERROR", e.InitResultError = "API_REQUEST_PARAMETER_ERROR", e.InitTimeout = "OVER_TIME", e.HTTPSRequired = "HTTPS_NEEDED", e.NotInUserGesture = "PAYMENTMETHOD_INSTANCE_USER_ACTION_NEEDED", e.UnknownChannelClientError = "PAYMENTMETHOD_INSTANCE_OTHER_ERROR", e.FrequentRequest = "FREQUENTLY_REQUEST", e.InvalidChannelClient = "The payment(s) failed due to system issues.", e.InvalidNextAction = "The payment(s) failed due to system issues.", e.PCINotLoaded = "PCIInstance is not loaded!", e.ElementNotExist = "Render element does not exist", e.InvalidOrderPayUrl = "Invalid order pay url", e.InvalidUploadUrl = "Invalid upload token url", e.InvalidPaymentInstrumentParams = "check_paymentInstrument_error", e.AbnormalInstrumentParams = "Please check the initData.paymentInstrument parameter, the parameter is abnormal", e.InnerSDKError = "sdk inner error";
}(y || (y = {})), function (e) {
  e.Fatal = "fatal", e.Error = "error";
}(m || (m = {}));
var T = function (t) {
    _(o, I(Error));
    var r = E(o);
    function o(t) {
      var a,
        i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : v.InnerSDKError,
        s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "UnknownError",
        u = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : m.Error;
      return n(this, o), c(w(a = r.call(this, t)), "code", void 0), c(w(a), "data", void 0), c(w(a), "errorLevel", void 0), c(w(a), "pvId", void 0), a.name = s, a.code = i, a.errorLevel = u, a.pvId = e, a;
    }
    return s(o, [{
      key: "setAPIErrorData",
      value: function value(e) {
        this.data = o.handleAPIErrorData(e);
      }
    }], [{
      key: "handleAPIErrorData",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            code: v.NetworkError,
            msg: y.NetworkError
          },
          r = {};
        return !D(e) || void 0 === e.code && void 0 === e.msg ? (r.code = t.code, r.msg = t.msg) : (r.code = e.code, r.msg = e.msg), void 0 === (null == e ? void 0 : e.channelCode) && void 0 === (null == e ? void 0 : e.channelMsg) || (r.channelCode = e.channelCode, r.channelMsg = e.channelMsg), r;
      }
    }]), o;
  }(),
  A = function (e) {
    _(r, T);
    var t = E(r);
    function r(e) {
      var o,
        a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : v.InnerSDKError,
        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "SilenceError",
        s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : m.Error;
      return n(this, r), c(w(o = t.call(this, e, a, i, s)), "statusCode", void 0), o;
    }
    return s(r);
  }();
function L(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) {
    n[r] = e[r];
  }
  return n;
}
function j(e) {
  return function (e) {
    if (Array.isArray(e)) return L(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return L(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? L(e, t) : void 0;
    }
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function N(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function B(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function M(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function F(e, t, r) {
  return t && M(e.prototype, t), r && M(e, r), e;
}
function H(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function V(e) {
  return (V = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function W(e, t, r) {
  return (W = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, r) {
    var n = function (e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = V(e));) {
        ;
      }
      return e;
    }(e, t);
    if (n) {
      var o = Object.getOwnPropertyDescriptor(n, t);
      return o.get ? o.get.call(r) : o.value;
    }
  })(e, t, r || e);
}
function U(e, t) {
  return (U = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function G(e) {
  return (G = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}
var K = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
  q = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i,
  z = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
  Z = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $(e) {
  return (e && e.message || "No error message").split("\n").filter(function (e) {
    return !!e;
  })[0];
}
function J(e) {
  try {
    var t = function (e) {
      if (!e.stack) return null;
      for (var t, r, n = [], o = e.stack.split("\n"), a = 0; a < o.length; ++a) {
        if (t = K.exec(o[a])) r = {
          filename: t[2] && 0 === t[2].indexOf("address at ") ? t[2].substr(11) : t[2],
          "function": t[1] || "?",
          lineno: t[3] ? +t[3] : null,
          colno: t[4] ? +t[4] : null
        };else if (t = z.exec(o[a])) r = {
          filename: t[2],
          "function": t[1] || "?",
          lineno: +t[3],
          colno: t[4] ? +t[4] : null
        };else {
          if (!(t = q.exec(o[a]))) continue;
          0 !== a || t[5] || void 0 === e.columnNumber || (n[0].column = e.columnNumber + 1), r = {
            filename: t[3],
            "function": t[1] || "?",
            lineno: t[4] ? +t[4] : null,
            colno: t[5] ? +t[5] : null
          };
        }
        !r["function"] && r.lineno && (r["function"] = "?"), n.push(r);
      }
      return n.length ? {
        value: $(e),
        type: e.name,
        stacktrace: {
          frames: n.reverse()
        }
      } : null;
    }(e);
    if (t) return t;
  } catch (e) {}
  return {
    value: $(e),
    type: e && e.name,
    stacktrace: {
      frames: []
    }
  };
}
var X = Object.assign || function (e) {
    for (var t = arguments.length, r = 1; r < t; r++) {
      var n = arguments[r];
      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }
    return e;
  },
  Y = function () {
    function e(t) {
      if (B(this, e), t.dsn) {
        var r = Z.exec(t.dsn),
          n = r ? r.slice(1) : [],
          o = n[5].split("/"),
          a = o.slice(0, -1).join("/");
        this.apiUrl = n[0] + "://" + n[3] + (n[4] ? ":" + n[4] : "") + (a ? "/" + a : "") + "/api/" + o.pop() + "/store/", this.authHeader = "Sentry sentry_version=7,sentry_key=" + n[1] + (n[2] ? ",sentry_secret=" + n[2] : "");
      }
      this.environment = t.environment;
    }
    return F(e, [{
      key: "prepare",
      value: function value(e) {
        return X(this.getRequestBlank(), {
          exception: {
            values: [J(e)]
          }
        });
      }
    }, {
      key: "report",
      value: function value(e) {
        this.send(this.prepare(e));
      }
    }, {
      key: "send",
      value: function value(e) {
        if (this.apiUrl) {
          var t = new XMLHttpRequest();
          t.open("POST", this.apiUrl, !0), t.setRequestHeader("Content-type", "application/json"), t.setRequestHeader("X-Sentry-Auth", this.authHeader || ""), t.send(JSON.stringify(e));
        }
      }
    }, {
      key: "getRequestBlank",
      value: function value() {
        return {
          platform: "javascript",
          sdk: {
            name: "micro-sentry.javascript.browser",
            version: "0.0.0"
          },
          timestamp: Date.now() / 1e3,
          request: {
            url: window.location.toString(),
            headers: {
              "User-Agent": window.navigator.userAgent
            }
          },
          environment: this.environment
        };
      }
    }]), e;
  }();
function Q(e, t) {
  return "[object RegExp]" === Object.prototype.toString.call(t) ? t.test(e) : "string" == typeof t && -1 !== e.indexOf(t);
}
function ee(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = V(e);
    if (t) {
      var o = V(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      return !t || "object" !== G(t) && "function" != typeof t ? H(e) : t;
    }(this, r);
  };
}
var te = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && U(e, t);
  }(r, Y);
  var t = ee(r);
  function r(e) {
    var n;
    B(this, r), (n = t.call(this, e)).options = e, n.destroyed = !1, n._state = {};
    var o = n.options || {},
      a = o.plugins,
      i = void 0 === a ? [] : a,
      s = o.beforeSend,
      c = void 0 === s ? function (e) {
        return e;
      } : s,
      u = o.beforeBreadcrumb,
      l = void 0 === u ? function (e) {
        return e;
      } : u,
      p = o.blacklistUrls,
      d = void 0 === p ? [] : p,
      f = o.ignoreErrors,
      h = void 0 === f ? [] : f,
      v = o.release,
      y = void 0 === v ? void 0 : v;
    return n.plugins = i.map(function (e) {
      return new e(H(n));
    }), n.beforeSend = c, n.beforeBreadcrumb = l, n.blacklistUrls = d, n.ignoreErrors = h, n.release = y, n;
  }
  return F(r, [{
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "clearState",
    value: function value() {
      this._state = {};
    }
  }, {
    key: "setTags",
    value: function value(e) {
      return this.setKeyState("tags", Object.assign({}, e)), this;
    }
  }, {
    key: "setTag",
    value: function value(e, t) {
      return this.extendState({
        tags: N({}, e, t)
      }), this;
    }
  }, {
    key: "setExtra",
    value: function value(e, t) {
      return this.extendState({
        extra: N({}, e, t)
      }), this;
    }
  }, {
    key: "setExtras",
    value: function value(e) {
      return this.setKeyState("extra", Object.assign({}, e)), this;
    }
  }, {
    key: "setUser",
    value: function value(e) {
      return this.setKeyState("user", Object.assign({}, e)), this;
    }
  }, {
    key: "clone",
    value: function value() {
      var e = new r(Object.assign(Object.assign({}, this.options), {
        plugins: []
      }));
      return e.extendState(this.state), e;
    }
  }, {
    key: "withScope",
    value: function value(e) {
      var t = this.clone();
      e(t), t.destroy(), this.setBreadcrumbs(void 0);
    }
  }, {
    key: "addBreadcrumb",
    value: function value(e) {
      this.extendState({
        breadcrumbs: [Object.assign({
          timestamp: Date.now() / 1e3
        }, this.beforeBreadcrumb(e))]
      });
    }
  }, {
    key: "setBreadcrumbs",
    value: function value(e) {
      this.setKeyState("breadcrumbs", e);
    }
  }, {
    key: "captureMessage",
    value: function value(e, t) {
      this.send(Object.assign(Object.assign({}, this.getRequestBlank()), {
        message: e,
        level: t
      }));
    }
  }, {
    key: "destroy",
    value: function value() {
      this.destroyed = !0, this.plugins.forEach(function (e) {
        e.destroy && e.destroy();
      });
    }
  }, {
    key: "isIgnoredError",
    value: function value(e) {
      var t = this;
      return !!this.ignoreErrors.length && this.getPossibleEventMessages(e).some(function (e) {
        return t.ignoreErrors.some(function (t) {
          return Q(e, t);
        });
      });
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return Object.assign(Object.assign({}, W(V(r.prototype), "getRequestBlank", this).call(this)), this.state);
    }
  }, {
    key: "send",
    value: function value(e) {
      this.destroyed || this.isDeniedUrl(e) || this.isIgnoredError(e) || (W(V(r.prototype), "send", this).call(this, this.beforeSend(Object.assign({
        release: this.release
      }, e))), this.setBreadcrumbs(void 0));
    }
  }, {
    key: "getPossibleEventMessages",
    value: function value(e) {
      if (e.message) return [e.message];
      if (e.exception) try {
        var t = e.exception.values && e.exception.values[0] || {},
          r = t.type,
          n = void 0 === r ? "" : r,
          o = t.value,
          a = void 0 === o ? "" : o;
        return ["".concat(a), "".concat(n, ": ").concat(a)];
      } catch (e) {
        return [];
      }
      return [];
    }
  }, {
    key: "isDeniedUrl",
    value: function value(e) {
      if (!this.blacklistUrls.length) return !1;
      var t = this.getEventFilterUrl(e);
      return !!t && this.blacklistUrls.some(function (e) {
        return Q(t, e);
      });
    }
  }, {
    key: "getEventFilterUrl",
    value: function value(e) {
      try {
        if (e.exception) {
          var t = e.exception.values && e.exception.values[0].stacktrace && e.exception.values[0].stacktrace.frames;
          return t && t[t.length - 1].filename || null;
        }
        return null;
      } catch (e) {
        return null;
      }
    }
  }, {
    key: "extendState",
    value: function value(e) {
      var t = this;
      this._state = Object.keys(e).reduce(function (r, n) {
        var o = t.state[n],
          a = Array.isArray(o) ? o : null,
          i = e[n],
          s = Array.isArray(i) ? i : null;
        return Object.assign(Object.assign({}, r), N({}, n, a || s ? [].concat(j(a || []), j(s || [])) : Object.assign(Object.assign({}, "string" != typeof o ? o : {}), "string" != typeof i ? i : {})));
      }, {});
    }
  }, {
    key: "setKeyState",
    value: function value(e, t) {
      this._state[e] = t;
    }
  }]), r;
}();
function re(e, t, r) {
  var n = e[t],
    o = r(n);
  if ("function" == typeof o) try {
    o.prototype = o.prototype || {}, Object.defineProperties(o, {
      __original__: {
        enumerable: !1,
        value: n
      }
    });
  } catch (e) {}
  e[t] = o;
}
function ne(e) {
  if (!e) return {};
  var t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t) return {};
  var r = t[6] || "",
    n = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    relative: t[5] + r + n
  };
}
function oe() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "Request" in window && e[0] instanceof Request && e[0].method ? String(e[0].method).toUpperCase() : e[1] && e[1].method ? String(e[1].method).toUpperCase() : "GET";
}
function ae() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "string" == typeof e[0] ? e[0] : "Request" in window && e[0] instanceof Request ? e[0].url : String(e[0]);
}
function ie(e) {
  return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}
function se(e) {
  var t = e,
    r = [];
  if (!t || !t.tagName) return "";
  r.push(t.tagName.toLowerCase()), t.id && r.push("#".concat(t.id));
  var n = t.className;
  if (n && "string" == typeof n) {
    var o = n.split(/\s+/);
    r.concat(o.map(function (e) {
      return ".".concat(e);
    }));
  }
  return ["type", "name", "title", "alt", "automation-id"].forEach(function (e) {
    var n = t.getAttribute(e);
    n && r.push("[".concat(e, '="').concat(n, '"]'));
  }), r.join("");
}
function ce(e) {
  try {
    for (var t, r = e, n = [], o = 0, a = 0; r && o++ < 5 && !("html" === (t = se(r)) || o > 1 && a + 3 * n.length + t.length >= 80);) {
      n.push(t), a += t.length, r = r.parentNode;
    }
    return n.reverse().join(" > ");
  } catch (e) {
    return "<unknown>";
  }
}
function ue(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
  return Array.isArray(e) ? e.map(function (e) {
    try {
      return String(e);
    } catch (e) {
      return "";
    }
  }).filter(function (e) {
    return "" !== e;
  }).join(t) : "";
}
function le(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? le(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : le(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
!function () {
  function e(t) {
    B(this, e), this.client = t, this.subscriptions = [], this.initDOM(), this.initConsole(), this.initFetch(), this.initHistory(), this.initXHR();
  }
  F(e, [{
    key: "initXHR",
    value: function value() {
      if ("XMLHttpRequest" in window) {
        var e = this,
          t = XMLHttpRequest.prototype;
        re(t, "open", function (t) {
          return function () {
            for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) {
              n[o] = arguments[o];
            }
            var a = this,
              i = n[1];
            a.__sentry_xhr__ = {
              method: "string" == typeof n[0] ? n[0].toUpperCase() : n[0],
              url: n[1]
            }, "string" == typeof i && "POST" === a.__sentry_xhr__.method && i.match(/sentry_key/) && (a.__sentry_own_request__ = !0);
            var s = function s() {
              if (4 === a.readyState) {
                try {
                  a.__sentry_xhr__ && (a.__sentry_xhr__.status_code = a.status);
                } catch (e) {}
                e.xhrBreadcrumb({
                  args: n,
                  endTimestamp: Date.now(),
                  startTimestamp: Date.now(),
                  xhr: a
                });
              }
            };
            return "onreadystatechange" in a && "function" == typeof a.onreadystatechange ? re(a, "onreadystatechange", function (e) {
              return function () {
                s();
                for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
                  r[n] = arguments[n];
                }
                e.apply(a, r);
              };
            }) : a.addEventListener("readystatechange", s), t.apply(a, n);
          };
        }), re(t, "send", function (t) {
          return function () {
            for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) {
              n[o] = arguments[o];
            }
            return e.xhrBreadcrumb({
              args: n,
              startTimestamp: Date.now(),
              xhr: this
            }), t.apply(this, n);
          };
        });
      }
    }
  }, {
    key: "initHistory",
    value: function value() {
      var e = this,
        t = window.onpopstate;
      function r(t) {
        return function () {
          for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) {
            n[o] = arguments[o];
          }
          var a = n.length > 2 ? n[2] : void 0;
          if (a) {
            var i = e.lastHref,
              s = String(a);
            e.lastHref = s, e.historyBreadcrumb({
              from: i,
              to: s
            });
          }
          return t.apply(this, n);
        };
      }
      window.onpopstate = function () {
        var r = window.location.href,
          n = e.lastHref;
        if (e.lastHref = r, e.historyBreadcrumb({
          from: n,
          to: r
        }), t) {
          for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) {
            a[i] = arguments[i];
          }
          return t.apply(this, a);
        }
      }, re(window.history, "pushState", r), re(window.history, "replaceState", r);
    }
  }, {
    key: "destroy",
    value: function value() {
      this.subscriptions.forEach(function (e) {
        return e();
      });
    }
  }, {
    key: "initDOM",
    value: function value() {
      var e = this,
        t = function t(_t2) {
          return e.prepareDomEvent("click", _t2);
        },
        r = function r(t) {
          return e.prepareDomEvent("keypress", t);
        };
      window.document.addEventListener("click", t, !1), window.document.addEventListener("keypress", r, !1), this.subscriptions.push(function () {
        window.document.removeEventListener("click", t, !1), window.document.removeEventListener("keypress", r, !1);
      });
    }
  }, {
    key: "prepareDomEvent",
    value: function value(e, t) {
      var r;
      try {
        r = t.target ? ce(t.target) : ce(t);
      } catch (e) {
        r = "<unknown>";
      }
      0 !== r.length && this.client.addBreadcrumb({
        category: "ui.".concat(e),
        message: r
      });
    }
  }, {
    key: "initFetch",
    value: function value() {
      var e = this;
      (function () {
        if (!function () {
          if (!("fetch" in window)) return !1;
          try {
            return new Headers(), new Request(""), new Response(), !0;
          } catch (e) {
            return !1;
          }
        }()) return !1;
        if (ie(window.fetch)) return !0;
        var e = !1,
          t = window.document;
        if (t && "function" == typeof t.createElement) try {
          var r = t.createElement("iframe");
          r.sandbox.add("allow-scripts"), r.sandbox.add("allow-same-origin"), r.hidden = !0, t.head.appendChild(r), r.contentWindow && r.contentWindow.fetch && (e = ie(r.contentWindow.fetch)), t.head.removeChild(r);
        } catch (e) {}
        return e;
      })() && re(window, "fetch", function (t) {
        return function () {
          for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) {
            n[o] = arguments[o];
          }
          var a = {
            args: n,
            fetchData: {
              method: oe(n),
              url: ae(n)
            },
            startTimestamp: Date.now()
          };
          return e.fetchBreadcrumb(Object.assign({}, a)), t.apply(window, n).then(function (t) {
            return e.fetchBreadcrumb(Object.assign(Object.assign({}, a), {
              endTimestamp: Date.now(),
              response: t
            })), t;
          }, function (t) {
            throw e.fetchBreadcrumb(Object.assign(Object.assign({}, a), {
              endTimestamp: Date.now(),
              error: t
            })), t;
          });
        };
      });
    }
  }, {
    key: "fetchBreadcrumb",
    value: function value(e) {
      e.endTimestamp && (e.fetchData.url.match(/sentry_key/) && "POST" === e.fetchData.method || (e.error ? this.client.addBreadcrumb({
        category: "fetch",
        data: e.fetchData,
        level: "error",
        type: "http"
      }) : this.client.addBreadcrumb({
        category: "fetch",
        data: Object.assign(Object.assign({}, e.fetchData), {
          status_code: e.response.status
        }),
        type: "http"
      })));
    }
  }, {
    key: "xhrBreadcrumb",
    value: function value(e) {
      if (e.endTimestamp) {
        if (e.xhr.__sentry_own_request__) return;
        this.client.addBreadcrumb({
          category: "xhr",
          data: e.xhr.__sentry_xhr__,
          type: "http"
        });
      }
    }
  }, {
    key: "initConsole",
    value: function value() {
      var e = this;
      ["debug", "info", "warn", "error", "log", "assert"].forEach(function (t) {
        t in window.console && re(window.console, t, function (r) {
          return function () {
            for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++) {
              o[a] = arguments[a];
            }
            var i = {
              category: "console",
              data: {
                arguments: o.map(function (e) {
                  try {
                    return JSON.stringify(e), e;
                  } catch (t) {
                    return Object.prototype.toString.call(e);
                  }
                }),
                logger: "console"
              },
              level: t,
              message: ue(o, " ")
            };
            if ("assert" === t) {
              if (!1 !== o[0]) return;
              i.message = "Assertion failed: ".concat(ue(o.slice(1), " ") || "console.assert"), i.data.arguments = o.slice(1);
            }
            e.client.addBreadcrumb(i), r && Function.prototype.apply.call(r, window.console, o);
          };
        });
      });
    }
  }, {
    key: "historyBreadcrumb",
    value: function value(e) {
      var t = e.from,
        r = e.to,
        n = ne(window.location.href),
        o = ne(t),
        a = ne(r);
      o.path || (o = n), n.protocol === a.protocol && n.host === a.host && (r = a.relative), n.protocol === o.protocol && n.host === o.host && (t = o.relative), this.client.addBreadcrumb({
        category: "navigation",
        data: {
          from: t,
          to: r
        }
      });
    }
  }]);
}();
var de = new te({
  dsn: "https://08c0eb817b5a4ac5b5b0de28a29a1932@sentry-new.myshopline.com/304",
  release: "3.17.1",
  environment: "production",
  beforeSend: function beforeSend(e) {
    return e;
  }
});
function fe(e) {
  try {
    de.report(e);
  } catch (t) {
    console.error("reportToSentry error", e.message, JSON.stringify(t));
  }
}
function he(e, t) {
  var r = JSON.stringify(pe(pe({}, e || {}), {}, {
      originErrorMessage: null == t ? void 0 : t.message,
      originErrorData: t ? JSON.stringify(t) : void 0,
      errorLevel: (null == t ? void 0 : t.errorLevel) || (null == e ? void 0 : e.errorLevel) || m.Error
    })),
    n = new Error(r);
  if (null != t && t.stack) try {
    n.stack = t.stack;
  } catch (e) {
    fe(e), fe(t);
  }
  fe(n);
}
function ve(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ye(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ve(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ve(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
de.setTag("pvId", e);
var me = "webpaymentsdk",
  ge = new t(me),
  be = {
    url: "https://slp-events.myshopline.com/eclytics/i",
    mode: "ajax",
    method: "post"
  },
  ke = function () {
    function e() {
      n(this, e);
    }
    return s(e, null, [{
      key: "getEventTrackingConfig",
      value: function value(e) {
        if (e) {
          if (!1 === e.enable) return {};
          if (e.url) return Object.freeze(e);
        }
        return Object.freeze(ye({}, be));
      }
    }, {
      key: "init",
      value: function value(t) {
        var r = e.getEventTrackingConfig(t.eventTrackingConfig);
        ge.init({
          consumer: t.clientId,
          version: "3.17.1",
          projectName: me,
          merchantId: t.merchantId,
          channelId: t.channelId,
          paymentMethod: t.paymentMethod,
          countryCode: t.countryCode,
          currency: t.currency,
          environment: "production"
        }, r), de.setTag("paymentMethod", t.paymentMethod), de.setTag("merchantId", t.merchantId), de.setTag("clientId", t.clientId);
      }
    }, {
      key: "reportError",
      value: function value(t) {
        var r,
          n,
          o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "report_error",
          a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          i = arguments.length > 3 ? arguments[3] : void 0;
        t instanceof A || (null != t && null !== (r = t.data) && void 0 !== r && r.msg && null != t && null !== (n = t.data) && void 0 !== n && n.msg.match(/[\u4e00-\u9fa5]+/) && he(Object.assign({}, e.formatReportData(a), i, {
          eventName: "chinese_error_msg"
        }), t), he(Object.assign({}, e.formatReportData(a), {
          eventName: o
        }, i), t));
      }
    }, {
      key: "handleError",
      value: function value(t) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default_error",
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          o = arguments.length > 3 ? arguments[3] : void 0;
        if (e.reportData(r, ye(ye({}, n), {}, {
          errorMessage: t.message,
          originErrorData: JSON.stringify(t)
        }), o), e.reportError(t, r, n, o), t instanceof A) throw t;
        var a,
          i,
          s,
          c,
          u,
          l,
          p = "".concat(r, " ").concat(t.message || (null == n ? void 0 : n.msg) || (null === (a = t.data) || void 0 === a ? void 0 : a.msg) || y.InnerSDKError),
          d = new A(p);
        throw d.statusCode = t.statusCode, d.name = t.name || "Error", d.code = t.code || (null === (i = t.data) || void 0 === i ? void 0 : i.code) || d.code, d.errorLevel = t.errorLevel || m.Error, d.data = {
          code: (null == n ? void 0 : n.code) || (null === (s = t.data) || void 0 === s ? void 0 : s.code) || d.code || v.InnerSDKError,
          msg: (null == n ? void 0 : n.msg) || (null === (c = t.data) || void 0 === c ? void 0 : c.msg) || p,
          channelCode: (null == n ? void 0 : n.channelCode) || (null === (u = t.data) || void 0 === u ? void 0 : u.channelCode),
          channelMsg: (null == n ? void 0 : n.channelMsg) || (null === (l = t.data) || void 0 === l ? void 0 : l.channelMsg)
        }, d;
      }
    }, {
      key: "formatReportData",
      value: function value(e) {
        if (!e) return {};
        var t = ye({}, e),
          r = "**********";
        return t.plugins && delete t.plugins, t.customerToken && (t.customerToken = "******************************" + t.customerToken.slice(30)), t.cardToken && (t.cardToken = r + t.cardToken.slice(10)), t.payToken && (t.payToken = r + t.payToken.slice(10)), t.ticket && (t.ticket = r + t.ticket.slice(10)), t;
      }
    }, {
      key: "reportData",
      value: function value(t, r, n) {
        var o = ye({}, n);
        r && (o.extraData = JSON.stringify(e.formatReportData(r)));
        try {
          0, ge.report(t, o);
        } catch (r) {
          e.reportError(r, "".concat(t, "_report_data_error"), o);
        }
      }
    }, {
      key: "reportErrorData",
      value: function value(t) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : m.Error,
          o = arguments.length > 3 ? arguments[3] : void 0;
        e.reportData(t, r, o), he(Object.assign(ye(ye({}, o), {}, {
          eventName: t,
          errorLevel: n
        }), e.formatReportData(r)));
      }
    }]), e;
  }(),
  we = s(function e(t) {
    var r = this;
    n(this, e), c(this, "originData", void 0), c(this, "addReportData", function (e) {
      var t = ke.formatReportData(e);
      ge.init(t), Object.assign(r.originData, t);
    }), c(this, "reportData", function (e, t) {
      return ke.reportData(e, t, r.originData);
    }), c(this, "reportErrorData", function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : m.Error;
      de.setTag("paymentMethod", r.originData.paymentMethod), ke.reportErrorData(e, t, n, r.originData);
    }), c(this, "reportError", function (e, t, n) {
      de.setTag("paymentMethod", r.originData.paymentMethod), ke.reportError(e, t, n, r.originData);
    }), c(this, "handleError", function (e, t, n) {
      return de.setTag("paymentMethod", r.originData.paymentMethod), ke.handleError(e, t, n, r.originData);
    }), this.originData = {
      consumer: t.clientId,
      merchantId: t.merchantId,
      channelId: t.channelId,
      paymentMethod: t.paymentMethod,
      countryCode: t.countryCode,
      currency: t.currency
    };
  }),
  Ce = ["body"];
function _e(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Oe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? _e(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _e(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var Pe,
  xe = ["/payment-sdk/assets/i18n/"],
  Ie = function () {
    function t() {
      var e = this;
      n(this, t), c(this, "options", {}), c(this, "pvIdBlackList", xe), c(this, "serialize", function (e) {
        var t = Object.prototype.toString.call(e);
        return e && "[object Object]" === t ? Object.keys(e).map(function (t) {
          return "".concat(encodeURIComponent(t), "=").concat(encodeURIComponent(e[t]));
        }).join("&") : "";
      }), c(this, "isInPvIdBlackList", function (t) {
        if (!t) return !0;
        for (var r = 0; r < e.pvIdBlackList.length; r++) {
          var n = e.pvIdBlackList[r];
          if (t.indexOf(n) > -1) return !0;
        }
        return !1;
      });
    }
    return s(t, [{
      key: "create",
      value: function value(e) {
        this.options = e;
      }
    }, {
      key: "get",
      value: function value(t) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        t = this.buildUrl(t, r.params);
        var n = {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8"
        };
        return this.isInPvIdBlackList(t) || (n["x-pvid"] = e, n["x-sdk-version"] = "payment-sdk_v3.17.1"), this.http(t, Oe(Oe(Oe({
          method: "GET"
        }, this.options), r), {}, {
          headers: Oe(Oe({}, n), r.headers)
        }));
      }
    }, {
      key: "post",
      value: function value(t, r) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          o = {
            Accept: "application/json"
          },
          a = r || n.data;
        return "form" === n.requestType ? (o["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8", a = this.serialize(a)) : (o["Content-Type"] = "application/json;charset=UTF-8", a = a ? JSON.stringify(a) : null), this.isInPvIdBlackList(t) || (o["x-pvid"] = e, o["x-sdk-version"] = "payment-sdk_v3.17.1"), this.http(t, Oe(Oe(Oe({
          method: "POST",
          body: a
        }, this.options), n), {}, {
          headers: Oe(Oe({}, o), n.headers)
        }));
      }
    }, {
      key: "http",
      value: function value(e, t) {
        var r = this;
        return new Promise(function (n, o) {
          var a = new XMLHttpRequest(),
            i = !1,
            s = t.body,
            c = k(t, Ce),
            u = r.options.baseUrl && !/^(https?\:)?(\/\/)/.test(e) ? "".concat(r.options.baseUrl).concat(e) : e;
          if (a.open(t.method, u), Object.keys(t.headers).forEach(function (e) {
            a.setRequestHeader(e, t.headers[e]);
          }), a.onreadystatechange = function () {
            if (4 === a.readyState) {
              var e = r.getXTraceId({
                  xhr: a
                }),
                t = {
                  options: c,
                  statusCode: a.status,
                  url: u,
                  xTraceId: e
                };
              if (0 === a.status) return void o(Oe({
                data: {
                  code: v.NetworkError,
                  msg: y.NetworkError
                }
              }, t));
              var i = "";
              try {
                i = JSON.parse(a.responseText);
              } catch (e) {
                i = a.responseText;
              }
              if (/^(2|3)\d{2}$/.test(a.status.toString())) {
                try {
                  n(Oe({
                    data: i
                  }, t));
                } catch (e) {
                  n(Oe({
                    data: i
                  }, t));
                }
                return;
              }
              o(Oe({
                data: i
              }, t));
            }
          }, a.send(s), a.onabort = function (t) {
            i = !0, ke.reportErrorData("xhr_onabort", {
              url: e,
              readyState: t.target.readyState,
              status: t.target.status,
              statusText: t.target.statusText,
              timeout: t.target.timeout,
              withCredentials: t.target.withCredentials
            });
          }, a.onerror = function (t) {
            ke.reportErrorData("xhr_onerror", {
              url: e,
              readyState: t.target.readyState,
              status: t.target.status,
              statusText: t.target.statusText,
              timeout: t.target.timeout,
              withCredentials: t.target.withCredentials
            });
          }, a.ontimeout = function (t) {
            ke.reportErrorData("xhr_ontimeout", {
              url: e,
              readyState: t.target.readyState,
              status: t.target.status,
              statusText: t.target.statusText,
              timeout: t.target.timeout,
              withCredentials: t.target.withCredentials
            });
          }, t.timeout) {
            if (i) return;
            setTimeout(function () {
              a.abort();
              var t = new Error("XMLHttpRequest timeout");
              t.code = "ETIMEDOUT", ke.reportErrorData("xhr_timeout", {
                url: e
              }), o(t);
            }, t.timeout);
          }
        });
      }
    }, {
      key: "getXTraceId",
      value: function value(e) {
        var t = e.xhr;
        try {
          return t.getResponseHeader("x-traceid") || "";
        } catch (e) {
          return "";
        }
      }
    }, {
      key: "buildUrl",
      value: function value(e, t) {
        var r = Object.prototype.toString.call(t);
        if (!t || "[object Object]" !== r) return e;
        var n = Object.keys(t);
        return (e = decodeURIComponent(e).indexOf("?") > -1 ? "".concat(e, "&") : "".concat(e, "?")) + n.map(function (e) {
          return "".concat(e, "=").concat(t[e]);
        }).join("&");
      }
    }]), t;
  }(),
  Se = new Ie(),
  De = {
    Android: ["(?:(?:Orca-)?Android|Adr)[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)", "Android|Silk-Accelerated=[a-z]{4,5}", "(?:TwitterAndroid).*[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)", "FB4A.*FBSV/(\\d+[\\.\\d]*);", "BeyondPod|AntennaPod|Podkicker|DoggCatcher|Player FM|okhttp|Podcatcher Deluxe"],
    Linux: ["Arch ?Linux(?:[ /\\-](\\d+[\\.\\d]+))?", "VectorLinux(?: package)?(?:[ /\\-](\\d+[\\.\\d]+))?", "Linux(?:OS)?[^a-z]"],
    iOS: ["CFNetwork/889", "CFNetwork/887", "CFNetwork/811", "CFNetwork/808\\.3", "CFNetwork/808\\.2", "CFNetwork/808\\.1", "CFNetwork/808\\.0", "CFNetwork/808", "CFNetwork/758\\.4\\.3", "CFNetwork/758\\.3\\.15", "CFNetwork/758\\.2\\.[78]", "CFNetwork/758\\.1\\.6", "CFNetwork/758\\.0\\.2", "CFNetwork/711\\.5\\.6", "CFNetwork/711\\.4\\.6", "CFNetwork/711\\.3\\.18", "CFNetwork/711\\.2\\.23", "CFNetwork/711\\.1\\.1[26]", "CFNetwork/711\\.0\\.6", "CFNetwork/672\\.1", "CFNetwork/672\\.0", "CFNetwork/609\\.1", "CFNetwork/60[29]", "CFNetwork/548\\.1", "CFNetwork/548\\.0", "CFNetwork/485\\.13", "CFNetwork/485\\.12", "CFNetwork/485\\.10", "CFNetwork/485\\.2", "CFNetwork/467\\.12", "CFNetwork/459", "(?:CPU OS|iPh(?:one)?[ _]OS|iOS)[ _/](\\d+(?:[_\\.]\\d+)*)", "FBIOS.*FBSV/(\\d+[\\.\\d]*);", "(?:Apple-)?(?:iPhone|iPad|iPod)(?:.*Mac OS X.*Version/(\\d+\\.\\d+)|; Opera)?", "Podcasts/(?:[\\d\\.]+)|Instacast(?:HD)?/(?:\\d\\.[\\d\\.abc]+)|Pocket Casts, iOS|Overcast|Castro|Podcat|i[cC]atcher|RSSRadio/", "iTunes-(iPod|iPad|iPhone)/(?:[\\d\\.]+)"],
    MacOS: ["CFNetwork/887.*(x86_64)", "CFNetwork/811.*(x86_64)", "CFNetwork/807", "CFNetwork/760", "CFNetwork/720", "CFNetwork/673", "CFNetwork/596", "CFNetwork/520", "CFNetwork/454", "CFNetwork/(?:438|422|339|330|221|220|217)", "CFNetwork/12[89]", "CFNetwork/1\\.2", "CFNetwork/1\\.1", "Mac[ +]OS[ +]X(?:[ /](?:Version )?(\\d+(?:[_\\.]\\d+)+))?", "Mac (\\d+(?:[_\\.]\\d+)+)", "Darwin|Macintosh|Mac_PowerPC|PPC|Mac PowerPC|iMac|MacBook"],
    Windows: ["CYGWIN_NT-10.0|Windows NT 10.0|Windows 10", "CYGWIN_NT-6.4|Windows NT 6.4|Windows 10", "CYGWIN_NT-6.3|Windows NT 6.3|Windows 8.1", "CYGWIN_NT-6.2|Windows NT 6.2|Windows 8", "CYGWIN_NT-6.1|Windows NT 6.1|Windows 7", "CYGWIN_NT-6.0|Windows NT 6.0|Windows Vista", "CYGWIN_NT-5.2|Windows NT 5.2|Windows Server 2003 / XP x64", "CYGWIN_NT-5.1|Windows NT 5.1|Windows XP", "CYGWIN_NT-5.0|Windows NT 5.0|Windows 2000", "CYGWIN_NT-4.0|Windows NT 4.0|WinNT|Windows NT", "CYGWIN_ME-4.90|Win 9x 4.90|Windows ME", "CYGWIN_98-4.10|Win98|Windows 98", "CYGWIN_95-4.0|Win32|Win95|Windows 95|Windows_95", "Windows 3.1", "Windows"]
  },
  Re = (Pe = {}, {
    set: function set(e, t) {
      Pe[e] = t;
    },
    get: function get(e) {
      if (Pe.hasOwnProperty(e)) return Pe[e];
    }
  }),
  Ee = function Ee(e, t) {
    try {
      var r = function (e) {
          var t = Re.get(e);
          if (t) return t.value;
          var r = RegExp("(?:^|[^A-Z0-9-_]|[^A-Z0-9-]_|sprd-)(?:".concat(e, ")"), "i");
          return Re.set(e, {
            value: r
          }), r;
        }(e),
        n = r.exec(t);
      return n ? n.slice(1) : null;
    } catch (e) {
      return null;
    }
  };
function Te(e, t) {
  var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Ae(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ae(e, t);
    }(e)) || t && e && "number" == typeof e.length) {
      r && (e = r);
      var _n2 = 0,
        o = function o() {};
      return {
        s: o,
        n: function n() {
          return _n2 >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[_n2++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: o
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var a,
    i = !0,
    s = !1;
  return {
    s: function s() {
      r = r.call(e);
    },
    n: function n() {
      var e = r.next();
      return i = e.done, e;
    },
    e: function e(_e3) {
      s = !0, a = _e3;
    },
    f: function f() {
      try {
        i || null == r["return"] || r["return"]();
      } finally {
        if (s) throw a;
      }
    }
  };
}
function Ae(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) {
    n[r] = e[r];
  }
  return n;
}
var Le = s(function e() {
  n(this, e), c(this, "parse", function (e) {
    for (var t = null, r = 0, n = Object.keys(De); r < n.length; r++) {
      var o,
        a = n[r],
        i = Te(De[a]);
      try {
        for (i.s(); !(o = i.n()).done;) {
          var s = o.value;
          if (Ee(s, e)) return t = a;
        }
      } catch (e) {
        i.e(e);
      } finally {
        i.f();
      }
    }
    return t;
  }), c(this, "getVersion", function (e, t) {
    switch (t) {
      case "MacOS":
        return e.replace(/^.*Mac OS X ([\d_]+).*$/, "$1").replace(/_/g, ".");
      case "iOS":
        return e.replace(/^.*OS ([\d_]+) like.*$/, "$1").replace(/_/g, ".");
      case "Windows":
        return e.replace(/^.*Windows NT ([\d.]+);.*$/, "$1");
      case "Android":
        return e.replace(/^.*Android ([\d.]+);.*$/, "$1");
    }
    return "";
  });
});
function je() {
  var e = new Le().parse(navigator.userAgent);
  return "Linux" === e || "Windows" === e || "MacOS" === e ? "PC" : "iOS" === e || "Android" === e || "HarmonyOS" === e ? "Mobile" : "Other";
}
var Ne = function () {
    var e = l(b.mark(function e(t) {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", new Promise(function (e) {
                setTimeout(function () {
                  e();
                }, t);
              }));
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
  Be = {
    maxCount: 3,
    interval: 100
  };
function Me(e) {
  return !!e;
}
var Fe = function Fe(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Me,
      r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Be;
    return l(b.mark(function n() {
      var o,
        a,
        i,
        s,
        c,
        u = arguments;
      return b.wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              o = r.maxCount, a = r.interval, i = 0;
            case 2:
              if (!(i < o)) {
                n.next = 27;
                break;
              }
              return s = i !== o - 1, n.prev = 4, n.next = 7, e.apply(void 0, u);
            case 7:
              if (c = n.sent, !t(null, c) || !s) {
                n.next = 13;
                break;
              }
              return n.next = 11, Ne(a);
            case 11:
              n.next = 14;
              break;
            case 13:
              return n.abrupt("return", c);
            case 14:
              n.next = 24;
              break;
            case 16:
              if (n.prev = 16, n.t0 = n["catch"](4), !t(n.t0, null) || !s) {
                n.next = 23;
                break;
              }
              return n.next = 21, Ne(a);
            case 21:
              n.next = 24;
              break;
            case 23:
              throw n.t0;
            case 24:
              i++, n.next = 2;
              break;
            case 27:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[4, 16]]);
    }));
  },
  He = function He(e) {
    var t = null == e ? void 0 : e.parentNode;
    t && t.removeChild(e);
  };
var Ve,
  We,
  Ue = {};
function Ge(e, t) {
  return new Promise(function (r, n) {
    !function (e, t) {
      var r = document.createElement("script");
      r.type = "text/javascript", r.src = e, t.id && (r.id = t.id, He(document.querySelector("#".concat(t.id)))), r.onload = r.onreadystatechange = function () {
        this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState || (t.onLoad && t.onLoad(), r.onload = r.onreadystatechange = null);
      }, r.onerror = function (e) {
        t.onError && t.onError(e);
      }, (document.head || document.body).appendChild(r);
    }(e, {
      id: t,
      onLoad: function onLoad() {
        Ue[e] || (Ue[e] = Promise.resolve()), r();
      },
      onError: function onError(t) {
        Ue[e] && (Ue[e] = void 0), n(t);
      }
    });
  });
}
function Ke(e) {
  return !!e;
}
function qe(e, t) {
  if (e && Ue[e]) return Ue[e];
  var r = Fe(Ge, Ke, t)(e, null == t ? void 0 : t.id);
  return Ue[e] = r, r;
}
!function (e) {
  e.FirstName = "firstName", e.Number = "number", e.Cvc = "cvc", e.ExpDate = "expDate";
}(Ve || (Ve = {})), function (e) {
  e.IdNumber = "idNumber", e.IssueDate = "issueDate", e.ReplacementCategory = "replacementCategory", e.IssueLocation = "issueLocation";
}(We || (We = {}));
var ze = "en",
  Ze = "SLPayments",
  $e = [Ve.Number, Ve.FirstName, Ve.ExpDate, Ve.Cvc];
function Je(e) {
  return e && !/^https?:\/\//.test(e) ? "https://".concat(e) : e;
}
function Xe(e) {
  var t,
    r = e.channelId,
    n = e.paymentInstrument;
  return r === Ze && !(null == n || null === (t = n.bindCard) || void 0 === t || !t.enable);
}
function Ye(e) {
  return Object.freeze(S(e, ["currency", "countryCode", "channelId", "paymentMethod", "merchantId"]));
}
function Qe(e) {
  return {
    merchantId: e.merchantId
  };
}
We.IdNumber, We.IssueDate, We.IssueLocation, We.ReplacementCategory;
var et,
  tt,
  rt,
  nt,
  ot,
  at,
  it,
  st = "https://h.online-metrix.net/fp/tags.js",
  ct = "cybs_script",
  ut = function () {
    var e;
    return function () {
      var t = l(b.mark(function t(r) {
        var n,
          o,
          a,
          i,
          s,
          c,
          u,
          l = arguments;
        return b.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (n = l.length > 1 && void 0 !== l[1] ? l[1] : "", !Boolean(e)) {
                  t.next = 3;
                  break;
                }
                return t.abrupt("return", e);
              case 3:
                return o = window.screen, a = o.width, i = o.height, s = "".concat(n, "/v1/api/cashier/paysession"), c = {
                  screenHeight: a.toString(),
                  screenWidth: i.toString()
                }, ke.reportData("get_paysession_start", {
                  url: s,
                  request: {
                    params: c
                  }
                }), u = Se.get(s, {
                  params: c,
                  headers: r ? Qe(r) : {}
                }).then(function (e) {
                  return ke.reportData("get_paysession_end", {
                    url: s,
                    request: {
                      params: c
                    },
                    response: e
                  }), e.data.paySession;
                })["catch"](function (t) {
                  return e = void 0, ke.handleError(t, "get_paysession_error", {
                    url: s,
                    request: {
                      params: c
                    },
                    response: {
                      error: t
                    }
                  });
                }), e = u, t.abrupt("return", u);
              case 10:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }(),
  lt = function () {
    function e(t, r) {
      n(this, e), c(this, "env", void 0), c(this, "host", void 0), this.env = t, this.host = r || this.env.host;
    }
    return s(e, [{
      key: "init",
      value: function value(e) {
        var t = this;
        return ut(e, this.host).then(function (e) {
          document.querySelector("#".concat(ct)) || t.appendCybsScript(e);
          var r = new Le(),
            n = r.parse(navigator.userAgent) || "Other";
          return e.label = t.env.cybsLabel, e.deviceType = je(), e.deviceOS = n, e.deviceOsVersion = r.getVersion(navigator.userAgent, n), e;
        });
      }
    }, {
      key: "appendCybsScript",
      value: function value(e) {
        var t = this.env.cybsMerchantId + e.sessionId,
          r = "".concat(st, "?org_id=").concat(this.env.cybsOrgId, "&session_id=").concat(t);
        qe(r, {
          maxCount: 3,
          interval: 100,
          id: ct
        }).then(function () {
          ke.reportData("load_cybs_js_success", {
            scriptSource: r
          });
        })["catch"](function (e) {
          ke.reportData("load_cybs_js_error", {
            scriptSource: r
          }), ke.reportError(e, "load_cybs_js_error", {
            scriptSource: r
          }), He(document.querySelector("#".concat(ct)));
        });
      }
    }]), e;
  }();
!function (e) {
  e.CreditCard = "CreditCard", e.FPX = "FPX", e.PaynowQrCode = "PaynowQrCode", e.AlipayQrCode = "AlipayQrCode", e.AlipayWap = "AlipayWap", e.Paypal = "Paypal", e.BankTransfer = "BankTransfer", e.Cash = "Cash", e.ChannelCashier = "ChannelCashier", e.VirtualAccount = "VirtualAccount", e.Ideal = "iDEAL", e.AtomeBNPL = "AtomeBNPL", e.ChaileaseBNPL = "ChaileaseBNPL", e.GooglePay = "GooglePay", e.WeChatPay = "WeChatPay", e.ApplePay = "ApplePay", e.OVO = "OVO", e.AfteeBNPL = "AfteeBNPL";
}(et || (et = {})), function (e) {
  e.Rtl = "rtl", e.Ltr = "ltr";
}(tt || (tt = {})), function (e) {
  e.CN = "CN";
}(rt || (rt = {})), function (e) {
  e.SUCCESS = "SUCCESS", e.FAIL = "FAIL";
}(nt || (nt = {})), function (e) {
  e.Redirect = "Redirect", e.ExchangeTicket = "ExchangeTicket", e.Confirm = "Confirm", e.QrCode = "QrCode", e.CreatePayClient = "CreatePayClient", e.OpenIframe = "OpenIframe", e.RedirectWebOrApp = "RedirectWebOrApp";
}(ot || (ot = {})), function (e) {
  e.IdCard = "ID_CARD";
}(at || (at = {})), function (e) {
  e.Browser = "browser", e.AndroidWebView = "androidWebView", e.IosWebView = "iosWebview";
}(it || (it = {}));
var pt = [".myshopline.com", ".myshoplinestg.com", "172.27.211.8:3000"];
function dt(e) {
  if (!e) return !1;
  for (var t = pt, r = 0, n = t.length; r < n; r++) {
    if (e.indexOf(t[r]) > -1) return !0;
  }
  return !1;
}
function ft(e) {
  if (Array.isArray(e)) return e;
}
function ht(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) {
    n[r] = e[r];
  }
  return n;
}
function vt(e, t) {
  if (e) {
    if ("string" == typeof e) return ht(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ht(e, t) : void 0;
  }
}
function yt() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function mt(e, t) {
  return ft(e) || function (e, t) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != r) {
      var n,
        o,
        a,
        i,
        s = [],
        c = !0,
        u = !1;
      try {
        if (a = (r = r.call(e)).next, 0 === t) {
          if (Object(r) !== r) return;
          c = !1;
        } else for (; !(c = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) {
          ;
        }
      } catch (e) {
        u = !0, o = e;
      } finally {
        try {
          if (!c && null != r["return"] && (i = r["return"](), Object(i) !== i)) return;
        } finally {
          if (u) throw o;
        }
      }
      return s;
    }
  }(e, t) || vt(e, t) || yt();
}
var gt,
  bt,
  kt,
  wt,
  Ct,
  _t,
  Ot,
  Pt,
  xt = function xt(e, t) {
    var r = [];
    for (var n in t) {
      if (Object.prototype.hasOwnProperty.call(t, n)) {
        var o = encodeURIComponent(encodeURIComponent(t[n]));
        r.push("".concat(n, "=").concat(o));
      }
    }
    var a = -1 === e.indexOf("?") ? "?" : "&";
    return "".concat(e).concat(a).concat(r.join("&"));
  };
function It(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function St(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? It(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : It(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
!function (e) {
  e.Dev = "https://cdn.myshopline.com/pay/fe-dev", e.Prod = "https://cdn.myshopline.com/pay/fe-prod";
}(wt || (wt = {})), function (e) {
  e.Dev = "https://slp-cdn.myshopline.cn/pay/fe-dev", e.Prod = "https://slp-cdn.myshopline.cn/pay/fe-prod";
}(Ct || (Ct = {})), function (e) {
  e.Dev = "stg", e.Test = "stg", e.Prev = "prev", e.Prod = "prod";
}(_t || (_t = {})), function (e) {
  e.Alpha = "alpha", e.Prod = "prod", e.Test1 = "test1", e.Test2 = "test2", e.Test3 = "test3";
}(Ot || (Ot = {})), function (e) {
  e.Prev1 = "prev1", e.Prev2 = "prev2", e.Prev3 = "prev3";
}(Pt || (Pt = {}));
var Dt = Ot.Prod,
  Rt = (c(gt = {}, Ot.Test1, {
    env: Ot.Test1,
    cybsOrgId: "1snn5n9w",
    cybsMerchantId: "yyrisk",
    cybsLabel: "cybs",
    host: "https://cashiers-test1.myshoplinestg.com",
    slI18nEnv: _t.Prev,
    imageHost: wt.Dev
  }), c(gt, Ot.Test2, {
    env: Ot.Test2,
    cybsOrgId: "1snn5n9w",
    cybsMerchantId: "yyrisk",
    cybsLabel: "cybs",
    host: "https://cashiers-test2.myshoplinestg.com",
    slI18nEnv: _t.Prev,
    imageHost: wt.Dev
  }), c(gt, Ot.Test3, {
    env: Ot.Test3,
    cybsOrgId: "1snn5n9w",
    cybsMerchantId: "yyrisk",
    cybsLabel: "cybs",
    host: "https://cashiers-test3.myshoplinestg.com",
    slI18nEnv: _t.Prev,
    imageHost: wt.Dev
  }), gt),
  Et = Object.freeze(St(St({}, Rt), {}, (c(bt = {}, Pt.Prev1, Rt[Ot.Test1]), c(bt, Pt.Prev2, Rt[Ot.Test2]), c(bt, Pt.Prev3, Rt[Ot.Test3]), c(bt, Ot.Alpha, {
    env: Ot.Alpha,
    cybsOrgId: "k8vif92e",
    cybsMerchantId: "yyrisk",
    cybsLabel: "cybs",
    host: "https://cashiers-alpha.myshopline.com",
    slI18nEnv: _t.Prev,
    imageHost: wt.Dev
  }), c(bt, Ot.Prod, {
    env: Ot.Prod,
    cybsOrgId: "k8vif92e",
    cybsMerchantId: "yyrisk",
    cybsLabel: "cybs",
    host: "https://cashiers.myshopline.com",
    slI18nEnv: _t.Prod,
    imageHost: wt.Prod
  }), bt))),
  Tt = (c(kt = {}, Ot.Prod, {
    "01": "https://cashiers-sg.myshopline.com",
    "02": "https://cashiers-us.myshopline.com"
  }), c(kt, Ot.Alpha, {
    "01": Et[Ot.Alpha].host,
    "02": Et[Ot.Alpha].host
  }), c(kt, "dev", {
    "01": Et[Ot.Test3].host,
    "02": Et[Ot.Test2].host,
    "03": Et[Ot.Test1].host
  }), kt);
function At(e) {
  return St({}, Et[e || Dt]);
}
function Lt(e, t) {
  if (!t || "string" != typeof t) return "";
  var r = t.split("@")[1];
  if (!r) return "";
  var n = function (e) {
      for (var t = e.split("&"), r = {}, n = 0; n < t.length; n++) {
        var o = mt(t[n].split("="), 2),
          a = o[0],
          i = o[1];
        r[a] = i;
      }
      return r;
    }(r),
    o = n.l;
  if (!o) return "";
  var a = (Tt[e] || Tt.dev)[o];
  return a || (ke.reportErrorData("customer_token_local_error", {
    customerToken: t.slice(30)
  }), dt(o) ? Je(decodeURIComponent(o)) : "");
}
var jt,
  Nt,
  Bt,
  Mt,
  Ft,
  Ht,
  Vt,
  Wt = function Wt(e) {
    try {
      var t;
      return Et[e] ? e = (t = At(e)).host : t = function (e) {
        var t;
        for (var r in Et) {
          if (e && -1 !== e.indexOf(Et[r].host)) {
            t = r;
            break;
          }
        }
        return St({}, Et[t = t || Dt]);
      }(e = Je(e)), ke.reportData("init_risk_start"), new lt(t, e).init().then(function (e) {
        ke.reportData("init_risk_end", {
          sessionId: e.sessionId
        });
      });
    } catch (t) {
      ke.handleError(t, "init_risk_error", {
        envName: e
      });
    }
  },
  Ut = {},
  Gt = [],
  Kt = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,
  qt = Array.isArray;
function zt(e, t) {
  for (var r in t) {
    e[r] = t[r];
  }
  return e;
}
function Zt(e) {
  var t = e.parentNode;
  t && t.removeChild(e);
}
function $t(e, t, r) {
  var n,
    o,
    a,
    i = {};
  for (a in t) {
    "key" == a ? n = t[a] : "ref" == a ? o = t[a] : i[a] = t[a];
  }
  if (arguments.length > 2 && (i.children = arguments.length > 3 ? jt.call(arguments, 2) : r), "function" == typeof e && null != e.defaultProps) for (a in e.defaultProps) {
    void 0 === i[a] && (i[a] = e.defaultProps[a]);
  }
  return Jt(e, i, n, o, null);
}
function Jt(e, t, r, n, o) {
  var a = {
    type: e,
    props: t,
    key: r,
    ref: n,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: null == o ? ++Bt : o
  };
  return null == o && null != Nt.vnode && Nt.vnode(a), a;
}
function Xt(e) {
  return e.children;
}
function Yt(e, t) {
  this.props = e, this.context = t;
}
function Qt(e, t) {
  if (null == t) return e.__ ? Qt(e.__, e.__.__k.indexOf(e) + 1) : null;
  for (var r; t < e.__k.length; t++) {
    if (null != (r = e.__k[t]) && null != r.__e) return r.__e;
  }
  return "function" == typeof e.type ? Qt(e) : null;
}
function er(e) {
  var t, r;
  if (null != (e = e.__) && null != e.__c) {
    for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) {
      if (null != (r = e.__k[t]) && null != r.__e) {
        e.__e = e.__c.base = r.__e;
        break;
      }
    }
    return er(e);
  }
}
function tr(e) {
  (!e.__d && (e.__d = !0) && Mt.push(e) && !rr.__r++ || Ft !== Nt.debounceRendering) && ((Ft = Nt.debounceRendering) || Ht)(rr);
}
function rr() {
  var e, t, r, n, o, a, i, s;
  for (Mt.sort(Vt); e = Mt.shift();) {
    e.__d && (t = Mt.length, n = void 0, o = void 0, i = (a = (r = e).__v).__e, (s = r.__P) && (n = [], (o = zt({}, a)).__v = a.__v + 1, pr(s, a, o, r.__n, void 0 !== s.ownerSVGElement, null != a.__h ? [i] : null, n, null == i ? Qt(a) : i, a.__h), dr(n, a), a.__e != i && er(a)), Mt.length > t && Mt.sort(Vt));
  }
  rr.__r = 0;
}
function nr(e, t, r, n, o, a, i, s, c, u) {
  var l,
    p,
    d,
    f,
    h,
    v,
    y,
    m = n && n.__k || Gt,
    g = m.length;
  for (r.__k = [], l = 0; l < t.length; l++) {
    if (null != (f = r.__k[l] = null == (f = t[l]) || "boolean" == typeof f || "function" == typeof f ? null : "string" == typeof f || "number" == typeof f || "bigint" == typeof f ? Jt(null, f, null, null, f) : qt(f) ? Jt(Xt, {
      children: f
    }, null, null, null) : f.__b > 0 ? Jt(f.type, f.props, f.key, f.ref ? f.ref : null, f.__v) : f)) {
      if (f.__ = r, f.__b = r.__b + 1, null === (d = m[l]) || d && f.key == d.key && f.type === d.type) m[l] = void 0;else for (p = 0; p < g; p++) {
        if ((d = m[p]) && f.key == d.key && f.type === d.type) {
          m[p] = void 0;
          break;
        }
        d = null;
      }
      pr(e, f, d = d || Ut, o, a, i, s, c, u), h = f.__e, (p = f.ref) && d.ref != p && (y || (y = []), d.ref && y.push(d.ref, null, f), y.push(p, f.__c || h, f)), null != h ? (null == v && (v = h), "function" == typeof f.type && f.__k === d.__k ? f.__d = c = or(f, c, e) : c = ar(e, f, d, m, h, c), "function" == typeof r.type && (r.__d = c)) : c && d.__e == c && c.parentNode != e && (c = Qt(d));
    }
  }
  for (r.__e = v, l = g; l--;) {
    null != m[l] && ("function" == typeof r.type && null != m[l].__e && m[l].__e == r.__d && (r.__d = ir(n).nextSibling), hr(m[l], m[l]));
  }
  if (y) for (l = 0; l < y.length; l++) {
    fr(y[l], y[++l], y[++l]);
  }
}
function or(e, t, r) {
  for (var n, o = e.__k, a = 0; o && a < o.length; a++) {
    (n = o[a]) && (n.__ = e, t = "function" == typeof n.type ? or(n, t, r) : ar(r, n, n, o, n.__e, t));
  }
  return t;
}
function ar(e, t, r, n, o, a) {
  var i, s, c;
  if (void 0 !== t.__d) i = t.__d, t.__d = void 0;else if (null == r || o != a || null == o.parentNode) e: if (null == a || a.parentNode !== e) e.appendChild(o), i = null;else {
    for (s = a, c = 0; (s = s.nextSibling) && c < n.length; c += 1) {
      if (s == o) break e;
    }
    e.insertBefore(o, a), i = a;
  }
  return void 0 !== i ? i : o.nextSibling;
}
function ir(e) {
  var t, r, n;
  if (null == e.type || "string" == typeof e.type) return e.__e;
  if (e.__k) for (t = e.__k.length - 1; t >= 0; t--) {
    if ((r = e.__k[t]) && (n = ir(r))) return n;
  }
  return null;
}
function sr(e, t, r) {
  "-" === t[0] ? e.setProperty(t, null == r ? "" : r) : e[t] = null == r ? "" : "number" != typeof r || Kt.test(t) ? r : r + "px";
}
function cr(e, t, r, n, o) {
  var a;
  e: if ("style" === t) {
    if ("string" == typeof r) e.style.cssText = r;else {
      if ("string" == typeof n && (e.style.cssText = n = ""), n) for (t in n) {
        r && t in r || sr(e.style, t, "");
      }
      if (r) for (t in r) {
        n && r[t] === n[t] || sr(e.style, t, r[t]);
      }
    }
  } else if ("o" === t[0] && "n" === t[1]) a = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + a] = r, r ? n || e.addEventListener(t, a ? lr : ur, a) : e.removeEventListener(t, a ? lr : ur, a);else if ("dangerouslySetInnerHTML" !== t) {
    if (o) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && "rowSpan" !== t && "colSpan" !== t && t in e) try {
      e[t] = null == r ? "" : r;
      break e;
    } catch (e) {}
    "function" == typeof r || (null == r || !1 === r && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, r));
  }
}
function ur(e) {
  return this.l[e.type + !1](Nt.event ? Nt.event(e) : e);
}
function lr(e) {
  return this.l[e.type + !0](Nt.event ? Nt.event(e) : e);
}
function pr(e, t, r, n, o, a, i, s, c) {
  var u,
    l,
    p,
    d,
    f,
    h,
    v,
    y,
    m,
    g,
    b,
    k,
    w,
    C,
    _,
    O = t.type;
  if (void 0 !== t.constructor) return null;
  null != r.__h && (c = r.__h, s = t.__e = r.__e, t.__h = null, a = [s]), (u = Nt.__b) && u(t);
  try {
    e: if ("function" == typeof O) {
      if (y = t.props, m = (u = O.contextType) && n[u.__c], g = u ? m ? m.props.value : u.__ : n, r.__c ? v = (l = t.__c = r.__c).__ = l.__E : ("prototype" in O && O.prototype.render ? t.__c = l = new O(y, g) : (t.__c = l = new Yt(y, g), l.constructor = O, l.render = vr), m && m.sub(l), l.props = y, l.state || (l.state = {}), l.context = g, l.__n = n, p = l.__d = !0, l.__h = [], l._sb = []), null == l.__s && (l.__s = l.state), null != O.getDerivedStateFromProps && (l.__s == l.state && (l.__s = zt({}, l.__s)), zt(l.__s, O.getDerivedStateFromProps(y, l.__s))), d = l.props, f = l.state, l.__v = t, p) null == O.getDerivedStateFromProps && null != l.componentWillMount && l.componentWillMount(), null != l.componentDidMount && l.__h.push(l.componentDidMount);else {
        if (null == O.getDerivedStateFromProps && y !== d && null != l.componentWillReceiveProps && l.componentWillReceiveProps(y, g), !l.__e && null != l.shouldComponentUpdate && !1 === l.shouldComponentUpdate(y, l.__s, g) || t.__v === r.__v) {
          for (t.__v !== r.__v && (l.props = y, l.state = l.__s, l.__d = !1), l.__e = !1, t.__e = r.__e, t.__k = r.__k, t.__k.forEach(function (e) {
            e && (e.__ = t);
          }), b = 0; b < l._sb.length; b++) {
            l.__h.push(l._sb[b]);
          }
          l._sb = [], l.__h.length && i.push(l);
          break e;
        }
        null != l.componentWillUpdate && l.componentWillUpdate(y, l.__s, g), null != l.componentDidUpdate && l.__h.push(function () {
          l.componentDidUpdate(d, f, h);
        });
      }
      if (l.context = g, l.props = y, l.__P = e, k = Nt.__r, w = 0, "prototype" in O && O.prototype.render) {
        for (l.state = l.__s, l.__d = !1, k && k(t), u = l.render(l.props, l.state, l.context), C = 0; C < l._sb.length; C++) {
          l.__h.push(l._sb[C]);
        }
        l._sb = [];
      } else do {
        l.__d = !1, k && k(t), u = l.render(l.props, l.state, l.context), l.state = l.__s;
      } while (l.__d && ++w < 25);
      l.state = l.__s, null != l.getChildContext && (n = zt(zt({}, n), l.getChildContext())), p || null == l.getSnapshotBeforeUpdate || (h = l.getSnapshotBeforeUpdate(d, f)), nr(e, qt(_ = null != u && u.type === Xt && null == u.key ? u.props.children : u) ? _ : [_], t, r, n, o, a, i, s, c), l.base = t.__e, t.__h = null, l.__h.length && i.push(l), v && (l.__E = l.__ = null), l.__e = !1;
    } else null == a && t.__v === r.__v ? (t.__k = r.__k, t.__e = r.__e) : t.__e = function (e, t, r, n, o, a, i, s) {
      var c,
        u,
        l,
        p = r.props,
        d = t.props,
        f = t.type,
        h = 0;
      if ("svg" === f && (o = !0), null != a) for (; h < a.length; h++) {
        if ((c = a[h]) && "setAttribute" in c == !!f && (f ? c.localName === f : 3 === c.nodeType)) {
          e = c, a[h] = null;
          break;
        }
      }
      if (null == e) {
        if (null === f) return document.createTextNode(d);
        e = o ? document.createElementNS("http://www.w3.org/2000/svg", f) : document.createElement(f, d.is && d), a = null, s = !1;
      }
      if (null === f) p === d || s && e.data === d || (e.data = d);else {
        if (a = a && jt.call(e.childNodes), u = (p = r.props || Ut).dangerouslySetInnerHTML, l = d.dangerouslySetInnerHTML, !s) {
          if (null != a) for (p = {}, h = 0; h < e.attributes.length; h++) {
            p[e.attributes[h].name] = e.attributes[h].value;
          }
          (l || u) && (l && (u && l.__html == u.__html || l.__html === e.innerHTML) || (e.innerHTML = l && l.__html || ""));
        }
        if (function (e, t, r, n, o) {
          var a;
          for (a in r) {
            "children" === a || "key" === a || a in t || cr(e, a, null, r[a], n);
          }
          for (a in t) {
            o && "function" != typeof t[a] || "children" === a || "key" === a || "value" === a || "checked" === a || r[a] === t[a] || cr(e, a, t[a], r[a], n);
          }
        }(e, d, p, o, s), l) t.__k = [];else if (nr(e, qt(h = t.props.children) ? h : [h], t, r, n, o && "foreignObject" !== f, a, i, a ? a[0] : r.__k && Qt(r, 0), s), null != a) for (h = a.length; h--;) {
          null != a[h] && Zt(a[h]);
        }
        s || ("value" in d && void 0 !== (h = d.value) && (h !== e.value || "progress" === f && !h || "option" === f && h !== p.value) && cr(e, "value", h, p.value, !1), "checked" in d && void 0 !== (h = d.checked) && h !== e.checked && cr(e, "checked", h, p.checked, !1));
      }
      return e;
    }(r.__e, t, r, n, o, a, i, c);
    (u = Nt.diffed) && u(t);
  } catch (e) {
    t.__v = null, (c || null != a) && (t.__e = s, t.__h = !!c, a[a.indexOf(s)] = null), Nt.__e(e, t, r);
  }
}
function dr(e, t) {
  Nt.__c && Nt.__c(t, e), e.some(function (t) {
    try {
      e = t.__h, t.__h = [], e.some(function (e) {
        e.call(t);
      });
    } catch (e) {
      Nt.__e(e, t.__v);
    }
  });
}
function fr(e, t, r) {
  try {
    "function" == typeof e ? e(t) : e.current = t;
  } catch (e) {
    Nt.__e(e, r);
  }
}
function hr(e, t, r) {
  var n, o;
  if (Nt.unmount && Nt.unmount(e), (n = e.ref) && (n.current && n.current !== e.__e || fr(n, null, t)), null != (n = e.__c)) {
    if (n.componentWillUnmount) try {
      n.componentWillUnmount();
    } catch (e) {
      Nt.__e(e, t);
    }
    n.base = n.__P = null, e.__c = void 0;
  }
  if (n = e.__k) for (o = 0; o < n.length; o++) {
    n[o] && hr(n[o], t, r || "function" != typeof e.type);
  }
  r || null == e.__e || Zt(e.__e), e.__ = e.__e = e.__d = void 0;
}
function vr(e, t, r) {
  return this.constructor(e, r);
}
function yr(e, t, r) {
  var n, o, a;
  Nt.__ && Nt.__(e, t), o = (n = "function" == typeof r) ? null : r && r.__k || t.__k, a = [], pr(t, e = (!n && r || t).__k = $t(Xt, null, [e]), o || Ut, Ut, void 0 !== t.ownerSVGElement, !n && r ? [r] : o ? null : t.firstChild ? jt.call(t.childNodes) : null, a, !n && r ? r : o ? o.__e : t.firstChild, n), dr(a, e);
}
function mr(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
jt = Gt.slice, Nt = {
  __e: function __e(e, t, r, n) {
    for (var o, a, i; t = t.__;) {
      if ((o = t.__c) && !o.__) try {
        if ((a = o.constructor) && null != a.getDerivedStateFromError && (o.setState(a.getDerivedStateFromError(e)), i = o.__d), null != o.componentDidCatch && (o.componentDidCatch(e, n || {}), i = o.__d), i) return o.__E = o;
      } catch (t) {
        e = t;
      }
    }
    throw e;
  }
}, Bt = 0, Yt.prototype.setState = function (e, t) {
  var r;
  r = null != this.__s && this.__s !== this.state ? this.__s : this.__s = zt({}, this.state), "function" == typeof e && (e = e(zt({}, r), this.props)), e && zt(r, e), null != e && this.__v && (t && this._sb.push(t), tr(this));
}, Yt.prototype.forceUpdate = function (e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), tr(this));
}, Yt.prototype.render = Xt, Mt = [], Ht = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Vt = function Vt(e, t) {
  return e.__v.__b - t.__v.__b;
}, rr.__r = 0;
function gr(e, t, r) {
  var n,
    o,
    a,
    i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
    s = function s() {
      var n = +getComputedStyle(e).getPropertyValue("width").replace("px", "");
      r(n > t);
    },
    c = (n = s, o = null == i ? void 0 : i.resizeWait, a = null, function () {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
        t[r] = arguments[r];
      }
      a && (clearTimeout(a), a = null), a = setTimeout(function () {
        n.apply(void 0, t);
      }, o);
    });
  return window.addEventListener("resize", c), {
    removeListener: function removeListener() {
      window.removeEventListener("resize", c);
    },
    callListener: function callListener() {
      return s();
    }
  };
}
var br = function (e) {
  _(r, Yt);
  var t = mr(r);
  function r() {
    var e;
    n(this, r);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) {
      a[i] = arguments[i];
    }
    return c(w(e = t.call.apply(t, [this].concat(a))), "removeResizeListener", void 0), c(w(e), "getResizeTriggerSize", function () {
      switch (e.props.triggerSize) {
        case !0:
          return 600;
        case !1:
          return null;
        default:
          return e.props.triggerSize;
      }
    }), e;
  }
  return s(r, [{
    key: "componentDidCatch",
    value: function value(e) {
      ke.reportError(e, "Resizer_componentDidCatch_error");
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      var e = this.getResizeTriggerSize();
      if (null !== e && this.base instanceof Element) {
        var t = gr(this.base, e, this.props.onResize, {
            resizeWait: 200
          }),
          r = t.removeListener,
          n = t.callListener;
        this.removeResizeListener = r, this.props.immediate && setTimeout(n);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.removeResizeListener && this.removeResizeListener();
    }
  }, {
    key: "render",
    value: function value() {
      return this.props.children;
    }
  }]), r;
}();
function kr() {
  return kr = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }
    return e;
  }, kr.apply(this, arguments);
}
c(br, "defaultProps", {
  immediate: !0
});
var wr = function wr(e) {
    return $t("svg", kr({}, e, {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }), $t("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.6 8C13.6 11.0928 11.0928 13.6 8 13.6C4.90721 13.6 2.4 11.0928 2.4 8C2.4 4.90721 4.90721 2.4 8 2.4C11.0928 2.4 13.6 4.90721 13.6 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM9.45298 7.94043C8.86649 8.2889 8.60666 8.62269 8.59923 9.33797C8.59563 9.68549 8.31985 9.94303 7.89582 9.94303C7.49737 9.94303 7.1924 9.68549 7.1924 9.33797C7.19612 8.05414 7.54504 7.66166 8.16865 7.27285C8.62522 6.98674 8.97785 6.66762 8.97785 6.1871C8.97785 5.67724 8.57325 5.34712 8.07214 5.34712C7.58587 5.34712 7.15624 5.63856 7.11445 6.26413C7.0902 6.62714 6.78059 6.98126 6.35721 6.98126C5.93369 6.98126 5.59998 6.61104 5.59998 6.26413C5.59998 4.80823 6.73212 4.09998 8.07956 4.09998C9.55321 4.09998 10.6 4.84826 10.6 6.13208C10.6 6.99407 10.1471 7.53328 9.45298 7.94043ZM7.92373 12.4033C8.39886 12.4033 8.81089 12.0109 8.8146 11.523C8.81089 11.0425 8.39886 10.65 7.92373 10.65C7.43375 10.65 7.02915 11.0425 7.03286 11.523C7.02915 12.0109 7.43375 12.4033 7.92373 12.4033Z",
      fill: "currentColor"
    }));
  },
  Cr = function Cr(e) {
    return $t("svg", kr({}, e, {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }), $t("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.6 8C13.6 11.0928 11.0928 13.6 8 13.6C4.90721 13.6 2.4 11.0928 2.4 8C2.4 4.90721 4.90721 2.4 8 2.4C11.0928 2.4 13.6 4.90721 13.6 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.00005 4C8.44188 4 8.80005 4.35817 8.80005 4.8V9C8.80005 9.44183 8.44188 9.8 8.00005 9.8C7.55822 9.8 7.20005 9.44183 7.20005 9V4.8C7.20005 4.35817 7.55822 4 8.00005 4ZM7.99999 12.45C8.47998 12.45 8.89623 12.0471 8.89998 11.5463C8.89623 11.053 8.47998 10.65 7.99999 10.65C7.505 10.65 7.09625 11.053 7.1 11.5463C7.09625 12.0471 7.505 12.45 7.99999 12.45Z",
      fill: "currentColor"
    }));
  },
  _r = {
    InstallmentHeaderContainer: "paymentSdk_InstallmentHeaderContainer_ea99cfa9",
    InstallmentHeaderSmallContainer: "paymentSdk_InstallmentHeaderSmallContainer_ea99cfa9",
    InstallmentHeaderLeftContent: "paymentSdk_InstallmentHeaderLeftContent_ea99cfa9",
    InstallmentHeaderRightContent: "paymentSdk_InstallmentHeaderRightContent_ea99cfa9",
    InstallmentHeaderQuesIcon: "paymentSdk_InstallmentHeaderQuesIcon_ea99cfa9",
    InstallmentHeaderInfoIcon: "paymentSdk_InstallmentHeaderInfoIcon_ea99cfa9",
    supportTipContentTitle: "paymentSdk_supportTipContentTitle_ea99cfa9",
    supportTipContentTitleSm: "paymentSdk_supportTipContentTitleSm_ea99cfa9"
  };
function Or(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var Pr = {
    splitReg: "!\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
    matchReg: /!\[([^\]]+)\]\(([^)]+)\)/,
    replaceReg: "(!\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
  },
  xr = {
    splitReg: "\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
    matchReg: /\[([^\]]+)\]\(([^)]+)\)/,
    replaceReg: "(\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
  },
  Ir = {
    splitReg: "\\\\?\\*\\\\?\\*(?:[^\\s]+?|[^\\s].+?[^\\s])(?:\\\\\\*\\\\\\*|\\*\\*+)",
    matchReg: /\*\*([^\s]+|[^\s].+[^\s])\*\*$/,
    replaceReg: "\\\\\\*\\\\\\*([^\\s]+|[^\\s].+[^\\s])\\\\\\*\\\\\\*"
  },
  Sr = {
    splitReg: "\\\\n|\\n",
    matchReg: /\n/,
    replaceReg: /\\n/
  },
  Dr = function Dr(e) {
    return {
      tagName: e,
      content: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
      property: arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}
    };
  },
  Rr = function Rr(e, t, r, n) {
    return t + (r ? r.slice(1) : "") + n;
  };
function Er(e) {
  return (Er = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}
var Tr = function Tr(e, t, r) {
    return "string" == typeof e && e ? t && "object" === Er(t) ? e.replace(/{{\s*([^}\s]+)\s*}}/g, function (e, n) {
      if (void 0 !== t[n]) {
        var o = t[n];
        return "function" == typeof r ? r(o) : o;
      }
      return e;
    }) : e : "";
  },
  Ar = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), Or(this, "formatString", function (e, t) {
        return t && t.variable ? Tr(e, t.variable, t.handleVariable) : e;
      }), Or(this, "handleStrong", function (e, t) {
        var r = t.match(e);
        return Dr("strong", r[1]);
      }), Or(this, "handleStrongReplace", function (e, t) {
        var r = t.replace(new RegExp(e, "g"), "**$1**");
        return Dr("text", r);
      });
    }
    var t;
    return (t = [{
      key: "parseToTagConfig",
      value: function value(e, t) {
        var r = this,
          n = [],
          o = xr,
          a = Pr,
          i = Ir,
          s = Sr;
        if (!e || 0 !== e.indexOf("$RT$")) return [Dr("text", e)];
        e = (e = this.formatString(e, t)).slice(4);
        var c = "(".concat(a.splitReg, ")|(").concat(o.splitReg, ")|(").concat(i.splitReg, ")|(").concat(s.splitReg, ")");
        return e.split(new RegExp(c)).filter(function (e) {
          return !!e;
        }).forEach(function (e) {
          var t;
          if (new RegExp(a.matchReg).test(e)) {
            var c = e.match(a.matchReg);
            t = Dr("img", "", {
              alt: c[1],
              src: c[2]
            });
          } else if (new RegExp(o.matchReg).test(e)) {
            var u = e.match(o.matchReg);
            t = Dr("a", u[1], {
              href: u[2],
              target: "_blank",
              rel: "noopener"
            });
          } else if (i.matchReg.test(e)) t = r.handleStrong(i.matchReg, e);else if (new RegExp(a.replaceReg).test(e)) {
            var l = e.replace(new RegExp(a.replaceReg, "g"), Rr);
            t = Dr("text", l);
          } else if (new RegExp(o.replaceReg).test(e)) {
            var p = e.replace(new RegExp(o.replaceReg, "g"), Rr);
            t = Dr("text", p);
          } else t = new RegExp(i.replaceReg).test(e) ? r.handleStrongReplace(i.replaceReg, e) : new RegExp(s.replaceReg).test(e) ? Dr("text", "\\n") : new RegExp(s.matchReg).test(e) ? Dr("br", "") : Dr("text", e);
          n.push(t);
        }), n;
      }
    }, {
      key: "parseToDom",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
          r = document.createElement(t);
        return e.forEach(function (e) {
          var t = document.createElement("text" === e.tagName ? "span" : e.tagName);
          t.textContent = e.content, e.property && Object.keys(e.property).forEach(function (r) {
            return t.setAttribute(r, e.property[r]);
          }), r.appendChild(t);
        }), r;
      }
    }, {
      key: "autoParseToDom",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
          r = arguments.length > 2 ? arguments[2] : void 0,
          n = this.parseToTagConfig(e, r);
        return this.parseToDom(n, t);
      }
    }]) && function (e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }(e.prototype, t), e;
  }(),
  Lr = "paymentSdk_richText_ef90b042",
  jr = "paymentSdk_tagText_ef90b042",
  Nr = "paymentSdk_tagLink_ef90b042";
function Br(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
function Mr(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
var Fr = new Ar();
var Hr = {
    text: function text(e, t) {
      return $t("span", {
        style: {
          color: null == t ? void 0 : t.fontColor
        },
        className: jr
      }, e.content);
    },
    a: function a(e, t) {
      var r = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Mr(Object(r), !0).forEach(function (t) {
            c(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Mr(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }({}, e.property);
      return $t("a", {
        style: {
          color: null == t ? void 0 : t.linkColor,
          textDecoration: null == t ? void 0 : t.linkDecoration
        },
        className: Nr,
        href: r.href,
        target: r.target,
        rel: "noopener"
      }, e.content);
    },
    strong: function strong(e, t) {
      return $t("strong", {
        style: {
          display: null == t ? void 0 : t.strongDisplay,
          color: null == t ? void 0 : t.fontColor,
          textAlign: null == t ? void 0 : t.strongTextAlign
        },
        className: Nr
      }, e.content);
    },
    br: function br() {
      return $t("br", null);
    }
  },
  Vr = function (e) {
    _(r, Yt);
    var t = Br(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "render",
      value: function value() {
        var e = this,
          t = Fr.parseToTagConfig(this.props.text, this.props.parseOption);
        return $t("span", {
          className: Lr
        }, t.map(function (t) {
          var r;
          return null !== (r = null == Hr ? void 0 : Hr[t.tagName](t, e.props.theme)) && void 0 !== r ? r : null;
        }));
      }
    }]), r;
  }(),
  Wr = d(function (e) {
    !function () {
      var t = {}.hasOwnProperty;
      function r() {
        for (var e = [], n = 0; n < arguments.length; n++) {
          var o = arguments[n];
          if (o) {
            var a = _typeof(o);
            if ("string" === a || "number" === a) e.push(this && this[o] || o);else if (Array.isArray(o)) e.push(r.apply(this, o));else if ("object" === a) if (o.toString === Object.prototype.toString) for (var i in o) {
              t.call(o, i) && o[i] && e.push(this && this[i] || i);
            } else e.push(o.toString());
          }
        }
        return e.join(" ");
      }
      e.exports ? (r["default"] = r, e.exports = r) : window.classNames = r;
    }();
  }),
  Ur = {
    tooltipWrapper: "paymentSdk_tooltipWrapper_4fd2d847",
    tooltip: "paymentSdk_tooltip_4fd2d847",
    tooltipWrap: "paymentSdk_tooltipWrap_4fd2d847",
    tooltipShow: "paymentSdk_tooltipShow_4fd2d847",
    tooltipContent: "paymentSdk_tooltipContent_4fd2d847",
    tooltipThemeDark: "paymentSdk_tooltipThemeDark_4fd2d847",
    tooltipThemeWhite: "paymentSdk_tooltipThemeWhite_4fd2d847"
  };
function Gr(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Kr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Gr(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Gr(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function qr(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var zr,
  Zr,
  $r = Wr.bind(Ur);
!function (e) {
  e.Dark = "dark", e.White = "white";
}(zr || (zr = {})), function (e) {
  e.Click = "click", e.Hover = "hover";
}(Zr || (Zr = {}));
var Jr = function (e) {
  _(r, Yt);
  var t = qr(r);
  function r() {
    return n(this, r), t.apply(this, arguments);
  }
  return s(r, [{
    key: "getTheme",
    value: function value() {
      var e = this.props.theme,
        t = {
          extend: zr.Dark
        };
      return "string" == typeof e ? t.extend = e : Object.assign(t, e), t;
    }
  }, {
    key: "componentDidCatch",
    value: function value(e) {
      ke.reportError(e, "Tooltip_Content_componentDidCatch_error");
    }
  }, {
    key: "stopBubble",
    value: function value(e) {
      e.stopPropagation();
    }
  }, {
    key: "getTooltipPosition",
    value: function value() {
      var e = this.props,
        t = e.triggerAbsPos,
        r = e.isAutoCenter,
        n = e.placement,
        o = e.containerAbsPos,
        a = e.isAutoInsideContainer,
        i = this.getTheme();
      if (!r && a && i.width && o) {
        var s = t.left - o.left,
          c = o.right - t.right,
          u = parseFloat(i.width) / 2;
        return s < u ? {
          left: "-".concat(s, "px"),
          right: "auto"
        } : c < u ? {
          left: "auto",
          right: "-".concat(c, "px")
        } : {};
      }
      if (!r || !n.includes("top") && !n.includes("bottom")) return {};
      var l = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        p = o ? o.width : l - 20,
        d = {
          width: "".concat(p, "px")
        };
      if (t.left < 10) d.left = "0", d.right = "auto";else if (l - t.right < 10) d.right = "0", d.left = "auto";else {
        var f;
        d.left = "".concat(-(t.left - (null !== (f = null == o ? void 0 : o.left) && void 0 !== f ? f : 10)), "px"), d.right = "auto";
      }
      return d;
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
        t = this.props,
        r = t.title,
        n = t.placement,
        o = t.content,
        a = t.triggerAbsPos,
        i = t.trigger,
        s = t.isShowTooltip,
        c = t.onHideTooltip;
      if (!r && !o) return null;
      var u = this.getTheme(),
        l = this.getTooltipPosition();
      return $t("div", {
        dir: u.rtl ? "rtl" : "ltr",
        className: $r({
          tooltip: !0,
          tooltipTriggerHover: i === Zr.Hover,
          tooltipTriggerClick: i === Zr.Click,
          tooltipThemeDark: u.extend === zr.Dark,
          tooltipThemeWhite: u.extend === zr.White,
          tooltipShow: s
        }),
        "data-placement": n,
        style: {
          width: "".concat(a.width, "px"),
          height: "".concat(a.height, "px"),
          left: "".concat(a.left, "px"),
          top: "".concat(a.top, "px"),
          borderColor: u.background
        },
        onClick: i === Zr.Click ? function (t) {
          return e.stopBubble(t);
        } : void 0,
        onMouseLeave: i === Zr.Hover ? function () {
          return c();
        } : void 0
      }, $t("div", {
        className: Ur.tooltipWrap,
        style: {
          width: l.width || u.width,
          borderRadius: u.borderRadius,
          background: u.background,
          color: u.fontColor,
          lineHeight: u.lineHeight,
          left: l.left,
          right: l.right
        }
      }, $t("div", {
        className: Ur.tooltipContent,
        style: {
          overflowY: u.maxHeight ? "scroll" : void 0,
          maxHeight: u.maxHeight,
          padding: u.padding
        }
      }, o || $t(Vr, {
        text: r,
        theme: u
      }))));
    }
  }]), r;
}();
c(Jr, "defaultProps", {
  title: "",
  placement: "topLeft",
  theme: zr.Dark
});
var Xr,
  Yr = function (e) {
    _(r, Yt);
    var t = qr(r);
    function r() {
      var e;
      n(this, r);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) {
        a[i] = arguments[i];
      }
      return c(w(e = t.call.apply(t, [this].concat(a))), "CONTAINER_DOM", void 0), c(w(e), "isShowTooltip", void 0), c(w(e), "removeEventListeners", []), c(w(e), "getTriggerDomPos", function () {
        var t,
          r,
          n = (e.base instanceof Element ? e.base : e.base.parentNode).getBoundingClientRect(),
          o = null !== (t = null !== (r = window.scrollY) && void 0 !== r ? r : window.pageYOffset) && void 0 !== t ? t : document.documentElement.scrollTop;
        return {
          width: n.width,
          height: n.height,
          right: n.right,
          left: n.x || n.left,
          top: (n.y || n.top) + o
        };
      }), c(w(e), "renderTooltip", function () {
        e.base && yr($t(Jr, Kr(Kr({}, e.props), {}, {
          triggerAbsPos: e.getTriggerDomPos(),
          isShowTooltip: e.isShowTooltip,
          onHideTooltip: e.hideTooltip
        })), e.CONTAINER_DOM);
      }), c(w(e), "handleResize", function () {
        e.isShowTooltip && e.renderTooltip();
      }), c(w(e), "showTooltip", function (t) {
        t.stopPropagation(), e.isShowTooltip = !0, e.renderTooltip();
      }), c(w(e), "hideTooltip", function () {
        e.isShowTooltip = !1, e.renderTooltip();
      }), e;
    }
    return s(r, [{
      key: "componentDidCatch",
      value: function value(e) {
        ke.reportError(e, "Tooltip_componentDidCatch_error");
      }
    }, {
      key: "createContainer",
      value: function value() {
        if (!this.CONTAINER_DOM) {
          var e = document.createElement("DIV");
          e.className = Ur.tooltipWrapper, document.body.appendChild(e), this.CONTAINER_DOM = e;
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        He(this.CONTAINER_DOM), this.removeEventListeners && this.removeEventListeners.length > 0 && this.removeEventListeners.forEach(function (e) {
          return e();
        });
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        this.base && (this.createContainer(), this.addEventListeners());
      }
    }, {
      key: "addEventListeners",
      value: function value() {
        var e = this;
        this.props.trigger === Zr.Click ? (this.base.addEventListener("click", this.showTooltip), document.addEventListener("click", this.hideTooltip), this.removeEventListeners.push(function () {
          return e.base.removeEventListener("click", e.showTooltip);
        }), this.removeEventListeners.push(function () {
          return document.removeEventListener("click", e.hideTooltip);
        })) : this.props.trigger === Zr.Hover && (this.base.addEventListener("mouseover", this.showTooltip), this.removeEventListeners.push(function () {
          return e.base.removeEventListener("mouseover", e.showTooltip);
        }));
      }
    }, {
      key: "render",
      value: function value() {
        return this.renderTooltip(), $t(br, {
          triggerSize: !0,
          onResize: this.handleResize
        }, this.props.children);
      }
    }]), r;
  }();
c(Yr, "defaultProps", {
  trigger: Zr.Hover,
  isAutoInsideContainer: !1
}), function (e) {
  e[e.PAYOFF = 0] = "PAYOFF", e[e.ONE = 1] = "ONE", e[e.MULTIPLE = 2] = "MULTIPLE";
}(Xr || (Xr = {}));
var Qr = "0";
function en(e, t) {
  for (var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, n = e.length; r < n; r++) {
    var o = e[r];
    if ("function" == typeof t) {
      if (o === t(o, r, e)) return r;
    } else if (o === t) return r;
  }
  return -1;
}
function tn(e) {
  return !e || !Array.isArray(e) || !e.length;
}
var rn = function rn(e) {
  return "[object Array]" === Object.prototype.toString.call(e);
};
function nn(e) {
  return !(!rn(e) || !e.length);
}
function on(e, t) {
  if (nn(e)) {
    if (null != t && t.length) return t.filter(function (e) {
      return !!e.supportCount;
    });
    ke.reportErrorData("cashier_check_installment_error", {
      installmentCounts: e
    });
  }
  return null;
}
var an = function an(e) {
  var t;
  return (null == e ? void 0 : e.length) > 1 ? Xr.MULTIPLE : 1 === (null == e ? void 0 : e.length) && (null == e || null === (t = e[0]) || void 0 === t ? void 0 : t.count) !== Qr ? Xr.ONE : Xr.PAYOFF;
};
function sn(e) {
  if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
}
function cn(e) {
  return function (e) {
    if (Array.isArray(e)) return ht(e);
  }(e) || sn(e) || vt(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var un = {
  AED: "د.إ(*)",
  AUD: "A$(*)",
  CNY: "CN¥(*)",
  EUR: "€(*)",
  GBP: "£(*)",
  HKD: "HK$(*)",
  JPY: "JP¥(*)",
  MYR: "RM(*)",
  SGD: "S$(*)",
  THB: "฿(*)",
  TWD: "NT$(*)",
  USD: "US$(*)",
  VND: "(*) ₫"
};
function ln(e, t) {
  return pn.apply(this, arguments);
}
function pn() {
  return pn = l(b.mark(function e(t, r) {
    var n, o, a, i, s, c, u, l, p, d, f, h, v, y, m, g;
    return b.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.next = 2, t.get(["installmentCount", "installmentDesc1", "installmentDesc2", "installmentDesc3", "installmentSelect", "installmentDiff", "installmentSelectParm", "installmentSupportContentTip", "installmentSupportTip", "installmentSupportBank", "installmentBankSeparator"].concat(cn(r)));
          case 2:
            return n = e.sent, o = ft(b = n) || sn(b) || vt(b) || yt(), a = o[0], i = o[1], s = o[2], c = o[3], u = o[4], l = o[5], p = o[6], d = o[7], f = o[8], h = o[9], v = o[10], y = o.slice(11), m = {
              installmentCount: a,
              installmentDesc1: i,
              installmentDesc2: s,
              installmentDesc3: c,
              installmentSelect: u,
              installmentDiff: l,
              installmentSelectParm: p,
              installmentSupportContentTip: d,
              installmentSupportTip: f,
              installmentBankSeparator: v,
              installmentBank: h
            }, y && y.length && (g = {}, r.forEach(function (e, t) {
              return g[e] = y[t] || "";
            }), m.installmentBankNames = g), e.abrupt("return", m);
          case 19:
          case "end":
            return e.stop();
        }
      }
      var b;
    }, e);
  })), pn.apply(this, arguments);
}
function dn(e) {
  return e ? "banks.".concat(e.toLocaleUpperCase().replace(/\s/g, "_")) : "";
}
function fn(e) {
  if (!e || !e.length) return [];
  var t = {};
  return e.forEach(function (e) {
    e && e.supportIssueBank && e.supportIssueBank.length && e.supportIssueBank.forEach(function (e) {
      var r = dn(e);
      r && !t[r] && (t[r] = !0);
    });
  }), Object.keys(t);
}
var hn = function hn(e, t) {
  var r = e.count,
    n = e.installDownpay,
    o = e.installpay,
    a = r === Qr ? n : o;
  return a = function (e, t) {
    var r = t,
      n = un[e];
    return n ? n.replace("(*)", r) : "".concat(e).concat(r);
  }(t, a), {
    money: a,
    count: r
  };
};
function vn(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var yn = Wr.bind(_r),
  mn = function (e) {
    _(r, Yt);
    var t = vn(r);
    function r(e) {
      var o;
      return n(this, r), c(w(o = t.call(this, e)), "installmentType", void 0), c(w(o), "headerRef", void 0), c(w(o), "state", {
        isBigSizeView: !1
      }), c(w(o), "handleResize", function (e) {
        var t = {
          isBigSizeView: e
        };
        o.setState(t);
      }), o.installmentType = an(o.props.installmentInfoList), o.headerRef = {
        current: null
      }, o;
    }
    return s(r, [{
      key: "componentDidCatch",
      value: function value(e) {
        ke.reportError(e, "InstallmentSelect_componentDidCatch_error");
      }
    }, {
      key: "getBankNames",
      value: function value(e, t, r) {
        return tn(e) ? "" : e.map(function (e) {
          var r = dn(e);
          return (null == t ? void 0 : t[r]) || "";
        }).filter(function (e) {
          return !!e.trim();
        }).join(r);
      }
    }, {
      key: "getRightTooltipContent",
      value: function value() {
        var e = this,
          t = this.props,
          r = t.language,
          n = t.installmentCapabilities;
        if (tn(n)) return null;
        var o = n.map(function (t) {
          if (!t) return "";
          var n,
            o,
            a = e.getBankNames(t.supportIssueBank, r.installmentBankNames, r.installmentBankSeparator);
          return a ? (n = r.installmentBank, o = {
            variable: {
              period: t.period,
              banks: a
            }
          }, Tr(n, null == o ? void 0 : o.variable, null == o ? void 0 : o.handleVariable)) : "";
        }).filter(function (e) {
          return !!e.trim();
        }).join("\n").trim();
        return o ? $t("div", null, $t("div", {
          className: _r.supportTipContentTitle
        }, r.installmentSupportContentTip), $t("div", {
          className: _r.supportTipContentTitleSm
        }, r.installmentDiff), $t("div", null, $t(Vr, {
          text: "$RT$".concat(o)
        }))) : null;
      }
    }, {
      key: "parseHint",
      value: function value() {
        var e = this.props,
          t = e.language,
          r = e.installmentInfoList,
          n = e.currency,
          o = e.isPci,
          a = this.installmentType;
        if (a === Xr.PAYOFF) return {};
        var i = {
          leftHint: "",
          leftHintParseOption: {},
          leftTooltip: "$RT$".concat(t.installmentDesc1, "\n").concat(t.installmentDesc2, "\n").concat(t.installmentDesc3),
          rightHint: "",
          rightTooltipContent: null
        };
        if (a === Xr.ONE) {
          var s = r[0],
            c = hn(s, n),
            u = c.count,
            l = c.money;
          i.leftHint = "$RT$".concat(t.installmentSelectParm), i.leftHintParseOption = {
            variable: {
              count: u,
              money: l
            },
            handleVariable: function handleVariable(e) {
              return "**".concat(e, "**");
            }
          };
        } else a === Xr.MULTIPLE && (i.leftHint = t.installmentSelect);
        return o && (i.rightHint = t.installmentSupportTip, i.rightHint && (i.rightTooltipContent = this.getRightTooltipContent())), i;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.needAdaptive,
          r = e.isPci,
          n = e.theme,
          o = this.state.isBigSizeView,
          a = this.parseHint(),
          i = {
            fontColor: null == n ? void 0 : n.headerFontColor
          },
          s = this.headerRef.current ? this.headerRef.current.getBoundingClientRect() : null;
        return $t(br, {
          triggerSize: t,
          onResize: this.handleResize
        }, $t("div", {
          className: yn({
            InstallmentHeaderContainer: !0,
            InstallmentHeaderSmallContainer: !o
          }),
          ref: this.headerRef
        }, a.leftHint && $t("div", {
          className: _r.InstallmentHeaderLeftContent
        }, $t(Vr, {
          text: a.leftHint,
          parseOption: a.leftHintParseOption,
          theme: i
        }), a.leftTooltip && $t(Yr, {
          placement: null != n && n.rtl ? "topLeft" : "topRight",
          title: a.leftTooltip,
          theme: {
            width: "290px",
            rtl: null == n ? void 0 : n.rtl
          },
          isAutoCenter: !o,
          containerAbsPos: s
        }, $t("span", {
          className: _r.InstallmentHeaderQuesIcon,
          style: {
            color: null == n ? void 0 : n.quesIconColor
          }
        }, $t(wr, null)))), r && a.rightHint && $t("div", {
          className: _r.InstallmentHeaderRightContent
        }, $t(Vr, {
          text: a.rightHint,
          theme: i
        }), a.rightTooltipContent && $t(Yr, {
          placement: null != n && n.rtl ? "bottomRight" : "bottomLeft",
          content: a.rightTooltipContent,
          theme: {
            extend: zr.White,
            maxHeight: "228px",
            width: "375px",
            padding: "16px 20px 20px 20px",
            rtl: null == n ? void 0 : n.rtl
          },
          isAutoCenter: !o,
          containerAbsPos: s
        }, $t("span", {
          className: _r.InstallmentHeaderInfoIcon,
          style: {
            color: null == n ? void 0 : n.infoIconColor
          }
        }, $t(Cr, null))))));
      }
    }]), r;
  }();
c(mn, "defaultProps", {
  needAdaptive: !0
});
var gn = {
    selectContainer: "paymentSdk_selectContainer_968190ac",
    selectWrap: "paymentSdk_selectWrap_968190ac",
    selectErrorMsg: "paymentSdk_selectErrorMsg_968190ac",
    selectErrorMsgShow: "paymentSdk_selectErrorMsgShow_968190ac",
    selectDropdown: "paymentSdk_selectDropdown_968190ac",
    selectDropdownOpen: "paymentSdk_selectDropdownOpen_968190ac"
  },
  bn = {
    selectLabelWrap: "paymentSdk_selectLabelWrap_8259298b",
    selectPlaceholder: "paymentSdk_selectPlaceholder_8259298b",
    rightArea: "paymentSdk_rightArea_8259298b",
    selectDividingLine: "paymentSdk_selectDividingLine_8259298b",
    selectIcon: "paymentSdk_selectIcon_8259298b",
    selectOptionImg: "paymentSdk_selectOptionImg_8259298b"
  },
  kn = function kn(e) {
    return $t("svg", kr({}, e, {
      width: "9",
      height: "6",
      viewBox: "0 0 9 6",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }), $t("path", {
      d: "M1.23682 1.5L4.73682 5L8.23682 1.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      fill: "none"
    }));
  },
  wn = /(left|Left|right|Right)/,
  Cn = /^(margin|padding)$/gi,
  _n = {
    left: "right",
    Left: "Right",
    right: "left",
    Right: "Left"
  },
  On = /calc\(.*?\)/g,
  Pn = function Pn(e) {
    if (!(arguments.length > 1 && void 0 !== arguments[1] && arguments[1])) return e;
    var t = {};
    return Object.entries(e).forEach(function (e) {
      var r = mt(e, 2),
        n = r[0],
        o = r[1],
        a = n,
        i = o;
      n.match(wn) ? a = a.replace(wn, function (e) {
        return _n[e];
      }) : n.match(Cn) && (i = function (e) {
        var t = e,
          r = (t = t.replace(On, function (e) {
            return e.replace(/\s+/g, "$");
          })).split(/\s+/),
          n = mt(r, 4),
          o = n[0],
          a = n[1],
          i = n[2],
          s = n[3];
        return 4 === r.length && a !== s && (t = "".concat(o, " ").concat(s, " ").concat(i, " ").concat(a)), t.replace(/\$/g, " ");
      }(o)), t[a] = i;
    }), t;
  },
  xn = Wr.bind({
    formItemContainer: "paymentSdk_formItemContainer_2af67d95",
    none: "paymentSdk_none_2af67d95",
    blockEnd: "paymentSdk_blockEnd_2af67d95",
    error: "paymentSdk_error_2af67d95",
    focused: "paymentSdk_focused_2af67d95"
  });
function In(e) {
  var t = e.isFocused,
    r = e.theme,
    n = e.isError,
    o = e.children;
  return $t("div", {
    className: xn({
      formItemContainer: !0,
      focused: t,
      error: n,
      none: "none" === (null == r ? void 0 : r.borderType),
      blockEnd: "block_end" === (null == r ? void 0 : r.borderType)
    }),
    style: {
      color: t ? null == r ? void 0 : r.focusBorderColor : n ? null == r ? void 0 : r.errorBorderColor : null == r ? void 0 : r.borderColor,
      height: null == r ? void 0 : r.height,
      backgroundColor: null == r ? void 0 : r.background,
      borderRadius: null == r ? void 0 : r.borderRadius
    }
  }, o);
}
function Sn(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Dn = Wr.bind(bn),
  Rn = function (e) {
    _(r, Yt);
    var t = Sn(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "getDisplayOptionComponent",
      value: function value() {
        var e = this.props.displayOption;
        return e ? $t(Xt, null, e.img && $t("img", {
          src: e.img,
          className: bn.selectOptionImg
        }), e.label && $t(Vr, {
          text: e.label,
          parseOption: e.labelParseOption
        })) : null;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.displayOption,
          r = e.placeholder,
          n = e.isError,
          o = e.theme,
          a = !t;
        return $t(In, {
          isError: n,
          theme: {
            errorBorderColor: null == o ? void 0 : o.selectErrorBorderColor,
            borderColor: null == o ? void 0 : o.selectBorderColor,
            background: null == o ? void 0 : o.selectBackground,
            height: null == o ? void 0 : o.selectHeight,
            borderRadius: null == o ? void 0 : o.selectBorderRadius,
            borderType: null == o ? void 0 : o.selectBorderType
          }
        }, $t("div", {
          className: Dn({
            selectLabelWrap: !0,
            selectPlaceholder: a
          }),
          style: Pn({
            color: a ? null == o ? void 0 : o.selectPlaceholderFontColor : null == o ? void 0 : o.selectFontColor,
            paddingTop: null == o ? void 0 : o.selectPaddingTop,
            paddingRight: null == o ? void 0 : o.selectPaddingRight,
            paddingBottom: null == o ? void 0 : o.selectPaddingBottom,
            paddingLeft: null == o ? void 0 : o.selectPaddingLeft
          }, null == o ? void 0 : o.rtl)
        }, a ? r : this.getDisplayOptionComponent()), $t("div", {
          className: bn.rightArea,
          style: Pn({
            right: null == o ? void 0 : o.selectPaddingRight
          }, null == o ? void 0 : o.rtl)
        }, null != o && o.selectDividingLineColor ? $t("div", {
          className: bn.selectDividingLine,
          style: Pn({
            borderLeftColor: null == o ? void 0 : o.selectDividingLineColor
          }, null == o ? void 0 : o.rtl)
        }) : null, $t("div", {
          className: bn.selectIcon,
          style: {
            color: null == o ? void 0 : o.selectIconColor
          }
        }, $t(kn, null))));
      }
    }]), r;
  }(),
  En = {
    selectOptionWrap: "paymentSdk_selectOptionWrap_0091ebf6",
    selectOptionDisabled: "paymentSdk_selectOptionDisabled_0091ebf6",
    selectOptionActive: "paymentSdk_selectOptionActive_0091ebf6",
    selectOptionContent: "paymentSdk_selectOptionContent_0091ebf6",
    selectOptionContentColumn: "paymentSdk_selectOptionContentColumn_0091ebf6",
    selectOptionLabel: "paymentSdk_selectOptionLabel_0091ebf6",
    selectOptionImg: "paymentSdk_selectOptionImg_0091ebf6",
    selectOptionDescription: "paymentSdk_selectOptionDescription_0091ebf6"
  };
function Tn(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var An = Wr.bind(En),
  Ln = function (e) {
    _(r, Yt);
    var t = Tn(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "getOption",
      value: function value(e) {
        var t = this,
          r = this.props,
          n = r.theme,
          o = r.displayOption,
          a = r.isContentColumn,
          i = (null == o ? void 0 : o.value) === e.value,
          s = e.disabled,
          c = {
            color: null == n ? void 0 : n.optionsFontColor,
            background: null == n ? void 0 : n.optionsBackground
          };
        return s ? (c.color = null == n ? void 0 : n.optionsDisabledFontColor, c.background = null == n ? void 0 : n.optionsDisabledBackground) : i && (c.color = (null == n ? void 0 : n.optionsActiveFontColor) || (null == n ? void 0 : n.optionsFontColor), c.background = (null == n ? void 0 : n.optionsActiveBackground) || (null == n ? void 0 : n.optionsBackground)), $t("div", {
          className: An({
            selectOptionWrap: !0,
            selectOptionDisabled: s,
            selectOptionActive: i
          }),
          style: c,
          onClick: s ? void 0 : function () {
            return t.props.onSelectOption(e);
          }
        }, e.img && $t("img", {
          className: En.selectOptionImg,
          src: e.img
        }), $t("div", {
          className: An({
            selectOptionContent: !0,
            selectOptionContentColumn: a
          })
        }, e.label && $t("div", {
          className: En.selectOptionLabel
        }, $t(Vr, {
          text: e.label,
          parseOption: e.labelParseOption
        })), e.description && $t("div", {
          className: En.selectOptionDescription,
          style: {
            color: null == n ? void 0 : n.optionsDescriptionFontColor
          }
        }, e.description)));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this;
        return $t("div", null, this.props.optionList.map(function (t) {
          return e.getOption(t);
        }));
      }
    }]), r;
  }(),
  jn = Wr.bind({
    formItemLabel: "paymentSdk_formItemLabel_9c87f3ed",
    inside: "paymentSdk_inside_9c87f3ed",
    outside: "paymentSdk_outside_9c87f3ed",
    stepAside: "paymentSdk_stepAside_9c87f3ed"
  });
function Nn(e) {
  var t = e.isStepAside,
    r = e.theme,
    n = e.label;
  if (!n) return null;
  var o = "outside" === r.position;
  return $t("label", {
    className: jn({
      formItemLabel: !0,
      stepAside: t,
      inside: !o,
      outside: o
    }),
    style: Pn({
      color: r.color,
      fontSize: t ? r.stepAsideFontSize : r.fontSize,
      top: t ? r.top : void 0,
      marginBottom: o ? r.gutter : void 0,
      left: r.left
    }, null == r ? void 0 : r.rtl)
  }, n);
}
function Bn(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Mn = Wr.bind(gn),
  Fn = function (e) {
    _(r, Yt);
    var t = Bn(r);
    function r() {
      var e;
      n(this, r);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) {
        a[i] = arguments[i];
      }
      return c(w(e = t.call.apply(t, [this].concat(a))), "state", {
        isShowDropdown: !1,
        isBigSizeView: !1,
        displayOption: null,
        errorMsg: "",
        isError: !1
      }), c(w(e), "clickOutsideCloseDropdown", function () {
        e.hideDropdown();
      }), c(w(e), "handleResize", function (t) {
        e.setState({
          isBigSizeView: t
        });
      }), c(w(e), "toggleDropdown", function () {
        e.setState({
          isShowDropdown: !e.state.isShowDropdown,
          errorMsg: "",
          isError: !1
        });
      }), c(w(e), "hideDropdown", function () {
        e.setState({
          isShowDropdown: !1
        });
      }), c(w(e), "selectOption", function (t) {
        var r,
          n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        e.hideDropdown(), (n || (null == t ? void 0 : t.value) !== (null === (r = e.state.displayOption) || void 0 === r ? void 0 : r.value)) && (e.setState({
          displayOption: t
        }), e.props.onChange(t));
      }), c(w(e), "showError", function (t) {
        e.setState({
          isError: !0,
          errorMsg: t
        });
      }), c(w(e), "removeError", function () {
        e.setState({
          isError: !1,
          errorMsg: ""
        });
      }), e;
    }
    return s(r, [{
      key: "componentWillReceiveProps",
      value: function value(e) {
        var t,
          r,
          n = e.optionList,
          o = this.props.optionList,
          a = this.state.displayOption;
        if (o.length !== n.length || (null === (t = o[0]) || void 0 === t ? void 0 : t.label) !== (null === (r = n[0]) || void 0 === r ? void 0 : r.label)) {
          var i = n.find(function (e) {
            return e.value === a.value;
          });
          i && this.selectOption(i, !0);
        }
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        document.addEventListener("click", this.clickOutsideCloseDropdown), this.props.defaultOption && this.selectOption(this.props.defaultOption);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        document.removeEventListener("click", this.clickOutsideCloseDropdown);
      }
    }, {
      key: "stopBubble",
      value: function value(e) {
        e.stopPropagation();
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
          t = this.props,
          r = t.needAdaptive,
          n = t.placeholder,
          o = t.optionList,
          a = t.theme,
          i = void 0 === a ? {} : a,
          s = this.state,
          c = s.isShowDropdown,
          u = s.isBigSizeView,
          l = s.displayOption,
          p = s.errorMsg,
          d = s.isError,
          f = "outside" === i.selectLabelPosition;
        return $t(br, {
          triggerSize: r,
          onResize: this.handleResize
        }, $t("div", {
          className: Mn({
            selectContainer: !0,
            selectMobileStyle: !u,
            selectPcStyle: u
          }),
          onClick: function onClick(t) {
            return e.stopBubble(t);
          }
        }, $t("div", {
          className: gn.selectWrap,
          onClick: function onClick() {
            return e.toggleDropdown();
          }
        }, f && $t(Nn, {
          label: n,
          theme: {
            position: i.selectLabelPosition,
            color: i.selectLabelColor || i.selectFontColor,
            gutter: i.selectLabelGutter
          }
        }), $t(Rn, {
          displayOption: l,
          placeholder: f ? void 0 : n,
          isError: d,
          theme: i
        })), $t("div", {
          className: Mn({
            selectDropdown: !0,
            selectDropdownOpen: c
          }),
          style: {
            maxHeight: c ? null == i ? void 0 : i.selectDropdownMaxHeight : void 0
          }
        }, $t(Ln, {
          optionList: o,
          displayOption: l,
          onSelectOption: function onSelectOption(t) {
            return e.selectOption(t);
          },
          isContentColumn: !u,
          theme: i
        }))), $t("div", {
          className: Mn({
            selectErrorMsg: !0,
            selectErrorMsgShow: !!p
          }),
          style: {
            color: null == i ? void 0 : i.selectErrorFontColor
          }
        }, p));
      }
    }]), r;
  }();
function Hn(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
c(Fn, "defaultProps", {
  needAdaptive: !0
});
var Vn = function (e) {
    _(r, Yt);
    var t = Hn(r);
    function r(e) {
      var o;
      return n(this, r), c(w(o = t.call(this, e)), "installmentType", void 0), c(w(o), "optionList", void 0), o.updateInstallmentInfoList(e.installmentInfoList), o;
    }
    return s(r, [{
      key: "updateInstallmentInfoList",
      value: function value(e) {
        var t = an(e),
          r = this.getOptionList(e),
          n = this.props.onChange;
        t === Xr.PAYOFF ? n({
          value: Qr,
          label: Qr
        }) : t === Xr.ONE && n(r[0]), this.setState({
          optionList: r,
          installmentType: t
        });
      }
    }, {
      key: "componentWillReceiveProps",
      value: function value(e) {
        var t = this.props.installmentInfoList,
          r = e.installmentInfoList;
        r.length === t.length && r[0].installDownpay == t[0].installDownpay && r[0].installpay == t[0].installpay || this.updateInstallmentInfoList(r);
      }
    }, {
      key: "componentDidCatch",
      value: function value(e) {
        ke.reportError(e, "InstallmentSelect_componentDidCatch_error");
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        var e = this.props.onChange;
        this.installmentType === Xr.PAYOFF ? e({
          value: Qr,
          label: Qr
        }) : this.installmentType === Xr.ONE && e(this.optionList[0]);
      }
    }, {
      key: "getOptionList",
      value: function value(e) {
        var t = this.props,
          r = t.currency,
          n = t.language;
        return e.map(function (e) {
          var t = hn(e, r),
            o = t.count,
            a = t.money,
            i = "$RT$ ".concat(a);
          return o !== Qr && (i += " x ".concat(n.installmentCount)), {
            value: o,
            label: i.trim(),
            labelParseOption: {
              variable: {
                number: o
              }
            },
            disabled: !e.supportCount
          };
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.onChange,
          r = e.theme,
          n = this.state,
          o = n.optionList;
        return n.installmentType !== Xr.MULTIPLE ? null : $t(Fn, {
          onChange: t,
          optionList: o,
          defaultOption: o[0],
          theme: r
        });
      }
    }]), r;
  }(),
  Wn = "paymentSdk_skeletonContainer_7346677b";
function Un(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Gn = function (e) {
    _(r, Yt);
    var t = Un(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "render",
      value: function value() {
        var e = this.props.theme;
        return $t("div", {
          style: {
            width: null == e ? void 0 : e.width,
            height: null == e ? void 0 : e.height,
            background: null == e ? void 0 : e.background,
            borderRadius: null == e ? void 0 : e.borderRadius
          },
          className: Wn
        });
      }
    }]), r;
  }(),
  Kn = {
    InstallmentContainer: "paymentSdk_InstallmentContainer_4aaebcb8",
    InstallmentHeader: "paymentSdk_InstallmentHeader_4aaebcb8",
    InstallmentSelect: "paymentSdk_InstallmentSelect_4aaebcb8",
    InstallmentContentLoading: "paymentSdk_InstallmentContentLoading_4aaebcb8",
    InstallmentPci: "paymentSdk_InstallmentPci_4aaebcb8"
  };
function qn(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var zn = Wr.bind(Kn),
  Zn = function (e) {
    _(r, Yt);
    var t = qn(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "getSkeleton",
      value: function value(e) {
        var t,
          r = {
            height: e,
            borderRadius: null === (t = this.props.theme) || void 0 === t ? void 0 : t.selectBorderRadius
          };
        return $t(Gn, {
          theme: r
        });
      }
    }, {
      key: "componentDidCatch",
      value: function value(e) {
        ke.reportError(e, "Installment_Layout_componentDidCatch_error");
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.isLoaded,
          r = e.theme,
          n = e.header,
          o = e.select;
        return $t("div", {
          className: zn({
            InstallmentContainer: !0,
            InstallmentContentLoading: !t
          })
        }, n && $t("div", {
          className: Kn.InstallmentHeader,
          style: {
            marginTop: null == r ? void 0 : r.formItemGutter,
            marginBottom: null == r ? void 0 : r.formItemGutter
          }
        }, t ? n : this.getSkeleton()), o && $t("div", {
          className: Kn.InstallmentSelect,
          style: {
            marginBottom: null == r ? void 0 : r.formItemGutter
          }
        }, t ? o : this.getSkeleton(null == r ? void 0 : r.selectHeight)));
      }
    }]), r;
  }();
function $n(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Jn = function (e) {
  _(o, Yt);
  var t,
    r = $n(o);
  function o() {
    var e;
    n(this, o);
    for (var t = arguments.length, a = new Array(t), i = 0; i < t; i++) {
      a[i] = arguments[i];
    }
    return c(w(e = r.call.apply(r, [this].concat(a))), "state", {
      isLoaded: !1,
      language: null
    }), e;
  }
  return s(o, [{
    key: "componentDidMount",
    value: function value() {
      this.getLanguage();
    }
  }, {
    key: "getLanguage",
    value: (t = l(b.mark(function e() {
      var t, r;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, ln(this.props.i18n, fn(null === (t = this.props.merchantCapability) || void 0 === t ? void 0 : t.installmentCapabilities));
            case 2:
              r = e.sent, this.setState({
                isLoaded: !0,
                language: r
              });
            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "render",
    value: function value() {
      var e = this.state,
        t = e.isLoaded,
        r = e.language,
        n = this.props,
        o = n.theme,
        a = n.onChange,
        i = n.installments,
        s = n.merchantCapability,
        c = n.currency,
        u = n.needAdaptive;
      return $t(Zn, {
        isLoaded: t,
        theme: o,
        header: $t(mn, {
          language: r,
          installmentInfoList: i,
          installmentCapabilities: null == s ? void 0 : s.installmentCapabilities,
          currency: c,
          needAdaptive: u,
          theme: o
        }),
        select: $t(Vn, {
          installmentInfoList: i,
          language: r,
          currency: c,
          onChange: a,
          theme: o
        })
      });
    }
  }]), o;
}();
function Xn(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Yn = Wr.bind({
    simpleContainer: "paymentSdk_simpleContainer_9d4d2712",
    simpleImg: "paymentSdk_simpleImg_9d4d2712",
    simpleDescription: "paymentSdk_simpleDescription_9d4d2712"
  }),
  Qn = function (e) {
    _(r, Yt);
    var t = Xn(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "componentDidCatch",
      value: function value(e) {
        ke.reportError(e, "Simple_componentDidCatch_error");
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.imgUrl,
          r = e.description,
          n = e.theme;
        return $t("div", {
          className: Yn({
            simpleContainer: !0
          })
        }, t && $t("img", {
          src: t,
          className: Yn({
            simpleImg: !0
          })
        }), r && $t("div", {
          className: Yn({
            simpleDescription: !0
          })
        }, $t(Vr, {
          text: r,
          theme: n
        })));
      }
    }]), r;
  }();
function eo(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var to = function (e) {
  _(a, Yt);
  var t,
    r,
    o = eo(a);
  function a() {
    var e;
    n(this, a);
    for (var t = arguments.length, r = new Array(t), i = 0; i < t; i++) {
      r[i] = arguments[i];
    }
    return c(w(e = o.call.apply(o, [this].concat(r))), "state", {
      isLoaded: !1,
      language: {
        description: ""
      }
    }), e;
  }
  return s(a, [{
    key: "componentDidMount",
    value: function value() {
      this.getLanguage();
    }
  }, {
    key: "componentDidCatch",
    value: function value(e) {
      ke.reportError(e, "SimpleContainer_componentDidCatch_error");
    }
  }, {
    key: "getLanguage",
    value: (r = l(b.mark(function e() {
      var t, r, n, o, a;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t = this.props.initResult.paymentMethodInfo || {}, r = t.cashierNotice, n = this.props.i18n, !(o = null == r ? void 0 : r.guideI18nKey)) {
                e.next = 9;
                break;
              }
              return e.next = 6, n.get(o);
            case 6:
              e.t0 = e.sent, e.next = 10;
              break;
            case 9:
              e.t0 = "";
            case 10:
              a = e.t0, this.setState({
                isLoaded: !0,
                language: {
                  description: a
                }
              });
            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return r.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (t = l(b.mark(function e() {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "needUserAction",
    value: function value() {
      return !1;
    }
  }, {
    key: "render",
    value: function value() {
      var e,
        t = this.props,
        r = t.initResult,
        n = t.initData,
        o = (r.paymentMethodInfo || {}).image,
        a = this.state,
        i = a.isLoaded,
        s = a.language;
      return (o || s.description) && i ? $t(Qn, {
        imgUrl: o,
        description: s.description,
        theme: null === (e = n.theme) || void 0 === e ? void 0 : e.simple
      }) : null;
    }
  }]), a;
}();
function ro(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function no(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ro(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ro(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var oo = function () {
    function e() {
      n(this, e), c(this, "componentRef", {
        current: null
      }), c(this, "installmentCount", void 0), c(this, "installmentType", void 0);
    }
    var t;
    return s(e, [{
      key: "getRenderer",
      value: function value() {
        var e = this;
        return {
          content: function content(t) {
            var r,
              n,
              o,
              a,
              i = on(t.initData.installmentCounts, null === (r = t.initResult) || void 0 === r ? void 0 : r.installments),
              s = an(t.initResult.installments);
            return e.installmentType = s, s === Xr.PAYOFF ? $t(to, {
              ref: e.componentRef,
              i18n: t.i18n,
              initData: t.initData,
              initResult: t.initResult
            }) : $t(Jn, {
              ref: e.componentRef,
              env: t.env,
              i18n: t.i18n,
              currency: t.initData.currency,
              needAdaptive: t.initData.needAdaptive,
              theme: no(no({}, null === (n = t.initData.theme) || void 0 === n ? void 0 : n["default"]), null === (o = t.initData.theme) || void 0 === o ? void 0 : o.installment),
              installments: i,
              merchantCapability: null === (a = t.initResult) || void 0 === a ? void 0 : a.merchantCapability,
              onChange: function onChange(t) {
                return e.installmentCount = t.value;
              }
            });
          }
        };
      }
    }, {
      key: "needUserAction",
      value: function value() {
        return this.installmentType === Xr.MULTIPLE;
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.installmentType !== Xr.PAYOFF) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return", !0);
              case 2:
                if (this.installmentCount) {
                  e.next = 4;
                  break;
                }
                return e.abrupt("return", !1);
              case 4:
                return e.abrupt("return", !0);
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }]), e;
  }(),
  ao = function () {
    function e() {
      n(this, e), c(this, "renderer", new oo());
    }
    var t;
    return s(e, [{
      key: "getRenderer",
      value: function value() {
        return this.renderer.getRenderer();
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.renderer.validate());
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "needUserAction",
      value: function value() {
        return this.renderer.needUserAction();
      }
    }, {
      key: "getPayHooks",
      value: function value() {
        var e,
          t = this.renderer.installmentCount;
        return t ? {
          extendConfirmParams: (e = l(b.mark(function e() {
            return b.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", {
                      paymentMethodOptions: {
                        installments: {
                          count: t
                        }
                      }
                    });
                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function () {
            return e.apply(this, arguments);
          })
        } : {};
      }
    }]), e;
  }(),
  io = function () {
    function e() {
      n(this, e), c(this, "installmentUI", new ao());
    }
    var t, r;
    return s(e, [{
      key: "needRenderWidget",
      value: (r = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !0);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "getRenderer",
      value: function value() {
        return this.installmentUI.getRenderer();
      }
    }, {
      key: "needUserAction",
      value: function value() {
        return this.installmentUI.needUserAction();
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.installmentUI.validate());
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "getPayHooks",
      value: function value() {
        return this.installmentUI.getPayHooks();
      }
    }, {
      key: "destroy",
      value: function value() {
        this.installmentUI = null;
      }
    }]), e;
  }();
function so(e) {
  var t = e.initData,
    r = e.render,
    n = e.status,
    a = e.error,
    i = t.createCustomRenderer;
  if (ke.reportData("get_renderer_content_start"), !i || "function" != typeof i) return ke.reportData("get_renderer_content_end"), r;
  var s,
    c = $t("div", {
      ref: (s = l(b.mark(function e(r) {
        var s, c, u;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.prev = 0, s = {
                  paymentMetaData: Ye(t)
                }, a && (s.error = {
                  code: v.RenderFail,
                  msg: null !== (c = a.msg) && void 0 !== c ? c : y.InnerSDKError
                }), e.next = 5, i(n, s);
              case 5:
                u = e.sent, l = u, ("object" === ("undefined" == typeof HTMLElement ? "undefined" : o(HTMLElement)) ? l instanceof HTMLElement : l && "object" === o(l) && 1 === l.nodeType && "string" == typeof l.nodeName) && (r.innerHTML = "", r.appendChild(u)), e.next = 12;
                break;
              case 9:
                e.prev = 9, e.t0 = e["catch"](0), ke.reportErrorData("get_renderer_content_error", {
                  error: e.t0
                });
              case 12:
              case "end":
                return e.stop();
            }
          }
          var l;
        }, e, null, [[0, 9]]);
      })), function (e) {
        return s.apply(this, arguments);
      })
    }, r);
  return ke.reportData("get_renderer_content_end"), c;
}
function co(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function uo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? co(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : co(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var lo = function () {
  function e() {
    var t = this;
    n(this, e), c(this, "componentRef", {
      current: null
    }), c(this, "getRenderer", function () {
      return {
        content: function content(e) {
          return so({
            initData: e.initData,
            render: $t(to, uo({
              ref: t.componentRef
            }, e)),
            status: nt.SUCCESS
          });
        }
      };
    });
  }
  var t;
  return s(e, [{
    key: "validate",
    value: (t = l(b.mark(function e() {
      var t;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (null !== (t = this.componentRef) && void 0 !== t && t.current) {
                e.next = 2;
                break;
              }
              return e.abrupt("return", !0);
            case 2:
              return e.abrupt("return", this.componentRef.current.validate());
            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();
var po = d(function (e, t) {
    e.exports = function () {
      var e = window.navigator.userAgent.toLowerCase() || "",
        t = /iphone/i.test(e),
        r = /ipad/i.test(e) || /macintosh|mac os x/i.test(e),
        n = (e = /ipod/i.test(e), t || r || e),
        o = (t = window.navigator.userAgent.toLowerCase() || "", /android/i.test(t));
      function a() {
        var e = "new",
          t = navigator.userAgent,
          r = {
            admin1: {
              currentVersion: l(t, "SLAdmin1"),
              version: "0.0.0",
              oldVersionName: "new"
            },
            admin2: {
              currentVersion: l(t, "SLAdmin"),
              version: "3.0.0",
              oldVersionName: "oldAdmin2"
            },
            saas: {
              currentVersion: p(t).appCodeVersion || "0.0.0",
              version: "1.6.0",
              oldVersionName: "oldShopper"
            }
          },
          n = 0 <= t.indexOf("SLAdmin1/");
        return 0 <= t.indexOf("SLAdmin/") && (e = "admin2"), n && (e = "admin1"), "new" === (e = 0 <= t.indexOf("JOYY-shopline") ? "saas" : e) ? e : !r[e].currentVersion || u(r[e].currentVersion, r[e].version) < 0 ? r[e].oldVersionName : "new";
      }
      function i(e, t, r, n) {
        return new Promise(function (o, i) {
          function s(e) {
            o(e), null != n && n(e);
          }
          var c = !1;
          switch (a()) {
            case "oldShopper":
              c = function (e, t, r, n) {
                if ("function" != typeof window.$nativeApi) return !1;
                t = (e = d(h, e, t, r)).name, r = e.params;
                try {
                  window.$nativeApi(t, r).then(function (e) {
                    return n(e);
                  });
                } catch (e) {
                  return n({
                    result: 0
                  }), !1;
                }
                return !0;
              }(e, t, r, s);
              break;
            case "oldAdmin2":
              c = function (e, t, r, n) {
                var o;
                if (void 0 === r && (r = {}), "function" != typeof (null == (a = window.SLApiCore) ? void 0 : a.invokeClientMethod)) return !1;
                var a = d(f, e, t, r);
                e = a.module, t = a.name, r = a.params;
                try {
                  null != (o = null === window || void 0 === window ? void 0 : window.SLApiCore) && o.invokeClientMethod(e, t, r, n);
                } catch (e) {
                  return n({
                    result: 0
                  }), !1;
                }
                return !0;
              }(e, t, r, s);
              break;
            default:
              c = function (e, t, r, n) {
                var o, a;
                if ("function" != typeof (null == (o = window.SLAppJSBridge) ? void 0 : o.invokeAppMethod)) return !1;
                try {
                  null != (a = null === window || void 0 === window ? void 0 : window.SLAppJSBridge) && a.invokeAppMethod(e, t, r, n);
                } catch (e) {
                  return n({
                    result: 0
                  }), !1;
                }
                return !0;
              }(e, t, r, s);
          }
          c || i(console.warn("未在客户端环境下调用JS SDK！"));
        }).then(function (e) {
          return e;
        });
      }
      function s(e, t, r) {
        if ("on" === e) {
          if ("function" != typeof r) return;
          v[t] || (y[t] = "shoplineAppBridge.".concat(t), v[t] = function (e) {}), v[t] = function (e) {
            return r(e.detail);
          }, window.addEventListener(y[t], v[t]);
        }
        "off" === e && v[t] && window.removeEventListener(y[t], v[t]);
      }
      function c(e, t, r, n) {
        if (y[t] || r) switch (a()) {
          case "oldAdmin2":
            !function (e, t, r) {
              if ("on" !== e || "function" == typeof r) {
                if ("on" === e) {
                  if ("function" != typeof r) return;
                  window[t] = r;
                }
                "off" === e && (window[t] = null);
              }
            }(e, t, n);
            break;
          case "oldShopper":
            s(e, t, n);
          case "new":
            s(e, t, n);
        }
      }
      var u = function u(e, t) {
          if (_typeof(e) + _typeof(t) != "stringstring") return !1;
          for (var r = e.split("."), n = t.split("."), o = Math.max(r.length, n.length), a = 0; a < o; a++) {
            if (r[a] && !n[a] && 0 < parseInt(r[a]) || parseInt(r[a]) > parseInt(n[a])) return 1;
            if (n[a] && !r[a] && 0 < parseInt(n[a]) || parseInt(r[a]) < parseInt(n[a])) return -1;
          }
          return 0;
        },
        l = function l(e, t) {
          return (e = e.split("".concat(t, "/"))).length <= 1 ? "" : e[1].split(" ")[0].split("-")[0];
        },
        p = function p(e) {
          var t, r, n, o, a, i, s, c, u, l, p, d;
          return (e = (e || window.navigator.userAgent).match(/JOYY-shopline \((.+)\)/i)) ? (t = (e = e[1].split("__"))[0], r = e[1], n = e[2], o = e[3], a = e[4], i = e[5], s = e[6], c = e[7], u = e[8], l = e[9], p = e[10], d = e[11], e = void 0 === (e = e[12]) ? "shopper" : e, {
            phoneName: t,
            appName: decodeURIComponent(r),
            appMarketVersion: n,
            sysName: o,
            sysVersion: a,
            appEnv: i,
            deviceid: s,
            merchantId: c,
            appVersionCode: u,
            countryCode: l,
            lang: p,
            appCodeVersion: d,
            appType: e
          }) : {};
        },
        d = function d(e, t, r, n) {
          void 0 === n && (n = {});
          var o = r,
            a = {},
            i = e[r];
          return a = i ? (t = i.module, o = i.name, Object.keys(i.params).length || (a = n), Object.keys(n).reduce(function (e, t) {
            return i.params[t] ? e[i.params[t]] = n[t] : e[t] = n[t], e;
          }, {})) : n, {
            module: t,
            name: o,
            params: a
          };
        },
        f = {
          showToast: {
            module: "ui",
            name: "toast",
            params: {
              text: "msg",
              duration: "duration",
              center: "center"
            }
          },
          copyText: {
            module: "ui",
            name: "copyText",
            params: {
              text: "text"
            }
          },
          setTitle: {
            module: "ui",
            name: "setTitle",
            params: {
              title: "title"
            }
          },
          setRightButton: {
            module: "ui",
            name: "setRightButton",
            params: {
              rightItem: "rightItem"
            }
          },
          openNative: {
            module: "ui",
            name: "goto",
            params: {
              uri: "uri"
            }
          },
          setBackButtonVisibility: {
            module: "ui",
            name: "hideBack",
            params: {
              hidden: "hide"
            }
          },
          setBackButtonDisabled: {
            module: "ui",
            name: "setPageBackMode",
            params: {
              targetUrl: "lastLayerUrl"
            }
          },
          openWebWindow: {
            module: "ui",
            name: "openWebWindow",
            params: {
              uri: "uri"
            }
          },
          closeWebWindow: {
            module: "ui",
            name: "closeWebWindow",
            params: {}
          },
          openDefaultBrowser: {
            module: "ui",
            name: "gotoSystemWeb",
            params: {
              url: "url"
            }
          },
          openHalfWindow: {
            module: "ui",
            name: "openActWindow",
            params: {
              id: "actId",
              url: "actUrl",
              title: "title",
              hideTitle: "hideTitle",
              portrait: "portrait",
              animationStyle: "animationStyle",
              bgColor: "bgColor"
            }
          },
          closeHalfWindow: {
            module: "ui",
            name: "openActWindow",
            params: {
              id: "actId"
            }
          },
          setPageTag: {
            module: "ui",
            name: "setPageTag",
            params: {
              tag: "tag"
            }
          },
          closePageTag: {
            module: "ui",
            name: "closePageTag",
            params: {
              tag: "tag"
            }
          },
          postMessage: {
            module: "ui",
            name: "sendMessageToWindow",
            params: {
              origin: "tag",
              message: "message"
            }
          },
          getDeviceId: {
            module: "device",
            name: "deviceId",
            params: {}
          },
          isLogin: {
            module: "login",
            name: "isLogin",
            params: {}
          },
          registSuccess: {
            module: "login",
            name: "registSuccess",
            params: {
              credit: "credit",
              uid: "uid"
            }
          },
          logout: {
            module: "login",
            name: "logout",
            params: {}
          },
          createMerchantSuccess: {
            module: "login",
            name: "createMerchantSuccess",
            params: {}
          },
          createShopSuccess: {
            module: "login",
            name: "createShopSuccess",
            params: {
              shopId: "shopId"
            }
          },
          thirdLoginSuccess: {
            module: "login",
            name: "thirdLoginSuccess",
            params: {
              credit: "credit",
              uid: "uid"
            }
          },
          linkieeLoginFailed: {
            module: "login",
            name: "linkieeLoginFailed",
            params: {}
          },
          activeShopSuccess: {
            module: "login",
            name: "activeShopSuccess",
            params: {
              shopId: "shopId"
            }
          },
          shopComboChange: {
            module: "login",
            name: "shopComboChange",
            params: {}
          },
          shopPermissionChange: {
            module: "login",
            name: "shopPermissionChange",
            params: {}
          },
          showAlertDialog: {
            module: "ui",
            name: "showAlertDialog",
            params: {
              title: "title",
              message: "message",
              buttons: "buttons",
              confirmColor: "confirmColor",
              cancelable: "cancelable"
            }
          },
          openCameraOrAlbumForUrl: {
            module: "ui",
            name: "openCameraOrAlbumForUrl",
            params: {
              maxImageLength: "maxImageLength",
              onlyAlbum: "onlyAlbum",
              limit: "limit",
              businessType: "businessType"
            }
          },
          showEditDialog: {
            module: "ui",
            name: "showEditDialog",
            params: {
              title: "title",
              hint: "hint",
              buttons: "buttons",
              confirmColor: "confirmColor",
              cancelable: "cancelable"
            }
          },
          sendDraftLink: {
            module: "order",
            name: "sendDraftLink",
            params: {}
          },
          reportEvent: {
            module: "order",
            name: "data",
            params: {
              eventId: "eventId",
              page: "page",
              module: "module",
              component: "component",
              actionType: "actionType",
              moreInfo: "moreInfo"
            }
          }
        },
        h = {
          showToast: {
            module: "",
            name: "showToast",
            params: {
              msg: "text"
            }
          },
          openNative: {
            module: "",
            name: "openNative",
            params: {
              uri: "deeplink"
            }
          },
          getSessionInfo: {
            module: "",
            name: "getSessionInfo",
            params: {}
          },
          showDailDialog: {
            module: "",
            name: "showDailDialog",
            params: {}
          },
          getStatInfo: {
            module: "",
            name: "getStatInfo",
            params: {}
          },
          logout: {
            module: "",
            name: "logout",
            params: {}
          },
          closeWebWindow: {
            module: "",
            name: "closeWebview",
            params: {}
          },
          showCascader: {
            module: "",
            name: "showCascader",
            params: {}
          },
          setRightButton: {
            module: "",
            name: "setNavigationButton",
            params: {}
          },
          setBackButtonVisibility: {
            module: "",
            name: "switchNavigationBack",
            params: {}
          },
          showSharePanel: {
            module: "",
            name: "share",
            params: {}
          }
        },
        v = {
          webViewAppear: function webViewAppear(e) {},
          webViewDisAppear: function webViewDisAppear(e) {},
          networkStatusChange: function networkStatusChange(e) {},
          receiveMessage: function receiveMessage(e) {}
        },
        y = {
          webViewAppear: "shoplineAppBridge.webViewAppear",
          webViewDisAppear: "shoplineAppBridge.webViewDisAppear",
          networkStatusChange: "shoplineAppBridge.networkStatusChange",
          receiveMessage: "shoplineAppBridge.receiveMessage"
        };
      return r = {
        common: function common(e, t, r) {
          return "isShoplineWebView" !== e ? i("common", e, t, r) : new Promise(function (e) {
            try {
              e({
                result: 1,
                message: "success",
                isShoplineWebView: Boolean(window.AndroidJSInterfaceV2 || window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.SLWKWebViewAPI)
              });
            } catch (t) {
              e({
                result: 0,
                message: "fail",
                isShoplineWebView: !1
              });
            }
          });
        },
        tracker: function tracker(e, t, r) {
          return i("tracker", e, t, r);
        },
        admin1: function admin1(e, t, r) {
          return i("admin1", e, t, r);
        },
        admin2: function admin2(e, t, r) {
          return i("admin2", e, t, r);
        },
        shopper: function shopper(e, t, r) {
          return i("shopper", e, t, r);
        },
        shopper2: function shopper2(e, t, r) {
          return i("shopper2", e, t, r);
        },
        pos2: function pos2(e, t, r) {
          return i("pos2", e, t, r);
        },
        payments: function payments(e, t, r) {
          return i("payments", e, t, r);
        },
        onWebViewAppear: function onWebViewAppear(e) {
          c("on", "webViewAppear", !1, e);
        },
        offWebViewAppear: function offWebViewAppear() {
          c("off", "webViewAppear");
        },
        onWebViewDisAppear: function onWebViewDisAppear(e) {
          c("on", "webViewDisAppear", !1, e);
        },
        offWebViewDisAppear: function offWebViewDisAppear() {
          c("off", "webViewDisAppear");
        },
        onNetworkStatusChange: function onNetworkStatusChange(e) {
          c("on", "networkStatusChange", !1, e);
        },
        offNetworkStatusChange: function offNetworkStatusChange() {
          c("off", "networkStatusChange");
        },
        onReceiveMessage: function onReceiveMessage(e) {
          c("on", "receiveMessage", !1, e);
        },
        offReceiveMessage: function offReceiveMessage() {
          c("off", "receiveMessage");
        },
        onCustomizeMessage: function onCustomizeMessage(e, t) {
          e && c("on", e, !0, t);
        },
        offCustomizeMessage: function offCustomizeMessage(e) {
          e && c("off", e, !0);
        }
      }, window.SLAppJSBridge || (window.SLAppJSBridge = {
        __GLOBAL_FUNC_INDEX__: 0,
        invokeAppMethod: function invokeAppMethod(e, t, r, a) {
          void 0 === r && (r = {});
          var i,
            s = "slapi://" + e + "/" + t + "?p=" + encodeURIComponent(JSON.stringify(r || {}));
          a && (s = s + "&cb=" + (i = "function" == typeof a ? window.SLAppJSBridge.createGlobalFuncForCallback(a) : a)), n ? window.webkit.messageHandlers.SLWKWebViewAPI.postMessage(s) : o ? window.AndroidJSInterfaceV2.invoke(e, t, JSON.stringify(r || {}), i) : null != a && a({
            result: 0
          });
        },
        createGlobalFuncForCallback: function createGlobalFuncForCallback(e) {
          var t;
          return e ? (t = "__GLOBAL_CALLBACK__" + window.SLAppJSBridge.__GLOBAL_FUNC_INDEX__++, window[t] = function () {
            var t = arguments,
              r = "function" == typeof e ? e : window[e];
            setTimeout(function () {
              r.apply(null, t);
            }, 0);
          }, t) : null;
        },
        invokeWebMethod: function invokeWebMethod(e, t) {
          window.SLAppJSBridge.invokeCallbackWithArgs(e, [t]);
        },
        invokeCallbackWithArgs: function invokeCallbackWithArgs(e, t) {
          var r, n;
          e && (r = null, n = void 0, "function" == typeof e ? r = e : (n = window[e]) && "function" == typeof n && (r = n), r) && setTimeout(function () {
            r.apply(null, t);
          }, 0);
        }
      }), window.shoplineAppBridge = r;
    }();
  }),
  fo = function () {
    var e = l(b.mark(function e(t) {
      var r,
        n = arguments;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return r = n.length > 1 && void 0 !== n[1] ? n[1] : 3e3, e.abrupt("return", Promise.race([t, new Promise(function (e, t) {
                setTimeout(function () {
                  t(new Error("js_bridge_timeout"));
                }, r);
              })])["catch"](function (e) {
                throw ke.reportError(e, "handleBridgeMethod_error"), new T((null == e ? void 0 : e.message) || y.InnerSDKError, v.InnerSDKError, "JSBridgeError");
              }));
            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
  ho = function () {
    var e = l(b.mark(function e() {
      var t;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return ke.reportData("isShoplineWebView_start"), e.next = 3, fo(po.common("isShoplineWebView"));
            case 3:
              return t = e.sent, ke.reportData("isShoplineWebView_end", {
                result: t
              }), e.abrupt("return", null == t ? void 0 : t.isShoplineWebView);
            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
  vo = function () {
    var e = l(b.mark(function e() {
      var t, r;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, ho();
            case 2:
              if (!e.sent) {
                e.next = 16;
                break;
              }
              return ke.reportData("getDeviceInfo_start"), e.next = 6, fo(po.common("getDeviceInfo"));
            case 6:
              if (t = e.sent, ke.reportData("getDeviceInfo_end", {
                result: t
              }), r = (t || {}).system, !(void 0 === r ? "" : r).startsWith("Android")) {
                e.next = 13;
                break;
              }
              return e.abrupt("return", it.AndroidWebView);
            case 13:
              return e.abrupt("return", it.IosWebView);
            case 14:
              e.next = 17;
              break;
            case 16:
              return e.abrupt("return", it.Browser);
            case 17:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
  yo = function () {
    var e = l(b.mark(function e(t) {
      var r, n, o, a;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, ke.reportData("js_bridge_canIUse_start"), e.next = 4, fo(po.common("canIUse", {
                module: "payments",
                method: t
              }));
            case 4:
              if (r = e.sent, ke.reportData("js_bridge_canIUse_end", {
                result: r
              }), o = (n = r || {}).supported, a = n.message, !o) {
                e.next = 9;
                break;
              }
              return e.abrupt("return", o);
            case 9:
              throw new Error(a);
            case 12:
              return e.prev = 12, e.t0 = e["catch"](0), ke.reportData("js_bridge_canIUse_".concat(t, "_error"), {
                error: JSON.stringify(e.t0),
                errorMessage: e.t0.message
              }), e.abrupt("return", !1);
            case 16:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 12]]);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
  mo = function () {
    var t = l(b.mark(function t(r) {
      var n, o, a, i;
      return b.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, t.next = 3, yo("isSupportPaymentMethod");
            case 3:
              if (t.sent) {
                t.next = 6;
                break;
              }
              return t.abrupt("return", !1);
            case 6:
              return ke.reportData("isWebViewSupportPaymentMethod_start"), t.next = 9, fo(po.payments("isSupportPaymentMethod", {
                paymentMethod: r,
                channelId: Ze,
                custom: {
                  traceId: e
                }
              }));
            case 9:
              if (n = t.sent, ke.reportData("isWebViewSupportPaymentMethod_end", {
                result: n
              }), a = (o = n || {}).isSupport, i = o.message, !a) {
                t.next = 14;
                break;
              }
              return t.abrupt("return", !0);
            case 14:
              throw new Error(i);
            case 17:
              return t.prev = 17, t.t0 = t["catch"](0), ke.reportData("isWebViewSupportPaymentMethod_error", {
                error: JSON.stringify(t.t0),
                errorMessage: t.t0.message
              }), t.abrupt("return", !1);
            case 21:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[0, 17]]);
    }));
    return function (e) {
      return t.apply(this, arguments);
    };
  }();
function go() {
  return bo.apply(this, arguments);
}
function bo() {
  return bo = l(b.mark(function e() {
    var t, r, n, o;
    return b.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return t = 4, e.next = 3, qe("https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js", {
              maxCount: 3,
              interval: 100
            }).then(function () {
              ke.reportData("load_apple_js_success");
            })["catch"](function (e) {
              throw ke.reportError(e, "load_apple_js_error"), new Error("LoadChannelJsFail");
            });
          case 3:
            if (r = window.ApplePaySession, n = "apple_pay_session_", !r) {
              e.next = 20;
              break;
            }
            if (ke.reportData("".concat(n, "load_success")), !r.canMakePayments()) {
              e.next = 17;
              break;
            }
            if (ke.reportData("".concat(n, "canMakePayments")), !r.supportsVersion(t)) {
              e.next = 14;
              break;
            }
            return ke.reportData("".concat(n, "supportsVersion_").concat(t)), e.abrupt("return");
          case 14:
            o = "".concat(n, "supportsVersion_").concat(t, "_failed");
          case 15:
            e.next = 18;
            break;
          case 17:
            o = "".concat(n, "canMakePayments_failed");
          case 18:
            e.next = 21;
            break;
          case 20:
            o = "".concat(n, "load_failed");
          case 21:
            throw ke.reportData(o), new Error("DeviceNotSupportPaymentMethod");
          case 23:
          case "end":
            return e.stop();
        }
      }
    }, e);
  })), bo.apply(this, arguments);
}
function ko() {
  return wo.apply(this, arguments);
}
function wo() {
  return (wo = l(b.mark(function e() {
    return b.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.prev = 0, e.next = 3, go();
          case 3:
            return e.abrupt("return", !0);
          case 6:
            return e.prev = 6, e.t0 = e["catch"](0), ke.reportData("isSupportApplePay_error", {
              error: JSON.stringify(e.t0),
              errorMessage: e.t0.message
            }), e.abrupt("return", !1);
          case 10:
          case "end":
            return e.stop();
        }
      }
    }, e, null, [[0, 6]]);
  }))).apply(this, arguments);
}
function Co() {
  return !/(micromessenger)/.test(navigator.userAgent.toLocaleLowerCase());
}
var _o = function () {
    var e = l(b.mark(function e() {
      var t, r;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, ho();
            case 2:
              if (!e.sent) {
                e.next = 4;
                break;
              }
              return e.abrupt("return", mo(et.GooglePay));
            case 4:
              if (!/iphone|ipod|ipad/i.test(navigator.userAgent.toLowerCase())) {
                e.next = 7;
                break;
              }
              return e.abrupt("return", !1);
            case 7:
              return t = navigator.userAgent.match(/Chrome\/(\d+)/), r = t && t[1] && Number(t[1]) >= 61, e.abrupt("return", (n = void 0, (!!(n = window.navigator.userAgent).match("CriOS") || /Chrome/.test(n) && /Google Inc./.test(window.navigator.vendor) && !!window.chrome) && r));
            case 10:
            case "end":
              return e.stop();
          }
        }
        var n;
      }, e);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
  Oo = function () {
    function e(t, r) {
      if (n(this, e), c(this, "env", void 0), c(this, "initData", void 0), c(this, "simpleRender", new lo()), this.env = t, this.initData = r, this.initData.paymentMethod === et.WeChatPay && !Co()) {
        var o = new T("not support WeChatPay");
        throw o.setAPIErrorData({
          code: v.DeviceNotSupportPaymentMethod,
          msg: y.DeviceNotSupportPaymentMethod
        }), o;
      }
    }
    var t, r;
    return s(e, [{
      key: "needRenderWidget",
      value: (r = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !0);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "needUserAction",
      value: function value() {
        return !1;
      }
    }, {
      key: "getRenderer",
      value: function value() {
        return this.simpleRender.getRenderer();
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.simpleRender.validate());
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "destroy",
      value: function value() {
        this.simpleRender = null;
      }
    }]), e;
  }(),
  Po = "paymentSdk_footer_8da0e7ad",
  xo = "paymentSdk_footerTips_8da0e7ad",
  Io = "paymentSdk_footerIcon_8da0e7ad",
  So = function So(e) {
    return $t("svg", kr({}, e, {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }), $t("path", {
      d: "M10.8773 5.33337H10.1557C9.99882 5.33337 9.84958 5.40529 9.75727 5.52856L7.33873 8.72793L6.24331 7.27795C6.151 7.15613 6.0033 7.08275 5.84484 7.08275H5.12328C5.02327 7.08275 4.96481 7.19136 5.02327 7.26914L6.94026 9.80515C6.98554 9.86545 7.04524 9.91458 7.11441 9.94847C7.18357 9.98236 7.26021 10 7.33796 10C7.41572 10 7.49235 9.98236 7.56152 9.94847C7.63068 9.91458 7.69038 9.86545 7.73567 9.80515L10.9758 5.51976C11.0358 5.44198 10.9773 5.33337 10.8773 5.33337V5.33337Z",
      fill: "currentColor"
    }), $t("path", {
      d: "M13.25 3.46888V9.59634C13.25 10.0143 13.0411 10.4046 12.6934 10.6364L8.13867 13.6729C8.0547 13.7289 7.9453 13.7289 7.86132 13.6729L3.30662 10.6364C2.95888 10.4046 2.75 10.0143 2.75 9.59634V3.46888C2.75 3.3517 2.83138 3.25025 2.94577 3.22483L7.94577 2.11372C7.98149 2.10578 8.01851 2.10578 8.05423 2.11372L13.0542 3.22483C13.1686 3.25025 13.25 3.3517 13.25 3.46888Z",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }));
  };
function Do(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Ro,
  Eo = function (e) {
    _(r, Yt);
    var t = Do(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.icon,
          r = e.theme,
          n = e.message,
          o = e.children;
        return n || o ? $t("div", {
          className: Po
        }, null === t ? null : $t("div", {
          className: Io,
          style: {
            color: null == r ? void 0 : r.iconColor
          }
        }, t || $t(So, null)), $t("div", {
          className: xo
        }, o, n && $t(Vr, {
          text: n,
          theme: r
        }))) : null;
      }
    }]), r;
  }();
c(Eo, "defaultProps", {
  withIcon: !0
}), function (e) {
  e[e.Maintaining = 0] = "Maintaining", e[e.Available = 1] = "Available";
}(Ro || (Ro = {}));
var To = function To(e) {
    var t;
    t = Number(e);
    var r = (t = new Date(t)).getFullYear(),
      n = t.getMonth() + 1 >= 10 ? t.getMonth() + 1 : "0".concat(t.getMonth() + 1),
      o = t.getDate() >= 10 ? t.getDate() : "0".concat(t.getDate()),
      a = t.getHours() >= 10 ? t.getHours() : "0".concat(t.getHours()),
      i = t.getMinutes() >= 10 ? t.getMinutes() : "0".concat(t.getMinutes()),
      s = t.getSeconds() >= 10 ? t.getSeconds() : "0".concat(t.getSeconds());
    return "".concat(r, "/").concat(n, "/").concat(o, " ").concat(a, ":").concat(i, ":").concat(s);
  },
  Ao = {
    FPXContainer: "paymentSdk_FPXContainer_deeec25b",
    FPXNextStepTip: "paymentSdk_FPXNextStepTip_deeec25b",
    FPXContentLoading: "paymentSdk_FPXContentLoading_deeec25b",
    FPXSelect: "paymentSdk_FPXSelect_deeec25b",
    FPXFooterTip: "paymentSdk_FPXFooterTip_deeec25b"
  };
function Lo(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Lo(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Lo(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function No(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Bo = Wr.bind(Ao),
  Mo = function (e) {
    _(r, Yt);
    var t = No(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "getSkeleton",
      value: function value(e) {
        var t;
        return $t(Gn, {
          theme: jo(jo({}, (null === (t = this.props.theme) || void 0 === t ? void 0 : t.skeleton) || {}), {}, {
            height: e
          })
        });
      }
    }, {
      key: "componentDidCatch",
      value: function value(e) {
        ke.reportError(e, "FPX_Layout_componentDidCatch_error");
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.isLoaded,
          r = e.theme,
          n = e.select,
          o = e.hint,
          a = e.footer;
        return $t("div", {
          className: Bo({
            FPXContainer: !0,
            FPXContentLoading: !t
          })
        }, !!n && $t("div", {
          className: Ao.FPXSelect
        }, t ? n : this.getSkeleton(null == r ? void 0 : r.selectHeight)), !!o && $t("div", {
          className: Ao.FPXNextStepTip,
          style: {
            marginTop: null == r ? void 0 : r.formItemGutter,
            marginBottom: null == r ? void 0 : r.formItemGutter
          }
        }, t ? o : this.getSkeleton()), !!a && $t("div", {
          className: Ao.FPXFooterTip
        }, t ? a : this.getSkeleton()));
      }
    }]), r;
  }();
function Fo(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
function Ho(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Vo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ho(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ho(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function Wo(e) {
  return {
    footer: {
      iconColor: null == e ? void 0 : e.footerIconColor,
      fontColor: null == e ? void 0 : e.footerFontColor,
      linkColor: (null == e ? void 0 : e.footerLinkColor) || "#356DFF"
    },
    hint: {
      fontColor: (null == e ? void 0 : e.nextStepTipFontColor) || "rgba(44, 44, 44, 0.75)"
    },
    select: Vo(Vo({}, e), {}, {
      optionsDescriptionFontColor: (null == e ? void 0 : e.maintainTimeFontColor) || "#F86140"
    }),
    layout: {
      formItemGutter: null == e ? void 0 : e.formItemGutter,
      selectHeight: null == e ? void 0 : e.selectHeight,
      skeleton: {
        background: null == e ? void 0 : e.selectSkeletonBackground,
        borderRadius: null == e ? void 0 : e.selectBorderRadius
      }
    }
  };
}
var Uo = function (e) {
    _(o, Yt);
    var t,
      r = Fo(o);
    function o(e) {
      var t;
      return n(this, o), c(w(t = r.call(this, e)), "selectRef", void 0), c(w(t), "state", {
        isLoaded: !1,
        errorMsg: "",
        displayOption: null,
        optionList: null,
        language: null
      }), c(w(t), "validate", function () {
        var e,
          r = t.state.displayOption,
          n = !!r && !r.disabled;
        n || t.showError(null === (e = t.state.language) || void 0 === e ? void 0 : e.placeholder);
        return n;
      }), c(w(t), "showError", function (e) {
        var r;
        null === (r = t.selectRef.current) || void 0 === r || r.showError(e);
      }), t.selectRef = {
        current: null
      }, t;
    }
    return s(o, [{
      key: "componentDidMount",
      value: function value() {
        this.getLanguage();
      }
    }, {
      key: "getLanguage",
      value: (t = l(b.mark(function e() {
        var t, r, n, o, a, i, s, c, u;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return t = this.props, r = t.guideI18nKey, n = t.i18n, e.next = 3, n.get(["FPX.selectBank", "FPX.bankMaintenance", r]);
              case 3:
                o = e.sent, a = mt(o, 3), i = a[0], s = a[1], c = a[2], u = {
                  placeholder: i,
                  errorMsg: i,
                  hint: c,
                  bankMaintenance: s
                }, this.setState({
                  isLoaded: !0,
                  language: u
                });
              case 10:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "getOptionList",
      value: function value() {
        var e = this.props,
          t = e.bankList,
          r = e.imgHost,
          n = this.state.language;
        return t.map(function (e) {
          return {
            value: e.bankCode,
            label: e.bankName,
            img: "".concat(r, "/payment-sdk/images/bank-icon/FPX/").concat(e.bankCode, ".png"),
            description: e.maintainEndTime ? "".concat(null == n ? void 0 : n.bankMaintenance, " ").concat(To(e.maintainEndTime)) : "",
            disabled: e.status === Ro.Maintaining
          };
        });
      }
    }, {
      key: "selectBank",
      value: function value(e) {
        this.props.onSelectBank(e), this.setState({
          displayOption: e
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
          t = this.state,
          r = t.isLoaded,
          n = t.language,
          o = Wo(this.props.theme);
        return $t(Mo, {
          isLoaded: r,
          theme: o.layout,
          select: $t(Fn, {
            ref: this.selectRef,
            optionList: this.getOptionList(),
            placeholder: null == n ? void 0 : n.placeholder,
            onChange: function onChange(t) {
              return e.selectBank(t);
            },
            theme: o.select,
            needAdaptive: this.props.needAdaptive
          }),
          hint: $t(Vr, {
            text: null == n ? void 0 : n.hint,
            theme: o.hint
          })
        });
      }
    }]), o;
  }(),
  Go = function (e) {
    _(o, Yt);
    var t,
      r = Fo(o);
    function o() {
      return n(this, o), r.apply(this, arguments);
    }
    return s(o, [{
      key: "componentDidMount",
      value: function value() {
        this.getLanguage();
      }
    }, {
      key: "getLanguage",
      value: (t = l(b.mark(function e() {
        var t, r, n, o;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return t = this.props, r = t.footerI18nKey, n = t.i18n, e.next = 3, n.get(r);
              case 3:
                o = e.sent, this.setState({
                  isLoaded: !0,
                  footer: o
                });
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "render",
      value: function value() {
        var e = this.state,
          t = e.footer,
          r = e.isLoaded,
          n = Wo(this.props.theme);
        return $t(Mo, {
          isLoaded: r,
          theme: n.layout,
          footer: $t(Eo, {
            message: t,
            theme: n.footer
          })
        });
      }
    }]), o;
  }();
function Ko(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ko(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ko(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var zo = function () {
    function e() {
      n(this, e), c(this, "componentRef", {
        current: null
      }), c(this, "bankCode", void 0);
    }
    var t;
    return s(e, [{
      key: "getRenderer",
      value: function value() {
        var e = this;
        return {
          content: function content(t) {
            var r,
              n,
              o,
              a = t.initResult.paymentMethodInfo;
            return $t(Uo, {
              ref: e.componentRef,
              i18n: t.i18n,
              bankList: a.banks,
              imgHost: t.env.imageHost,
              guideI18nKey: null === (r = a.cashierNotice) || void 0 === r ? void 0 : r.guideI18nKey,
              needAdaptive: t.initData.needAdaptive,
              onSelectBank: function onSelectBank(t) {
                return e.bankCode = t.value;
              },
              theme: qo(qo({}, null === (n = t.initData.theme) || void 0 === n ? void 0 : n["default"]), null === (o = t.initData.theme) || void 0 === o ? void 0 : o.FPX)
            });
          },
          footer: function footer(e) {
            var t,
              r,
              n,
              o = e.initResult.paymentMethodInfo;
            return $t(Go, {
              i18n: e.i18n,
              theme: qo(qo({}, null === (t = e.initData.theme) || void 0 === t ? void 0 : t["default"]), null === (r = e.initData.theme) || void 0 === r ? void 0 : r.FPX),
              footerI18nKey: null === (n = o.cashierNotice) || void 0 === n ? void 0 : n.footerI18nKey
            });
          }
        };
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.componentRef.current) {
                  e.next = 3;
                  break;
                }
                return ke.reportErrorData("fpx_validate_before_render"), e.abrupt("return", !1);
              case 3:
                return e.abrupt("return", this.componentRef.current.validate());
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }]), e;
  }(),
  Zo = function () {
    function e() {
      n(this, e), c(this, "FPXUI", new zo());
    }
    var t, r;
    return s(e, [{
      key: "needRenderWidget",
      value: (r = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !0);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "needUserAction",
      value: function value() {
        return !0;
      }
    }, {
      key: "getRenderer",
      value: function value() {
        return this.FPXUI.getRenderer();
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.FPXUI.validate());
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "getPayHooks",
      value: function value() {
        var e,
          t = this;
        return {
          extendConfirmParams: (e = l(b.mark(function e() {
            return b.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", {
                      paymentInstrument: {
                        subPaymentMethod: t.FPXUI.bankCode
                      }
                    });
                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function () {
            return e.apply(this, arguments);
          })
        };
      }
    }, {
      key: "destroy",
      value: function value() {
        this.FPXUI = null;
      }
    }]), e;
  }();
function $o(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Jo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? $o(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $o(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var Xo = function () {
    var e = l(b.mark(function e(t, r) {
      var n;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (dt(t)) {
                e.next = 2;
                break;
              }
              throw new T("".concat(y.InvalidUploadUrl, " ").concat(t));
            case 2:
              return n = {
                "x-requester": "cashierSDK"
              }, e.abrupt("return", Se.post(t, r, {
                headers: n
              })["catch"](function (e) {
                var n,
                  o = T.handleAPIErrorData(null == e ? void 0 : e.data, {
                    code: v.AbnormalTrade,
                    msg: y.AbnormalTrade
                  }),
                  a = (null == e || null === (n = e.data) || void 0 === n ? void 0 : n.code) === v.CancelPayClient ? "upload_order_status_cancel" : "upload_order_status_error";
                ke.handleError(e, a, Jo({
                  url: t,
                  request: {
                    actionType: r.actionType
                  },
                  response: {
                    error: e
                  }
                }, o));
              }));
            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r) {
      return e.apply(this, arguments);
    };
  }(),
  Yo = function () {
    var e = l(b.mark(function e(t, r) {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", Xo(t, {
                actionType: "uploadChannelError",
                data: JSON.stringify(r)
              }));
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r) {
      return e.apply(this, arguments);
    };
  }(),
  Qo = function () {
    var e = l(b.mark(function e(t) {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", Xo(t, {
                actionType: "uploadChannelCancel",
                data: ""
              }));
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
  ea = function () {
    var e = l(b.mark(function e(t, r) {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", Xo(t, {
                actionType: "uploadToken",
                data: JSON.stringify(r)
              }));
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r) {
      return e.apply(this, arguments);
    };
  }(),
  ta = function () {
    var e = l(b.mark(function e(t, r) {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", Xo(t, {
                actionType: "uploadPaymentSuccess",
                data: JSON.stringify(r)
              }));
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r) {
      return e.apply(this, arguments);
    };
  }(),
  ra = function ra(e) {
    if (e) {
      var t;
      if (void 0 === e.statusCode) return !1;
      var r = 400 === e.statusCode && (null === (t = e.data) || void 0 === t ? void 0 : t.code) === v.FrequentRequest;
      return 400 !== e.statusCode || r;
    }
    return !1;
  },
  na = Fe(Yo, ra, {
    maxCount: 5,
    interval: 1e3
  }),
  oa = Fe(Qo, ra, {
    maxCount: 5,
    interval: 1e3
  }),
  aa = Fe(ea, ra, {
    maxCount: 5,
    interval: 1e3
  }),
  ia = Fe(ta, ra, {
    maxCount: 5,
    interval: 1e3
  }),
  sa = {
    CANCELED: "4600",
    DEVELOPER_ERROR: "4600",
    BUYER_ACCOUNT_ERROR: "4552",
    MERCHANT_ACCOUNT_ERROR: "4600",
    INTERNAL_ERROR: "4403"
  },
  ca = "requires either transient user activation",
  ua = "User closed the Payment Request UI";
function la(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? la(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : la(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function da(e, t) {
  var r = e.payToken,
    n = e.header,
    o = pa({}, t);
  return n && Object.keys(n).forEach(function (e) {
    "x-api-version" !== e && 0 !== e.indexOf("s-") || (o[e] = n[e]);
  }), r && (o["x-paytoken"] = r), o;
}
var fa = function () {
    var e = l(b.mark(function e(t, r, n, o) {
      var a;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (dt(t)) {
                e.next = 2;
                break;
              }
              throw new T("".concat(y.InvalidOrderPayUrl, " ").concat(t));
            case 2:
              return a = da(r, o), ke.reportData("order_pay_start", n), e.abrupt("return", Se.post(t, n, {
                headers: a
              })["catch"](function (e) {
                var r = T.handleAPIErrorData(null == e ? void 0 : e.data, {
                  code: v.AbnormalTrade,
                  msg: y.AbnormalTrade
                });
                e.options && delete e.options, ke.handleError(e, "order_pay_error", pa({
                  url: t,
                  response: {
                    error: e
                  }
                }, r));
              }));
            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n, o) {
      return e.apply(this, arguments);
    };
  }(),
  ha = function ha(e) {
    if (e) {
      var t;
      if (void 0 === e.statusCode) return !1;
      var r = 400 === e.statusCode && (null === (t = e.data) || void 0 === t ? void 0 : t.code) === v.FrequentRequest;
      return 400 !== e.statusCode || r;
    }
    return !1;
  },
  va = function () {
    var e = l(b.mark(function e(t, r, n) {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", fa(t.url, t, r, n));
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r, n) {
      return e.apply(this, arguments);
    };
  }(),
  ya = Fe(fa, ha, {
    maxCount: 5,
    interval: 1e3
  }),
  ma = Fe(va, ha, {
    maxCount: 5,
    interval: 1e3
  });
function ga(e, t) {
  if (function (e) {
    return void 0 === e;
  }(r = t) || function (e) {
    return null === e;
  }(r)) return R(e);
  var r;
  if (!D(t) || !D(e)) return R(t);
  var n = {};
  return Object.keys(e).forEach(function (r) {
    n[r] = ga(e[r], t[r]);
  }), Object.keys(t).forEach(function (e) {
    n[e] || (n[e] = R(t[e]));
  }), n;
}
var ba = function ba(e) {
    var t = window.navigator,
      r = t.userAgent,
      n = t.language,
      o = window.screen,
      a = o.colorDepth,
      i = o.width,
      s = o.height,
      c = window.navigator.javaEnabled().toString();
    return {
      transactionWebSite: window.location.href,
      javaEnabled: c,
      colorDepth: a.toString(),
      screenHeight: i.toString(),
      screenWidth: s.toString(),
      timeZoneOffset: new Date().getTimezoneOffset().toString(),
      accept: "application/json",
      userAgent: r,
      language: n,
      displayLanguage: e,
      javaScriptEnabled: "true"
    };
  },
  ka = "paymentSdk_modalRoot_a81126ab",
  wa = "paymentSdk_modalMask_a81126ab",
  Ca = "paymentSdk_modalWrap_a81126ab",
  _a = "paymentSdk_content_a81126ab";
function Oa(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Pa = function (e) {
    _(r, Yt);
    var t = Oa(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "componentDidCatch",
      value: function value(e) {
        ke.reportError(e, "Modal_componentDidCatch_error");
      }
    }, {
      key: "render",
      value: function value() {
        var e,
          t = this.props,
          r = t.theme,
          n = void 0 === r ? {} : r,
          o = t.children;
        return $t("div", {
          className: ka
        }, $t("div", {
          className: wa,
          style: {
            backgroundColor: null == n ? void 0 : n.modalMaskBackground
          }
        }), $t("div", {
          className: Ca
        }, $t("div", {
          className: _a,
          style: {
            width: null == n ? void 0 : n.modalContentWidth,
            height: null == n ? void 0 : n.modalContentHeight,
            top: null !== (e = null == n ? void 0 : n.modalContentTop) && void 0 !== e ? e : "50%",
            transform: null != n && n.modalContentTop ? void 0 : "translateY(-50%)",
            maxWidth: "100%" === (null == n ? void 0 : n.modalContentWidth) ? "100%" : "calc(100vw - 32px)"
          }
        }, o)));
      }
    }]), r;
  }(),
  xa = function () {
    function e() {
      n(this, e), c(this, "rendered", !1), c(this, "destroyed", !1), c(this, "customContainer", void 0), c(this, "targetElement", void 0);
    }
    var t;
    return s(e, [{
      key: "createContainerElement",
      value: function value() {
        return document.createElement("div");
      }
    }, {
      key: "renderContainer",
      value: function value(e) {
        yr(this.component, e);
      }
    }, {
      key: "render",
      value: (t = l(b.mark(function e(t) {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                this.checkDestroyed(), this.checkRendered(), this.customContainer = this.getContainerElement(), this.targetElement = "string" == typeof t ? document.querySelector(t) : t, null === this.customContainer ? this.renderContainer(this.targetElement) : (this.renderContainer(this.customContainer), this.targetElement.appendChild(this.customContainer)), this.rendered = !0;
              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "destroy",
      value: function value() {
        this.checkNotRendered(), this.checkDestroyed(), this.customContainer ? (yr(null, this.customContainer), He(this.customContainer)) : yr(null, this.targetElement), this.component = null, this.destroyed = !0;
      }
    }, {
      key: "getContainerElement",
      value: function value() {
        return void 0 === this.customContainer ? this.createContainerElement() : this.customContainer;
      }
    }, {
      key: "checkDestroyed",
      value: function value() {
        if (this.destroyed) throw new Error("Widget already destroyed!");
      }
    }, {
      key: "checkRendered",
      value: function value() {
        if (this.rendered) throw new Error("Widget already rendered!");
      }
    }, {
      key: "checkNotRendered",
      value: function value() {
        if (!this.rendered) throw new Error("Call render() method first!");
      }
    }]), e;
  }();
function Ia(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Sa,
  Da = function (e) {
    _(o, xa);
    var t,
      r = Ia(o);
    function o() {
      var e;
      n(this, o);
      for (var t = arguments.length, a = new Array(t), i = 0; i < t; i++) {
        a[i] = arguments[i];
      }
      return c(w(e = r.call.apply(r, [this].concat(a))), "component", null), e;
    }
    return s(o, [{
      key: "show",
      value: (t = l(b.mark(function e(t) {
        var r, n;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = t.content, n = t.theme, this.component = $t(Pa, {
                  theme: n
                }, r), e.next = 4, this.render(document.body);
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }]), o;
  }();
function Ra(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ea(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ra(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ra(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var Ta = "ON_AWX_3DS_START_PAGE_LOAD",
  Aa = "ON_AWX_3DS_START_PAGE_LEAVE",
  La = (c(Sa = {}, Ta, !1), c(Sa, Aa, !1), Sa),
  ja = function () {
    function e(t) {
      var r,
        o,
        a,
        i,
        s = this;
      n(this, e), c(this, "iframeMessageCache", void 0), c(this, "iframeMessageTimer", void 0), c(this, "retryDuration", 0), c(this, "retryCount", 0), c(this, "nextActionCache", void 0), c(this, "createIframeCallback", void 0), c(this, "removeIframeCallback", void 0), c(this, "onMessageCallback", function (e) {
        var t = e.data,
          r = e.origin;
        r === new URL(s.nextActionCache.url).origin ? (ke.reportData("AWXIframeRetry_iframe_msg", Ea({
          msg: t
        }, s.iframeMessageCache)), t === Ta && s.iframeMessageTimer && clearTimeout(s.iframeMessageTimer), s.iframeMessageCache[t] = !0) : ke.reportData("AWXIframeRetry_url_origin", {
          origin: r,
          msg: t
        });
      }), c(this, "createTimer", function (e) {
        s.removeIframeCallback = e.removeIframeCallback, s.createIframeCallback = e.createIframeCallback, s.iframeMessageTimer = setTimeout(function () {
          ke.reportData("AWXIframeRetry_createTimer_retry_start", Ea({
            retryCount: s.retryCount,
            retryDuration: s.retryDuration
          }, s.iframeMessageCache)), !s.iframeMessageCache[Ta] && s.retryCount > 0 && (s.removeIframeCallback(), s.retryCount--, s.createIframeCallback(), ke.reportData("AWXIframeRetry_createTimer_retry_end"));
        }, s.retryDuration);
      }), c(this, "clearAll", function () {
        ke.reportData("AWXIframeRetry_clearAll"), s.iframeMessageTimer && clearTimeout(s.iframeMessageTimer), window.removeEventListener("message", s.onMessageCallback);
      }), this.nextActionCache = t, this.iframeMessageCache = La, this.retryDuration = null === (r = t.header) || void 0 === r || null === (o = r.openIframeOptions) || void 0 === o ? void 0 : o.retryIntervalMillisec, this.retryCount = null === (a = t.header) || void 0 === a || null === (i = a.openIframeOptions) || void 0 === i ? void 0 : i.retryCount;
    }
    return s(e, [{
      key: "addIframeLoadedListener",
      value: function value() {
        var e, t, r;
        null !== (e = this.nextActionCache) && void 0 !== e && null !== (t = e.header) && void 0 !== t && null !== (r = t.openIframeOptions) && void 0 !== r && r.hidden ? this.retryCount && this.retryDuration ? (this.clearAll(), ke.reportData("AWXIframeRetry_addIframeLoadedListener_add"), window.addEventListener("message", this.onMessageCallback)) : ke.reportData("AWXIframeRetryListener_iframe_next_action_retry_condition_invalid", {
          retryCount: this.retryCount,
          retryDuration: this.retryDuration
        }) : ke.reportData("AWXIframeRetry_nextAction_is_not_hidden");
      }
    }]), e;
  }(),
  Na = function () {
    function t(e, r) {
      var o = this;
      n(this, t), c(this, "env", void 0), c(this, "resolveFn", void 0), c(this, "rejectFn", void 0), c(this, "IframeRetryListener", void 0), c(this, "nextActionCache", void 0), c(this, "createIframe", function () {
        var e,
          t = o.nextActionCache.header;
        null != t && null !== (e = t.openIframeOptions) && void 0 !== e && e.hidden ? o.createHiddenIframe(o.nextActionCache) : o.createVisibleIframe(o.nextActionCache);
      }), c(this, "handlePostmessage", function (e, t) {
        var r = e.data || {},
          n = r.origin,
          a = void 0 === n ? "" : n,
          i = r.success,
          s = r.nextAction;
        if (dt(a)) {
          if (o.IframeRetryListener && o.IframeRetryListener.clearAll(), t(), ke.reportData("open_iframe_next_action", {
            postMessageData: r
          }), !i || !D(s)) return ke.reportErrorData("open_iframe_next_action_error", {
            postMessageData: r
          }), o.rejectFn({
            data: {
              code: v.InvalidNextAction,
              msg: y.InvalidNextAction
            }
          });
          o.resolveFn(s);
        } else ke.reportErrorData("open_iframe_invalid_host_error", {
          postMessageData: r
        });
      }), this.env = e, this.nextActionCache = r;
    }
    var r;
    return s(t, [{
      key: "createHiddenIframe",
      value: function value(e) {
        var t = this,
          r = e.url,
          n = document.createElement("iframe");
        n.style.display = "none", n.src = r, n.onload = function () {
          ke.reportData("hidden_iframe_loaded", {
            url: r
          }), t.handleLoadEvent(n, function () {
            return He(n);
          });
        }, document.body.appendChild(n);
      }
    }, {
      key: "createVisibleIframe",
      value: function value(e) {
        var t = this,
          r = e.url,
          n = new Da(),
          o = {
            current: null
          };
        n.show({
          content: $t("iframe", {
            ref: o,
            src: r,
            width: "100%",
            height: "100%",
            style: {
              border: "none",
              background: "#fff"
            },
            onLoad: function onLoad() {
              ke.reportData("visible_iframe_loaded", {
                url: r
              }), t.handleLoadEvent(o.current, function () {
                return n.destroy();
              });
            }
          }),
          theme: {
            modalContentWidth: "100%",
            modalContentHeight: "100%",
            modalContentTop: "0"
          }
        });
      }
    }, {
      key: "handleLoadEvent",
      value: function value(t, r) {
        var n = this;
        this.IframeRetryListener && this.IframeRetryListener.createTimer({
          removeIframeCallback: r,
          createIframeCallback: this.createIframe
        }), function () {
          var o = new MessageChannel();
          o.port1.onmessage = function (e) {
            o.port1.close(), o.port2.close(), n.handlePostmessage(e, r);
          };
          var a = /MSIE|Trident\//.test(window.navigator.userAgent) ? "*" : n.env.host;
          t.contentWindow.postMessage({
            origin: "payment-sdk",
            version: "3.17.1",
            pvid: e
          }, a, [o.port2]);
        }();
      }
    }, {
      key: "render",
      value: (r = l(b.mark(function e() {
        var t,
          r,
          n = this;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return this.resolveFn && console.warn("The render method of open iframe handler cannot be called repeatedly"), "Airwallex" === (null === (t = this.nextActionCache.header) || void 0 === t || null === (r = t.openIframeOptions) || void 0 === r ? void 0 : r.channel) && (this.IframeRetryListener = new ja(this.nextActionCache), this.IframeRetryListener.addIframeLoadedListener()), e.abrupt("return", new Promise(function (e, t) {
                  if (n.resolveFn = e, n.rejectFn = t, !n.env || !n.env.host) return ke.reportErrorData("open_iframe_missing_env_error"), t({
                    data: {
                      code: v.InnerSDKError,
                      msg: "Opening iframe fails because env is missing"
                    }
                  });
                  n.createIframe();
                }));
              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }]), t;
  }();
function Ba(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "post",
    n = arguments.length > 3 ? arguments[3] : void 0;
  ke.reportData("redirectPost_start");
  var o = document.createElement("form");
  for (var a in o.style.display = "none", o.method = r, o.action = e, n && (o.target = n), t) {
    var i = document.createElement("input");
    i.name = a, i.value = t[a], o.appendChild(i);
  }
  document.body.appendChild(o), ke.reportData("redirectPost_end"), o.submit();
}
function Ma(e, t) {
  return Fa.apply(this, arguments);
}
function Fa() {
  return Fa = l(b.mark(function e(t, r) {
    var n, o, a, i, s, c, u, p, d, f, h;
    return b.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return n = t.method, o = void 0 === n ? "GET" : n, a = t.url, i = t.data, s = t.target, u = (c = r || {}).beforeRedirect, p = c.redirectBySelf, d = c.cdn, f = new Promise(function () {
              var e = l(b.mark(function e(r) {
                return b.wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        if (!u) {
                          e.next = 9;
                          break;
                        }
                        return e.prev = 1, e.next = 4, u(s);
                      case 4:
                        e.next = 9;
                        break;
                      case 6:
                        e.prev = 6, e.t0 = e["catch"](1), ke.reportErrorData("before_redirect_error", {
                          nextAction: t,
                          error: e.t0
                        });
                      case 9:
                        r(null);
                      case 10:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, null, [[1, 6]]);
              }));
              return function (t) {
                return e.apply(this, arguments);
              };
            }()), h = new Promise(function (e) {
              setTimeout(e, 3e3);
            }), e.abrupt("return", Promise.race([f, h]).then(function () {
              if (p) return ke.reportData("redirectBySelf"), void p(t);
              if ("POST" === o) Ba(a, i);else if ("GET" === o) if (ke.reportData("handleRedirect_GET", {
                url: a.split("?")[0]
              }), d === rt.CN && a.includes("/payment-sdk-extension/")) {
                var e = a.split("?"),
                  r = e[0],
                  n = e[1];
                r.endsWith("/index.html") ? r = r.replace("/index.html", "/index-oss.html") : r.endsWith("/") && (r += "index-oss.html"), window.location.href = "".concat(r, "?").concat(n);
              } else window.location.href = a;
            }));
          case 5:
          case "end":
            return e.stop();
        }
      }
    }, e);
  })), Fa.apply(this, arguments);
}
function Ha(e) {
  var t = document.createElement("a");
  t.href = e, t.style.display = "none", document.body.appendChild(t), t.click(), document.body.removeChild(t);
}
function Va(e, t) {
  return Wa.apply(this, arguments);
}
function Wa() {
  return (Wa = l(b.mark(function e(t, r) {
    var n, o, a, i, s;
    return b.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (n = t.data, a = (o = n || {}).web, i = o.app, s = (r || {}).deepLinkImmediately, ke.reportData("handleRedirectWebOrApp", {
              deepLinkImmediately: s,
              web: a,
              app: i
            }), !s) {
              e.next = 10;
              break;
            }
            if (a || i) {
              e.next = 7;
              break;
            }
            throw new T(y.InvalidNextAction, v.InvalidNextAction);
          case 7:
            i ? (ke.reportData("handleRedirectWebOrApp_app_start"), Ha(i), ke.reportData("handleRedirectWebOrApp_app_end")) : (ke.reportErrorData("handleRedirectWebOrApp_no_app_try_web"), window.location.href = a), e.next = 14;
            break;
          case 10:
            if (a) {
              e.next = 12;
              break;
            }
            throw new T(y.InvalidNextAction, v.InvalidNextAction);
          case 12:
            ke.reportData("handleRedirectWebOrApp_web", {
              web: a
            }), window.location.href = a;
          case 14:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}
function Ua(e, t) {
  return Ga.apply(this, arguments);
}
function Ga() {
  return (Ga = l(b.mark(function e(t, r) {
    var n;
    return b.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (200 !== t.statusCode) {
              e.next = 5;
              break;
            }
            return n = t.data.nextAction, e.abrupt("return", za(n, r));
          case 5:
            ke.handleError(t, "pay_nextAction_error");
          case 6:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}
function Ka(e, t) {
  return qa.apply(this, arguments);
}
function qa() {
  return qa = l(b.mark(function e(t, r) {
    var n, o, a, i, s, c, u, l;
    return b.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (o = (n = null != r ? r : {}).hooks, a = n.paymentMethod, i = n.language, s = n.APIRequestHeader, ke.reportData("nextAction_confirm_start"), e.t0 = null == o ? void 0 : o.beforeConfirm, !e.t0) {
              e.next = 6;
              break;
            }
            return e.next = 6, o.beforeConfirm()["catch"](function (e) {
              return ke.handleError(e, "handleNextAction_beforeConfirm_error");
            });
          case 6:
            if (c = {
              client: ba(i),
              paymentInstrument: {
                paymentMethod: a
              }
            }, null == o || !o.extendConfirmParams) {
              e.next = 12;
              break;
            }
            return e.next = 10, o.extendConfirmParams(t)["catch"](function (e) {
              return ke.handleError(e, "handleNextAction_extendConfirmParams_error");
            });
          case 10:
            (u = e.sent) && D(u) && (c = ga(u, c));
          case 12:
            if (null == o || !o.confirmOrderPay) {
              e.next = 18;
              break;
            }
            return e.next = 15, o.confirmOrderPay(t, c, s);
          case 15:
            e.t1 = e.sent, e.next = 21;
            break;
          case 18:
            return e.next = 20, ma(t, c, s);
          case 20:
            e.t1 = e.sent;
          case 21:
            if (l = e.t1, ke.reportData("order_pay_end", {
              xTraceId: l.xTraceId
            }), e.t2 = null == o ? void 0 : o.afterConfirm, !e.t2) {
              e.next = 27;
              break;
            }
            return e.next = 27, o.afterConfirm()["catch"](function (e) {
              return ke.handleError(e, "handleNextAction_afterConfirm_error");
            });
          case 27:
            return ke.reportData("nextAction_confirm_end"), e.abrupt("return", Ua(l, r));
          case 29:
          case "end":
            return e.stop();
        }
      }
    }, e);
  })), qa.apply(this, arguments);
}
function za(e, t) {
  return Za.apply(this, arguments);
}
function Za() {
  return Za = l(b.mark(function e(t, r) {
    var n, o, a, i, s;
    return b.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (o = (n = null != r ? r : {}).hooks, a = n.env, ke.reportData("handleNextAction_start", {
              nextAction: ke.formatReportData(t)
            }), t.type || ke.reportErrorData("Empty nextAction.type"), t.type !== ot.Confirm) {
              e.next = 7;
              break;
            }
            return e.abrupt("return", Ka(t, r));
          case 7:
            if (t.type !== ot.Redirect) {
              e.next = 13;
              break;
            }
            return e.next = 10, Ma(t, r)["catch"](function (e) {
              return ke.handleError(e, "handleNextAction_Redirect_error");
            });
          case 10:
          case 16:
          case 30:
            return e.abrupt("return", e.sent);
          case 13:
            if (t.type !== ot.ExchangeTicket) {
              e.next = 19;
              break;
            }
            return e.next = 16, Ma(t, r)["catch"](function (e) {
              return ke.handleError(e, "handleNextAction_ExchangeTicket_error");
            });
          case 19:
            if (t.type !== ot.OpenIframe) {
              e.next = 27;
              break;
            }
            return i = new Na(a, t), e.next = 23, i.render();
          case 23:
            return s = e.sent, e.abrupt("return", za(s, r));
          case 27:
            if (t.type !== ot.RedirectWebOrApp) {
              e.next = 33;
              break;
            }
            return e.next = 30, Va(t, r)["catch"](function (e) {
              return ke.handleError(e, "handleNextAction_RedirectWebOrApp_error");
            });
          case 33:
            if (null == o || !o.handlePayAction) {
              e.next = 37;
              break;
            }
            return e.abrupt("return", o.handlePayAction(t, r));
          case 37:
            throw new T(y.InvalidNextAction, v.InvalidNextAction, "InvalidNextAction");
          case 38:
          case "end":
            return e.stop();
        }
      }
    }, e);
  })), Za.apply(this, arguments);
}
var $a,
  Ja = "google_pay_client_",
  Xa = function () {
    function e(t, r) {
      n(this, e), c(this, "environment", void 0), c(this, "payOptions", void 0), c(this, "env", void 0), c(this, "initData", void 0), c(this, "startSubmitTime", void 0), this.reportData("constructor"), this.env = t, this.initData = r;
    }
    var t, r, o;
    return s(e, [{
      key: "afterSubmit",
      value: (o = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                this.startSubmitTime = new Date().getTime();
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return o.apply(this, arguments);
      })
    }, {
      key: "reportData",
      value: function value(e, t) {
        ke.reportData("".concat(Ja).concat(e), t);
      }
    }, {
      key: "handleErrorData",
      value: function value(e, t) {
        var r = sa[null == t ? void 0 : t.statusCode] || (null == t ? void 0 : t.statusCode),
          n = (null == t ? void 0 : t.message) || (null == t ? void 0 : t.statusMessage),
          o = {
            code: r || (null == t ? void 0 : t.code),
            msg: n,
            channelErrorCode: null == t ? void 0 : t.statusCode,
            channelErrorMsg: null == t ? void 0 : t.statusMessage
          };
        null != t && t.statusCode && (o.channelCode = r, o.channelMsg = n), ke.handleError(t, "".concat(Ja).concat(e), o);
      }
    }, {
      key: "triggerPayOptions",
      value: function value(e) {
        var t = this,
          r = this.payOptions[e];
        if (this.reportData(e), "function" == typeof r) {
          var n = function () {
            var e = l(b.mark(function e() {
              return b.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      return e.abrupt("return", r());
                    case 1:
                    case "end":
                      return e.stop();
                  }
                }
              }, e);
            }));
            return function () {
              return e.apply(this, arguments);
            };
          }();
          n().then(function () {
            t.reportData("".concat(e, "_after"));
          })["catch"](function (r) {
            t.reportData("".concat(e, "_error"), {
              error: r
            });
          });
        }
      }
    }, {
      key: "uploadToken",
      value: (r = l(b.mark(function e(t, r, n) {
        var o;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, aa(t, r);
              case 2:
                return o = e.sent, this.reportData("upload_order_token_success", {
                  url: t,
                  response: o
                }), e.abrupt("return", Ua(o, n));
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t, n) {
        return r.apply(this, arguments);
      })
    }, {
      key: "uploadError",
      value: (t = l(b.mark(function e(t, r) {
        var n = this;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", na(t, r)["catch"](function (e) {
                  ke.reportError(e, "".concat(Ja, "uploadOrderError"));
                  var t = T.handleAPIErrorData(null == e ? void 0 : e.data, {
                    code: v.AbnormalTrade,
                    msg: y.AbnormalTrade
                  });
                  return n.reportData("loadPaymentData_error", {
                    channelError: r,
                    response: t
                  }), t;
                }));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function (e, r) {
        return t.apply(this, arguments);
      })
    }]), e;
  }(),
  Ya = "paymentSdk_confirmModel_3cf1877d",
  Qa = "paymentSdk_title_3cf1877d",
  ei = "paymentSdk_content_3cf1877d",
  ti = "paymentSdk_footer_3cf1877d",
  ri = "paymentSdk_cancelBtn_3cf1877d";
function ni(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
!function (e) {
  e.OK = "OK", e.Cancel = "Cancel";
}($a || ($a = {}));
var oi = function (e) {
    _(r, Yt);
    var t = ni(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "componentDidCatch",
      value: function value(e) {
        ke.reportError(e, "ConfirmComponent_componentDidCatch_error");
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.title,
          r = e.content,
          n = e.okText,
          o = e.cancelText,
          a = e.onOk,
          i = e.onCancel;
        return $t("div", {
          className: Ya
        }, t && $t("div", {
          className: Qa
        }, t), r && $t("div", {
          className: ei
        }, r), $t("div", {
          className: ti
        }, n && $t("div", {
          onClick: a
        }, n), o && $t("div", {
          className: ri,
          onClick: i
        }, o)));
      }
    }]), r;
  }(),
  ai = function ai(e) {
    var t = e.title,
      r = e.content,
      n = e.okText,
      o = e.cancelText,
      a = e.onOk,
      i = e.onCancel,
      s = e.theme,
      c = e.timeout,
      u = e.onTimeout,
      l = new Da(),
      p = null;
    return l.show({
      content: $t(oi, {
        title: t,
        content: r,
        okText: n,
        cancelText: o,
        onOk: function onOk() {
          a();
        },
        onCancel: function onCancel() {
          i();
        }
      }),
      theme: s
    }), c && (p = window.setTimeout(function () {
      p = null, u && u();
    }, c)), {
      destroy: function destroy() {
        l.destroy(), p && (window.clearTimeout(p), p = null);
      }
    };
  };
function ii(e, t, r) {
  return "https://".concat(r === rt.CN ? "cdn.myshopline.cn" : "cdn.myshopline.com", "/t/i18n/payment-acceptance-payment-sdk/").concat(e || _t.Prod, "/").concat(t || ze, ".raw.tree.json");
}
var si = "After clicking the checkout button below, you will be redirected to AFTEE to complete your purchase securely.",
  ci = 'After clicking "Complete order", you will be redirected to Afterpay to complete your purchase securely.',
  ui = 'After clicking "Complete order", you will be redirected to GrabPay to complete your purchase sercurely. ',
  li = "After clicking “Complete order”, you will be redirected to Bancontact to complete your purchase securely.",
  pi = "After clicking “Complete order”, you will be redirected to Dana to complete your purchase securely.",
  di = "After clicking the checkout button below, you will be redirected to FPS QR code to complete your purchase securely.",
  fi = {
    FPXFooter: "Completing the payment means that you agree to the FPX ${serviceTerms}",
    FPXPayGuide: "The next step will be connected to the bank page to make the payment. After completion, please remember to press Confirm payment and return to the order page to confirm that the order is complete.",
    bankMaintenance: "Bank maintenance to",
    footer: "$RT$Completing the payment means that you agree to the FPX [terms of service](https://www.mepsfpx.com.my/FPXMain/termsAndConditions.jsp)",
    selectBank: "Please select a bank",
    serviceTerms: "terms of service"
  },
  hi = {
    cancelText: "Cancel",
    okText: "Pay with {{icon}}",
    prompt: "Continue the transaction with Google Pay？"
  },
  vi = "After clicking “Complete order”, you will be redirected to JKOPay to complete your purchase securely.",
  yi = "After clicking the checkout button below, you will be redirected to Klarna to complete your purchase securely.",
  mi = "After clicking the checkout button below, you will be redirected to LINE Pay to complete your purchase securely.",
  gi = "After clicking “Complete order”, you will be redirected to LinkAja to complete your purchase securely.",
  bi = {
    footer: "Complete the payment on your OVO App after confirming.",
    invalidErrorHint: "Enter a valid mobile number",
    mobilePhoneLabel: "Mobile number"
  },
  ki = "Enter the mobile number you registered on your OVO wallet.",
  wi = "After clicking “Complete order”, you will be redirected to Przelewy24 to complete your purchase securely.",
  Ci = "After clicking “Complete order”, you will be redirected to QRIS to complete your purchase securely.",
  _i = "The payment is powered by SHOPLINE Payments. SHOPLINE Payments is PCI-DSS Level 1 validated and supports the secure use of domestic ＆ international credit cards.",
  Oi = {
    idNumber: {
      43100: "The ID number has currently reached 1 error in verification data. After accumulating 3 errors today, this ID number will no longer be queryable.",
      43101: "The ID number has currently reached 2 errors in verification data. After accumulating 3 errors today, this ID number will no longer be queryable.",
      43102: "The ID number has currently reached 3 errors in verification data. After accumulating 3 errors today, this ID number will no longer be queryable.",
      43103: "The ID number has reached 3 errors in verification data. It cannot be queried today; please check again after 12:00 AM tomorrow.",
      43104: "The ID number you queried has been deactivated.",
      43105: "The ID you queried has been reported lost by the applicant.",
      43106: "The service for verifying the ID data is busy. Please try again later.",
      errorTips: "Please enter a valid Number",
      exceededLimitErrorTimes: "The identity information has been wrong 3 times today, please try again tomorrow",
      labelTitle: "Number"
    },
    issueDate: {
      errorTips: "Please enter a valid date",
      labelTitle: "Date"
    },
    issueLocation: {
      errorTips: "Please select the Issuing Municipality",
      labelTitle: "Issuing Municipality"
    },
    issueLocationOptions: {
      i18nKey_09007: "連江",
      i18nKey_09020: "金門",
      i18nKey_10001: "北縣",
      i18nKey_10002: "宜縣",
      i18nKey_10003: "桃縣",
      i18nKey_10004: "竹縣",
      i18nKey_10005: "苗縣",
      i18nKey_10006: "中縣",
      i18nKey_10007: "彰縣",
      i18nKey_10008: "投縣",
      i18nKey_10009: "雲縣",
      i18nKey_10010: "嘉縣",
      i18nKey_10011: "南縣",
      i18nKey_10012: "高縣",
      i18nKey_10013: "屏縣",
      i18nKey_10014: "東縣",
      i18nKey_10015: "花縣",
      i18nKey_10016: "澎縣",
      i18nKey_10017: "基市",
      i18nKey_10018: "竹市",
      i18nKey_10020: "嘉市",
      i18nKey_63000: "北市",
      i18nKey_64000: "高市",
      i18nKey_65000: "新北市",
      i18nKey_66000: "中市",
      i18nKey_67000: "南市",
      i18nKey_68000: "桃市"
    },
    replacementCategory: {
      errorTips: "Please select the Issuance Type",
      labelTitle: "Issuance Type"
    },
    replacementCategoryOptions: {
      i18nKey_0: "未領",
      i18nKey_1: "初發",
      i18nKey_2: "補發",
      i18nKey_3: "換發"
    },
    title: 'According to the regulation requirement, S Technology Co., Ltd. ("SHOPLINE PAYMENTS") will collect your National ID and transaction records of large transactions and delete them after the statutory period',
    tooltip: "$RT$**Due to regulatory requirements, we have to collect your identity information for the transactions below:**\n1. A single credit card transaction exceeding NT$ 200,000;\n\n2. A single non-credit card transaction exceeding NT$ 50,000;\n\nFor details, please see: [Regulations Governing Anti-Money Laundering and Countering the Financing of Terrorism for the Third-Party Payment Enterprises](https://law.moj.gov.tw/LawClass/LawAll.aspx?pcode=J0080060)"
  },
  Pi = {
    bankNameI18nKey_BCA: "BCA",
    bankNameI18nKey_BJB: "BJB",
    bankNameI18nKey_BNI: "BNI",
    bankNameI18nKey_BRI: "BRI",
    bankNameI18nKey_BSI: "BSI",
    bankNameI18nKey_CIMB: "CIMB",
    bankNameI18nKey_MANDIRI: "Mandiri",
    bankNameI18nKey_Otherbanks: "Other Banks",
    bankNameI18nKey_PERMATA: "Permata",
    bankNameI18nKey_SAHABAT_SAMPOERNA: "BSS",
    footer: "The next step will be to connect to the bank page for payment, please remember to press confirm payment after completion, and return to the order page to confirm the completion of the order.",
    selectBank: "Choose payment bank"
  },
  xi = "After clicking “Complete order”, you will be redirected to bank to complete your purchase securely.",
  Ii = "After clicking “Complete order”, you will be redirected to Zip to complete your purchase securely.",
  Si = 'After clicking "Complete order", you will be redirected to Alipay to complete your purchase securely.',
  Di = "After clicking “Complete order”, you can select the cards stored on your ApplePay account to complete your purchase securely.",
  Ri = 'After clicking "Complete order", you will be redirected to Atome to complete your purchase securely.',
  Ei = {
    BANK_SINOPAC: "永豐銀行",
    CATHAY_UNITED_BANK: "國泰世華",
    CHINATRUST_COMMERCIAL_BANK: "中信銀行",
    "DBS_BANK_(TAIWAN)_LTD": "星展銀行",
    E_SUN_COMMERCIAL_BANK: "玉山銀行",
    FAR_EASTERN_INTERNATIONAL_BANK: "遠東商銀",
    KGI_BANK: "凱基銀行",
    TAIPEI_FUBON_COMMERCIAL_BANK: "",
    TAISHIN_INTERNATIONAL_BANK: "台新銀行",
    UNION_BANK_OF_TAIWAN: "聯邦銀行"
  },
  Ti = {
    43010: "Oops! The payment method is under maintenance. Please use another payment method.",
    43012: "The application currently in use does not support this payment method at the moment. Please select another payment method."
  },
  Ai = "bank card not supported at this stage",
  Li = "An error has occurred. Please try again with a different card or payment method",
  ji = 'After clicking "Complete order", you will be redirected to Chailease 0Card to complete your purchase securely.',
  Ni = "You've made too many incorrect card number inputs. Please try again with a different card or payment method.",
  Bi = "You've made too many incorrect CVV/CVC inputs. Please try again with a different card or payment method.",
  Mi = "We've blocked bank card payments as you've made too many incorrect CVV/CVC inputs. Please try again after 24 hours or use a different payment method",
  Fi = "Card information is guaranteed  to be safe on PCI DSS standards.",
  Hi = {
    cvc: {
      errorTips: "Enter a valid CVV/CVC",
      labelTitle: "CVV/CVC",
      placeholder: "",
      tips: "The 3-digit numeric code displayed on the back of your card (or the 4-digit code at the front for American Express® users)."
    },
    expDate: {
      errorTips: "Enter a valid expiry date",
      labelTitle: "Expiry date (MM/YY)",
      placeholder: "",
      tips: ""
    },
    firstName: {
      errorTips: "Enter your full name as shown on your bank card",
      labelTitle: "Cardholder name",
      placeholder: "",
      tips: "Separate the first and last names with a blank space"
    },
    number: {
      errorTips: "Enter a valid card number",
      labelTitle: "Card number",
      placeholder: "",
      tips: "All transactions are secure and encrypted"
    }
  },
  Vi = "After clicking the checkout button below, you can pay with Google Pay.",
  Wi = 'After clicking "Complete order", you will be redirected to Grab pay to complete your purchase securely.',
  Ui = "After clicking “Complete order”, you will be redirected to iDEAL to complete your purchase securely.",
  Gi = "3 Installments supported banks：\n台新銀行、國泰世華、中信銀行、玉山銀行、永豐銀行、凱基銀行、聯邦銀行\n\n6 Installments supported banks：\n台新銀行、國泰世華、中信銀行、玉山銀行、永豐銀行、凱基銀行、聯邦銀行\n\n9 Installments supported banks：\n台新銀行、國泰世華、中信銀行、凱基銀行、聯邦銀行\n\n12 Installments supported banks：\n台新銀行、國泰世華、中信銀行、玉山銀行、永豐銀行、凱基銀行、聯邦銀行\n\n18 Installments supported banks：\n台新銀行、國泰世華、中信銀行、玉山銀行、凱基銀行、聯邦銀行\n\n24 Installments supported banks：\n台新銀行、國泰世華、中信銀行、玉山銀行、凱基銀行、聯邦銀行",
  Ki = "3 Installments supported banks：\n台新銀行、國泰世華、中信銀行、玉山銀行、永豐銀行、凱基銀行、聯邦銀行\n\n6 Installments supported banks：\n台新銀行、國泰世華、中信銀行、玉山銀行、永豐銀行、凱基銀行、聯邦銀行\n\n9 Installments supported banks：\n台新銀行、國泰世華、中信銀行、凱基銀行、聯邦銀行\n\n12 Installments supported banks：\n台新銀行、國泰世華、中信銀行、玉山銀行、永豐銀行、凱基銀行、聯邦銀行\n\n18 Installments supported banks：\n台新銀行、國泰世華、中信銀行、玉山銀行、凱基銀行、聯邦銀行\n\n24 Installments supported banks：\n台新銀行、國泰世華、中信銀行、玉山銀行、凱基銀行、聯邦銀行",
  qi = "3 Installments supported banks：\n台新銀行、中信銀行、玉山銀行\n\n6 Installments supported banks：\n台新銀行、中信銀行、玉山銀行\n\n9 Installments supported banks：\n台新銀行、中信銀行\n\n12 Installments supported banks：\n台新銀行、中信銀行、玉山銀行\n\n18 Installments supported banks：\n台新銀行、中信銀行、玉山銀行\n\n24 Installments supported banks：\n台新銀行、中信銀行、玉山銀行",
  zi = "3 Installments supported banks：\n台新銀行、玉山銀行\n\n6 Installments supported banks：\n台新銀行、玉山銀行\n\n9 Installments supported banks：\n台新銀行\n\n12 Installments supported banks：\n台新銀行、玉山銀行\n\n18 Installments supported banks：\n台新銀行、玉山銀行\n\n24 Installments supported banks：\n台新銀行、玉山銀行",
  Zi = "{{number}} installments",
  $i = "1. Any indivisible amount remaining will be collected in the first installment.",
  Ji = "2. The actual installment amount will differ slightly according to the regulations of each credit card issuing bank. ",
  Xi = "Details from each supporting bank may differ due to varying product regard. ",
  Yi = "Please select the number of installments. ",
  Qi = "A total of {{count}} installments, each repayment amount as {{money}}. ",
  es = "{{period}} Installments supported banks：\n{{banks}}\n",
  ts = "Supported banks",
  rs = "Supported banks",
  ns = "Fast checkout with your saved cards",
  os = "Use a new card",
  as = "Please agree to the agreement first",
  is = "After clicking “Complete order”, you will be redirected to PayNow QR checkout page to complete you purchase securely. ",
  ss = "After clicking “Go checkout”, you will be redirected to PayNow QR checkout page to complete you purchase securely. ",
  cs = "Agree to remember the credit card information for quick payment next time.",
  us = "You agree to save the payment details under your user account to facilitate future transactions.",
  ls = "You agree to save the payment details under your user account to facilitate future transactions.",
  ps = "Sorry, this method is not currently supported, please use another method to complete the payment.",
  ds = "Invalid card. Please try again with another card",
  fs = "Enter a valid card number to ensure a successful transaction",
  hs = "Enter a valid CVV/CVC",
  vs = "Enter card number manually",
  ys = "Enter a valid expiry date",
  ms = "Enter your full name as shown on your bank card",
  gs = "Example: John Doe",
  bs = "Enter a valid card number",
  ks = 'After clicking "Complete order", you will be redirected to Boost to complete your purchase securely.',
  ws = 'After clicking "Complete order", you will be redirected to  GrabPay to complete your purchase securely.',
  Cs = 'After clicking "Complete order", you will be redirected to  Maybank QR to complete your purchase securely.',
  _s = 'After clicking "Complete order", you will be redirected to  Touch \'n Go to complete your purchase securely.',
  Os = "SHOPLINE Payments Privacy Policy",
  Ps = {
    AU: "Card information is guaranteed to be safe on PCI DSS standards.",
    CN: "$RT$You are using SHOPLINE Payments to checkout now. By completing the payment, you are agree to the [Terms of service of SHOPLINE Payments](https://www.shopline.com/about-payments-shopper-terms).",
    GB: "Card information is guaranteed to be safe on PCI DSS standards.",
    HK: "$RT$You are using SHOPLINE Payments to checkout now. By completing the payment, you are agree to the  [Terms of service of SHOPLINE Payments](https://www.shopline.com/about-payments-shopper-terms).",
    HK2: "Card information is guaranteed to be safe on PCI DSS standards.",
    MY: "The payment is powered by SHOPLINE Payments. SHOPLINE Payments is PCI-DSS Level 1 validated and supports the secure use of domestic ＆ international credit cards.",
    MY2: "Card information is guaranteed to be safe on PCI DSS standards.",
    SG: "The payment is powered by SHOPLINE Payments. SHOPLINE Payments is PCI-DSS Level 1 validated and supports the secure use of domestic ＆ international credit cards.",
    SG2: "Card information is guaranteed to be safe on PCI DSS standards.",
    TW: "The payment is powered by SHOPLINE Payments. SHOPLINE Payments is PCI-DSS Level 1 validated and supports the secure use of domestic ＆ international credit cards.",
    US: "Card information is guaranteed to be safe on PCI DSS standards."
  },
  xs = "$RT$We'll use the payment details you just provided for subsequent recurrent payments. By submitting, you agree to the [Term Purchase bank card Withholding Agreement](https://shopline.tw/about/product_subscription_agreements_en).",
  Is = "$RT$SHOPLINE will use this transaction information as a subsequent regular deduction. Click Submit to agree to the  [SHOPLINE Payments Terms](https://shoplineapp.com/about/payments_terms_agreements) and [SHOPLINE Payments Privacy Policy](https://shopline.com/privacy)",
  Ss = "$RT$SHOPLINE will use this transaction information as a subsequent regular deduction. Click Submit to agree to the  [SHOPLINE Payments Terms](https://shopline.tw/about/shopline_payments_terms) and [SHOPLINE Payments Privacy Policy](https://shopline.tw/about/privacy)",
  Ds = "Not supported",
  Rs = {
    43e3: "Bank card brand not supported at this stage",
    43001: "Card-issue bank not supported at this stage",
    43002: "Bank card type not supported at this stage",
    43003: "Bank card issued in this country/region not supported at this stage",
    43004: "Bank card class not supported at this stage",
    43005: "Bank card series not supported at this stage",
    43006: "Installment period not supported at this time",
    43007: "We don't support this payment method at this time. Please choose another method and try again.",
    43008: "Transaction amount incompatible at this stage"
  },
  Es = "After clicking “Complete order”, you will be redirected to WeChat Pay to complete your purchase securely.",
  Ts = {
    AfteeGuide: si,
    AfterpayGuide: ci,
    AwxGrabPayGuide: ui,
    BancontactGuide: li,
    DanaGuide: pi,
    FPSGuide: di,
    FPX: fi,
    GooglePayGuideModel: hi,
    JKOPayGuide: vi,
    KlarnaGuide: yi,
    LINEPayGuide: mi,
    LINKAJAGuide: gi,
    OVO: bi,
    OVOGuide: ki,
    Przelewy24Guide: wi,
    QRISGuide: Ci,
    SLPaymentsFooter: _i,
    TWIdCard: Oi,
    VirtualAccount: Pi,
    VirtualAccountGuide: xi,
    ZipPayGuide: Ii,
    alipayPayGuide: Si,
    applePayGuide: Di,
    atomePayGuide: Ri,
    banks: Ei,
    blockText: Ti,
    cardIsNotSupported: Ai,
    cardNotProcessedPleaseChangeAnother: Li,
    chaileasePayGuide: ji,
    errorCardNumberTooManyTimesAndAfter24hRetry: Ni,
    errorSecurityCodeTooManyTimes: Bi,
    errorSecurityCodeTooManyTimesAndAfter24hRetry: Mi,
    footer: Fi,
    formItems: Hi,
    googlePayGuide: Vi,
    grabPayPayLaterGuide: Wi,
    iDEALGuide: Ui,
    installmentBank: Gi,
    installmentBankBeta: Ki,
    installmentBankForIndividual: qi,
    installmentBankForPrepaidIndividual: zi,
    installmentBankSeparator: "、",
    installmentCount: Zi,
    installmentDesc1: $i,
    installmentDesc2: Ji,
    installmentDesc3: "",
    installmentDiff: Xi,
    installmentSelect: Yi,
    installmentSelectParm: Qi,
    installmentSupportBank: es,
    installmentSupportContentTip: ts,
    installmentSupportTip: rs,
    instrumentCheckout: ns,
    instrumentChoose: os,
    instrumentRequireTip: as,
    language: "英文",
    payNowGuide: is,
    payNowLogistics: ss,
    paymentAgreement: cs,
    paymentAgreement_HK: us,
    paymentAgreement_TW: ls,
    paymentMethodNotSupported: ps,
    pleaseChangeAnotherCard: ds,
    pleaseEnsureCardNumber: fs,
    pleaseEnterCVV: hs,
    pleaseEnterCardNumberManually: vs,
    pleaseEnterExpired: ys,
    pleaseEnterNameOnCard: ms,
    pleaseEnterNameOnCardOrBusinessName: gs,
    pleaseEnterValidCardNumber: bs,
    revpayBSTPayGuide: ks,
    revpayGRBPayGuide: ws,
    revpayQRMBBPayGuide: Cs,
    revpayTNGPayGuide: _s,
    shangyehuaprivacy: Os,
    slPaymentsCountryFooter: Ps,
    subscribeAgreement: xs,
    subscribeAgreement_HK: Is,
    subscribeAgreement_TW: Ss,
    unsupportedCount: Ds,
    validator: Rs,
    wechatPayGuide: Es
  },
  As = Object.freeze({
    __proto__: null,
    AfteeGuide: si,
    AfterpayGuide: ci,
    AwxGrabPayGuide: ui,
    BancontactGuide: li,
    DanaGuide: pi,
    FPSGuide: di,
    FPX: fi,
    GooglePayGuideModel: hi,
    JKOPayGuide: vi,
    KlarnaGuide: yi,
    LINEPayGuide: mi,
    LINKAJAGuide: gi,
    OVO: bi,
    OVOGuide: ki,
    Przelewy24Guide: wi,
    QRISGuide: Ci,
    SLPaymentsFooter: _i,
    TWIdCard: Oi,
    VirtualAccount: Pi,
    VirtualAccountGuide: xi,
    ZipPayGuide: Ii,
    alipayPayGuide: Si,
    applePayGuide: Di,
    atomePayGuide: Ri,
    banks: Ei,
    blockText: Ti,
    cardIsNotSupported: Ai,
    cardNotProcessedPleaseChangeAnother: Li,
    chaileasePayGuide: ji,
    errorCardNumberTooManyTimesAndAfter24hRetry: Ni,
    errorSecurityCodeTooManyTimes: Bi,
    errorSecurityCodeTooManyTimesAndAfter24hRetry: Mi,
    footer: Fi,
    formItems: Hi,
    googlePayGuide: Vi,
    grabPayPayLaterGuide: Wi,
    iDEALGuide: Ui,
    installmentBank: Gi,
    installmentBankBeta: Ki,
    installmentBankForIndividual: qi,
    installmentBankForPrepaidIndividual: zi,
    installmentBankSeparator: "、",
    installmentCount: Zi,
    installmentDesc1: $i,
    installmentDesc2: Ji,
    installmentDesc3: "",
    installmentDiff: Xi,
    installmentSelect: Yi,
    installmentSelectParm: Qi,
    installmentSupportBank: es,
    installmentSupportContentTip: ts,
    installmentSupportTip: rs,
    instrumentCheckout: ns,
    instrumentChoose: os,
    instrumentRequireTip: as,
    language: "英文",
    payNowGuide: is,
    payNowLogistics: ss,
    paymentAgreement: cs,
    paymentAgreement_HK: us,
    paymentAgreement_TW: ls,
    paymentMethodNotSupported: ps,
    pleaseChangeAnotherCard: ds,
    pleaseEnsureCardNumber: fs,
    pleaseEnterCVV: hs,
    pleaseEnterCardNumberManually: vs,
    pleaseEnterExpired: ys,
    pleaseEnterNameOnCard: ms,
    pleaseEnterNameOnCardOrBusinessName: gs,
    pleaseEnterValidCardNumber: bs,
    revpayBSTPayGuide: ks,
    revpayGRBPayGuide: ws,
    revpayQRMBBPayGuide: Cs,
    revpayTNGPayGuide: _s,
    shangyehuaprivacy: Os,
    slPaymentsCountryFooter: Ps,
    subscribeAgreement: xs,
    subscribeAgreement_HK: Is,
    subscribeAgreement_TW: Ss,
    unsupportedCount: Ds,
    validator: Rs,
    wechatPayGuide: Es,
    "default": Ts
  });
function Ls(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function js(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ls(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ls(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var Ns = {
    "zh-CN": "zh-hans-cn",
    "zh-TW": "zh-hant-tw",
    no: "nb"
  },
  Bs = {},
  Ms = function () {
    function e(t, r) {
      n(this, e), c(this, "language", ze), c(this, "newLanguage", void 0), c(this, "displayLanguage", void 0), c(this, "data", void 0), c(this, "defaultData", void 0), c(this, "env", void 0), c(this, "languageJson", void 0), c(this, "defaultJson", void 0), c(this, "cdn", void 0), this.language = t, this.env = r.env, this.cdn = r.cdn, this.init();
    }
    var t, r, o, a, i, u, p;
    return s(e, [{
      key: "init",
      value: function value() {
        var e = this,
          t = this.language || ze;
        this.newLanguage = "string" == typeof t ? {
          extend: t
        } : t, this.newLanguage.extend = this.newLanguage.extend || ze, this.displayLanguage = this.newLanguage.extend;
        var r = Ns[this.displayLanguage] ? Ns[this.displayLanguage] : this.displayLanguage;
        this.languageJson = this.requestJsonData(r)["catch"](function () {
          var t = l(b.mark(function t(n) {
            return b.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return ke.reportError(n, "I18n_request_".concat(r, "_error"), {
                      language: r,
                      response: {
                        error: n
                      }
                    }), ke.reportData("I18n_use_en_language", {
                      displayLanguage: r
                    }), e.displayLanguage = ze, e.defaultJson = e.getDefaultLanguage(), t.abrupt("return", e.defaultJson);
                  case 5:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          }));
          return function (e) {
            return t.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "getDefaultLanguage",
      value: function value() {
        return this.requestJsonData(ze)["catch"](function (e) {
          return ke.reportData("I18n_use_sdk_inner_language", {
            errorMessage: e.message
          }), {
            data: As,
            options: {},
            statusCode: 200,
            url: "inner"
          };
        });
      }
    }, {
      key: "setData",
      value: (p = l(b.mark(function e() {
        var t, r;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.languageJson;
              case 2:
                t = e.sent, r = t.data, this.data = r;
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return p.apply(this, arguments);
      })
    }, {
      key: "setDefaultData",
      value: (u = l(b.mark(function e() {
        var t, r;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return Boolean(this.defaultJson) || (this.defaultJson = this.getDefaultLanguage()), e.next = 3, this.defaultJson;
              case 3:
                t = e.sent, r = t.data, this.defaultData = r;
              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return u.apply(this, arguments);
      })
    }, {
      key: "requestJsonData",
      value: (i = l(b.mark(function e(t) {
        var r, n, o, a;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (r = "".concat(this.env, "_").concat(t), n = Bs[r], !Boolean(n)) {
                  e.next = 4;
                  break;
                }
                return e.abrupt("return", n);
              case 4:
                return o = ii(this.env, t, this.cdn), a = function () {
                  var e = l(b.mark(function e() {
                    return b.wrap(function (e) {
                      for (;;) {
                        switch (e.prev = e.next) {
                          case 0:
                            return e.abrupt("return", Se.http(o, {
                              method: "GET",
                              headers: {
                                Accept: "application/json"
                              }
                            })["catch"](function (e) {
                              throw delete Bs[r], ke.reportData("I18n_request_".concat(t, "_error"), {
                                language: t,
                                response: {
                                  error: e
                                }
                              }), e;
                            }));
                          case 1:
                          case "end":
                            return e.stop();
                        }
                      }
                    }, e);
                  }));
                  return function () {
                    return e.apply(this, arguments);
                  };
                }(), Bs[r] = Fe(a)(), e.abrupt("return", Bs[r]);
              case 8:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return i.apply(this, arguments);
      })
    }, {
      key: "getVal",
      value: function value(e, t) {
        return t ? t.split(".").reduce(function (e, t) {
          var r;
          return null !== (r = null == e ? void 0 : e[t]) && void 0 !== r ? r : "";
        }, e) : "";
      }
    }, {
      key: "getOne",
      value: (a = l(b.mark(function e(t) {
        var r;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.data) {
                  e.next = 3;
                  break;
                }
                return e.next = 3, this.setData();
              case 3:
                if ("" !== (r = "" === (r = this.getVal(this.newLanguage, t)) ? this.getVal(this.data, t) : r)) {
                  e.next = 12;
                  break;
                }
                if (this.defaultData) {
                  e.next = 9;
                  break;
                }
                return e.next = 9, this.setDefaultData();
              case 9:
                return e.abrupt("return", this.getVal(this.defaultData, t));
              case 12:
                return e.abrupt("return", r);
              case 13:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return a.apply(this, arguments);
      })
    }, {
      key: "getData",
      value: (o = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.data) {
                  e.next = 3;
                  break;
                }
                return e.next = 3, this.setData();
              case 3:
                return e.abrupt("return", js(js({}, this.data), this.newLanguage));
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return o.apply(this, arguments);
      })
    }, {
      key: "get",
      value: (r = l(b.mark(function e(t) {
        var r = this;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (!Array.isArray(t)) {
                  e.next = 4;
                  break;
                }
                return e.abrupt("return", Promise.all(t.map(function (e) {
                  return r.getOne(e);
                })));
              case 4:
                return e.abrupt("return", this.getOne(t));
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return r.apply(this, arguments);
      })
    }, {
      key: "getDisplayLanguage",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.data) {
                  e.next = 3;
                  break;
                }
                return e.next = 3, this.setData();
              case 3:
                return e.abrupt("return", this.displayLanguage);
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }]), e;
  }(),
  Fs = function Fs(e) {
    return $t("svg", kr({}, e, {
      width: "61",
      height: "24",
      viewBox: "0 0 61 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }), $t("g", {
      "clip-path": "url(#clip0_835_38458)"
    }, $t("path", {
      d: "M29.0843 11.7248V18.76H26.8524V1.38622H32.7717C33.4783 1.37146 34.1807 1.49678 34.8386 1.75493C35.4965 2.01308 36.0967 2.39896 36.6047 2.8903C37.1177 3.3518 37.5261 3.91779 37.8022 4.55023C38.0784 5.18266 38.216 5.86688 38.2058 6.5569C38.2205 7.25062 38.085 7.93931 37.8086 8.57577C37.5323 9.21223 37.1216 9.78142 36.6047 10.2443C35.5696 11.2313 34.2919 11.7244 32.7717 11.7234H29.0843V11.7248ZM29.0843 3.52519V9.59H32.8271C33.2375 9.60216 33.6458 9.52855 34.0261 9.37387C34.4063 9.2192 34.7501 8.98686 35.0354 8.69172C35.3193 8.41577 35.5449 8.08571 35.6989 7.72105C35.853 7.3564 35.9324 6.96455 35.9324 6.56869C35.9324 6.17282 35.853 5.78098 35.6989 5.41632C35.5449 5.05167 35.3193 4.72161 35.0354 4.44566C34.7537 4.1443 34.4111 3.90627 34.0304 3.74734C33.6497 3.58841 33.2395 3.51222 32.8271 3.52381H29.0843V3.52519Z",
      fill: "currentColor"
    }), $t("path", {
      d: "M43.3487 6.48473C44.9984 6.48473 46.3005 6.92555 47.2552 7.8072C48.2098 8.68885 48.6867 9.89765 48.6858 11.4336V18.7599H46.5509V17.1103H46.4539C45.5297 18.4688 44.3006 19.148 42.7665 19.148C41.457 19.148 40.3614 18.7599 39.4797 17.9836C39.0566 17.6273 38.7184 17.1811 38.4896 16.6775C38.2608 16.1739 38.1473 15.6255 38.1573 15.0725C38.1573 13.8424 38.6221 12.8642 39.5518 12.1378C40.4815 11.4114 41.7227 11.0473 43.2753 11.0455C44.6005 11.0455 45.6919 11.2881 46.5496 11.7732V11.2631C46.5521 10.8861 46.4707 10.5132 46.3112 10.1715C46.1518 9.82986 45.9183 9.52795 45.6277 9.28771C45.0375 8.75522 44.2683 8.46468 43.4735 8.47398C42.2268 8.47398 41.2403 8.99983 40.5139 10.0515L38.5482 8.81361C39.6294 7.26102 41.2296 6.48473 43.3487 6.48473ZM40.4612 15.121C40.4597 15.4051 40.5261 15.6853 40.6549 15.9385C40.7836 16.1917 40.971 16.4105 41.2014 16.5766C41.695 16.9648 42.3077 17.1705 42.9356 17.1588C43.8774 17.1572 44.7802 16.7823 45.4461 16.1163C46.1854 15.4204 46.5551 14.6039 46.5551 13.6668C45.8592 13.1123 44.8888 12.8351 43.644 12.8351C42.7374 12.8351 41.9814 13.0537 41.3761 13.4908C40.7648 13.9344 40.4612 14.4736 40.4612 15.121Z",
      fill: "currentColor"
    }), $t("path", {
      d: "M60.9401 6.87292L53.4877 23.9999H51.1838L53.9493 18.0072L49.049 6.87292H51.4749L55.0167 15.4122H55.0652L58.51 6.87292H60.9401Z",
      fill: "currentColor"
    }), $t("path", {
      d: "M20.0654 10.2082C20.0663 9.52804 20.0088 8.84907 19.8935 8.17874H10.481V12.0228H15.872C15.7617 12.6367 15.5282 13.222 15.1856 13.7433C14.843 14.2646 14.3984 14.7111 13.8786 15.0559V17.5511H17.0961C18.98 15.8142 20.0654 13.2455 20.0654 10.2082Z",
      fill: "#4285F4"
    }), $t("path", {
      d: "M10.481 19.9618C13.1744 19.9618 15.4423 19.0774 17.0961 17.5526L13.8786 15.0573C12.9831 15.6645 11.8298 16.0111 10.481 16.0111C7.87759 16.0111 5.66792 14.2561 4.87777 11.8911H1.56326V14.4626C2.39399 16.1157 3.66782 17.5053 5.24254 18.4764C6.81726 19.4475 8.63089 19.9618 10.481 19.9618Z",
      fill: "#34A853"
    }), $t("path", {
      d: "M4.87775 11.8911C4.46003 10.6519 4.46003 9.30986 4.87775 8.07062V5.49915H1.56325C0.864412 6.88976 0.500458 8.42453 0.500458 9.98086C0.500458 11.5372 0.864412 13.072 1.56325 14.4626L4.87775 11.8911Z",
      fill: "#FBBC04"
    }), $t("path", {
      d: "M10.481 3.95079C11.9043 3.92753 13.2797 4.46533 14.3098 5.44793L17.1585 2.5992C15.3521 0.902547 12.959 -0.0289447 10.481 -1.28505e-06C8.63089 8.30333e-05 6.81726 0.51437 5.24254 1.48544C3.66782 2.45652 2.39399 3.84616 1.56326 5.49922L4.87777 8.0707C5.66792 5.70577 7.87759 3.95079 10.481 3.95079Z",
      fill: "#EA4335"
    })), $t("defs", null, $t("clipPath", {
      id: "clip0_835_38458"
    }, $t("rect", {
      width: "60.436",
      height: "24",
      fill: "currentColor",
      transform: "translate(0.5)"
    }))));
  },
  Hs = "paymentSdk_payBtn_3bcbba35";
function Vs(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Ws = function (e) {
    _(p, Xa);
    var t,
      r,
      o,
      a,
      i,
      u = Vs(p);
    function p() {
      var e;
      n(this, p);
      for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++) {
        r[o] = arguments[o];
      }
      return c(w(e = u.call.apply(u, [this].concat(r))), "googlePayClient", null), e;
    }
    return s(p, [{
      key: "isReadyToPay",
      value: (i = l(b.mark(function e(t, r) {
        var n, o;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return this.environment = t, e.next = 3, this.getGooglePayClient();
              case 3:
                return n = e.sent, e.prev = 4, this.reportData("isReadyToPay_start", {
                  isReadyToPayRequest: r
                }), e.next = 8, n.isReadyToPay(r);
              case 8:
                if (null != (o = e.sent) && o.result) {
                  e.next = 11;
                  break;
                }
                throw new T(y.DeviceNotSupportPaymentMethod, v.DeviceNotSupportPaymentMethod);
              case 11:
                return this.reportData("isReadyToPay_end", {
                  result: o
                }), e.abrupt("return", !0);
              case 15:
                e.prev = 15, e.t0 = e["catch"](4), this.handleErrorData("isReadyToPay_end_error", e.t0);
              case 18:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[4, 15]]);
      })), function (e, t) {
        return i.apply(this, arguments);
      })
    }, {
      key: "getGooglePayClient",
      value: (a = l(b.mark(function e() {
        var t, r, n;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (null !== this.googlePayClient) {
                  e.next = 14;
                  break;
                }
                if (e.prev = 1, this.reportData("new_instance_start", {
                  environment: this.environment
                }), null === (t = window.google) || void 0 === t || null === (r = t.payments) || void 0 === r || null === (n = r.api) || void 0 === n || !n.PaymentsClient) {
                  e.next = 8;
                  break;
                }
                this.googlePayClient = new window.google.payments.api.PaymentsClient({
                  environment: this.environment,
                  paymentDataCallbacks: {
                    onPaymentAuthorized: this.onPaymentAuthorized
                  }
                }), this.reportData("new_instance_end"), e.next = 9;
                break;
              case 8:
                throw new T("invalid window.google");
              case 9:
                e.next = 14;
                break;
              case 11:
                e.prev = 11, e.t0 = e["catch"](1), this.handleErrorData("new_instance_end_error", e.t0);
              case 14:
                return e.abrupt("return", this.googlePayClient);
              case 15:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[1, 11]]);
      })), function () {
        return a.apply(this, arguments);
      })
    }, {
      key: "onPaymentAuthorized",
      value: function value() {
        return Promise.resolve({
          transactionState: "SUCCESS"
        });
      }
    }, {
      key: "isTimeout",
      value: function value() {
        if (!this.startSubmitTime) return ke.reportErrorData("".concat(Ja, "afterSubmit_not_called")), !1;
        return new Date().getTime() - this.startSubmitTime > 4500;
      }
    }, {
      key: "showConfirmModal",
      value: (o = l(b.mark(function e(t) {
        var r = this;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return this.reportData("show_confirm_model"), e.abrupt("return", new Promise(function () {
                  var e = l(b.mark(function e(n, o) {
                    var a, i, s, c, u, p, d, f, h, m;
                    return b.wrap(function (e) {
                      for (;;) {
                        switch (e.prev = e.next) {
                          case 0:
                            return a = null, i = new Ms(r.initData.language, {
                              env: r.env.slI18nEnv,
                              cdn: r.initData.cdn
                            }), e.next = 4, i.get(["GooglePayGuideModel.prompt", "GooglePayGuideModel.okText", "GooglePayGuideModel.cancelText"]);
                          case 4:
                            s = e.sent, c = mt(s, 3), u = c[0], p = c[1], d = c[2], f = p.split("{{icon}}"), h = $t("div", {
                              className: Hs
                            }, f[0] && $t("span", {
                              style: {
                                marginRight: "4px"
                              }
                            }, f[0]), $t(Fs, null), f[1] && $t("span", {
                              style: {
                                marginLeft: "4px"
                              }
                            }, f[1])), m = function () {
                              var e = l(b.mark(function e(i, s) {
                                var c, u;
                                return b.wrap(function (e) {
                                  for (;;) {
                                    switch (e.prev = e.next) {
                                      case 0:
                                        if (a.destroy(), i !== $a.Cancel) {
                                          e.next = 10;
                                          break;
                                        }
                                        return r.reportData("user_click_model_cancel_btn"), c = t.url, e.next = 6, r.uploadError(c, {
                                          statusCode: v[s],
                                          statusMessage: y[s]
                                        });
                                      case 6:
                                        u = e.sent, o({
                                          data: u
                                        }), e.next = 12;
                                        break;
                                      case 10:
                                        r.reportData("user_click_model_confirm_btn"), n();
                                      case 12:
                                      case "end":
                                        return e.stop();
                                    }
                                  }
                                }, e);
                              }));
                              return function (t, r) {
                                return e.apply(this, arguments);
                              };
                            }(), a = ai({
                              title: $t(Fs, null),
                              content: u,
                              okText: h,
                              cancelText: d,
                              onOk: function onOk() {
                                return m($a.OK);
                              },
                              onCancel: function onCancel() {
                                return m($a.Cancel, "CancelPayClient");
                              },
                              theme: {
                                modalContentWidth: "397px"
                              },
                              timeout: 3e5,
                              onTimeout: function onTimeout() {
                                r.reportData("auto_close_model_after_five_minutes"), m($a.Cancel, "AutoCancelAfterTimeout");
                              }
                            });
                          case 13:
                          case "end":
                            return e.stop();
                        }
                      }
                    }, e);
                  }));
                  return function (t, r) {
                    return e.apply(this, arguments);
                  };
                }()));
              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return o.apply(this, arguments);
      })
    }, {
      key: "loadPaymentData",
      value: (r = l(b.mark(function e(t, r) {
        var n = this;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return this.payOptions = r, e.abrupt("return", new Promise(function () {
                  var e = l(b.mark(function e(o, a) {
                    var i, s, c;
                    return b.wrap(function (e) {
                      for (;;) {
                        switch (e.prev = e.next) {
                          case 0:
                            if (i = t.url, s = t.data.paymentDataRequest, c = function c(e) {
                              a({
                                data: e
                              });
                            }, i) {
                              e.next = 4;
                              break;
                            }
                            return e.abrupt("return", c({
                              code: v.InvalidNextAction,
                              msg: y.InvalidNextAction
                            }));
                          case 4:
                            return n.triggerPayOptions("onPayClientCreate"), e.next = 7, n.getGooglePayClient();
                          case 7:
                            e.sent.loadPaymentData(s).then(function () {
                              var e = l(b.mark(function e(t) {
                                return b.wrap(function (e) {
                                  for (;;) {
                                    switch (e.prev = e.next) {
                                      case 0:
                                        return n.triggerPayOptions("onPayClientAuthorize"), e.next = 3, n.uploadToken(i, t, r).then(function () {
                                          n.reportData("upload_token_success_with_redirect"), o();
                                        })["catch"](function (e) {
                                          n.reportData("upload_token_error", {
                                            errorMsg: e.message,
                                            error: e
                                          }), c(e.data);
                                        });
                                      case 3:
                                      case "end":
                                        return e.stop();
                                    }
                                  }
                                }, e);
                              }));
                              return function (t) {
                                return e.apply(this, arguments);
                              };
                            }())["catch"](function () {
                              var e = l(b.mark(function e(s) {
                                var u, l, p;
                                return b.wrap(function (e) {
                                  for (;;) {
                                    switch (e.prev = e.next) {
                                      case 0:
                                        if (-1 === (u = s.statusMessage || s.message || "").indexOf(ca)) {
                                          e.next = 14;
                                          break;
                                        }
                                        return ke.reportErrorData("".concat(Ja, "loadPaymentData_timeout")), e.prev = 3, e.next = 6, n.showConfirmModal(t);
                                      case 6:
                                        return e.next = 8, n.loadPaymentData(t, r);
                                      case 8:
                                        return e.abrupt("return", o());
                                      case 11:
                                        return e.prev = 11, e.t0 = e["catch"](3), e.abrupt("return", a(e.t0));
                                      case 14:
                                        return l = {
                                          statusCode: s.statusCode,
                                          statusMessage: u
                                        }, -1 !== u.indexOf(ua) ? n.reportData("user_click_googlePay_cancel_btn") : ke.reportErrorData("".concat(Ja, "loadPaymentData_catch_error"), l), e.next = 18, n.uploadError(i, l);
                                      case 18:
                                        p = e.sent, c(p);
                                      case 20:
                                      case "end":
                                        return e.stop();
                                    }
                                  }
                                }, e, null, [[3, 11]]);
                              }));
                              return function (t) {
                                return e.apply(this, arguments);
                              };
                            }());
                          case 9:
                          case "end":
                            return e.stop();
                        }
                      }
                    }, e);
                  }));
                  return function (t, r) {
                    return e.apply(this, arguments);
                  };
                }()));
              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t) {
        return r.apply(this, arguments);
      })
    }, {
      key: "pay",
      value: (t = l(b.mark(function e(t, r) {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (!this.isTimeout()) {
                  e.next = 3;
                  break;
                }
                return e.next = 3, this.showConfirmModal(t);
              case 3:
                return e.abrupt("return", this.loadPaymentData(t, r));
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, r) {
        return t.apply(this, arguments);
      })
    }]), p;
  }(),
  Us = function Us(e) {
    return e && "string" == typeof e ? e.split("/").pop() : "";
  };
function Gs(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Ks,
  qs = function (t) {
    _(c, Xa);
    var r,
      o,
      a,
      i = Gs(c);
    function c() {
      return n(this, c), i.apply(this, arguments);
    }
    return s(c, [{
      key: "isReadyToPay",
      value: (a = l(b.mark(function t(r, n) {
        var o;
        return b.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return this.environment = r, t.prev = 1, this.reportData("isReadyToPay_start", {
                  isReadyToPayRequest: n
                }), t.next = 5, fo(po.payments("isGooglePayReady", {
                  channelId: Ze,
                  environment: this.environment,
                  paymentInfoConfig: n,
                  custom: {
                    traceId: e
                  }
                }));
              case 5:
                if (null != (o = t.sent) && o.isReady) {
                  t.next = 8;
                  break;
                }
                throw new T(y.DeviceNotSupportPaymentMethod, v.DeviceNotSupportPaymentMethod);
              case 8:
                return this.reportData("isReadyToPay_end", {
                  result: o
                }), t.abrupt("return", !0);
              case 12:
                t.prev = 12, t.t0 = t["catch"](1), this.handleErrorData("isReadyToPay_end_error", t.t0);
              case 15:
              case "end":
                return t.stop();
            }
          }
        }, t, this, [[1, 12]]);
      })), function (e, t) {
        return a.apply(this, arguments);
      })
    }, {
      key: "loadPaymentData",
      value: (o = l(b.mark(function t(r, n) {
        var o = this;
        return b.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return this.payOptions = n, t.abrupt("return", new Promise(function () {
                  var t = l(b.mark(function t(a, i) {
                    var s, c, u, l, p, d, f, h, m, g, k;
                    return b.wrap(function (t) {
                      for (;;) {
                        switch (t.prev = t.next) {
                          case 0:
                            if (s = r.url, c = r.data.paymentDataRequest, u = function u(e) {
                              i({
                                data: e
                              });
                            }, s) {
                              t.next = 4;
                              break;
                            }
                            return t.abrupt("return", u({
                              code: v.InvalidNextAction,
                              msg: y.InvalidNextAction
                            }));
                          case 4:
                            return o.triggerPayOptions("onPayClientCreate"), o.reportData("loadGooglePaymentData_start"), t.next = 8, po.payments("loadGooglePaymentData", {
                              channelId: Ze,
                              paymentDataRequest: c,
                              custom: {
                                traceId: e,
                                tradeOrderId: Us(s)
                              }
                            });
                          case 8:
                            if (l = t.sent, o.reportData("loadGooglePaymentData_end", {
                              result: l
                            }), p = l.paymentData, d = l.error, f = void 0 === d ? {} : d, !p) {
                              t.next = 16;
                              break;
                            }
                            return t.next = 14, o.uploadToken(s, p, n).then(function () {
                              o.reportData("upload_token_success_with_redirect"), a();
                            })["catch"](function (e) {
                              o.reportData("upload_token_error", {
                                errorMsg: e.message,
                                error: e
                              }), u(e.data);
                            });
                          case 14:
                            t.next = 23;
                            break;
                          case 16:
                            return h = f.statusMessage || f.message || "", m = f.statusCode || f.code || "", g = {
                              statusCode: m,
                              statusMessage: h
                            }, t.next = 21, o.uploadError(s, g);
                          case 21:
                            k = t.sent, u(k);
                          case 23:
                          case "end":
                            return t.stop();
                        }
                      }
                    }, t);
                  }));
                  return function (e, r) {
                    return t.apply(this, arguments);
                  };
                }()));
              case 2:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      })), function (e, t) {
        return o.apply(this, arguments);
      })
    }, {
      key: "pay",
      value: (r = l(b.mark(function e(t, r) {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.loadPaymentData(t, r));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t) {
        return r.apply(this, arguments);
      })
    }]), c;
  }(),
  zs = function () {
    function e(t) {
      n(this, e), c(this, "env", void 0), c(this, "simpleRender", new lo()), c(this, "payClient", void 0), c(this, "isValid", !1), this.env = t;
    }
    var t, r, o, a;
    return s(e, [{
      key: "throwError",
      value: function value(e) {
        var t = new T(y.DeviceNotSupportPaymentMethod);
        throw t.setAPIErrorData({
          code: v[e],
          msg: y[e]
        }), t;
      }
    }, {
      key: "afterInit",
      value: (a = l(b.mark(function e(t, r) {
        var n,
          o,
          a,
          i = this;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return (a = null === (n = r.channelInfo) || void 0 === n || null === (o = n[t.paymentMethod]) || void 0 === o ? void 0 : o.data) && a.environment && a.isReadyToPayRequest || this.throwError("InitResultError"), e.next = 4, _o();
              case 4:
                if (e.sent) {
                  e.next = 6;
                  break;
                }
                this.throwError("DeviceNotSupportPaymentMethod");
              case 6:
                return e.next = 8, vo();
              case 8:
                if (e.sent !== it.Browser) {
                  e.next = 15;
                  break;
                }
                return e.next = 12, qe("https://pay.google.com/gp/p/js/pay.js", {
                  maxCount: 3,
                  interval: 100
                }).then(function () {
                  ke.reportData("load_google_js_success");
                })["catch"](function (e) {
                  ke.reportError(e, "load_google_js_error"), i.throwError("LoadChannelJsFail");
                });
              case 12:
                this.payClient = new Ws(this.env, t), e.next = 16;
                break;
              case 15:
                this.payClient = new qs(this.env, t);
              case 16:
                return e.next = 18, this.payClient.isReadyToPay(a.environment, a.isReadyToPayRequest);
              case 18:
                this.isValid = !0;
              case 19:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t) {
        return a.apply(this, arguments);
      })
    }, {
      key: "needRenderWidget",
      value: (o = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !0);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function () {
        return o.apply(this, arguments);
      })
    }, {
      key: "needUserAction",
      value: function value() {
        return !1;
      }
    }, {
      key: "getRenderer",
      value: function value() {
        return this.simpleRender = new lo(), this.simpleRender.getRenderer();
      }
    }, {
      key: "afterSubmit",
      value: (r = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.payClient.afterSubmit());
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.isValid);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "getPayHooks",
      value: function value() {
        var e = this;
        return {
          handlePayAction: function handlePayAction(t, r) {
            if (t.type === ot.CreatePayClient) return e.payClient.pay(t, r);
            throw new T(y.InvalidNextAction, v.InvalidNextAction);
          }
        };
      }
    }, {
      key: "destroy",
      value: function value() {
        this.payClient = null, this.simpleRender = null;
      }
    }]), e;
  }();
!function (e) {
  e.Create = "create", e.ValidateMerchant = "validate_merchant", e.SelectPaymentMethod = "select_paymentMethod", e.Authorize = "authorize", e.Cancel = "cancel";
}(Ks || (Ks = {}));
var Zs = function () {
    function e(t, r) {
      n(this, e), c(this, "payClient", void 0);
      var o = window.ApplePaySession;
      if (!o) throw new Error(y.DeviceNotSupportPaymentMethod);
      this.reportData("constructor_start", {
        version: t,
        requestData: r
      }), this.payClient = new o(t, r), this.reportData("constructor_end");
    }
    var t, r, o;
    return s(e, [{
      key: "reportData",
      value: function value(e, t) {
        ke.reportData("apple_pay_client_".concat(e), t);
      }
    }, {
      key: "pay",
      value: (o = l(b.mark(function e(t, r) {
        var n = this;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", new Promise(function (e, o) {
                  var a = function a(e) {
                    o({
                      data: e
                    });
                  };
                  if (!t.url) return a({
                    code: v.InvalidNextAction,
                    msg: y.InvalidNextAction
                  });
                  var i = function i(e, o, _i2) {
                    var s = {
                      statusCode: v[o],
                      statusMessage: y[o]
                    };
                    n.reportData(e, {
                      nextAction: t,
                      request: s,
                      originError: _i2,
                      originErrorMsg: null == _i2 ? void 0 : _i2.message
                    }), n.uploadError(t, s, r).then(function (e) {
                      a(e);
                    })["catch"](function (e) {
                      ke.reportError(e, "apple_pay_client_uploadOrderError"), a(T.handleAPIErrorData(null == e ? void 0 : e.data, {
                        code: v.AbnormalTrade,
                        msg: y.AbnormalTrade
                      }));
                    });
                  };
                  t.type !== ot.CreatePayClient && i(Ks.Create, "InvalidNextAction");
                  var s = Ks.Create,
                    u = function u(e, t) {
                      s = e, n.reportData(e, t);
                    },
                    p = function p(e) {
                      var t = null == r ? void 0 : r[e],
                        o = "fireEvent_".concat(e);
                      if (n.reportData(o), "function" == typeof t) {
                        var a = function () {
                          var e = l(b.mark(function e() {
                            return b.wrap(function (e) {
                              for (;;) {
                                switch (e.prev = e.next) {
                                  case 0:
                                    return e.abrupt("return", t());
                                  case 1:
                                  case "end":
                                    return e.stop();
                                }
                              }
                            }, e);
                          }));
                          return function () {
                            return e.apply(this, arguments);
                          };
                        }();
                        a().then(function () {
                          n.reportData("".concat(o, "_after"));
                        })["catch"](function (e) {
                          n.reportData("".concat(o, "_error"), {
                            error: e
                          });
                        });
                      }
                    };
                  try {
                    p("onPayClientCreate");
                    var d = t.data.paymentSession.data,
                      f = t.data.paymentRequestUpdate,
                      h = n.payClient,
                      m = JSON.parse(window.atob(d)),
                      g = !!window.ApplePayWebOptions;
                    h.onvalidatemerchant = function (e) {
                      u(Ks.ValidateMerchant, {
                        event: e,
                        decodeMerchantSession: {
                          domainName: m.domainName,
                          displayName: m.displayName
                        }
                      }), h.completeMerchantValidation(m), p("afterPayClientCreate");
                    }, h.onpaymentmethodselected = function (e) {
                      u(Ks.SelectPaymentMethod, {
                        event: e,
                        paymentRequestUpdate: f
                      }), h.completePaymentMethodSelection(f);
                    }, h.onpaymentauthorized = function (o) {
                      u(Ks.Authorize), p("onPayClientAuthorize");
                      var i = {
                        status: window.ApplePaySession.STATUS_SUCCESS
                      };
                      h.completePayment(i), n.uploadToken(t, o.payment, r).then(function () {
                        n.reportData("upload_token_success_without_redirect"), e();
                      })["catch"](function (e) {
                        n.reportData("upload_token_error", {
                          errorMsg: e.message,
                          error: e
                        }), a(e.data);
                      });
                    }, h.oncancel = function (e) {
                      var t;
                      if (s !== Ks.Authorize) {
                        var r = (c(t = {}, Ks.Create, "CreatePayClientFail"), c(t, Ks.ValidateMerchant, "CreatePayClientFail"), c(t, "default", "CancelPayClient"), t),
                          n = r[s] || r["default"];
                        g && s == Ks.Create && (n = r["default"]), u(Ks.Cancel, {
                          preEvent: s,
                          event: e
                        }), i("on_cancel", n);
                      } else console.warn("cant not cancel after getting token");
                    }, h.begin();
                  } catch (e) {
                    i("catch_error", "CreatePayClientFail", e);
                  }
                }));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function (e, t) {
        return o.apply(this, arguments);
      })
    }, {
      key: "uploadError",
      value: (r = l(b.mark(function e(t, r, n) {
        var o, a, i, s;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (!0 !== (null === (o = t.sdkSwitch) || void 0 === o ? void 0 : o.newSwitch)) {
                  e.next = 7;
                  break;
                }
                if (i = null === (a = t.data) || void 0 === a ? void 0 : a.cancelUrl) {
                  e.next = 5;
                  break;
                }
                throw new T(y.InvalidNextAction, v.InvalidNextAction);
              case 5:
                return s = {
                  client: ba(n.language),
                  paymentInstrument: {
                    paymentMethod: n.paymentMethod
                  },
                  paymentError: {
                    channelCode: r.statusCode,
                    channelMsg: r.statusMessage
                  }
                }, e.abrupt("return", ya(i, t, s, n.APIRequestHeader));
              case 7:
                return e.abrupt("return", na(t.url, r));
              case 8:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function (e, t, n) {
        return r.apply(this, arguments);
      })
    }, {
      key: "uploadToken",
      value: (t = l(b.mark(function e(t, r, n) {
        var o, a, i, s, c;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (!0 !== (null === (o = t.sdkSwitch) || void 0 === o ? void 0 : o.newSwitch)) {
                  e.next = 12;
                  break;
                }
                if (s = {
                  client: ba(n.language),
                  paymentInstrument: {
                    paymentMethod: n.paymentMethod
                  },
                  paymentMethodOptions: {
                    fastCheckoutPaymentOptions: {
                      paymentMethodInstrument: r
                    }
                  }
                }, null === (i = n.hooks) || void 0 === i || !i.extendConfirmParams) {
                  e.next = 7;
                  break;
                }
                return e.next = 5, n.hooks.extendConfirmParams(t)["catch"](function (e) {
                  return ke.handleError(e, "handleNextAction_extendConfirmParams_error");
                });
              case 5:
                (c = e.sent) && D(c) && (s = ga(c, s));
              case 7:
                return e.next = 9, ma(t, s, n.APIRequestHeader);
              case 9:
                a = e.sent, e.next = 15;
                break;
              case 12:
                return e.next = 14, aa(t.url, r);
              case 14:
                a = e.sent;
              case 15:
                return this.reportData("upload_order_token_success", {
                  url: t.url,
                  response: a
                }), e.abrupt("return", Ua(a, n));
              case 17:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, r, n) {
        return t.apply(this, arguments);
      })
    }]), e;
  }(),
  $s = function () {
    function e() {
      n(this, e), c(this, "initData", void 0), c(this, "initResult", void 0), c(this, "simpleRender", new lo()), c(this, "payClient", void 0), c(this, "isValid", !1);
    }
    var t, r, o, a;
    return s(e, [{
      key: "afterInit",
      value: (a = l(b.mark(function e(t, r) {
        var n, o, a, i, s, c, u;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return this.initData = t, this.initResult = r, a = function a(e, t) {
                  var r = new T(t || y.DeviceNotSupportPaymentMethod);
                  throw r.setAPIErrorData({
                    code: e,
                    msg: t
                  }), r;
                }, null != (i = null === (n = r.channelInfo) || void 0 === n || null === (o = n[t.paymentMethod]) || void 0 === o ? void 0 : o.data) && i.version || a(v.InitResultError, y.InitResultError), e.prev = 5, e.next = 8, go();
              case 8:
                this.isValid = !0, e.next = 15;
                break;
              case 11:
                e.prev = 11, e.t0 = e["catch"](5), s = ("string" == typeof e.t0 ? e.t0 : null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.message) || "", v[s] ? a(v[s], y[s]) : (c = s || y.DeviceNotSupportPaymentMethod, u = v.DeviceNotSupportPaymentMethod, s.indexOf("insecure document") > -1 && (u = v.HTTPSRequired), a(u, c));
              case 15:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[5, 11]]);
      })), function (e, t) {
        return a.apply(this, arguments);
      })
    }, {
      key: "needRenderWidget",
      value: (o = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !0);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function () {
        return o.apply(this, arguments);
      })
    }, {
      key: "needUserAction",
      value: function value() {
        return !1;
      }
    }, {
      key: "getRenderer",
      value: function value() {
        return this.simpleRender.getRenderer();
      }
    }, {
      key: "validate",
      value: (r = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.isValid);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "afterSubmit",
      value: (t = l(b.mark(function e() {
        var t, r, n, o, a;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (n = null === (t = this.initResult.channelInfo) || void 0 === t || null === (r = t[this.initData.paymentMethod]) || void 0 === r ? void 0 : r.data) {
                  e.next = 3;
                  break;
                }
                throw new T(y.InitResultError, v.InitResultError, "AfterSubmitFail");
              case 3:
                e.prev = 3, this.payClient = new Zs(n.version, n.paymentRequest), e.next = 14;
                break;
              case 7:
                throw e.prev = 7, e.t0 = e["catch"](3), o = "UnknownChannelClientError", (a = e.t0.message) && (a.indexOf(y.DeviceNotSupportPaymentMethod) > -1 ? o = "DeviceNotSupportPaymentMethod" : a.indexOf("gesture handler") > -1 && (o = "NotInUserGesture")), ke.reportError(e.t0, "create_pay_client_error"), new T("".concat(y[o], ": ").concat(a), v[o], "AfterSubmitFail");
              case 14:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[3, 7]]);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "getPayHooks",
      value: function value() {
        var e,
          t = this;
        return {
          beforeConfirm: (e = l(b.mark(function e() {
            return b.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t.payClient) {
                      e.next = 2;
                      break;
                    }
                    throw new T(y.InvalidChannelClient, v.InvalidChannelClient);
                  case 2:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function () {
            return e.apply(this, arguments);
          }),
          handlePayAction: function handlePayAction(e, r) {
            if (e.type === ot.CreatePayClient) return t.payClient.pay(e, r);
            throw new T(y.InvalidNextAction, v.InvalidNextAction);
          }
        };
      }
    }, {
      key: "destroy",
      value: function value() {
        this.payClient = null, this.simpleRender = null;
      }
    }]), e;
  }();
function Js(e, t) {
  var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Xs(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Xs(e, t);
    }(e)) || t && e && "number" == typeof e.length) {
      r && (e = r);
      var _n3 = 0,
        o = function o() {};
      return {
        s: o,
        n: function n() {
          return _n3 >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[_n3++]
          };
        },
        e: function e(_e4) {
          throw _e4;
        },
        f: o
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var a,
    i = !0,
    s = !1;
  return {
    s: function s() {
      r = r.call(e);
    },
    n: function n() {
      var e = r.next();
      return i = e.done, e;
    },
    e: function e(_e5) {
      s = !0, a = _e5;
    },
    f: function f() {
      try {
        i || null == r["return"] || r["return"]();
      } finally {
        if (s) throw a;
      }
    }
  };
}
function Xs(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) {
    n[r] = e[r];
  }
  return n;
}
var Ys = function () {
  function e(t) {
    n(this, e), c(this, "rules", void 0), this.rules = t;
  }
  return s(e, [{
    key: "test",
    value: function value(t) {
      var r,
        n = Js(this.rules);
      try {
        for (n.s(); !(r = n.n()).done;) {
          var o = r.value;
          if (!e.checkRule(t, o)) return [!1, o];
        }
      } catch (e) {
        n.e(e);
      } finally {
        n.f();
      }
      return [!0, null];
    }
  }], [{
    key: "checkRule",
    value: function value(e, t) {
      return this.RULE_MAP[t.type](e, t.value);
    }
  }]), e;
}();
c(Ys, "RULE_MAP", {
  min: function min(e, t) {
    return +e >= t;
  },
  max: function max(e, t) {
    return +e <= t;
  },
  minLength: function minLength(e, t) {
    return e.length >= t;
  },
  maxLength: function maxLength(e, t) {
    return e.length <= t;
  },
  pattern: function pattern(e, t) {
    return t.test(e);
  },
  startsWith: function startsWith(e, t) {
    return e.startsWith(t);
  }
});
var Qs = {
  OVOContainer: "paymentSdk_OVOContainer_887e8679",
  OVONextStepTip: "paymentSdk_OVONextStepTip_887e8679",
  OVOFooterTip: "paymentSdk_OVOFooterTip_887e8679",
  OVOMobilePhone: "paymentSdk_OVOMobilePhone_887e8679",
  OVOContentLoading: "paymentSdk_OVOContentLoading_887e8679"
};
function ec(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function tc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ec(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ec(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function rc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var nc = Wr.bind(Qs),
  oc = function (e) {
    _(r, Yt);
    var t = rc(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "getSkeleton",
      value: function value(e) {
        var t;
        return $t(Gn, {
          theme: tc(tc({}, (null === (t = this.props.theme) || void 0 === t ? void 0 : t.skeleton) || {}), {}, {
            height: e
          })
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.isLoaded,
          r = e.theme,
          n = e.mobilePhone,
          o = e.hint,
          a = e.footer;
        return $t("div", {
          className: nc({
            OVOContainer: !0,
            OVOContentLoading: !t
          })
        }, !!o && $t("div", {
          className: Qs.OVONextStepTip,
          style: {
            marginBottom: null == r ? void 0 : r.formItemGutter
          }
        }, t ? o : this.getSkeleton()), !!n && $t("div", {
          className: Qs.OVOMobilePhone
        }, t ? n : this.getSkeleton(null == r ? void 0 : r.inputHeight)), !!a && $t("div", {
          className: Qs.OVOFooterTip,
          style: {
            marginTop: null == r ? void 0 : r.formItemGutter
          }
        }, t ? a : this.getSkeleton()));
      }
    }]), r;
  }();
function ac(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var ic = Wr.bind({
    extraMessageContainer: "paymentSdk_extraMessageContainer_7c1e7b01",
    hidden: "paymentSdk_hidden_7c1e7b01",
    error: "paymentSdk_error_7c1e7b01"
  }),
  sc = function (e) {
    _(r, Yt);
    var t = ac(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.message,
          r = e.hidden,
          n = e.type,
          o = e.gutter,
          a = e.color;
        return $t("div", {
          className: ic({
            extraMessageContainer: !0,
            hidden: r,
            error: "error" === n
          }),
          style: {
            marginTop: r ? void 0 : o,
            color: a
          }
        }, $t("span", {
          className: ic({
            message: !0
          })
        }, t));
      }
    }]), r;
  }(),
  cc = {
    iconTipsContainer: "paymentSdk_iconTipsContainer_78cb66fd",
    icon: "paymentSdk_icon_78cb66fd",
    imgIcon: "paymentSdk_imgIcon_78cb66fd"
  };
function uc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var lc = Wr.bind(cc),
  pc = function (e) {
    _(r, Yt);
    var t = uc(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.icon,
          r = e.text,
          n = e.theme,
          o = null != n && n.rtl ? "topRight" : "topLeft",
          a = "string" == typeof t ? $t("img", {
            src: t,
            alt: "icon",
            className: cc.imgIcon
          }) : t;
        return $t("div", {
          className: lc({
            iconTipsContainer: !0
          }),
          style: Pn({
            color: null == n ? void 0 : n.color,
            right: null == n ? void 0 : n.right
          }, null == n ? void 0 : n.rtl)
        }, $t("div", {
          className: cc.icon
        }, r ? $t(Yr, {
          content: r,
          placement: o,
          theme: {
            rtl: null == n ? void 0 : n.rtl
          }
        }, a) : a));
      }
    }]), r;
  }(),
  dc = {
    inputWrapper: "paymentSdk_inputWrapper_c3dabaf1",
    content: "paymentSdk_content_c3dabaf1"
  };
function fc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var hc = Wr.bind(dc),
  vc = function (e) {
    _(r, Yt);
    var t = fc(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "render",
      value: function value() {
        var e,
          t,
          r = this.props,
          n = r.isEmpty,
          o = r.isFocused,
          a = r.isError,
          i = r.errorMessage,
          s = r.helpMessage,
          u = r.label,
          l = r.theme,
          p = void 0 === l ? {} : l,
          d = r.tips,
          f = r.className,
          h = r.shouldLabelStepAside,
          v = "outside" === p.inputLabelPosition,
          y = $t(Nn, {
            isStepAside: !v && h && (o || !n),
            label: u,
            theme: {
              color: p.inputLabelColor,
              fontSize: p.inputLabelFontSize,
              stepAsideFontSize: p.inputLabelSmallFontSize,
              position: p.inputLabelPosition,
              top: p.inputPaddingTop,
              left: p.inputPaddingLeft,
              gutter: p.inputTipGutter,
              rtl: p.rtl
            }
          }),
          m = null !== (e = this.props.tipComponent) && void 0 !== e ? e : (null == d ? void 0 : d.icon) && $t(pc, {
            icon: d.icon,
            text: d.text,
            theme: {
              right: p.inputPaddingRight,
              color: p.inputIconColor,
              rtl: p.rtl
            }
          }),
          g = !!i && $t(sc, {
            message: i,
            hidden: !a || o,
            type: "error",
            gutter: p.inputTipGutter,
            color: p.inputErrorFontColor
          }),
          b = !!s && $t(sc, {
            message: s,
            hidden: a || !o,
            gutter: p.inputTipGutter,
            color: p.inputTipColor
          });
        return $t("div", {
          className: hc((t = {
            inputWrapper: !0
          }, c(t, f, !!f), c(t, "error", a && !o), t))
        }, v && y, $t(In, {
          isError: a,
          isFocused: o,
          theme: {
            focusBorderColor: null == p ? void 0 : p.inputFocusBorderColor,
            errorBorderColor: null == p ? void 0 : p.inputErrorBorderColor,
            borderColor: null == p ? void 0 : p.inputBorderColor,
            background: null == p ? void 0 : p.inputBackground,
            height: null == p ? void 0 : p.inputHeight,
            borderRadius: null == p ? void 0 : p.inputBorderRadius,
            borderType: null == p ? void 0 : p.inputBorderType
          }
        }, !v && y, $t("div", {
          className: dc.content
        }, this.props.children), m), $t("div", {
          className: dc.messageArea
        }, b, g));
      }
    }]), r;
  }();
c(vc, "defaultProps", {
  label: "",
  isEmpty: !0,
  isFocused: !1,
  isError: !1,
  errorMessage: "",
  helpMessage: "",
  shouldLabelStepAside: !0
});
var yc = function yc(e) {
  for (var t = "", r = 0; r < e.length; r++) {
    12288 !== e.charCodeAt(r) ? e.charCodeAt(r) > 65280 && e.charCodeAt(r) < 65375 ? t += String.fromCharCode(e.charCodeAt(r) - 65248) : t += String.fromCharCode(e.charCodeAt(r)) : t += String.fromCharCode(e.charCodeAt(r) - 12256);
  }
  return t;
};
var mc = {
  inputErrorFontColor: "#F04949",
  inputIconColor: "rgba(44,44,44,0.75)",
  inputTipGutter: "6px",
  inputFontColor: "#2C2C2C",
  inputLabelGutter: "1px",
  inputTipColor: "rgba(44,44,44,0.5)",
  inputPaddingLabelOutsideBottom: "13px",
  inputPaddingLabelOutsideTop: "13px",
  inputPaddingLabelOutsideLeft: "12px",
  inputPaddingLabelOutsideRight: "12px",
  inputPaddingTop: "5px",
  inputPaddingLeft: "16px",
  inputPaddingRight: "16px",
  inputPaddingBottom: "0px"
};
var gc = function gc() {
  return Object.freeze(mc);
};
var bc = {
  formItemLabelFontSize: "14px",
  formItemLabelOutsideFontSize: "12px",
  formItemLabelSmallFontSize: "10px",
  formItemLabelLineHeight: "16px",
  formItemLabelSmallLineHeight: "14px",
  formItemLabelColor: "rgba(44,44,44,0.75)",
  formItemBackground: "#fff",
  formItemHeight: "46px",
  formItemBorderColor: "rgba(142,142,142,0.3)",
  formItemFocusBorderColor: "#276EAF",
  formItemErrorBorderColor: "#F04949",
  formItemBorderRadius: "4px",
  formItemLabelOutsideGutter: "6px",
  formItemLabelInsideTop: "5px",
  formItemLabelInsideLeft: "16px"
};
var kc = function kc() {
  return Object.freeze(bc);
};
function wc(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Cc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? wc(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : wc(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function _c(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Oc = gc(),
  Pc = kc(),
  xc = Wr.bind({
    inputArea: "paymentSdk_inputArea_6dce055f",
    labelInside: "paymentSdk_labelInside_6dce055f"
  }),
  Ic = function (e) {
    _(r, Yt);
    var t = _c(r);
    function r(e) {
      var o;
      return n(this, r), c(w(o = t.call(this, e)), "inputRef", void 0), c(w(o), "isOnComposition", !1), c(w(o), "state", {
        value: (o.props.value || "").trim(),
        isFocused: !1,
        isError: !1,
        errorMessage: ""
      }), c(w(o), "handleComposition", function (e, t) {
        o.isOnComposition = e, e || o.handleInputEvent(t);
      }), c(w(o), "handleInputEvent", function (e) {
        if (!o.isOnComposition) {
          var t = e.target.value || "";
          t = yc(t), "function" == typeof o.props.onInput && (t = o.props.onInput(t)), o.setState({
            value: t
          });
        }
      }), o.inputRef = {
        current: null
      }, o;
    }
    return s(r, [{
      key: "componentDidMount",
      value: function value() {
        this.props.isAutoFocus && this.inputRef.current.focus();
      }
    }, {
      key: "setError",
      value: function value(e) {
        this.setState({
          isError: !0,
          errorMessage: e
        });
      }
    }, {
      key: "removerError",
      value: function value() {
        this.setState({
          isError: !1,
          errorMessage: ""
        });
      }
    }, {
      key: "getValue",
      value: function value() {
        return this.state.value;
      }
    }, {
      key: "setFocus",
      value: function value(e) {
        this.setState({
          isFocused: e,
          isError: !1
        });
      }
    }, {
      key: "handleBlur",
      value: function value(e) {
        var t = e.target.value || "";
        this.setFocus(!1), "function" == typeof this.props.onBlur && this.props.onBlur(t);
      }
    }, {
      key: "handleFocus",
      value: function value(e) {
        var t = e.target.value || "";
        this.setFocus(!0), "function" == typeof this.props.onFocus && this.props.onFocus(t);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
          t = this.props,
          r = t.label,
          n = t.theme,
          o = void 0 === n ? {} : n,
          a = t.prefix,
          i = this.state,
          s = i.value,
          c = i.isFocused,
          u = i.isError,
          l = i.errorMessage,
          p = !s,
          d = "outside" === o.inputLabelPosition,
          f = {
            oncompositionstart: function oncompositionstart() {
              return e.handleComposition(!0);
            },
            oncompositionupdate: function oncompositionupdate() {
              return e.handleComposition(!0);
            },
            oncompositionend: function oncompositionend(t) {
              return e.handleComposition(!1, t);
            }
          };
        return $t(vc, {
          isError: u,
          isEmpty: p,
          isFocused: c,
          errorMessage: l,
          theme: o,
          label: r
        }, a, $t("input", Cc(Cc({
          ref: this.inputRef,
          className: xc({
            inputArea: !0,
            labelInside: !d
          }),
          style: {
            color: o.inputFontColor,
            paddingLeft: o.inputPaddingLeft,
            paddingTop: !d && (null != o && o.inputPaddingTop || null != o && o.inputLabelGutter) ? "calc(".concat((null == o ? void 0 : o.inputPaddingTop) || Oc.inputPaddingTop, " +\n                ").concat(Pc.formItemLabelSmallLineHeight, " +\n                ").concat((null == o ? void 0 : o.inputLabelGutter) || Oc.inputLabelGutter, "\n              )") : o.inputPaddingTop,
            paddingRight: o.inputPaddingRight,
            paddingBottom: null == o ? void 0 : o.inputPaddingBottom
          },
          type: "text"
        }, f), {}, {
          onInput: function onInput(t) {
            return e.handleInputEvent(t);
          },
          onFocus: function onFocus(t) {
            return e.handleFocus(t);
          },
          onBlur: function onBlur(t) {
            return e.handleBlur(t);
          },
          value: s
        })));
      }
    }]), r;
  }(),
  Sc = "paymentSdk_areaCode_46a4884c";
var Dc = {
  itemGutter: "12px",
  areaCodeWidth: "48px"
};
function Rc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
function Ec(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Tc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ec(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ec(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var Ac = function () {
    return Object.freeze(Dc);
  }(),
  Lc = gc();
function jc(e) {
  return {
    footer: {
      fontColor: null == e ? void 0 : e.footerFontColor
    },
    hint: {
      fontColor: (null == e ? void 0 : e.nextStepTipFontColor) || "rgba(44, 44, 44, 0.75)"
    },
    mobilePhoneTheme: Tc({}, e),
    layout: {
      formItemGutter: null == e ? void 0 : e.formItemGutter,
      inputHeight: (null == e ? void 0 : e.inputHeight) || "48px",
      skeleton: {
        background: null == e ? void 0 : e.inputSkeletonBackground,
        borderRadius: null == e ? void 0 : e.inputBorderRadius
      }
    }
  };
}
var Nc = function (e) {
    _(a, Yt);
    var t,
      r,
      o = Rc(a);
    function a(e) {
      var t;
      return n(this, a), c(w(t = o.call(this, e)), "mobilePhoneInputRef", void 0), c(w(t), "validator", void 0), c(w(t), "state", {
        isLoaded: !1,
        language: null
      }), t.mobilePhoneInputRef = {
        current: null
      }, t;
    }
    return s(a, [{
      key: "componentDidMount",
      value: (r = l(b.mark(function e() {
        var t,
          r = this;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.getLanguage();
              case 2:
                t = e.sent, this.setState({
                  isLoaded: !0,
                  language: t
                }, function () {
                  return r.afterLoaded();
                });
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "getLanguage",
      value: (t = l(b.mark(function e() {
        var t, r, n, o, a, i, s, c;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return t = this.props, r = t.guideI18nKey, n = t.i18n, e.next = 3, n.get(["OVO.mobilePhoneLabel", "OVO.invalidErrorHint", r]);
              case 3:
                return o = e.sent, a = mt(o, 3), i = a[0], s = a[1], c = a[2], e.abrupt("return", {
                  nextStepHint: c,
                  mobilePhoneLabel: i,
                  invalidErrorHint: s
                });
              case 9:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "afterLoaded",
      value: function value() {
        this.createValidator(), this.props.mobilePhone && this.validate();
      }
    }, {
      key: "createValidator",
      value: function value() {
        var e = this.state.language.invalidErrorHint,
          t = [{
            type: "minLength",
            value: 9,
            message: e
          }, {
            type: "maxLength",
            value: 12,
            message: e
          }, {
            type: "startsWith",
            value: "8",
            message: e
          }];
        this.validator = new Ys(t);
      }
    }, {
      key: "validate",
      value: function value() {
        if (!this.validator) return !1;
        var e = this.getMobilePhone(),
          t = mt(this.validator.test(e), 2),
          r = t[0],
          n = t[1];
        return !!r || (this.mobilePhoneInputRef.current.setError(n.message), !1);
      }
    }, {
      key: "getMobilePhone",
      value: function value() {
        return this.mobilePhoneInputRef.current.getValue();
      }
    }, {
      key: "getAccount",
      value: function value() {
        var e = this.getMobilePhone();
        return "".concat(this.props.areaCode).concat(e);
      }
    }, {
      key: "componentDidCatch",
      value: function value(e) {
        ke.reportError(e, "OVO_componentDidCatch_error");
      }
    }, {
      key: "render",
      value: function value() {
        var e,
          t = this,
          r = this.props,
          n = r.areaCode,
          o = r.theme,
          a = r.mobilePhone,
          i = jc(o),
          s = this.state,
          c = s.isLoaded,
          u = s.language,
          l = i.mobilePhoneTheme;
        return $t(oc, {
          isLoaded: c,
          theme: i.layout,
          hint: $t(Vr, {
            text: null == u ? void 0 : u.nextStepHint,
            theme: i.hint
          }),
          mobilePhone: $t(Ic, {
            ref: this.mobilePhoneInputRef,
            theme: Tc(Tc({}, l), {}, {
              inputPaddingLeft: "calc(".concat(Ac.areaCodeWidth, " + ").concat((null == l ? void 0 : l.inputPaddingLeft) || Lc.inputPaddingLeft, ")")
            }),
            value: a,
            label: null == u ? void 0 : u.mobilePhoneLabel,
            prefix: $t("div", {
              className: Sc,
              style: {
                color: null === (e = i.mobilePhoneTheme) || void 0 === e ? void 0 : e.areaCodeColor
              }
            }, n),
            onInput: function onInput(e) {
              var t = e.trim().replace(/[^\d]/g, "");
              return t = t.slice(0, 12);
            },
            onBlur: function onBlur() {
              return t.validate();
            },
            isAutoFocus: !a
          })
        });
      }
    }]), a;
  }(),
  Bc = function (e) {
    _(a, Yt);
    var t,
      r,
      o = Rc(a);
    function a() {
      var e;
      n(this, a);
      for (var t = arguments.length, r = new Array(t), i = 0; i < t; i++) {
        r[i] = arguments[i];
      }
      return c(w(e = o.call.apply(o, [this].concat(r))), "state", {
        isLoaded: !1,
        language: null
      }), e;
    }
    return s(a, [{
      key: "componentDidMount",
      value: (r = l(b.mark(function e() {
        var t;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.getLanguage();
              case 2:
                t = e.sent, this.setState({
                  isLoaded: !0,
                  language: t
                });
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "componentDidCatch",
      value: function value(e) {
        ke.reportError(e, "OVOFooter_componentDidCatch_error");
      }
    }, {
      key: "getLanguage",
      value: (t = l(b.mark(function e() {
        var t, r, n, o;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return t = this.props, r = t.footerI18nKey, n = t.i18n, e.next = 3, n.get(r);
              case 3:
                return o = e.sent, e.abrupt("return", {
                  footer: o
                });
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "render",
      value: function value() {
        var e = jc(this.props.theme),
          t = this.state,
          r = t.isLoaded,
          n = t.language;
        return $t(oc, {
          isLoaded: r,
          theme: e.layout,
          footer: $t(Eo, {
            icon: null,
            message: null == n ? void 0 : n.footer,
            theme: e.footer
          })
        });
      }
    }]), a;
  }();
function Mc(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Fc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Mc(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Mc(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var Hc = function () {
    function e() {
      n(this, e), c(this, "componentRef", {
        current: null
      });
    }
    var t;
    return s(e, [{
      key: "getRenderer",
      value: function value() {
        var e = this;
        return {
          content: function content(t) {
            var r,
              n,
              o,
              a,
              i = t.initResult.paymentMethodInfo,
              s = ((null === (r = t.initData.paymentInstrument) || void 0 === r ? void 0 : r.OVO) || {}).mobilePhone,
              c = void 0 === s ? "" : s;
            return $t(Nc, {
              ref: e.componentRef,
              areaCode: "+62",
              mobilePhone: c.trim(),
              theme: Fc(Fc({}, null === (n = t.initData.theme) || void 0 === n ? void 0 : n["default"]), null === (o = t.initData.theme) || void 0 === o ? void 0 : o.OVO),
              i18n: t.i18n,
              guideI18nKey: null === (a = i.cashierNotice) || void 0 === a ? void 0 : a.guideI18nKey
            });
          },
          footer: function footer(e) {
            var t,
              r,
              n,
              o = e.initResult.paymentMethodInfo;
            return $t(Bc, {
              theme: Fc(Fc({}, null === (t = e.initData.theme) || void 0 === t ? void 0 : t["default"]), null === (r = e.initData.theme) || void 0 === r ? void 0 : r.OVO),
              footerI18nKey: null === (n = o.cashierNotice) || void 0 === n ? void 0 : n.footerI18nKey,
              i18n: e.i18n
            });
          }
        };
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.componentRef.current) {
                  e.next = 3;
                  break;
                }
                return ke.reportErrorData("ovo_validate_before_render"), e.abrupt("return", !1);
              case 3:
                return e.abrupt("return", this.componentRef.current.validate());
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "getAccount",
      value: function value() {
        return this.componentRef.current ? this.componentRef.current.getAccount() : (ke.reportErrorData("ovo_getAccount_before_render"), "");
      }
    }]), e;
  }(),
  Vc = function () {
    function e() {
      n(this, e), c(this, "env", void 0), c(this, "initData", void 0), c(this, "OVOUI", new Hc());
    }
    var t, r;
    return s(e, [{
      key: "needRenderWidget",
      value: (r = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !0);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "needUserAction",
      value: function value() {
        return !0;
      }
    }, {
      key: "getRenderer",
      value: function value() {
        return this.OVOUI.getRenderer();
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.OVOUI.validate());
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "getPayHooks",
      value: function value() {
        var e,
          t = this;
        return {
          extendConfirmParams: (e = l(b.mark(function e() {
            return b.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", {
                      additionalData: {
                        paymentNumber: t.OVOUI.getAccount()
                      }
                    });
                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function () {
            return e.apply(this, arguments);
          })
        };
      }
    }, {
      key: "destroy",
      value: function value() {
        this.OVOUI = null;
      }
    }]), e;
  }(),
  Wc = {
    VirtualAccountContainer: "paymentSdk_VirtualAccountContainer_97300547",
    VirtualAccountFooterTip: "paymentSdk_VirtualAccountFooterTip_97300547",
    VirtualAccountSelect: "paymentSdk_VirtualAccountSelect_97300547",
    VirtualAccountContentLoading: "paymentSdk_VirtualAccountContentLoading_97300547"
  };
function Uc(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Uc(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Uc(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function Kc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var qc = Wr.bind(Wc),
  zc = function (e) {
    _(r, Yt);
    var t = Kc(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "getSkeleton",
      value: function value(e) {
        var t;
        return $t(Gn, {
          theme: Gc(Gc({}, (null === (t = this.props.theme) || void 0 === t ? void 0 : t.skeleton) || {}), {}, {
            height: e
          })
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.isLoaded,
          r = e.theme,
          n = e.select,
          o = e.footer;
        return $t("div", {
          className: qc({
            VirtualAccountContainer: !0,
            VirtualAccountContentLoading: !t
          })
        }, !!n && $t("div", {
          className: Wc.VirtualAccountSelect
        }, t ? n : this.getSkeleton(null == r ? void 0 : r.selectHeight)), !!o && $t("div", {
          className: Wc.VirtualAccountFooterTip,
          style: {
            marginTop: null == r ? void 0 : r.formItemGutter
          }
        }, t ? o : this.getSkeleton()));
      }
    }]), r;
  }();
function Zc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
function $c(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Jc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? $c(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $c(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function Xc(e) {
  return {
    footer: {
      fontColor: (null == e ? void 0 : e.footerFontColor) || "rgba(44, 44, 44, 0.75)",
      linkColor: null == e ? void 0 : e.footerLinkColor
    },
    select: Jc({}, e),
    layout: {
      formItemGutter: null == e ? void 0 : e.formItemGutter,
      selectHeight: (null == e ? void 0 : e.selectHeight) || "48px",
      skeleton: {
        background: null == e ? void 0 : e.selectSkeletonBackground,
        borderRadius: null == e ? void 0 : e.selectBorderRadius
      }
    }
  };
}
var Yc = function (e) {
    _(u, Yt);
    var t,
      r,
      o,
      a,
      i = Zc(u);
    function u() {
      var e;
      n(this, u);
      for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++) {
        r[o] = arguments[o];
      }
      return c(w(e = i.call.apply(i, [this].concat(r))), "selectRef", {
        current: null
      }), c(w(e), "state", {
        isLoaded: !1,
        errorMsg: "",
        displayOption: null,
        optionList: null,
        language: null
      }), c(w(e), "validate", l(b.mark(function t() {
        var r, n, o;
        return b.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return r = e.state.displayOption, (n = !!r && !r.disable) || e.showError(null === (o = e.state.language) || void 0 === o ? void 0 : o.placeholder), t.abrupt("return", n);
              case 4:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))), c(w(e), "showError", function (t) {
        var r;
        null === (r = e.selectRef.current) || void 0 === r || r.showError(t);
      }), e;
    }
    return s(u, [{
      key: "componentDidMount",
      value: function value() {
        this.initData();
      }
    }, {
      key: "componentDidCatch",
      value: function value(e) {
        ke.reportError(e, "VirtualAccount_componentDidCatch_error");
      }
    }, {
      key: "initData",
      value: (a = l(b.mark(function e() {
        var t, r;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.getLanguage();
              case 2:
                return t = e.sent, e.next = 5, this.getOptionList();
              case 5:
                r = e.sent, this.setState({
                  isLoaded: !0,
                  language: t,
                  optionList: r
                });
              case 7:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return a.apply(this, arguments);
      })
    }, {
      key: "getLanguage",
      value: (o = l(b.mark(function e() {
        var t, r;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return t = this.props.i18n, e.next = 3, t.get("VirtualAccount.selectBank");
              case 3:
                return r = e.sent, e.abrupt("return", {
                  placeholder: r,
                  errorMsg: r
                });
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return o.apply(this, arguments);
      })
    }, {
      key: "getBankNameMap",
      value: (r = l(b.mark(function e() {
        var t, r, n, o, a;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return t = this.props, r = t.bankList, n = t.i18n, o = t.paymentMethod, a = {}, e.next = 4, Promise.all(r.map(function () {
                  var e = l(b.mark(function e(t) {
                    var r, i, s, c;
                    return b.wrap(function (e) {
                      for (;;) {
                        switch (e.prev = e.next) {
                          case 0:
                            if (r = t.bankName, i = t.bankNameI18nKey, s = t.bankCode, !i) {
                              e.next = 7;
                              break;
                            }
                            return e.next = 4, n.get("".concat(o, ".").concat(i));
                          case 4:
                            e.t0 = e.sent, e.next = 8;
                            break;
                          case 7:
                            e.t0 = "";
                          case 8:
                            c = e.t0, a[s] = c || r;
                          case 10:
                          case "end":
                            return e.stop();
                        }
                      }
                    }, e);
                  }));
                  return function (t) {
                    return e.apply(this, arguments);
                  };
                }()));
              case 4:
                return e.abrupt("return", a);
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "getOptionList",
      value: (t = l(b.mark(function e() {
        var t, r, n, o, a;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return t = this.props, r = t.bankList, n = t.imgHost, o = t.paymentMethod, e.next = 3, this.getBankNameMap();
              case 3:
                return a = e.sent, e.abrupt("return", r.map(function (e) {
                  return {
                    value: e.bankCode,
                    label: a[e.bankCode],
                    img: "".concat(n, "/payment-sdk/images/bank-icon/").concat(o, "/").concat(e.bankCode, ".png")
                  };
                }));
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "needUserAction",
      value: function value() {
        return !0;
      }
    }, {
      key: "selectBank",
      value: function value(e) {
        this.props.onSelectBank(e), this.setState({
          displayOption: e
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
          t = this.state,
          r = t.isLoaded,
          n = t.language,
          o = t.optionList,
          a = Xc(this.props.theme);
        return $t(zc, {
          isLoaded: r,
          theme: a.layout,
          select: $t(Fn, {
            ref: this.selectRef,
            optionList: o,
            placeholder: null == n ? void 0 : n.placeholder,
            onChange: function onChange(t) {
              return e.selectBank(t);
            },
            theme: a.select,
            needAdaptive: this.props.needAdaptive
          })
        });
      }
    }]), u;
  }(),
  Qc = function (e) {
    _(a, Yt);
    var t,
      r,
      o = Zc(a);
    function a() {
      return n(this, a), o.apply(this, arguments);
    }
    return s(a, [{
      key: "componentDidMount",
      value: function value() {
        this.initData();
      }
    }, {
      key: "initData",
      value: (r = l(b.mark(function e() {
        var t;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.getLanguage();
              case 2:
                t = e.sent, this.setState({
                  isLoaded: !0,
                  language: t
                });
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "getLanguage",
      value: (t = l(b.mark(function e() {
        var t, r, n, o;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return t = this.props, r = t.footerI18nKey, n = t.i18n, e.next = 3, n.get(r);
              case 3:
                return o = e.sent, e.abrupt("return", {
                  footer: o
                });
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "render",
      value: function value() {
        var e = this.state,
          t = e.isLoaded,
          r = e.language,
          n = this.props.theme,
          o = Xc(n);
        return $t(zc, {
          isLoaded: t,
          theme: o.layout,
          footer: null != n && n.noFooter ? null : $t(Eo, {
            icon: null,
            message: null == r ? void 0 : r.footer,
            theme: o.footer
          })
        });
      }
    }]), a;
  }();
function eu(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function tu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? eu(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : eu(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var ru = function () {
    function e(t) {
      n(this, e), c(this, "componentRef", {
        current: null
      }), c(this, "onSelectBank", void 0), this.onSelectBank = t;
    }
    var t;
    return s(e, [{
      key: "getRenderer",
      value: function value() {
        var e = this;
        return {
          content: function content(t) {
            var r,
              n,
              o = t.env,
              a = t.initData,
              i = t.initResult,
              s = t.i18n,
              c = i.paymentMethodInfo,
              u = c.banks || [];
            if (u.length > 1) return $t(Yc, {
              ref: e.componentRef,
              paymentMethod: a.paymentMethod,
              bankList: c.banks,
              imgHost: o.imageHost,
              i18n: s,
              theme: tu(tu({}, null === (r = a.theme) || void 0 === r ? void 0 : r["default"]), null === (n = a.theme) || void 0 === n ? void 0 : n.VirtualAccount),
              needAdaptive: a.needAdaptive,
              onSelectBank: e.onSelectBank
            });
            if (1 === u.length) {
              var l = u[0].bankCode;
              e.onSelectBank({
                value: l,
                label: l
              });
            }
            return $t(to, {
              ref: e.componentRef,
              i18n: s,
              initData: a,
              initResult: i
            });
          },
          footer: function footer(e) {
            var t,
              r,
              n,
              o = e.initData,
              a = e.initResult,
              i = e.i18n,
              s = a.paymentMethodInfo;
            if ((s.banks || []).length > 1) return $t(Qc, {
              i18n: i,
              theme: tu(tu({}, null === (t = o.theme) || void 0 === t ? void 0 : t["default"]), null === (r = o.theme) || void 0 === r ? void 0 : r.VirtualAccount),
              footerI18nKey: null === (n = s.cashierNotice) || void 0 === n ? void 0 : n.footerI18nKey
            });
          }
        };
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.componentRef.current) {
                  e.next = 3;
                  break;
                }
                return ke.reportErrorData("VirtualAccount_validate_before_render"), e.abrupt("return", !1);
              case 3:
                return e.abrupt("return", this.componentRef.current.validate());
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "needUserAction",
      value: function value() {
        return this.componentRef.current ? this.componentRef.current.needUserAction() : (ke.reportErrorData("VirtualAccount_needUserAction_before_render"), !1);
      }
    }]), e;
  }(),
  nu = function () {
    function e() {
      var t = this;
      n(this, e), c(this, "bankCode", void 0), c(this, "renderer", new ru(function (e) {
        return t.bankCode = e.value;
      }));
    }
    var t;
    return s(e, [{
      key: "getRenderer",
      value: function value() {
        return this.renderer.getRenderer();
      }
    }, {
      key: "needUserAction",
      value: function value() {
        return this.renderer.needUserAction();
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.renderer.validate());
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }]), e;
  }(),
  ou = function () {
    function e() {
      n(this, e), c(this, "VirtualAccountUI", new nu());
    }
    var t, r;
    return s(e, [{
      key: "needRenderWidget",
      value: (r = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !0);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "needUserAction",
      value: function value() {
        return this.VirtualAccountUI.needUserAction();
      }
    }, {
      key: "getRenderer",
      value: function value() {
        return this.VirtualAccountUI.getRenderer();
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.VirtualAccountUI.validate());
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "getPayHooks",
      value: function value() {
        var e,
          t = this;
        return {
          extendConfirmParams: (e = l(b.mark(function e() {
            return b.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", {
                      paymentInstrument: {
                        subPaymentMethod: t.VirtualAccountUI.bankCode
                      }
                    });
                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function () {
            return e.apply(this, arguments);
          })
        };
      }
    }, {
      key: "destroy",
      value: function value() {
        this.VirtualAccountUI = null;
      }
    }]), e;
  }(),
  au = {
    mustAccept: !1,
    textType: {
      paymentAgreement: !0,
      subscribeAgreement: !0
    },
    defaultSwitchStatus: !0,
    switchVisible: !1
  },
  iu = "IS_ADD_CARD";
function su(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? su(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : su(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var uu = function () {
    var e = l(b.mark(function e(t) {
      var r, n, o, a, i;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t.get(["instrumentCheckout", "instrumentChoose", "unsupportedCount"]);
            case 2:
              return r = e.sent, n = mt(r, 3), o = n[0], a = n[1], i = n[2], e.abrupt("return", {
                instrumentCheckout: o,
                instrumentChoose: a,
                unsupportedCount: i
              });
            case 8:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
  lu = function () {
    var e = l(b.mark(function e(t, r) {
      var n, o, a, i, s, c;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t.get(["instrumentRequireTip", null == r ? void 0 : r.paymentAgreementI18nKey, null == r ? void 0 : r.subscribeAgreementI18nKey, null == r ? void 0 : r.footerI18nKey]);
            case 2:
              return n = e.sent, o = mt(n, 4), a = o[0], i = o[1], s = o[2], c = o[3], e.abrupt("return", {
                instrumentRequireTip: a,
                paymentAgreement: i,
                subscribeAgreement: s,
                footer: c
              });
            case 9:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r) {
      return e.apply(this, arguments);
    };
  }();
function pu(e) {
  var t,
    r,
    n = null == e || null === (t = e.paymentInstrument) || void 0 === t || null === (r = t.bindCard) || void 0 === r ? void 0 : r.protocol;
  return cu(cu({}, au), n);
}
function du(e) {
  return {
    iconColor: e.footerIconColor,
    fontColor: e.footerFontColor,
    linkColor: e.footerLinkColor
  };
}
function fu(e) {
  var t = e || {},
    r = t.bindCardProtocol,
    n = void 0 === r ? {} : r,
    o = t.CreditCard,
    a = void 0 === o ? {} : o;
  return cu(cu({
    rtl: t.rtl
  }, n), {}, {
    inputHeight: a.inputHeight
  });
}
function hu(e, t) {
  var r,
    n = function (e) {
      var t, r;
      if (!e || !D(e)) return {};
      var n = e[et.CreditCard] || {};
      return cu(cu(cu({}, e["default"]), n), {}, {
        inputFontLib: n.inputFontLib || (null === (t = e["default"]) || void 0 === t ? void 0 : t.fontLib),
        inputFontFamily: n.inputFontFamily || (null === (r = e["default"]) || void 0 === r ? void 0 : r.fontFamily)
      });
    }(e),
    o = cu(cu(cu(cu({}, null == e ? void 0 : e["default"]), n), t ? null == e ? void 0 : e.installment : {}), null == e ? void 0 : e.bindCardProtocol);
  return {
    rtl: null == e || null === (r = e["default"]) || void 0 === r ? void 0 : r.rtl,
    CreditCard: n,
    installment: cu(cu(cu({}, null == e ? void 0 : e["default"]), n), null == e ? void 0 : e.installment),
    bindCardProtocol: o
  };
}
function vu(e, t) {
  var r,
    n,
    o,
    a = Xe(e),
    i = !(null === (r = e.paymentInstrument) || void 0 === r || null === (n = r.CreditCard) || void 0 === n || !n.cardToken),
    s = !1,
    c = !1,
    u = !1;
  if (a) {
    var l = pu(e);
    s = l.textType.paymentAgreement || l.switchVisible, c = l.textType.subscribeAgreement, u = Boolean(l.defaultSwitchStatus);
  }
  var p = function (e) {
      var t = e.paymentMethodInfo,
        r = (void 0 === t ? {} : t).paymentInstruments;
      return null != r && r.length ? r.filter(function (e) {
        return !e.expired;
      }) : r;
    }(t),
    d = on(e.installmentCounts, null == t ? void 0 : t.installments),
    f = function (e, t) {
      var r,
        n = nn(null == e ? void 0 : e.installmentCounts);
      return null != t && null !== (r = t.installments) && void 0 !== r && r.length || (n = !1), an(t.installments) === Xr.PAYOFF && (n = !1), n;
    }(e, t);
  return {
    isCustomerPaymentInstrument: a,
    hasCardToken: i,
    theme: hu(e.theme, f),
    isDefaultPci: i || !a,
    isPaymentAgreementExist: s,
    isSubscribeAgreementExist: c,
    defaultSavePaymentInstrument: u,
    isInstallmentExist: f,
    installmentCapabilities: null === (o = t.merchantCapability) || void 0 === o ? void 0 : o.installmentCapabilities,
    installmentInfoList: d,
    paymentInstruments: p
  };
}
function yu(e, t) {
  var r = t.initData,
    n = t.isCustomerPaymentInstrument,
    o = {
      paymentMethod: r.paymentMethod
    };
  return n && (t.selectInstrumentId ? (o.customerToken = r.customerToken, o.paymentInstrumentId = t.selectInstrumentId) : !0 === t.savePaymentInstrument && (o.customerToken = null != e && e.customerToken ? e.customerToken : r.customerToken, o.paymentInstrumentExtraData = {
    savePaymentInstrument: !0
  })), t.isInstallmentExist && null != e && e.onlyStoreCard && ke.reportErrorData("card_binding_validate_pay_error"), t.isInstallmentExist && (o.paymentMethodOptions = {
    installments: {
      count: null == t ? void 0 : t.installmentCount
    }
  }), o;
}
function mu(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) {
    n[r] = e[r];
  }
  return n;
}
function gu(e) {
  return function (e) {
    if (Array.isArray(e)) return mu(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return mu(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? mu(e, t) : void 0;
    }
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function bu(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function ku(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function wu(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Cu(e, t, r) {
  return t && wu(e.prototype, t), r && wu(e, r), e;
}
function _u(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ou(e) {
  return (Ou = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function Pu(e, t, r) {
  return (Pu = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, r) {
    var n = function (e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Ou(e));) {
        ;
      }
      return e;
    }(e, t);
    if (n) {
      var o = Object.getOwnPropertyDescriptor(n, t);
      return o.get ? o.get.call(r) : o.value;
    }
  })(e, t, r || e);
}
function xu(e, t) {
  return (xu = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function Iu(e) {
  return (Iu = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}
"function" != typeof Object.assign && (Object.assign = function (e) {
  for (var t = arguments.length, r = 1; r < t; r++) {
    var n = arguments[r];
    for (var o in n) {
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
  }
  return e;
});
var Su = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
  Du = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i,
  Ru = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
  Eu = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function Tu(e) {
  return (e && e.message || "No error message").split("\n").filter(function (e) {
    return !!e;
  })[0];
}
function Au(e) {
  try {
    var t = function (e) {
      if (!e.stack) return null;
      for (var t, r, n = [], o = e.stack.split("\n"), a = 0; a < o.length; ++a) {
        if (t = Su.exec(o[a])) r = {
          filename: t[2] && 0 === t[2].indexOf("address at ") ? t[2].substr(11) : t[2],
          "function": t[1] || "?",
          lineno: t[3] ? +t[3] : null,
          colno: t[4] ? +t[4] : null
        };else if (t = Ru.exec(o[a])) r = {
          filename: t[2],
          "function": t[1] || "?",
          lineno: +t[3],
          colno: t[4] ? +t[4] : null
        };else {
          if (!(t = Du.exec(o[a]))) continue;
          0 !== a || t[5] || void 0 === e.columnNumber || (n[0].column = e.columnNumber + 1), r = {
            filename: t[3],
            "function": t[1] || "?",
            lineno: t[4] ? +t[4] : null,
            colno: t[5] ? +t[5] : null
          };
        }
        !r["function"] && r.lineno && (r["function"] = "?"), n.push(r);
      }
      return n.length ? {
        value: Tu(e),
        type: e.name,
        stacktrace: {
          frames: n.reverse()
        }
      } : null;
    }(e);
    if (t) return t;
  } catch (e) {}
  return {
    value: Tu(e),
    type: e && e.name,
    stacktrace: {
      frames: []
    }
  };
}
var Lu = Object.assign || function (e) {
    for (var t = arguments.length, r = 1; r < t; r++) {
      var n = arguments[r];
      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }
    return e;
  },
  ju = function () {
    function e(t) {
      if (ku(this, e), t.dsn) {
        var r = Eu.exec(t.dsn),
          n = r ? r.slice(1) : [],
          o = n[5].split("/"),
          a = o.slice(0, -1).join("/");
        this.apiUrl = n[0] + "://" + n[3] + (n[4] ? ":" + n[4] : "") + (a ? "/" + a : "") + "/api/" + o.pop() + "/store/", this.authHeader = "Sentry sentry_version=7,sentry_key=" + n[1] + (n[2] ? ",sentry_secret=" + n[2] : "");
      }
      this.environment = t.environment;
    }
    return Cu(e, [{
      key: "prepare",
      value: function value(e) {
        return Lu(this.getRequestBlank(), {
          exception: {
            values: [Au(e)]
          }
        });
      }
    }, {
      key: "report",
      value: function value(e) {
        this.send(this.prepare(e));
      }
    }, {
      key: "send",
      value: function value(e) {
        if (this.apiUrl) {
          var t = new XMLHttpRequest();
          t.open("POST", this.apiUrl, !0), t.setRequestHeader("Content-type", "application/json"), t.setRequestHeader("X-Sentry-Auth", this.authHeader || ""), t.send(JSON.stringify(e));
        }
      }
    }, {
      key: "getRequestBlank",
      value: function value() {
        return {
          platform: "javascript",
          sdk: {
            name: "micro-sentry.javascript.browser",
            version: "0.0.0"
          },
          timestamp: Date.now() / 1e3,
          request: {
            url: window.location.toString(),
            headers: {
              "User-Agent": window.navigator.userAgent
            }
          },
          environment: this.environment
        };
      }
    }]), e;
  }();
function Nu(e, t) {
  return "[object RegExp]" === Object.prototype.toString.call(t) ? t.test(e) : "string" == typeof t && -1 !== e.indexOf(t);
}
function Bu(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = Ou(e);
    if (t) {
      var o = Ou(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      return !t || "object" !== Iu(t) && "function" != typeof t ? _u(e) : t;
    }(this, r);
  };
}
var Mu = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && xu(e, t);
  }(r, ju);
  var t = Bu(r);
  function r(e) {
    var n;
    ku(this, r), (n = t.call(this, e)).options = e, n.destroyed = !1, n._state = {};
    var o = n.options || {},
      a = o.plugins,
      i = void 0 === a ? [] : a,
      s = o.beforeSend,
      c = void 0 === s ? function (e) {
        return e;
      } : s,
      u = o.beforeBreadcrumb,
      l = void 0 === u ? function (e) {
        return e;
      } : u,
      p = o.blacklistUrls,
      d = void 0 === p ? [] : p,
      f = o.ignoreErrors,
      h = void 0 === f ? [] : f,
      v = o.release,
      y = void 0 === v ? void 0 : v;
    return n.plugins = i.map(function (e) {
      return new e(_u(n));
    }), n.beforeSend = c, n.beforeBreadcrumb = l, n.blacklistUrls = d, n.ignoreErrors = h, n.release = y, n;
  }
  return Cu(r, [{
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "clearState",
    value: function value() {
      this._state = {};
    }
  }, {
    key: "setTags",
    value: function value(e) {
      return this.setKeyState("tags", Object.assign({}, e)), this;
    }
  }, {
    key: "setTag",
    value: function value(e, t) {
      return this.extendState({
        tags: bu({}, e, t)
      }), this;
    }
  }, {
    key: "setExtra",
    value: function value(e, t) {
      return this.extendState({
        extra: bu({}, e, t)
      }), this;
    }
  }, {
    key: "setExtras",
    value: function value(e) {
      return this.setKeyState("extra", Object.assign({}, e)), this;
    }
  }, {
    key: "setUser",
    value: function value(e) {
      return this.setKeyState("user", Object.assign({}, e)), this;
    }
  }, {
    key: "clone",
    value: function value() {
      var e = new r(Object.assign(Object.assign({}, this.options), {
        plugins: []
      }));
      return e.extendState(this.state), e;
    }
  }, {
    key: "withScope",
    value: function value(e) {
      var t = this.clone();
      e(t), t.destroy(), this.setBreadcrumbs(void 0);
    }
  }, {
    key: "addBreadcrumb",
    value: function value(e) {
      this.extendState({
        breadcrumbs: [Object.assign({
          timestamp: Date.now() / 1e3
        }, this.beforeBreadcrumb(e))]
      });
    }
  }, {
    key: "setBreadcrumbs",
    value: function value(e) {
      this.setKeyState("breadcrumbs", e);
    }
  }, {
    key: "captureMessage",
    value: function value(e, t) {
      this.send(Object.assign(Object.assign({}, this.getRequestBlank()), {
        message: e,
        level: t
      }));
    }
  }, {
    key: "destroy",
    value: function value() {
      this.destroyed = !0, this.plugins.forEach(function (e) {
        e.destroy && e.destroy();
      });
    }
  }, {
    key: "isIgnoredError",
    value: function value(e) {
      var t = this;
      return !!this.ignoreErrors.length && this.getPossibleEventMessages(e).some(function (e) {
        return t.ignoreErrors.some(function (t) {
          return Nu(e, t);
        });
      });
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return Object.assign(Object.assign({}, Pu(Ou(r.prototype), "getRequestBlank", this).call(this)), this.state);
    }
  }, {
    key: "send",
    value: function value(e) {
      this.destroyed || this.isDeniedUrl(e) || this.isIgnoredError(e) || (Pu(Ou(r.prototype), "send", this).call(this, this.beforeSend(Object.assign({
        release: this.release
      }, e))), this.setBreadcrumbs(void 0));
    }
  }, {
    key: "getPossibleEventMessages",
    value: function value(e) {
      if (e.message) return [e.message];
      if (e.exception) try {
        var t = e.exception.values && e.exception.values[0] || {},
          r = t.type,
          n = void 0 === r ? "" : r,
          o = t.value,
          a = void 0 === o ? "" : o;
        return ["".concat(a), "".concat(n, ": ").concat(a)];
      } catch (e) {
        return [];
      }
      return [];
    }
  }, {
    key: "isDeniedUrl",
    value: function value(e) {
      if (!this.blacklistUrls.length) return !1;
      var t = this.getEventFilterUrl(e);
      return !!t && this.blacklistUrls.some(function (e) {
        return Nu(t, e);
      });
    }
  }, {
    key: "getEventFilterUrl",
    value: function value(e) {
      try {
        if (e.exception) {
          var t = e.exception.values && e.exception.values[0].stacktrace && e.exception.values[0].stacktrace.frames;
          return t && t[t.length - 1].filename || null;
        }
        return null;
      } catch (e) {
        return null;
      }
    }
  }, {
    key: "extendState",
    value: function value(e) {
      var t = this;
      this._state = Object.keys(e).reduce(function (r, n) {
        var o = t.state[n],
          a = Array.isArray(o) ? o : null,
          i = e[n],
          s = Array.isArray(i) ? i : null;
        return Object.assign(Object.assign({}, r), bu({}, n, a || s ? [].concat(gu(a || []), gu(s || [])) : Object.assign(Object.assign({}, "string" != typeof o ? o : {}), "string" != typeof i ? i : {})));
      }, {});
    }
  }, {
    key: "setKeyState",
    value: function value(e, t) {
      this._state[e] = t;
    }
  }]), r;
}();
function Fu(e, t, r) {
  var n = e[t],
    o = r(n);
  if ("function" == typeof o) try {
    o.prototype = o.prototype || {}, Object.defineProperties(o, {
      __original__: {
        enumerable: !1,
        value: n
      }
    });
  } catch (e) {}
  e[t] = o;
}
function Hu(e) {
  if (!e) return {};
  var t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t) return {};
  var r = t[6] || "",
    n = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    relative: t[5] + r + n
  };
}
function Vu() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "Request" in window && e[0] instanceof Request && e[0].method ? String(e[0].method).toUpperCase() : e[1] && e[1].method ? String(e[1].method).toUpperCase() : "GET";
}
function Wu() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "string" == typeof e[0] ? e[0] : "Request" in window && e[0] instanceof Request ? e[0].url : String(e[0]);
}
function Uu(e) {
  return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}
function Gu(e) {
  var t = e,
    r = [];
  if (!t || !t.tagName) return "";
  r.push(t.tagName.toLowerCase()), t.id && r.push("#".concat(t.id));
  var n = t.className;
  if (n && "string" == typeof n) {
    var o = n.split(/\s+/);
    r.concat(o.map(function (e) {
      return ".".concat(e);
    }));
  }
  return ["type", "name", "title", "alt", "automation-id"].forEach(function (e) {
    var n = t.getAttribute(e);
    n && r.push("[".concat(e, '="').concat(n, '"]'));
  }), r.join("");
}
function Ku(e) {
  try {
    for (var t, r = e, n = [], o = 0, a = 0; r && o++ < 5 && !("html" === (t = Gu(r)) || o > 1 && a + 3 * n.length + t.length >= 80);) {
      n.push(t), a += t.length, r = r.parentNode;
    }
    return n.reverse().join(" > ");
  } catch (e) {
    return "<unknown>";
  }
}
function qu(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
  return Array.isArray(e) ? e.map(function (e) {
    try {
      return String(e);
    } catch (e) {
      return "";
    }
  }).filter(function (e) {
    return "" !== e;
  }).join(t) : "";
}
function zu(e, t, r, n, o, a, i) {
  try {
    var s = e[a](i),
      c = s.value;
  } catch (e) {
    return void r(e);
  }
  s.done ? t(c) : Promise.resolve(c).then(n, o);
}
function Zu(e) {
  return function () {
    var t = this,
      r = arguments;
    return new Promise(function (n, o) {
      var a = e.apply(t, r);
      function i(e) {
        zu(a, n, o, i, s, "next", e);
      }
      function s(e) {
        zu(a, n, o, i, s, "throw", e);
      }
      i(void 0);
    });
  };
}
function $u(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Ju(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Xu(e, t, r) {
  return t && Ju(e.prototype, t), r && Ju(e, r), e;
}
function Yu(e, t) {
  return (Yu = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function Qu(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Yu(e, t);
}
function el(e) {
  return (el = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}
function tl(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function rl(e, t) {
  return !t || "object" !== el(t) && "function" != typeof t ? tl(e) : t;
}
function nl(e) {
  return (nl = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function ol(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
!function () {
  function e(t) {
    ku(this, e), this.client = t, this.subscriptions = [], this.initDOM(), this.initConsole(), this.initFetch(), this.initHistory(), this.initXHR();
  }
  Cu(e, [{
    key: "initXHR",
    value: function value() {
      if ("XMLHttpRequest" in window) {
        var e = this,
          t = XMLHttpRequest.prototype;
        Fu(t, "open", function (t) {
          return function () {
            for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) {
              n[o] = arguments[o];
            }
            var a = this,
              i = n[1];
            a.__sentry_xhr__ = {
              method: "string" == typeof n[0] ? n[0].toUpperCase() : n[0],
              url: n[1]
            }, "string" == typeof i && "POST" === a.__sentry_xhr__.method && i.match(/sentry_key/) && (a.__sentry_own_request__ = !0);
            var s = function s() {
              if (4 === a.readyState) {
                try {
                  a.__sentry_xhr__ && (a.__sentry_xhr__.status_code = a.status);
                } catch (e) {}
                e.xhrBreadcrumb({
                  args: n,
                  endTimestamp: Date.now(),
                  startTimestamp: Date.now(),
                  xhr: a
                });
              }
            };
            return "onreadystatechange" in a && "function" == typeof a.onreadystatechange ? Fu(a, "onreadystatechange", function (e) {
              return function () {
                s();
                for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
                  r[n] = arguments[n];
                }
                e.apply(a, r);
              };
            }) : a.addEventListener("readystatechange", s), t.apply(a, n);
          };
        }), Fu(t, "send", function (t) {
          return function () {
            for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) {
              n[o] = arguments[o];
            }
            return e.xhrBreadcrumb({
              args: n,
              startTimestamp: Date.now(),
              xhr: this
            }), t.apply(this, n);
          };
        });
      }
    }
  }, {
    key: "initHistory",
    value: function value() {
      var e = this,
        t = window.onpopstate;
      function r(t) {
        return function () {
          for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) {
            n[o] = arguments[o];
          }
          var a = n.length > 2 ? n[2] : void 0;
          if (a) {
            var i = e.lastHref,
              s = String(a);
            e.lastHref = s, e.historyBreadcrumb({
              from: i,
              to: s
            });
          }
          return t.apply(this, n);
        };
      }
      window.onpopstate = function () {
        var r = window.location.href,
          n = e.lastHref;
        if (e.lastHref = r, e.historyBreadcrumb({
          from: n,
          to: r
        }), t) {
          for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) {
            a[i] = arguments[i];
          }
          return t.apply(this, a);
        }
      }, Fu(window.history, "pushState", r), Fu(window.history, "replaceState", r);
    }
  }, {
    key: "destroy",
    value: function value() {
      this.subscriptions.forEach(function (e) {
        return e();
      });
    }
  }, {
    key: "initDOM",
    value: function value() {
      var e = this,
        t = function t(_t3) {
          return e.prepareDomEvent("click", _t3);
        },
        r = function r(t) {
          return e.prepareDomEvent("keypress", t);
        };
      window.document.addEventListener("click", t, !1), window.document.addEventListener("keypress", r, !1), this.subscriptions.push(function () {
        window.document.removeEventListener("click", t, !1), window.document.removeEventListener("keypress", r, !1);
      });
    }
  }, {
    key: "prepareDomEvent",
    value: function value(e, t) {
      var r;
      try {
        r = t.target ? Ku(t.target) : Ku(t);
      } catch (e) {
        r = "<unknown>";
      }
      0 !== r.length && this.client.addBreadcrumb({
        category: "ui.".concat(e),
        message: r
      });
    }
  }, {
    key: "initFetch",
    value: function value() {
      var e = this;
      (function () {
        if (!function () {
          if (!("fetch" in window)) return !1;
          try {
            return new Headers(), new Request(""), new Response(), !0;
          } catch (e) {
            return !1;
          }
        }()) return !1;
        if (Uu(window.fetch)) return !0;
        var e = !1,
          t = window.document;
        if (t && "function" == typeof t.createElement) try {
          var r = t.createElement("iframe");
          r.sandbox.add("allow-scripts"), r.sandbox.add("allow-same-origin"), r.hidden = !0, t.head.appendChild(r), r.contentWindow && r.contentWindow.fetch && (e = Uu(r.contentWindow.fetch)), t.head.removeChild(r);
        } catch (e) {}
        return e;
      })() && Fu(window, "fetch", function (t) {
        return function () {
          for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) {
            n[o] = arguments[o];
          }
          var a = {
            args: n,
            fetchData: {
              method: Vu(n),
              url: Wu(n)
            },
            startTimestamp: Date.now()
          };
          return e.fetchBreadcrumb(Object.assign({}, a)), t.apply(window, n).then(function (t) {
            return e.fetchBreadcrumb(Object.assign(Object.assign({}, a), {
              endTimestamp: Date.now(),
              response: t
            })), t;
          }, function (t) {
            throw e.fetchBreadcrumb(Object.assign(Object.assign({}, a), {
              endTimestamp: Date.now(),
              error: t
            })), t;
          });
        };
      });
    }
  }, {
    key: "fetchBreadcrumb",
    value: function value(e) {
      e.endTimestamp && (e.fetchData.url.match(/sentry_key/) && "POST" === e.fetchData.method || (e.error ? this.client.addBreadcrumb({
        category: "fetch",
        data: e.fetchData,
        level: "error",
        type: "http"
      }) : this.client.addBreadcrumb({
        category: "fetch",
        data: Object.assign(Object.assign({}, e.fetchData), {
          status_code: e.response.status
        }),
        type: "http"
      })));
    }
  }, {
    key: "xhrBreadcrumb",
    value: function value(e) {
      if (e.endTimestamp) {
        if (e.xhr.__sentry_own_request__) return;
        this.client.addBreadcrumb({
          category: "xhr",
          data: e.xhr.__sentry_xhr__,
          type: "http"
        });
      }
    }
  }, {
    key: "initConsole",
    value: function value() {
      var e = this;
      ["debug", "info", "warn", "error", "log", "assert"].forEach(function (t) {
        t in window.console && Fu(window.console, t, function (r) {
          return function () {
            for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++) {
              o[a] = arguments[a];
            }
            var i = {
              category: "console",
              data: {
                arguments: o.map(function (e) {
                  try {
                    return JSON.stringify(e), e;
                  } catch (t) {
                    return Object.prototype.toString.call(e);
                  }
                }),
                logger: "console"
              },
              level: t,
              message: qu(o, " ")
            };
            if ("assert" === t) {
              if (!1 !== o[0]) return;
              i.message = "Assertion failed: ".concat(qu(o.slice(1), " ") || "console.assert"), i.data.arguments = o.slice(1);
            }
            e.client.addBreadcrumb(i), r && Function.prototype.apply.call(r, window.console, o);
          };
        });
      });
    }
  }, {
    key: "historyBreadcrumb",
    value: function value(e) {
      var t = e.from,
        r = e.to,
        n = Hu(window.location.href),
        o = Hu(t),
        a = Hu(r);
      o.path || (o = n), n.protocol === a.protocol && n.host === a.host && (r = a.relative), n.protocol === o.protocol && n.host === o.host && (t = o.relative), this.client.addBreadcrumb({
        category: "navigation",
        data: {
          from: t,
          to: r
        }
      });
    }
  }]);
}();
var al = {
  exports: {}
};
!function (e) {
  var t = function (e) {
    var t,
      r = Object.prototype,
      n = r.hasOwnProperty,
      o = "function" == typeof Symbol ? Symbol : {},
      a = o.iterator || "@@iterator",
      i = o.asyncIterator || "@@asyncIterator",
      s = o.toStringTag || "@@toStringTag";
    function c(e, t, r) {
      return Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), e[t];
    }
    try {
      c({}, "");
    } catch (e) {
      c = function c(e, t, r) {
        return e[t] = r;
      };
    }
    function u(e, t, r, n) {
      var o = t && t.prototype instanceof y ? t : y,
        a = Object.create(o.prototype),
        i = new S(n || []);
      return a._invoke = function (e, t, r) {
        var n = p;
        return function (o, a) {
          if (n === f) throw new Error("Generator is already running");
          if (n === h) {
            if ("throw" === o) throw a;
            return R();
          }
          for (r.method = o, r.arg = a;;) {
            var i = r.delegate;
            if (i) {
              var s = P(i, r);
              if (s) {
                if (s === v) continue;
                return s;
              }
            }
            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (n === p) throw n = h, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = f;
            var c = l(e, t, r);
            if ("normal" === c.type) {
              if (n = r.done ? h : d, c.arg === v) continue;
              return {
                value: c.arg,
                done: r.done
              };
            }
            "throw" === c.type && (n = h, r.method = "throw", r.arg = c.arg);
          }
        };
      }(e, r, i), a;
    }
    function l(e, t, r) {
      try {
        return {
          type: "normal",
          arg: e.call(t, r)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }
    e.wrap = u;
    var p = "suspendedStart",
      d = "suspendedYield",
      f = "executing",
      h = "completed",
      v = {};
    function y() {}
    function m() {}
    function g() {}
    var b = {};
    b[a] = function () {
      return this;
    };
    var k = Object.getPrototypeOf,
      w = k && k(k(D([])));
    w && w !== r && n.call(w, a) && (b = w);
    var C = g.prototype = y.prototype = Object.create(b);
    function _(e) {
      ["next", "throw", "return"].forEach(function (t) {
        c(e, t, function (e) {
          return this._invoke(t, e);
        });
      });
    }
    function O(e, t) {
      function r(o, a, i, s) {
        var c = l(e[o], e, a);
        if ("throw" !== c.type) {
          var u = c.arg,
            p = u.value;
          return p && "object" == _typeof(p) && n.call(p, "__await") ? t.resolve(p.__await).then(function (e) {
            r("next", e, i, s);
          }, function (e) {
            r("throw", e, i, s);
          }) : t.resolve(p).then(function (e) {
            u.value = e, i(u);
          }, function (e) {
            return r("throw", e, i, s);
          });
        }
        s(c.arg);
      }
      var o;
      this._invoke = function (e, n) {
        function a() {
          return new t(function (t, o) {
            r(e, n, t, o);
          });
        }
        return o = o ? o.then(a, a) : a();
      };
    }
    function P(e, r) {
      var n = e.iterator[r.method];
      if (n === t) {
        if (r.delegate = null, "throw" === r.method) {
          if (e.iterator["return"] && (r.method = "return", r.arg = t, P(e, r), "throw" === r.method)) return v;
          r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return v;
      }
      var o = l(n, e.iterator, r.arg);
      if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, v;
      var a = o.arg;
      return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, v) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, v);
    }
    function x(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }
    function I(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }
    function S(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(x, this), this.reset(!0);
    }
    function D(e) {
      if (e) {
        var r = e[a];
        if (r) return r.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var o = -1,
            i = function r() {
              for (; ++o < e.length;) {
                if (n.call(e, o)) return r.value = e[o], r.done = !1, r;
              }
              return r.value = t, r.done = !0, r;
            };
          return i.next = i;
        }
      }
      return {
        next: R
      };
    }
    function R() {
      return {
        value: t,
        done: !0
      };
    }
    return m.prototype = C.constructor = g, g.constructor = m, m.displayName = c(g, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === m || "GeneratorFunction" === (t.displayName || t.name));
    }, e.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, c(e, s, "GeneratorFunction")), e.prototype = Object.create(C), e;
    }, e.awrap = function (e) {
      return {
        __await: e
      };
    }, _(O.prototype), O.prototype[i] = function () {
      return this;
    }, e.AsyncIterator = O, e.async = function (t, r, n, o, a) {
      void 0 === a && (a = Promise);
      var i = new O(u(t, r, n, o), a);
      return e.isGeneratorFunction(r) ? i : i.next().then(function (e) {
        return e.done ? e.value : i.next();
      });
    }, _(C), c(C, s, "Generator"), C[a] = function () {
      return this;
    }, C.toString = function () {
      return "[object Generator]";
    }, e.keys = function (e) {
      var t = [];
      for (var r in e) {
        t.push(r);
      }
      return t.reverse(), function r() {
        for (; t.length;) {
          var n = t.pop();
          if (n in e) return r.value = n, r.done = !1, r;
        }
        return r.done = !0, r;
      };
    }, e.values = D, S.prototype = {
      constructor: S,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(I), !e) for (var r in this) {
          "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        }
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var r = this;
        function o(n, o) {
          return s.type = "throw", s.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
        }
        for (var a = this.tryEntries.length - 1; a >= 0; --a) {
          var i = this.tryEntries[a],
            s = i.completion;
          if ("root" === i.tryLoc) return o("end");
          if (i.tryLoc <= this.prev) {
            var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");
            if (c && u) {
              if (this.prev < i.catchLoc) return o(i.catchLoc, !0);
              if (this.prev < i.finallyLoc) return o(i.finallyLoc);
            } else if (c) {
              if (this.prev < i.catchLoc) return o(i.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < i.finallyLoc) return o(i.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];
          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var a = o;
            break;
          }
        }
        a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
        var i = a ? a.completion : {};
        return i.type = e, i.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, v) : this.complete(i);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), v;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];
          if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), I(r), v;
        }
      },
      "catch": function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];
          if (r.tryLoc === e) {
            var n = r.completion;
            if ("throw" === n.type) {
              var o = n.arg;
              I(r);
            }
            return o;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, r, n) {
        return this.delegate = {
          iterator: D(e),
          resultName: r,
          nextLoc: n
        }, "next" === this.method && (this.arg = t), v;
      }
    }, e;
  }(al.exports);
  try {
    regeneratorRuntime = t;
  } catch (e) {
    Function("r", "regeneratorRuntime = r")(t);
  }
}();
var il,
  sl,
  cl,
  ul,
  ll = al.exports;
function pl(e, t, r) {
  return (pl = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }() ? Reflect.construct : function (e, t, r) {
    var n = [null];
    n.push.apply(n, t);
    var o = new (Function.bind.apply(e, n))();
    return r && Yu(o, r.prototype), o;
  }).apply(null, arguments);
}
function dl(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return (dl = function dl(e) {
    if (null === e || (r = e, -1 === Function.toString.call(r).indexOf("[native code]"))) return e;
    var r;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, n);
    }
    function n() {
      return pl(e, arguments, nl(this).constructor);
    }
    return n.prototype = Object.create(e.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Yu(n, e);
  })(e);
}
function fl(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = nl(e);
    if (t) {
      var o = nl(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return rl(this, r);
  };
}
!function (e) {
  e.NotSupportBrowser = "1026", e.InnerSDKError = "1027", e.RenderFail = "1028", e.NetworkError = "1109", e.FrequentRequest = "1904", e.AbnormalTrade = "4205";
}(il || (il = {})), function (e) {
  e.AbnormalTrade = "TRANSACTION_ABNORMAL", e.NetworkError = "Network error";
}(sl || (sl = {})), function (e) {
  e.Fatal = "fatal", e.Error = "error";
}(cl || (cl = {})), function (e) {
  e.IframeError = "PciIframeError", e.NoDom = "NoDomError";
}(ul || (ul = {}));
var hl = function (e) {
    Qu(r, dl(Error));
    var t = fl(r);
    function r(e) {
      var n,
        o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : il.InnerSDKError,
        a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "UnknownError",
        i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : cl.Error;
      return $u(this, r), ol(tl(n = t.call(this, e)), "code", void 0), ol(tl(n), "isReported", !1), ol(tl(n), "data", void 0), ol(tl(n), "errorLevel", void 0), n.name = a, n.code = o, n.errorLevel = i, n;
    }
    return Xu(r, [{
      key: "setIsReported",
      value: function value() {
        this.isReported = !0;
      }
    }]), r;
  }(),
  vl = function (e) {
    Qu(r, hl);
    var t = fl(r);
    function r(e) {
      var n,
        o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : il.InnerSDKError,
        a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "SilenceError",
        i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : cl.Error;
      return $u(this, r), ol(tl(n = t.call(this, e, o, a, i)), "statusCode", void 0), n;
    }
    return r;
  }();
function yl(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ml(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? yl(Object(r), !0).forEach(function (t) {
      ol(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yl(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var gl = new Mu({
  dsn: "https://820fe9124d6a4b4d8ef0ee1e44a29c4b@sentry-new.myshopline.com/305",
  release: "3.6.2",
  environment: "production",
  beforeSend: function beforeSend(e) {
    return e;
  }
});
function bl(e, t) {
  var r = JSON.stringify(ml(ml({}, e || {}), {}, {
      originErrorMessage: null == t ? void 0 : t.message,
      originErrorData: t ? JSON.stringify(t) : void 0,
      errorLevel: (null == t ? void 0 : t.errorLevel) || (null == e ? void 0 : e.errorLevel) || cl.Error
    })),
    n = new Error(r);
  if (null != t && t.stack) try {
    n.stack = t.stack;
  } catch (e) {
    gl.report(e), gl.report(t);
  }
  gl.report(n);
}
function kl(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 10;
  return e ? function (e, t) {
    for (var r = "", n = 0; n < t; n++) {
      r += e;
    }
    return r;
  }("*", t) + e.slice(t) : e;
}
function wl(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Cl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? wl(Object(r), !0).forEach(function (t) {
      ol(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : wl(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var _l,
  Ol,
  Pl,
  xl,
  Il = new t("webpaymentsdk"),
  Sl = function () {
    function t() {
      $u(this, t);
    }
    return Xu(t, null, [{
      key: "init",
      value: function value(t) {
        Il.init({
          projectName: "pcisdk",
          environment: "production",
          version: "3.6.2"
        }, t.eventTrackingConfig), gl.setTag("pvId", e);
      }
    }, {
      key: "setHost",
      value: function value(e) {
        gl.setTag("host", e);
      }
    }, {
      key: "reportError",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "report_error",
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        e instanceof vl || e.name === ul.IframeError || (e instanceof hl ? e.isReported || (bl(Cl({
          eventName: t
        }, r), e), e.setIsReported()) : bl(Cl({
          eventName: t
        }, r), e));
      }
    }, {
      key: "handleError",
      value: function value(e) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "pci_sdk_default_error",
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if (t.reportData(r, Cl(Cl({}, e), n)), t.reportError(e, r, n), e instanceof vl || e instanceof hl) throw e;
        var o = "".concat(r, " ").concat(e.message || "pci sdk inner error"),
          a = new vl(o);
        throw a.statusCode = e.statusCode, a.name = e.name || "Error", a.code = e.code || a.code, a.errorLevel = e.errorLevel || cl.Error, a.data = Cl({
          code: il.InnerSDKError,
          msg: o
        }, e.data || {}), a;
      }
    }, {
      key: "formatReportData",
      value: function value(e) {
        if (!e) return {};
        var t = Cl({}, e);
        return t.customerToken && (t.customerToken = kl(t.customerToken, 30)), t.payToken && (t.payToken = kl(t.payToken, 10)), t;
      }
    }, {
      key: "reportData",
      value: function value(e, r) {
        try {
          Il.report(e, r ? {
            extraData: JSON.stringify(r)
          } : {});
        } catch (n) {
          t.reportError(n, "".concat(e, "_report_data_error"), r);
        }
      }
    }, {
      key: "reportErrorData",
      value: function value(e, r) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : cl.Error;
        t.reportData(e, r), bl(Cl({
          eventName: e,
          errorLevel: n
        }, r));
      }
    }]), t;
  }();
!function (e) {
  e.Redirect = "Redirect", e.Confirm = "Confirm", e.QrCode = "QrCode", e.WorldPayGather = "WorldPayGather", e.ExchangeTicket = "ExchangeTicket";
}(_l || (_l = {})), function (e) {
  e.Success = "success", e.Fail = "fail";
}(Ol || (Ol = {})), function (e) {
  e.Number = "number", e.Cvc = "cvc", e.FirstName = "firstName", e.ExpDate = "expDate";
}(Pl || (Pl = {})), function (e) {
  e.Hidden = "hidden-iframe", e.Cache = "cache-iframe";
}(xl || (xl = {})), Pl.Number, Pl.Cvc, Pl.ExpDate;
var Dl,
  Rl,
  El,
  Tl,
  Al = [Pl.Number, Pl.Cvc, Pl.ExpDate, Pl.FirstName];
function Ll(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ll(Object(r), !0).forEach(function (t) {
      ol(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ll(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
(Dl || (Dl = {})).CN = "CN", function (e) {
  e.SL2 = "shopline2", e.SLP = "slp";
}(Rl || (Rl = {})), function (e) {
  e.validate = "getValidate", e.pay = "pay", e.getBeforePayData = "getBeforePayData", e.getCardToken = "getCardToken", e.updateCardToken = "updateCardToken", e.getCurrentCardInfo = "getCurrentCardInfo", e.getCardTokenInfoByCardToken = "getCardTokenInfoByCardToken";
}(El || (El = {})), function (e) {
  e.validate = "validate", e.pay = "payResult", e.getBeforePayData = "getBeforePayData", e.getCardToken = "cardTokenResult", e.updateCardToken = "updateCardTokenResult", e.getCurrentCardInfo = "cardInfoResult", e.getCardTokenInfoByCardToken = "getCardTokenInfoByCardTokenResult";
}(Tl || (Tl = {}));
var Nl = function () {
    function t(r) {
      var n = this,
        o = r.uuid,
        a = r.host,
        i = r.channelId,
        s = r.env,
        c = r.receiveMessageHandler;
      $u(this, t), ol(this, "uuid", void 0), ol(this, "iframeHost", "https://cashiers.myshopline.com"), ol(this, "isDev", !1), ol(this, "env", void 0), ol(this, "config", {}), ol(this, "channelId", void 0), ol(this, "mainIframe", Pl.Number), ol(this, "receiveMessageHandler", void 0), ol(this, "onIframeLoaded", function (t) {
        var r = t.name,
          o = t.mainIframe,
          a = t.displayFieldNames,
          i = n.config.placeholder;
        n.postToIframe(r, "initData", {
          pvId: e,
          env: n.env,
          mainIframe: o,
          displayFieldNames: a,
          parentUrl: window.location.href,
          parentOrigin: window.location.origin,
          channelId: n.channelId
        }), i && i[r] && n.postToIframe(r, "setAttr", {
          attr: {
            placeholder: i[r]
          }
        });
      }), this.uuid = o, this.channelId = i, this.env = s, this.receiveMessageHandler = c, a && !this.isDev && (this.iframeHost = a);
    }
    return Xu(t, [{
      key: "setConfig",
      value: function value(e) {
        this.config = e;
      }
    }, {
      key: "setIframeStatus",
      value: function value(e) {
        this.mainIframe = e.mainIframe;
      }
    }, {
      key: "handleApi",
      value: function value(e, t, r) {
        var n = this,
          o = El[e];
        return Sl.reportData("pci_sdk_".concat(o, "_start"), {
          eventData: null != t && t.nextAction ? jl(jl({}, t), {}, {
            nextAction: Sl.formatReportData(t.nextAction)
          }) : t
        }), new Promise(function (r, a) {
          n.receiveMessageHandler.setApiHandlerMap(e, r, a), n.postToMainIframe(o, t);
        }).then(function (e) {
          var t = r ? r(e) : {
            result: e
          };
          return Sl.reportData("pci_sdk_".concat(o, "_end"), t), e;
        })["catch"](function (e) {
          return Sl.handleError(e, "pci_sdk_".concat(o, "_error"));
        });
      }
    }, {
      key: "handleApiWithKey",
      value: function value(e, t, r) {
        var n = this,
          o = El[e];
        return Sl.reportData("pci_sdk_".concat(o, "_start"), {
          eventData: t ? t("") : void 0
        }), new Promise(function (r, a) {
          var i = n.receiveMessageHandler.setApiHandlerMapWithKey(e, r, a),
            s = t ? t(i) : void 0;
          n.postToMainIframe(o, s);
        }).then(function (e) {
          var t = e.key,
            n = e.result,
            a = r ? r({
              key: t,
              result: n
            }) : {
              key: t,
              result: n
            };
          return Sl.reportData("pci_sdk_".concat(o, "_end"), a), n;
        })["catch"](function (e) {
          return Sl.handleError(e, "pci_sdk_".concat(o, "_error"));
        });
      }
    }, {
      key: "postToMainIframe",
      value: function value(e, t) {
        this.postToIframe(this.mainIframe, e, t);
      }
    }, {
      key: "postToIframe",
      value: function value(e, t, r) {
        var n,
          o = jl({
            eventType: t,
            uuid: this.uuid
          }, r || {}),
          a = "".concat(e).concat(this.uuid);
        (null === (n = window.frames[a]) || void 0 === n ? void 0 : n.postMessage) && window.frames[a].postMessage(o, this.iframeHost);
      }
    }]), t;
  }(),
  Bl = function () {
    var e = Zu(ll.mark(function e(t) {
      return ll.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", new Promise(function (e) {
                setTimeout(function () {
                  e();
                }, t);
              }));
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
  Ml = function () {
    function e(t) {
      var r = t.uuid,
        n = t.host,
        o = t.receiveMessageHandler,
        a = t.cdn,
        i = t.merchantId;
      $u(this, e), ol(this, "uuid", void 0), ol(this, "merchantId", void 0), ol(this, "iframePath", "https://cashiers.myshopline.com/pci-sdk"), ol(this, "innerDisplayIframeNames", []), ol(this, "cdn", void 0), ol(this, "renderIframeDomMap", {}), ol(this, "innerMainIframe", Pl.Number), ol(this, "receiveMessageHandler", void 0), ol(this, "destroyed", !1), ol(this, "isDev", !1), this.uuid = r, this.receiveMessageHandler = o, n && !this.isDev && (this.iframePath = "".concat(n, "/pci-sdk")), this.cdn = a, this.merchantId = i, this.createCacheIframe();
    }
    var t;
    return Xu(e, [{
      key: "displayIframeNames",
      get: function get() {
        return this.innerDisplayIframeNames;
      }
    }, {
      key: "mainIframe",
      get: function get() {
        return this.innerMainIframe;
      }
    }, {
      key: "mountIframe",
      value: function value(e, t, r, n) {
        if (!e) throw new hl("Can't find the related dom node to mount the iframe", il.InnerSDKError, ul.NoDom);
        var o = document.createElement("iframe");
        o.onload = n, o.src = r, o.name = t, o.id = t, o.style.width = "100%", o.style.height = "100%", o.style.border = "none", e.innerHTML = "", e.appendChild(o);
      }
    }, {
      key: "getIframeLink",
      value: function value(e) {
        var t = this.isDev ? "" : "v".concat("3.6.2".split(".")[0], "/"),
          r = this.merchantId ? "?merchantId=".concat(this.merchantId) : "",
          n = "#name=".concat(e, "&uuid=").concat(this.uuid);
        return "".concat(this.iframePath, "/").concat(t, "iframe").concat(this.cdn === Dl.CN ? "-oss" : "", ".html").concat(r).concat(n);
      }
    }, {
      key: "createHiddenMountDom",
      value: function value(e) {
        var t = document.createElement("div");
        return t.setAttribute("data-pci", e), t.setAttribute("style", "display: none !important"), t.hidden = !0, document.body.appendChild(t), t;
      }
    }, {
      key: "doRenderIframe",
      value: function value(e, t) {
        var r = this,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
        this.destroyed || e.forEach(function (e) {
          r.mountIframe(r.renderIframeDomMap[e], "".concat(e).concat(r.uuid), r.getIframeLink(e), function () {
            return t({
              name: e,
              mainIframe: r.innerMainIframe,
              displayFieldNames: n
            });
          });
        });
      }
    }, {
      key: "createHiddenIframeDom",
      value: function value(e) {
        var t = xl.Hidden,
          r = this.createHiddenMountDom(t);
        this.innerDisplayIframeNames.push(t), this.renderIframeDomMap[t] = r, this.innerMainIframe = t, this.doRenderIframe(this.innerDisplayIframeNames, e), this.startIframeReloadTiming(e);
      }
    }, {
      key: "createCacheIframe",
      value: function value() {
        var e = xl.Cache,
          t = document.querySelector("div[data-pci=".concat(e, "]"));
        if (!t || !t.querySelector("iframe[id=".concat(e, "]"))) {
          var r = this.createHiddenMountDom(e);
          this.mountIframe(r, e, this.getIframeLink(e), function () {
            Sl.reportData("pci_sdk_cache_iframe_onload");
          });
        }
      }
    }, {
      key: "renderIframe",
      value: function value(e, t) {
        var r = this,
          n = [];
        if (e.querySelectorAll("[data-pci]").forEach(function (e, t) {
          var o = e.getAttribute("data-pci");
          0 !== t && o !== Pl.Number || (r.innerMainIframe = o), Al.indexOf(o) > -1 && (r.innerDisplayIframeNames.push(o), r.renderIframeDomMap[o] = e, n.push(o));
        }), 0 === this.innerDisplayIframeNames.length) throw new hl("Can't find any dom node to mount the iframe", il.InnerSDKError, ul.NoDom);
        this.doRenderIframe(this.innerDisplayIframeNames, t, n), this.startIframeReloadTiming(t, n);
      }
    }, {
      key: "startIframeReloadTiming",
      value: (t = Zu(ll.mark(function e(t) {
        var r,
          n,
          o,
          a,
          i,
          s = this,
          c = arguments;
        return ll.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                r = c.length > 1 && void 0 !== c[1] ? c[1] : [], n = 3, o = ll.mark(function e(o) {
                  var a, i;
                  return ll.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          if (!s.destroyed) {
                            e.next = 2;
                            break;
                          }
                          return e.abrupt("return", {
                            v: void 0
                          });
                        case 2:
                          return e.next = 4, Bl(15e3);
                        case 4:
                          if (!s.destroyed) {
                            e.next = 6;
                            break;
                          }
                          return e.abrupt("return", {
                            v: void 0
                          });
                        case 6:
                          if (a = s.receiveMessageHandler.getIframeLoadedStatus(), i = Object.keys(a).filter(function (e) {
                            return !a[e];
                          }), Sl.reportData("pci_sdk_check_iframe_status", {
                            loadFailIframeNames: i
                          }), i.length) {
                            e.next = 13;
                            break;
                          }
                          return e.abrupt("return", {
                            v: void 0
                          });
                        case 13:
                          if (!(o < n - 1)) {
                            e.next = 19;
                            break;
                          }
                          Sl.reportData("pci_sdk_reload_iframe"), i.forEach(function (e) {
                            var t = s.renderIframeDomMap[e];
                            t && (t.innerHTML = "");
                          }), s.doRenderIframe(i, t, r), e.next = 23;
                          break;
                        case 19:
                          return s.unmountIframe(), s.receiveMessageHandler.triggerEvent("onError", {}), Sl.reportError(new Error("failed to load iframe"), "pci_sdk_load_iframe_failed"), e.abrupt("return", {
                            v: void 0
                          });
                        case 23:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e);
                }), a = 0;
              case 4:
                if (!(a < n)) {
                  e.next = 12;
                  break;
                }
                return e.delegateYield(o(a), "t0", 6);
              case 6:
                if ("object" !== el(i = e.t0)) {
                  e.next = 9;
                  break;
                }
                return e.abrupt("return", i.v);
              case 9:
                a++, e.next = 4;
                break;
              case 12:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "unmountDom",
      value: function value(e) {
        if (e) {
          var t = this.renderIframeDomMap[e];
          t && (Sl.reportData("pci_sdk_unmount_dom", {
            name: e
          }), e === xl.Hidden ? t.parentNode.removeChild(t) : t.innerHTML = "", this.renderIframeDomMap[e] = null);
        }
      }
    }, {
      key: "unmountIframe",
      value: function value() {
        var e = this;
        Sl.reportData("pci_sdk_unmount_iframe"), this.innerDisplayIframeNames.forEach(function (t) {
          return e.unmountDom(t);
        });
      }
    }, {
      key: "destroy",
      value: function value() {
        this.destroyed = !0, this.unmountIframe();
      }
    }]), e;
  }();
function Fl(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
var Hl,
  Vl,
  Wl = function () {
    function e(t) {
      var r,
        n = this;
      $u(this, e), ol(this, "uuid", void 0), ol(this, "config", void 0), ol(this, "iframeLoaded", {}), ol(this, "ApiHandlerMap", {}), ol(this, "ReceiveMessageHandler", (ol(r = {
        loadFinished: function loadFinished(e) {
          n.iframeLoaded[e.name] = !0, Sl.reportData("pci_sdk_iframe_loadFinished", e), Object.keys(n.iframeLoaded).every(function (e) {
            return n.iframeLoaded[e];
          }) && (Sl.reportData("pci_sdk_onInit"), n.triggerEvent("onInit", {}));
        },
        focus: function focus(e) {
          n.triggerEvent("onFocus", {
            fieldName: e.name,
            isEmpty: e.isEmpty,
            isFocus: e.isFocus
          });
        },
        input: function input(e) {
          n.triggerEvent("onFieldValidChange", {
            fieldName: e.name,
            isValid: e.isValid,
            isEmpty: e.isEmpty
          });
        },
        cardBinChange: function cardBinChange(e) {
          n.triggerEvent("onCardBinChange", e.value);
        }
      }, Tl.validate, function (e) {
        Sl.reportData("pci_sdk_validate_credit_card_cache", e.reportData), n.resolveApiHandler("validate", e.isValid);
      }), ol(r, Tl.pay, function (e) {
        Sl.reportData("pci_sdk_pay_credit_card_cache", e.reportData), e.status === Ol.Success ? n.resolveApiHandler("pay", e.value) : n.rejectApiHandler("pay", e.value);
      }), ol(r, Tl.getBeforePayData, function (e) {
        n.resolveApiHandler("getBeforePayData", e.value);
      }), ol(r, Tl.getCardToken, function (e) {
        var t = (e.extraOptions || {}).key;
        t && (e.status === Ol.Success ? n.resolveApiHandlerWithKey("getCardToken", e.value, t) : n.rejectApiHandlerWithKey("getCardToken", e.value, t));
      }), ol(r, Tl.updateCardToken, function (e) {
        var t = (e.extraOptions || {}).key;
        t && (e.status === Ol.Success ? n.resolveApiHandlerWithKey("updateCardToken", e.value, t) : n.rejectApiHandlerWithKey("updateCardToken", e.value, t));
      }), ol(r, Tl.getCardTokenInfoByCardToken, function (e) {
        var t = (e.extraOptions || {}).key;
        t && (e.status === Ol.Success ? n.resolveApiHandlerWithKey("getCardTokenInfoByCardToken", e.value, t) : n.rejectApiHandlerWithKey("getCardTokenInfoByCardToken", e.value, t));
      }), ol(r, Tl.getCurrentCardInfo, function (e) {
        e.status === Ol.Success ? n.resolveApiHandler("getCurrentCardInfo", e.value) : n.rejectApiHandler("getCurrentCardInfo", e.value);
      }), r)), this.uuid = t;
    }
    return Xu(e, [{
      key: "init",
      value: function value(e, t) {
        var r = this;
        this.config = t, e.forEach(function (e) {
          return r.iframeLoaded[e] = !1;
        }), this.listenMessage();
      }
    }, {
      key: "getIframeLoadedStatus",
      value: function value() {
        return function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Fl(Object(r), !0).forEach(function (t) {
              ol(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Fl(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
          }
          return e;
        }({}, this.iframeLoaded);
      }
    }, {
      key: "listenMessage",
      value: function value() {
        var e = this;
        window.addEventListener("message", function (t) {
          var r = t.data,
            n = r.uuid,
            o = r.eventType;
          n === e.uuid && e.ReceiveMessageHandler[o] && e.ReceiveMessageHandler[o](t.data);
        });
      }
    }, {
      key: "setApiHandlerMap",
      value: function value(e, t, r) {
        this.ApiHandlerMap[e] = {
          resolve: t,
          reject: r
        };
      }
    }, {
      key: "setApiHandlerMapWithKey",
      value: function value(e, t, r) {
        var n = (new Date().getTime() + Math.floor(Math.random() * Math.pow(10, 13))).toString();
        return this.ApiHandlerMap[e] || (this.ApiHandlerMap[e] = {}), this.ApiHandlerMap[e][n] = {
          resolve: t,
          reject: r
        }, n;
      }
    }, {
      key: "resolveApiHandler",
      value: function value(e, t) {
        var r;
        (null === (r = this.ApiHandlerMap[e]) || void 0 === r ? void 0 : r.resolve) && this.ApiHandlerMap[e].resolve(t);
      }
    }, {
      key: "rejectApiHandler",
      value: function value(e, t) {
        var r;
        (null === (r = this.ApiHandlerMap[e]) || void 0 === r ? void 0 : r.reject) && this.ApiHandlerMap[e].reject(t);
      }
    }, {
      key: "resolveApiHandlerWithKey",
      value: function value(e, t, r) {
        var n, o;
        null !== (n = this.ApiHandlerMap[e]) && void 0 !== n && null !== (o = n[r]) && void 0 !== o && o.resolve && (this.ApiHandlerMap[e][r].resolve({
          key: r,
          result: t
        }), delete this.ApiHandlerMap[e][r]);
      }
    }, {
      key: "rejectApiHandlerWithKey",
      value: function value(e, t, r) {
        var n, o;
        null !== (n = this.ApiHandlerMap[e]) && void 0 !== n && null !== (o = n[r]) && void 0 !== o && o.reject && (this.ApiHandlerMap[e][r].reject(t), delete this.ApiHandlerMap[e][r]);
      }
    }, {
      key: "triggerEvent",
      value: function value(e, t) {
        try {
          this.config[e] && this.config[e](t);
        } catch (r) {
          Sl.handleError(r, "pci_sdk_triggerEvent_".concat(e, "_error"), t);
        }
      }
    }]), e;
  }();
!function (e) {
  e.Test1 = "test1", e.Test2 = "test2", e.Test3 = "test3", e.Alpha = "alpha", e.Prod = "prod";
}(Hl || (Hl = {}));
var Ul = (ol(Vl = {}, Hl.Test1, {
  host: "https://cashiers-test1.myshoplinestg.com"
}), ol(Vl, Hl.Test2, {
  host: "https://cashiers-test2.myshoplinestg.com"
}), ol(Vl, Hl.Test3, {
  host: "https://cashiers-test3.myshoplinestg.com"
}), ol(Vl, Hl.Alpha, {
  host: "https://cashiers-alpha.myshopline.com"
}), ol(Vl, Hl.Prod, {
  host: "https://cashiers.myshopline.com"
}), Vl);
function Gl(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Kl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Gl(Object(r), !0).forEach(function (t) {
      ol(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Gl(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var ql = function () {
  function e(t) {
    $u(this, e), ol(this, "apiInstance", void 0), ol(this, "iframeInstance", void 0), ol(this, "receiveMessageInstance", void 0), ol(this, "cardToken", void 0), ol(this, "config", void 0), this.initReporter(t);
    try {
      var r;
      Sl.reportData("pci_sdk_constructor_start", Sl.formatReportData(t));
      var n = (null === (r = Ul[t.env]) || void 0 === r ? void 0 : r.host) || "";
      Sl.setHost(n);
      var o = (a = new Date().getTime(), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
        var t = (a + 16 * Math.random()) % 16 | 0;
        return a = Math.floor(a / 16), ("x" === e ? t : 3 & t | 8).toString(16);
      }));
      this.cardToken = t.cardToken, this.receiveMessageInstance = new Wl(o), this.apiInstance = new Nl({
        uuid: o,
        host: n,
        channelId: null == t ? void 0 : t.channelId,
        env: t.env,
        receiveMessageHandler: this.receiveMessageInstance
      }), this.iframeInstance = new Ml({
        uuid: o,
        host: n,
        receiveMessageHandler: this.receiveMessageInstance,
        cdn: t.cdn,
        merchantId: t.merchantId
      }), Sl.reportData("pci_sdk_constructor_end");
    } catch (e) {
      Sl.handleError(e, "pci_sdk_constructor_error");
    }
    var a;
  }
  var t;
  return Xu(e, [{
    key: "initReporter",
    value: function value(e) {
      try {
        Sl.init(e);
      } catch (e) {
        Sl.handleError(e, "pci_sdk_init_reporter_error");
      }
    }
  }, {
    key: "update",
    value: (t = Zu(ll.mark(function e() {
      var t,
        r = arguments;
      return ll.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              t = r.length > 0 && void 0 !== r[0] ? r[0] : {}, Sl.reportData("pci_sdk_update_start", Sl.formatReportData(t)), t.cardToken && (this.cardToken = t.cardToken), Sl.reportData("pci_sdk_update_end");
            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "setConfig",
    value: function value(e) {
      this.apiInstance.setConfig(e);
    }
  }, {
    key: "getCardToken",
    value: function value(e) {
      return this.apiInstance.handleApiWithKey("getCardToken", function (t) {
        return {
          options: e,
          extraOptions: {
            key: t
          }
        };
      }, function (t) {
        var r = t.key,
          n = t.result;
        return Kl(Kl({}, e), {}, {
          token: (n.token || "").slice(-6),
          key: r
        });
      });
    }
  }, {
    key: "checkCardToken",
    value: function value() {
      if (!this.cardToken) return Sl.handleError(new hl("Empty CardToken", il.InnerSDKError, "EmptyCardToken"), "pci_sdk_getCardTokenInfoByCardToken_empty_cardToken_error");
    }
  }, {
    key: "getCardTokenInfoByCardToken",
    value: function value(e) {
      var t = this;
      return this.checkCardToken(), this.apiInstance.handleApiWithKey("getCardTokenInfoByCardToken", function (r) {
        return {
          options: Kl(Kl({}, e), {}, {
            token: t.cardToken
          }),
          extraOptions: {
            key: r
          }
        };
      }, function (t) {
        var r = t.key,
          n = t.result;
        return Kl(Kl({}, e), {}, {
          token: kl(n.token),
          key: r
        });
      });
    }
  }, {
    key: "pay",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return this.apiInstance.handleApi("pay", {
        nextAction: e,
        requestParams: Kl(Kl({}, t), {}, {
          cardToken: this.cardToken
        })
      });
    }
  }, {
    key: "destroy",
    value: function value() {
      try {
        Sl.reportData("pci_sdk_destroy_start"), this.iframeInstance.destroy(), Sl.reportData("pci_sdk_destroy_end");
      } catch (e) {
        Sl.handleError(e, "pci_sdk_destroy_error");
      }
    }
  }]), e;
}();
var zl = function (e) {
  Qu(r, ql);
  var t = function (e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var r,
        n = nl(e);
      if (t) {
        var o = nl(this).constructor;
        r = Reflect.construct(n, arguments, o);
      } else r = n.apply(this, arguments);
      return rl(this, r);
    };
  }(r);
  function r() {
    return $u(this, r), t.apply(this, arguments);
  }
  return Xu(r, [{
    key: "create",
    value: function value(e) {
      try {
        Sl.reportData("api_only_pci_sdk_create_start"), this.config = e, this.setConfig(e), this.iframeInstance.createHiddenIframeDom(this.apiInstance.onIframeLoaded), this.receiveMessageInstance.init(this.iframeInstance.displayIframeNames, this.config), this.apiInstance.setIframeStatus({
          mainIframe: this.iframeInstance.mainIframe
        }), Sl.reportData("api_only_pci_sdk_create_end");
      } catch (e) {
        Sl.handleError(e, "api_only_pci_sdk_create_error");
      }
    }
  }]), r;
}();
function Zl(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $l(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Zl(Object(r), !0).forEach(function (t) {
      ol(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Zl(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var Jl = function (e) {
  Qu(n, ql);
  var t,
    r = function (e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = nl(e);
        if (t) {
          var o = nl(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return rl(this, r);
      };
    }(n);
  function n() {
    return $u(this, n), r.apply(this, arguments);
  }
  return Xu(n, [{
    key: "create",
    value: function value(e) {
      try {
        Sl.reportData("pci_sdk_create_start", {
          config: e
        }), this.config = e, this.apiInstance.setConfig(e), Sl.reportData("pci_sdk_create_end");
      } catch (e) {
        Sl.handleError(e, "pci_sdk_create_error");
      }
    }
  }, {
    key: "mount",
    value: function value(e) {
      try {
        Sl.reportData("pci_sdk_mount_start");
        var t = "string" == typeof e ? document.querySelector(e) : e;
        if (!t) throw new hl("Can't find the mount dom", il.InnerSDKError, ul.NoDom);
        this.iframeInstance.renderIframe(t, this.apiInstance.onIframeLoaded), this.receiveMessageInstance.init(this.iframeInstance.displayIframeNames, this.config), this.apiInstance.setIframeStatus({
          mainIframe: this.iframeInstance.mainIframe
        }), Sl.reportData("pci_sdk_mount_end", {
          displayIframeNames: this.iframeInstance.displayIframeNames,
          mainIframe: this.iframeInstance.mainIframe
        });
      } catch (e) {
        Sl.handleError(e, "pci_sdk_mount_error");
      }
    }
  }, {
    key: "setStyle",
    value: function value(e) {
      try {
        Sl.reportData("pci_sdk_setStyle_start", {
          params: e
        });
        var t = e.type,
          r = e.fieldName,
          n = e.style;
        this.apiInstance.postToIframe(r, "setStyle", {
          style: n,
          type: t
        }), Sl.reportData("pci_sdk_setStyle_end");
      } catch (e) {
        Sl.handleError(e, "pci_sdk_setStyle_error");
      }
    }
  }, {
    key: "validate",
    value: function value(e) {
      return this.apiInstance.handleApi("validate", {
        validateItems: e
      });
    }
  }, {
    key: "getBeforePayData",
    value: function value(e) {
      return this.apiInstance.handleApi("getBeforePayData", {
        nextAction: e
      });
    }
  }, {
    key: "updateCardToken",
    value: function value(e) {
      var t = this;
      return this.checkCardToken(), this.apiInstance.handleApiWithKey("updateCardToken", function (r) {
        return {
          options: $l($l({}, e), {}, {
            token: t.cardToken
          }),
          extraOptions: {
            key: r
          }
        };
      }, function (t) {
        var r = t.key,
          n = t.result;
        return $l($l({}, e), {}, {
          token: kl(n.token),
          key: r
        });
      }).then(function (e) {
        return t.cardToken = e.token, Sl.reportData("pci_sdk_updateCardToken_update_token"), e;
      });
    }
  }, {
    key: "getCurrentCardInfo",
    value: (t = Zu(ll.mark(function e() {
      return ll.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.apiInstance.handleApi("getCurrentCardInfo"));
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), n;
}();
function Xl(e, t, r, n, o, a, i) {
  try {
    var s = e[a](i),
      c = s.value;
  } catch (e) {
    return void r(e);
  }
  s.done ? t(c) : Promise.resolve(c).then(n, o);
}
function Yl(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
ol(Jl, "ApiOnly", zl);
var Ql = {};
!function (e) {
  var t = function (e) {
    var t,
      r = Object.prototype,
      n = r.hasOwnProperty,
      o = "function" == typeof Symbol ? Symbol : {},
      a = o.iterator || "@@iterator",
      i = o.asyncIterator || "@@asyncIterator",
      s = o.toStringTag || "@@toStringTag";
    function c(e, t, r) {
      return Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), e[t];
    }
    try {
      c({}, "");
    } catch (e) {
      c = function c(e, t, r) {
        return e[t] = r;
      };
    }
    function u(e, t, r, n) {
      var o = t && t.prototype instanceof y ? t : y,
        a = Object.create(o.prototype),
        i = new S(n || []);
      return a._invoke = function (e, t, r) {
        var n = p;
        return function (o, a) {
          if (n === f) throw new Error("Generator is already running");
          if (n === h) {
            if ("throw" === o) throw a;
            return R();
          }
          for (r.method = o, r.arg = a;;) {
            var i = r.delegate;
            if (i) {
              var s = P(i, r);
              if (s) {
                if (s === v) continue;
                return s;
              }
            }
            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (n === p) throw n = h, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = f;
            var c = l(e, t, r);
            if ("normal" === c.type) {
              if (n = r.done ? h : d, c.arg === v) continue;
              return {
                value: c.arg,
                done: r.done
              };
            }
            "throw" === c.type && (n = h, r.method = "throw", r.arg = c.arg);
          }
        };
      }(e, r, i), a;
    }
    function l(e, t, r) {
      try {
        return {
          type: "normal",
          arg: e.call(t, r)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }
    e.wrap = u;
    var p = "suspendedStart",
      d = "suspendedYield",
      f = "executing",
      h = "completed",
      v = {};
    function y() {}
    function m() {}
    function g() {}
    var b = {};
    c(b, a, function () {
      return this;
    });
    var k = Object.getPrototypeOf,
      w = k && k(k(D([])));
    w && w !== r && n.call(w, a) && (b = w);
    var C = g.prototype = y.prototype = Object.create(b);
    function _(e) {
      ["next", "throw", "return"].forEach(function (t) {
        c(e, t, function (e) {
          return this._invoke(t, e);
        });
      });
    }
    function O(e, t) {
      function r(o, a, i, s) {
        var c = l(e[o], e, a);
        if ("throw" !== c.type) {
          var u = c.arg,
            p = u.value;
          return p && "object" == _typeof(p) && n.call(p, "__await") ? t.resolve(p.__await).then(function (e) {
            r("next", e, i, s);
          }, function (e) {
            r("throw", e, i, s);
          }) : t.resolve(p).then(function (e) {
            u.value = e, i(u);
          }, function (e) {
            return r("throw", e, i, s);
          });
        }
        s(c.arg);
      }
      var o;
      this._invoke = function (e, n) {
        function a() {
          return new t(function (t, o) {
            r(e, n, t, o);
          });
        }
        return o = o ? o.then(a, a) : a();
      };
    }
    function P(e, r) {
      var n = e.iterator[r.method];
      if (n === t) {
        if (r.delegate = null, "throw" === r.method) {
          if (e.iterator["return"] && (r.method = "return", r.arg = t, P(e, r), "throw" === r.method)) return v;
          r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return v;
      }
      var o = l(n, e.iterator, r.arg);
      if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, v;
      var a = o.arg;
      return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, v) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, v);
    }
    function x(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }
    function I(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }
    function S(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(x, this), this.reset(!0);
    }
    function D(e) {
      if (e) {
        var r = e[a];
        if (r) return r.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var o = -1,
            i = function r() {
              for (; ++o < e.length;) {
                if (n.call(e, o)) return r.value = e[o], r.done = !1, r;
              }
              return r.value = t, r.done = !0, r;
            };
          return i.next = i;
        }
      }
      return {
        next: R
      };
    }
    function R() {
      return {
        value: t,
        done: !0
      };
    }
    return m.prototype = g, c(C, "constructor", g), c(g, "constructor", m), m.displayName = c(g, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === m || "GeneratorFunction" === (t.displayName || t.name));
    }, e.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, c(e, s, "GeneratorFunction")), e.prototype = Object.create(C), e;
    }, e.awrap = function (e) {
      return {
        __await: e
      };
    }, _(O.prototype), c(O.prototype, i, function () {
      return this;
    }), e.AsyncIterator = O, e.async = function (t, r, n, o, a) {
      void 0 === a && (a = Promise);
      var i = new O(u(t, r, n, o), a);
      return e.isGeneratorFunction(r) ? i : i.next().then(function (e) {
        return e.done ? e.value : i.next();
      });
    }, _(C), c(C, s, "Generator"), c(C, a, function () {
      return this;
    }), c(C, "toString", function () {
      return "[object Generator]";
    }), e.keys = function (e) {
      var t = [];
      for (var r in e) {
        t.push(r);
      }
      return t.reverse(), function r() {
        for (; t.length;) {
          var n = t.pop();
          if (n in e) return r.value = n, r.done = !1, r;
        }
        return r.done = !0, r;
      };
    }, e.values = D, S.prototype = {
      constructor: S,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(I), !e) for (var r in this) {
          "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        }
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var r = this;
        function o(n, o) {
          return s.type = "throw", s.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
        }
        for (var a = this.tryEntries.length - 1; a >= 0; --a) {
          var i = this.tryEntries[a],
            s = i.completion;
          if ("root" === i.tryLoc) return o("end");
          if (i.tryLoc <= this.prev) {
            var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");
            if (c && u) {
              if (this.prev < i.catchLoc) return o(i.catchLoc, !0);
              if (this.prev < i.finallyLoc) return o(i.finallyLoc);
            } else if (c) {
              if (this.prev < i.catchLoc) return o(i.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < i.finallyLoc) return o(i.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];
          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var a = o;
            break;
          }
        }
        a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
        var i = a ? a.completion : {};
        return i.type = e, i.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, v) : this.complete(i);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), v;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];
          if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), I(r), v;
        }
      },
      "catch": function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];
          if (r.tryLoc === e) {
            var n = r.completion;
            if ("throw" === n.type) {
              var o = n.arg;
              I(r);
            }
            return o;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, r, n) {
        return this.delegate = {
          iterator: D(e),
          resultName: r,
          nextLoc: n
        }, "next" === this.method && (this.arg = t), v;
      }
    }, e;
  }(Ql);
  try {
    regeneratorRuntime = t;
  } catch (e) {
    "object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) ? globalThis.regeneratorRuntime = t : Function("r", "regeneratorRuntime = r")(t);
  }
}();
var ep,
  tp = Ql;
!function (e) {
  e.Google = "googleFont", e.ShopLine = "slFont", e.System = "system";
}(ep || (ep = {}));
var rp = ["Helvetica Neue", "Arial", "sans-serif"];
!function () {
  var e, t, r, n;
  e = function e() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ep.System,
      r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : rp;
    (function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    })(this, e), Yl(this, "fontLib", void 0), Yl(this, "fontFamily", void 0), this.fontLib = t, this.fontFamily = r;
  }, (t = [{
    key: "setFontFamily",
    value: (r = tp.mark(function e(t) {
      var r;
      return tp.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.fontLib !== ep.Google) {
                e.next = 5;
                break;
              }
              return e.next = 3, this.injectGoogleFontCss();
            case 3:
              e.next = 8;
              break;
            case 5:
              if (this.fontLib !== ep.ShopLine) {
                e.next = 8;
                break;
              }
              return e.next = 8, this.injectSLPFontCss();
            case 8:
              r = t.getAttribute("style") || "", t.setAttribute("style", "".concat(r, "font-family:").concat(this.fontFamily.join(",")));
            case 10:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    }), n = function n() {
      var e = this,
        t = arguments;
      return new Promise(function (n, o) {
        var a = r.apply(e, t);
        function i(e) {
          Xl(a, n, o, i, s, "next", e);
        }
        function s(e) {
          Xl(a, n, o, i, s, "throw", e);
        }
        i(void 0);
      });
    }, function (e) {
      return n.apply(this, arguments);
    })
  }, {
    key: "injectCss",
    value: function value(e) {
      var t = document.getElementsByTagName("head")[0],
        r = document.createElement("link");
      return r.rel = "stylesheet", r.href = e, t.appendChild(r), new Promise(function (t, n) {
        r.onerror = function () {
          n({
            message: "inject css failed",
            url: e
          });
        }, r.onload = function () {
          t();
        };
      });
    }
  }, {
    key: "injectGoogleFontCss",
    value: function value() {
      var e = this.fontFamily.map(function (e) {
        return "family=".concat(e.replace(/\s/g, "+"));
      });
      return this.injectCss("https://fonts.googleapis.com/css?".concat(e.join("&"), "&display=swap"));
    }
  }, {
    key: "injectSLPFontCss",
    value: function value() {
      var e = this,
        t = this.fontFamily.map(function (t) {
          return e.injectCss("https://cdn-theme.myshopline.com/cdn/shop/fonts/".concat(t, ".css"));
        });
      return Promise.all(t);
    }
  }]) && function (e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  });
}();
var np = "paymentSdk_pciContent_bcc319ee",
  op = "paymentSdk_cardBrandIconContainer_8c6f02a4",
  ap = "paymentSdk_image_8c6f02a4",
  ip = At(Ot.Prod).imageHost;
function sp(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ip,
    r = e.toLowerCase().replace(/[ (\/]/g, "-").replace(/[)]/g, "");
  return "".concat(t, "/payment-sdk/images/card-brand/").concat(r, ".png");
}
function cp(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
function up(e, t) {
  return lp.apply(this, arguments);
}
function lp() {
  return (lp = l(b.mark(function e(t, r) {
    var n, o;
    return b.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (t && "Other" !== t) {
              e.next = 2;
              break;
            }
            return e.abrupt("return", !1);
          case 2:
            return n = sp(t, r), o = document.createElement("img"), e.abrupt("return", Promise.race([new Promise(function (e) {
              o.addEventListener("load", function () {
                return e(!0);
              }), o.addEventListener("error", function () {
                return e(!1);
              }), o.addEventListener("abort", function () {
                return e(!1);
              }), o.src = n, o.complete && e(!0);
            }), new Promise(function (e) {
              var t;
              return setTimeout(e, 1e3, null !== (t = o.complete) && void 0 !== t && t);
            })]));
          case 5:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}
var pp = function (e) {
  _(r, Yt);
  var t = cp(r);
  function r() {
    var e;
    n(this, r);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) {
      a[i] = arguments[i];
    }
    return c(w(e = t.call.apply(t, [this].concat(a))), "state", {
      cardBrandImgIsValid: null
    }), e;
  }
  return s(r, [{
    key: "render",
    value: function value() {
      var e = this.props,
        t = e.cardBrand,
        r = e.imageHost,
        n = e.theme;
      return $t("div", {
        className: op,
        style: Pn({
          right: null == n ? void 0 : n.right
        }, null == n ? void 0 : n.rtl)
      }, !1 !== this.state.cardBrandImgIsValid && $t("img", {
        className: ap,
        src: sp(t, r),
        alt: t
      }));
    }
  }]), r;
}();
function dp(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
c(pp, "defaultProps", {
  imageHost: ip
});
var fp = kc(),
  hp = gc(),
  vp = function (e) {
    _(o, Yt);
    var t,
      r = dp(o);
    function o(e) {
      var t;
      return n(this, o), c(w(t = r.call(this, e)), "functionArrayCallAtUnmount", []), c(w(t), "envConfig", void 0), c(w(t), "addUnmountFunction", function () {
        for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) {
          r[n] = arguments[n];
        }
        r.forEach(function (e) {
          "function" == typeof e && t.functionArrayCallAtUnmount.push(e);
        });
      }), c(w(t), "setPlaceholder", function () {
        t.props.pciInstanceBusInput.setPciInstanceCreateConfig({
          placeholder: c({}, t.props.name, t.props.placeholder)
        });
      }), c(w(t), "setTheme", function () {
        var e,
          r = (null === (e = t.props) || void 0 === e ? void 0 : e.theme) || {},
          n = "outside" === r.inputLabelPosition ? {
            top: r.inputPaddingTop || hp.inputPaddingLabelOutsideTop,
            right: r.inputPaddingRight || hp.inputPaddingLabelOutsideRight,
            bottom: r.inputPaddingBottom || hp.inputPaddingLabelOutsideBottom,
            left: r.inputPaddingLeft || hp.inputPaddingLabelOutsideLeft
          } : {
            top: "calc(".concat(r.inputPaddingTop || hp.inputPaddingTop, " + ").concat(fp.formItemLabelSmallLineHeight, " + ").concat(r.inputLabelGutter || hp.inputLabelGutter, ")"),
            right: r.inputPaddingRight || hp.inputPaddingRight,
            bottom: r.inputPaddingBottom || hp.inputPaddingBottom,
            left: r.inputPaddingLeft || hp.inputPaddingLeft
          };
        t.props.pciInstanceBusInput.setStyle(t.props.name, {
          padding: "".concat(n.top, " ").concat(n.right, " ").concat(n.bottom, " ").concat(n.left),
          color: null == r ? void 0 : r.inputFontColor,
          fontLib: null == r ? void 0 : r.inputFontLib,
          fontFamily: null == r ? void 0 : r.inputFontFamily,
          fontWeight: null == r ? void 0 : r.inputFontWeight,
          letterSpacing: null == r ? void 0 : r.inputFontLetterSpacing,
          rtl: r.rtl
        });
      }), c(w(t), "handleFocus", function (e) {
        var r = e.isFocus,
          n = {
            isFocused: r,
            isEmpty: e.isEmpty
          };
        r && (n.isDisplayErrorForce = !1), t.setState(n);
      }), c(w(t), "handleFieldValidChange", function (e) {
        var r = e.isEmpty,
          n = e.isValid,
          o = {
            isEmpty: r,
            isValid: n,
            isCreditNumberFormatInError: r || !n
          };
        n && (o.isDisplayErrorForce = !1), t.setState(o);
      }), c(w(t), "handleCardBinChange", function () {
        var e = l(b.mark(function e(r) {
          var n, o, a, i;
          return b.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!(a = null !== (n = null == r || null === (o = r.binInfo) || void 0 === o ? void 0 : o.brand) && void 0 !== n ? n : null)) {
                    e.next = 6;
                    break;
                  }
                  return e.next = 4, up(a, null === (i = t.envConfig) || void 0 === i ? void 0 : i.imageHost);
                case 4:
                  if (e.sent) {
                    e.next = 6;
                    break;
                  }
                  a = null;
                case 6:
                  t.setState({
                    cardBrand: a
                  });
                case 7:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }()), c(w(t), "handleCardBinVerifyChange", function () {
        var e = l(b.mark(function e(r) {
          var n, o, a;
          return b.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = r.verifyResult, o = null, null != n && n.result) {
                    e.next = 7;
                    break;
                  }
                  return a = n.errorCode, e.next = 6, t.getCardBinErrorMessage(a);
                case 6:
                  o = e.sent;
                case 7:
                  t.setState({
                    cardBinErrorMessage: o,
                    isCardBrandValidateInError: !!o
                  });
                case 8:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }()), c(w(t), "linkInputEvent", function () {
        var e = t.props.pciInstanceBusInput,
          r = t.props.name === Ve.Number;
        t.addUnmountFunction(e.addEventListener("init", function () {
          t.setTheme();
        }), e.addEventListener("focus", t.handleFocus, t.props.name), e.addEventListener("fieldValidChange", t.handleFieldValidChange, t.props.name), r && e.addEventListener("cardBinChange", t.handleCardBinChange), r && e.addEventListener("cardBinVerifyChange", t.handleCardBinVerifyChange));
      }), c(w(t), "state", {
        isFocused: !1,
        isValid: !1,
        isEmpty: !0,
        errorMessage: null,
        isCreditNumberFormatInError: !1,
        cardBinErrorMessage: null,
        isCardBrandValidateInError: !1,
        cardBrand: null,
        isDisplayErrorForce: !1
      }), t.envConfig = t.props.envConfig, t;
    }
    return s(o, [{
      key: "getCardBinErrorMessage",
      value: (t = l(b.mark(function e(t) {
        var r;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if ("number" != typeof t && "string" != typeof t || (r = this.props.i18nGetText("validator.".concat(t))), r) {
                  e.next = 5;
                  break;
                }
                return e.next = 4, this.props.i18nGetAsyncText("validator.".concat(t));
              case 4:
                r = e.sent;
              case 5:
                if (!r) {
                  e.next = 9;
                  break;
                }
                return e.abrupt("return", r);
              case 9:
                return e.abrupt("return", this.props.i18nGetText("cardIsNotSupported"));
              case 10:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "getErrorDisplayStatus",
      value: function value() {
        if (this.state.isDisplayErrorForce) return !0;
        var e = this.state,
          t = e.isCardBrandValidateInError,
          r = e.isCreditNumberFormatInError,
          n = e.isFocused,
          o = e.isEmpty;
        return !!t || !n && !o && r;
      }
    }, {
      key: "getErrorMessage",
      value: function value() {
        return this.props.error ? this.props.error : this.state.isCardBrandValidateInError ? this.state.cardBinErrorMessage : this.state.errorMessage ? this.state.errorMessage : this.state.isEmpty || !this.state.isValid ? this.props.i18nGetText("formItems.".concat(this.props.name, ".errorTips")) : void 0;
      }
    }, {
      key: "setError",
      value: function value(e) {
        this.setState({
          errorMessage: e,
          isDisplayErrorForce: !0
        });
      }
    }, {
      key: "validate",
      value: function value() {
        return this.setState({
          isDisplayErrorForce: !this.state.isValid
        }), !this.state.isCreditNumberFormatInError && !this.state.isCardBrandValidateInError;
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        this.props.placeholder && this.setPlaceholder(), this.linkInputEvent();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.functionArrayCallAtUnmount.forEach(function (e) {
          return e();
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e,
          t = this.props,
          r = t.label,
          n = t.name,
          o = t.className,
          a = t.help,
          i = t.tips,
          s = t.theme,
          c = void 0 === s ? {} : s,
          u = this.state,
          l = u.isFocused,
          p = u.isEmpty,
          d = u.cardBrand,
          f = this.getErrorMessage(),
          h = this.getErrorDisplayStatus(),
          v = d ? $t(pp, {
            cardBrand: d,
            imageHost: null === (e = this.envConfig) || void 0 === e ? void 0 : e.imageHost,
            theme: {
              right: c.inputPaddingRight,
              rtl: c.rtl
            }
          }) : void 0;
        return $t(vc, {
          className: o,
          label: r,
          isEmpty: p,
          isFocused: l,
          isError: h,
          errorMessage: f,
          helpMessage: a,
          theme: c,
          tips: i,
          tipComponent: v
        }, $t("div", {
          className: np,
          "data-pci": n
        }));
      }
    }]), o;
  }();
function yp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function mp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? yp(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yp(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var gp = {
  focus: function focus(e, t) {
    return function (r) {
      e === r.fieldName && t(r);
    };
  },
  fieldValidChange: function fieldValidChange(e, t) {
    return function (r) {
      e === r.fieldName && t(r);
    };
  }
};
function bp(e) {
  var t = !1,
    r = Object.freeze({
      init: [],
      focus: [],
      fieldValidChange: [],
      cardBinChange: [],
      cardBinVerifyChange: []
    }),
    n = Object.freeze({
      placeholder: Object.freeze({}),
      extraConfig: Object.freeze({})
    }),
    o = {
      input: {
        addEventListener: function addEventListener(e, t, n) {
          return e in gp && (t = gp[e](n, t)), r[e].push(t), function () {
            return o.input.removeEventListener(e, t);
          };
        },
        removeEventListener: function removeEventListener(e, t) {
          if (r) {
            var n = en(r[e], t);
            -1 !== n && r[e].splice(n, 1);
          }
        },
        setPciInstanceCreateConfig: function setPciInstanceCreateConfig(e) {
          var t, r;
          t = n, r = e, n = Object.freeze({
            placeholder: Object.freeze(mp(mp({}, t.placeholder), r.placeholder)),
            extraConfig: Object.freeze(mp(mp({}, t.extraConfig), r.extraConfig))
          });
        },
        setStyle: function setStyle(t, r) {
          e.setStyle({
            type: "base",
            fieldName: t,
            style: r
          });
        }
      },
      form: {
        setInitialed: function setInitialed() {
          t = !0;
        },
        getPciInstanceCreateConfig: function getPciInstanceCreateConfig() {
          if (t) throw new Error("Call getPciInstanceCreateConfig() before initialed!");
          return n;
        },
        emitEvent: function emitEvent(e, t) {
          var n;
          (null === (n = r) || void 0 === n ? void 0 : n[e]) && r[e].forEach(function (e) {
            return e(t);
          });
        },
        destroyBus: function destroyBus() {
          r = null, n = null;
        }
      }
    };
  return o;
}
var kp = [Ve.Number, Ve.FirstName, Ve.ExpDate, Ve.Cvc].map(function (e) {
    return ["formItems.".concat(e, ".labelTitle"), "formItems.".concat(e, ".placeholder"), "formItems.".concat(e, ".tips"), "formItems.".concat(e, ".errorTips")];
  }).reduce(function (e, t) {
    return e.concat(t);
  }),
  wp = ["43000", "43001", "43002", "43004", "43005", "43006", "43007", "43008"].map(function (e) {
    return "validator.".concat(e);
  }),
  Cp = [].concat(cn(kp), cn(wp), ["cardIsNotSupported", "pleaseEnterNameOnCardOrBusinessName", "footer", "content.creditCard.serviceTips"]),
  _p = s(function e(t, r) {
    var o = this;
    n(this, e), c(this, "config", void 0), c(this, "usefulLanguage", void 0), c(this, "isReady", void 0), c(this, "i18nGetter", void 0), c(this, "ready", l(b.mark(function e() {
      var t;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = [o.config.footerI18nKey], e.next = 3, o.i18nGetter(Cp.concat(t));
            case 3:
              o.usefulLanguage = e.sent, o.isReady = !0;
            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), c(this, "getAsyncText", function () {
      var e = l(b.mark(function e(t) {
        var r;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, o.i18nGetter(t);
              case 2:
                return r = e.sent, e.abrupt("return", r);
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), c(this, "getText", function (e) {
      var t, r;
      return o.usefulLanguage.hasOwnProperty(e) ? r = o.usefulLanguage[e] : o.isReady && console.warn("TextHandler.getText() does not have key: ".concat(e)), null !== (t = r) && void 0 !== t ? t : "";
    }), this.config = r, this.i18nGetter = t, this.usefulLanguage = {}, this.isReady = !1;
  }),
  Op = {
    inputWrapper: "paymentSdk_inputWrapper_9e1f088a",
    content: "paymentSdk_content_9e1f088a",
    pciContainer: "paymentSdk_pciContainer_9e1f088a",
    input: "paymentSdk_input_9e1f088a",
    pciDateAndCvcBox: "paymentSdk_pciDateAndCvcBox_9e1f088a",
    pciPcStyle: "paymentSdk_pciPcStyle_9e1f088a",
    pciExpDataInput: "paymentSdk_pciExpDataInput_9e1f088a",
    pciCvcInput: "paymentSdk_pciCvcInput_9e1f088a",
    pciMobileStyle: "paymentSdk_pciMobileStyle_9e1f088a",
    footerArea: "paymentSdk_footerArea_9e1f088a",
    skeletonBone: "paymentSdk_skeletonBone_9e1f088a",
    hidden: "paymentSdk_hidden_9e1f088a",
    skeletonClient: "paymentSdk_skeletonClient_9e1f088a",
    visible: "paymentSdk_visible_9e1f088a"
  };
function Pp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function xp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Pp(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Pp(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function Ip(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Sp = Wr.bind(Op),
  Dp = function Dp(e) {
    var t, r;
    return $t(Xt, null, $t("div", {
      className: Sp({
        skeletonBone: !0,
        hidden: e.isLoaded
      }),
      style: {
        background: null == e || null === (t = e.theme) || void 0 === t ? void 0 : t.background,
        borderRadius: null == e || null === (r = e.theme) || void 0 === r ? void 0 : r.borderRadius
      }
    }), $t("div", {
      className: Sp({
        skeletonClient: !0,
        visible: e.isLoaded
      })
    }, e.children));
  },
  Rp = function (e) {
    _(r, Yt);
    var t = Ip(r);
    function r() {
      var e;
      n(this, r);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) {
        a[i] = arguments[i];
      }
      return c(w(e = t.call.apply(t, [this].concat(a))), "handleResize", function (t) {
        e.setState({
          isBigSizeView: t
        });
      }), c(w(e), "state", {
        isBigSizeView: !1
      }), e;
    }
    return s(r, [{
      key: "render",
      value: function value() {
        var e = this.state.isBigSizeView,
          t = this.props,
          r = t.inputCardNumber,
          n = t.inputCvc,
          o = t.inputExpDate,
          a = t.inputFirstName,
          i = t.ref,
          s = t.needAdaptive,
          c = t.isLoaded,
          u = t.theme,
          l = void 0 === u ? {} : u,
          p = {
            marginBottom: l.formItemGutter
          },
          d = {
            background: l.inputFontColor,
            borderRadius: l.inputBorderRadius
          };
        return $t(br, {
          triggerSize: s,
          onResize: this.handleResize
        }, $t("div", {
          className: Sp({
            pciContainer: !0,
            pciPcStyle: e,
            pciMobileStyle: !e
          }),
          ref: i
        }, !!r && $t("div", {
          className: Op.input,
          style: p
        }, $t(Dp, {
          isLoaded: c,
          theme: d
        }, r)), !!a && $t("div", {
          className: Op.input,
          style: p
        }, $t(Dp, {
          isLoaded: c,
          theme: d
        }, a)), (!!o || !!n) && $t("div", {
          className: Op.pciDateAndCvcBox
        }, !!o && $t("div", {
          className: Sp({
            input: !0,
            pciExpDataInput: !0
          }),
          style: Pn(xp(xp({}, p), {}, {
            marginRight: e ? l.formItemGutter : void 0
          }), l.rtl)
        }, $t(Dp, {
          isLoaded: c,
          theme: d
        }, o)), !!n && $t("div", {
          className: Sp({
            input: !0,
            pciCvcInput: !0
          }),
          style: p
        }, $t(Dp, {
          isLoaded: c,
          theme: d
        }, n)))));
      }
    }]), r;
  }();
c(Rp, "defaultProps", {
  needAdaptive: !0
});
var Ep = function Ep(e) {
  return $t("svg", kr({}, e, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }), $t("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.99998 2.70002C6.70211 2.70002 5.64998 3.75216 5.64998 5.05002V5.79999H10.35V5.05002C10.35 3.75216 9.29784 2.70002 7.99998 2.70002ZM4.34998 5.05002V5.79999H4C2.89543 5.79999 2 6.69542 2 7.79999V12.8C2 13.9046 2.89543 14.8 4 14.8H12C13.1046 14.8 14 13.9046 14 12.8V7.79999C14 6.69542 13.1046 5.79999 12 5.79999H11.65V5.05002C11.65 3.03418 10.0158 1.40002 7.99998 1.40002C5.98414 1.40002 4.34998 3.03418 4.34998 5.05002ZM4 7.09999H12C12.3866 7.09999 12.7 7.41339 12.7 7.79999V12.8C12.7 13.1866 12.3866 13.5 12 13.5H4C3.6134 13.5 3.3 13.1866 3.3 12.8V7.79999C3.3 7.41339 3.6134 7.09999 4 7.09999ZM8.59998 10.5395C8.9587 10.332 9.20005 9.94419 9.20005 9.49999C9.20005 8.83725 8.66279 8.29999 8.00005 8.29999C7.33731 8.29999 6.80005 8.83725 6.80005 9.49999C6.80005 9.94413 7.04134 10.3319 7.39998 10.5394V11.9C7.39998 12.2314 7.6686 12.5 7.99998 12.5C8.33135 12.5 8.59998 12.2314 8.59998 11.9V10.5395Z",
    fill: "currentColor"
  }));
};
function Tp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ap(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Tp(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Tp(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function Lp(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var jp = function (e) {
  _(o, Yt);
  var t,
    r = Lp(o);
  function o() {
    return n(this, o), r.apply(this, arguments);
  }
  return s(o, [{
    key: "componentDidMount",
    value: function value() {
      this.getI18nText();
    }
  }, {
    key: "getI18nText",
    value: (t = l(b.mark(function e() {
      var t, r, n, o, a, i, s;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = this.props, r = t.i18n, n = t.footerKey, e.next = 3, r.get(["content.creditCard.serviceTips", n]);
            case 3:
              o = e.sent, a = mt(o, 2), i = a[0], s = a[1], this.setState({
                isLoaded: !0,
                i18nText: {
                  serviceTips: i,
                  footerTips: s
                }
              });
            case 8:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "render",
    value: function value() {
      var e = this.props.theme,
        t = void 0 === e ? {} : e,
        r = this.state,
        n = r.i18nText,
        o = r.isLoaded,
        a = n || {},
        i = a.serviceTips,
        s = a.footerTips;
      return o ? $t(Eo, {
        theme: {
          iconColor: t.iconColor
        }
      }, i && $t(Vr, {
        text: i,
        theme: t
      }), s && $t(Vr, {
        text: s,
        theme: t
      })) : $t(Gn, {
        theme: Ap({
          height: "16px"
        }, t.skeleton)
      });
    }
  }]), o;
}();
var Np = Fe(function () {
  var e = l(b.mark(function e(t, r, n) {
    var o;
    return b.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return o = "".concat(t, "/v1/api/cashier/preVerify"), e.abrupt("return", Se.post(o, r, {
              headers: n
            }).then(function (e) {
              var t;
              ke.reportData("pre_verify_success", {
                url: o,
                response: {
                  res: e
                }
              });
              var r = (null === (t = e.data) || void 0 === t ? void 0 : t.verifyResult) || {};
              return {
                verifyResult: {
                  result: r.result,
                  errorCode: r.errorCode
                }
              };
            })["catch"](function (e) {
              ke.handleError(e, "pre_verify_error", {
                url: o,
                response: {
                  error: e
                }
              });
            }));
          case 2:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }));
  return function (t, r, n) {
    return e.apply(this, arguments);
  };
}(), function (e) {
  if (e) {
    var t;
    if (void 0 === e.statusCode) return !1;
    var r = 400 === e.statusCode && (null === (t = e.data) || void 0 === t ? void 0 : t.code) === v.FrequentRequest;
    return 400 !== e.statusCode || r;
  }
  return !1;
}, {
  maxCount: 5,
  interval: 1e3
});
function Bp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Mp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Bp(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Bp(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function Fp(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Hp = function (e) {
  _(i, Yt);
  var t,
    r,
    o,
    a = Fp(i);
  function i(e) {
    var t;
    return n(this, i), c(w(t = a.call(this, e)), "pciInstance", void 0), c(w(t), "pciContainerRef", void 0), c(w(t), "pciInstanceBus", void 0), c(w(t), "textHandler", void 0), c(w(t), "inputRefs", void 0), c(w(t), "envConfig", void 0), c(w(t), "cardBinCache", {}), c(w(t), "cardBinVerificationParams", void 0), c(w(t), "currentCardInfo", void 0), c(w(t), "initStatus", {
      pci: !1,
      i18n: !1
    }), c(w(t), "state", Object.freeze({
      cardBinError: null,
      isLoaded: !1
    })), c(w(t), "validate", l(b.mark(function e() {
      var r, n, o, a;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t.state.isLoaded) {
                e.next = 3;
                break;
              }
              return console.error("Warning: Can't call validate() if CreditCardForm is not loaded"), e.abrupt("return", !1);
            case 3:
              return e.next = 5, t.checkPreVerifyResult();
            case 5:
              if (e.sent) {
                e.next = 8;
                break;
              }
              return e.abrupt("return", !1);
            case 8:
              if (r = t.props.validateFields || t.props.fields, n = !0, o = [], a = Object.keys(t.inputRefs), r ? a.forEach(function (e) {
                -1 !== en(r, e) && o.push(e);
              }) : o.push.apply(o, a), o.forEach(function (e) {
                var r;
                n = (null === (r = t.inputRefs[e].current) || void 0 === r ? void 0 : r.validate()) && n;
              }), !n) {
                e.next = 16;
                break;
              }
              return e.abrupt("return", t.pciInstance.validate(r));
            case 16:
              return e.abrupt("return", !1);
            case 17:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), t.envConfig = t.props.envConfig, t.pciInstance = t.props.pciInstance, t.cardBinVerificationParams = t.props.cardBinVerificationParams, t.pciInstanceBus = bp(t.pciInstance), t.pciContainerRef = {
      current: null
    }, t.textHandler = new _p(t.props.i18nResolver(t.props.language, {
      env: t.envConfig.slI18nEnv,
      cdn: t.props.cdn
    }), {
      channelId: t.props.channelId,
      footerI18nKey: t.props.footerI18nKey
    }), t.inputRefs = {
      number: {
        current: null
      },
      firstName: {
        current: null
      },
      expDate: {
        current: null
      },
      cvc: {
        current: null
      }
    }, t;
  }
  return s(i, [{
    key: "componentDidCatch",
    value: function value(e) {
      ke.reportError(e, "CreditCardForm_componentDidCatch_error");
    }
  }, {
    key: "mountPciInstance",
    value: function value() {
      var e = this,
        t = this.pciInstanceBus.form,
        r = t.getPciInstanceCreateConfig,
        n = t.emitEvent,
        o = t.setInitialed,
        a = r();
      this.pciInstance.create({
        placeholder: a.placeholder,
        onInit: function onInit() {
          o(), n("init"), e.initStatus.pci = !0, e.checkIsLoaded(), ke.reportData("credit_card_pci_onInit");
        },
        onFocus: function onFocus(e) {
          return n("focus", e);
        },
        onFieldValidChange: function onFieldValidChange(e) {
          return n("fieldValidChange", e);
        },
        onCardBinChange: function onCardBinChange(t) {
          n("cardBinChange", t), (null == t || !t.binInfo) && ke.reportErrorData("creditCard_preVerifyCardInfo_binInfo_error", {
            binInfo: null == t ? void 0 : t.binInfo
          }), e.preVerifyCardInfo(null == t ? void 0 : t.binInfo)["catch"](function (e) {
            ke.reportError(e, "creditCard_preVerifyCardInfo_error");
          });
        }
      }), this.pciInstance.mount(this.pciContainerRef.current.base);
    }
  }, {
    key: "verifyCardInfo",
    value: function value(e) {
      ke.reportData("verifyCardInfo", e), this.cardBinVerificationParams = e, this.preVerifyCardInfo(this.currentCardInfo)["catch"](function (e) {
        ke.reportError(e, "creditCard_preVerifyCardInfo_error");
      });
    }
  }, {
    key: "getPreVerifyCacheKey",
    value: function value(e) {
      if (!e.bin) return "EMPTY_BIN";
      var t = this.cardBinVerificationParams,
        r = t.installmentCount,
        n = t.amount;
      return "".concat(e.bin, "_").concat(e.brand, "_").concat(e.cardCategory, "_").concat(e.cardType, "_").concat(e.issuerBank, "_").concat(e.issuerCountry, "_").concat(r || "", "_").concat(n);
    }
  }, {
    key: "preVerifyCardInfo",
    value: (o = l(b.mark(function e(t) {
      var r,
        n,
        o,
        a,
        i,
        s = this;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (r = this.pciInstanceBus.form.emitEvent, null != t && t.bin) {
                e.next = 5;
                break;
              }
              return r("cardBinVerifyChange", n = {
                verifyResult: {
                  result: !0,
                  errorCode: null
                }
              }), e.abrupt("return", n);
            case 5:
              return this.currentCardInfo = t, o = this.getPreVerifyCacheKey(t), a = this.cardBinCache[o], Boolean(a) || (i = Mp(Mp({}, this.cardBinVerificationParams), {}, {
                binInfo: t
              }), ke.reportData("pre_verify_start", {
                request: {
                  params: i
                }
              }), a = Np(this.envConfig.host, i, this.props.requestHeader), this.cardBinCache[o] = a), e.next = 11, a["catch"](function () {
                return delete s.cardBinCache[o], {
                  verifyResult: {
                    result: !0,
                    errorCode: null
                  }
                };
              });
            case 11:
              return n = e.sent, r("cardBinVerifyChange", n), e.abrupt("return", n);
            case 14:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return o.apply(this, arguments);
    })
  }, {
    key: "checkPreVerifyResult",
    value: (r = l(b.mark(function e() {
      var t;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.preVerifyCardInfo(this.currentCardInfo);
            case 2:
              return t = e.sent, e.abrupt("return", t.verifyResult.result);
            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return r.apply(this, arguments);
    })
  }, {
    key: "checkIsLoaded",
    value: function value() {
      var e,
        t = this;
      Object.keys(this.initStatus).every(function (e) {
        return t.initStatus[e];
      }) && (this.setState({
        isLoaded: !0
      }), "function" == typeof (null === (e = this.props) || void 0 === e ? void 0 : e.onLoad) && this.props.onLoad());
    }
  }, {
    key: "getCurrentCardInfo",
    value: function value() {
      return this.currentCardInfo;
    }
  }, {
    key: "setFieldError",
    value: function value(e, t) {
      var r;
      this.state.isLoaded ? null === (r = this.inputRefs[e]) || void 0 === r || r.current.setError(t) : console.error("Warning: Can't call setFieldError() if CreditCardForm is not loaded!");
    }
  }, {
    key: "componentDidMount",
    value: (t = l(b.mark(function e() {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return this.mountPciInstance(), e.next = 3, this.textHandler.ready();
            case 3:
              this.initStatus.i18n = !0, this.checkIsLoaded();
            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.pciInstanceBus.form.destroyBus();
    }
  }, {
    key: "render",
    value: function value() {
      var e,
        t,
        r,
        n,
        o = this.textHandler.getText,
        a = null !== (e = this.props.theme) && void 0 !== e ? e : {},
        i = this.props.fields || [],
        s = {
          pciInstanceBusInput: this.pciInstanceBus.input,
          theme: a,
          i18nGetAsyncText: this.textHandler.getAsyncText.bind(this.textHandler),
          i18nGetText: o.bind(this.textHandler),
          envConfig: this.props.envConfig
        };
      return $t(Rp, {
        ref: this.pciContainerRef,
        needAdaptive: this.props.needAdaptive,
        theme: a,
        isLoaded: this.state.isLoaded,
        inputCardNumber: i.indexOf(Ve.Number) > -1 && $t(vp, Mp(Mp({
          name: Ve.Number,
          label: o("formItems.number.labelTitle")
        }, s), {}, {
          ref: this.inputRefs.number,
          tips: {
            icon: null !== (t = a.cardNumberIcon) && void 0 !== t ? t : $t(Ep, null),
            text: o("formItems.number.tips")
          }
        })),
        inputFirstName: i.indexOf(Ve.FirstName) > -1 && $t(vp, Mp(Mp({
          name: Ve.FirstName,
          label: o("formItems.firstName.labelTitle"),
          help: o("pleaseEnterNameOnCardOrBusinessName")
        }, s), {}, {
          ref: this.inputRefs.firstName,
          tips: {
            icon: null !== (r = a.holderNameIcon) && void 0 !== r ? r : $t(wr, null),
            text: o("formItems.firstName.tips")
          }
        })),
        inputExpDate: i.indexOf(Ve.ExpDate) > -1 && $t(vp, Mp(Mp({
          name: Ve.ExpDate,
          label: o("formItems.expDate.labelTitle")
        }, s), {}, {
          ref: this.inputRefs.expDate
        })),
        inputCvc: i.indexOf(Ve.Cvc) > -1 && $t(vp, Mp(Mp({
          name: Ve.Cvc,
          label: o("formItems.cvc.labelTitle")
        }, s), {}, {
          ref: this.inputRefs.cvc,
          tips: {
            icon: null !== (n = a.securityCodeIcon) && void 0 !== n ? n : $t(wr, null),
            text: o("formItems.cvc.tips")
          }
        }))
      });
    }
  }]), i;
}();
c(Hp, "defaultProps", Object.freeze({
  i18nResolver: function i18nResolver(e, t) {
    var r = t.env,
      n = t.cdn,
      o = new Ms(e, {
        env: r,
        cdn: n
      });
    return function () {
      var e = l(b.mark(function e(t) {
        var r, n;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, o.get(t);
              case 2:
                if (r = e.sent, "string" != typeof t) {
                  e.next = 5;
                  break;
                }
                return e.abrupt("return", r);
              case 5:
                return n = {}, t.forEach(function (e, t) {
                  n[e] = r[t];
                }), e.abrupt("return", n);
              case 8:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }();
  },
  supportCardBrands: [],
  env: Ot.Prod,
  isBindCard: !1,
  fields: $e
}));
var Vp = "paymentSdk_label_25c3192c";
function Wp(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Up = function (e) {
    _(r, Yt);
    var t = Wp(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.language,
          r = e.theme;
        return $t("div", {
          className: Vp,
          style: {
            color: (void 0 === r ? {} : r).checkoutTipColor
          }
        }, t.instrumentCheckout);
      }
    }]), r;
  }(),
  Gp = "paymentSdk_gutter_b3918210";
function Kp(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var qp = Wr.bind({
    hide: "paymentSdk_hide_b8c2a1c9"
  }),
  zp = function (e) {
    _(r, Yt);
    var t = Kp(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.hide,
          r = void 0 === t || t,
          n = e.children;
        return $t("div", {
          className: qp({
            hide: r
          })
        }, n);
      }
    }]), r;
  }();
function Zp(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var $p = function $p(e) {
    var t = e.height,
      r = e.radius,
      n = {
        height: "".concat(t, "px"),
        borderRadius: r || "4px"
      };
    return $t(Gn, {
      theme: n
    });
  },
  Jp = function (e) {
    _(r, Yt);
    var t = Zp(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.theme,
          r = void 0 === t ? {} : t,
          n = e.children,
          o = r.formItemGutter;
        return $t("div", {
          className: Gp,
          style: {
            marginBottom: o
          }
        }, n);
      }
    }]), r;
  }(),
  Xp = function (e) {
    _(r, Yt);
    var t = Zp(r);
    function r() {
      return n(this, r), t.apply(this, arguments);
    }
    return s(r, [{
      key: "componentDidCatch",
      value: function value(e) {
        ke.reportError(e, "CreditCard_Layout_componentDidCatch_error");
      }
    }, {
      key: "render",
      value: function value() {
        var e,
          t = this.props,
          r = t.isLoaded,
          n = t.theme,
          o = void 0 === n ? {} : n,
          a = t.initResult,
          i = t.header,
          s = t.installment,
          c = t.list,
          u = t.pci,
          l = t.footer,
          p = o.inputHeight,
          d = o.rtl,
          f = parseFloat(p) || 46;
        return $t("div", {
          dir: d ? tt.Rtl : tt.Ltr
        }, i && $t(Jp, {
          theme: o
        }, r ? i : $t($p, {
          height: 18
        })), s && $t(Xt, null, r ? s : $t(Xt, null, $t(Jp, {
          theme: o
        }, $t($p, {
          height: 18
        })), $t(zp, {
          hide: (null == a ? void 0 : a.installments) && (null == a || null === (e = a.installments) || void 0 === e ? void 0 : e.length) <= 1
        }, $t(Jp, {
          theme: o
        }, $t($p, {
          height: f
        }))))), c && $t("div", null, c), u && $t("div", null, u), l && $t("div", null, r ? l : $t($p, {
          height: 54
        })));
      }
    }]), r;
  }(),
  Yp = {
    wrap: "paymentSdk_wrap_918e623e",
    item: "paymentSdk_item_918e623e",
    imgWrapper: "paymentSdk_imgWrapper_918e623e",
    label: "paymentSdk_label_918e623e",
    suffix: "paymentSdk_suffix_918e623e",
    footer: "paymentSdk_footer_918e623e",
    disabled: "paymentSdk_disabled_918e623e"
  },
  Qp = function Qp(e) {
    return $t("svg", kr({}, e, {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }), $t("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM6.02191 10.2404L4.29182 8.35794L4.18294 8.23948L4.1765 8.23238C3.92533 7.95152 3.9442 7.51867 4.22052 7.26114C4.49919 7.00143 4.93416 7.01837 5.19207 7.29898L5.19855 7.30604L5.31369 7.43131L6.08897 8.27484L7.0238 9.29198L7.03753 9.30692L7.05199 9.29222L8.02074 8.3078L10.9489 5.33225L11.0674 5.21185L11.0742 5.205C11.3414 4.93341 11.7767 4.93142 12.0464 5.20056C12.3139 5.46742 12.318 5.90066 12.0575 6.17272L12.0508 6.17962L11.9389 6.29341L8.02094 10.2747L7.5089 10.795C7.37693 10.9291 7.1963 11.0031 7.00884 10.9999C6.82137 10.9967 6.64335 10.9165 6.516 10.7779L6.02191 10.2404Z",
      fill: "currentColor"
    }));
  };
function ed(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var td = Wr.bind(Yp),
  rd = function (e) {
    _(r, Yt);
    var t = ed(r);
    function r() {
      var e;
      n(this, r);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) {
        a[i] = arguments[i];
      }
      return c(w(e = t.call.apply(t, [this].concat(a))), "onChange", function (t) {
        e.props.onChange && e.props.onChange(t);
      }), e;
    }
    return s(r, [{
      key: "render",
      value: function value() {
        var e = this,
          t = this.props,
          r = t.value,
          n = t.dataSource,
          o = t.theme,
          a = void 0 === o ? {} : o;
        return null != n && n.length ? $t("div", {
          className: Yp.wrap,
          style: {
            borderColor: a.optionsBorderColor,
            borderRadius: a.optionsBorderRadius
          }
        }, n.map(function (t) {
          return $t("div", {
            className: td({
              item: !0,
              disabled: t.disabled
            }),
            key: t.value,
            onClick: function onClick() {
              !t.disabled && e.onChange(t.value);
            },
            style: {
              height: a.optionsHeight,
              background: a.optionsBackground,
              borderColor: a.optionsBorderColor
            }
          }, !!t.img && $t("div", {
            className: Yp.imgWrapper
          }, "string" == typeof t.img ? $t("img", {
            src: t.img,
            alt: ""
          }) : t.img), $t("div", {
            className: Yp.label,
            style: {
              color: a.optionsFontColor
            }
          }, t.label), !!t.suffix && $t("div", {
            className: Yp.suffix,
            style: {
              color: a.optionsFontColor
            }
          }, t.suffix), $t("div", {
            className: Yp.footer
          }, t.value === r && $t("div", {
            style: {
              color: a.optionsIconColor
            }
          }, $t(Qp, null))));
        })) : null;
      }
    }]), r;
  }();
function nd(e, t) {
  var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return od(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return od(e, t);
    }(e)) || t && e && "number" == typeof e.length) {
      r && (e = r);
      var _n4 = 0,
        o = function o() {};
      return {
        s: o,
        n: function n() {
          return _n4 >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[_n4++]
          };
        },
        e: function e(_e6) {
          throw _e6;
        },
        f: o
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var a,
    i = !0,
    s = !1;
  return {
    s: function s() {
      r = r.call(e);
    },
    n: function n() {
      var e = r.next();
      return i = e.done, e;
    },
    e: function e(_e7) {
      s = !0, a = _e7;
    },
    f: function f() {
      try {
        i || null == r["return"] || r["return"]();
      } finally {
        if (s) throw a;
      }
    }
  };
}
function od(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) {
    n[r] = e[r];
  }
  return n;
}
function ad(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var id = function (e) {
    _(r, Yt);
    var t = ad(r);
    function r() {
      var e;
      n(this, r);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) {
        a[i] = arguments[i];
      }
      return c(w(e = t.call.apply(t, [this].concat(a))), "state", {
        instrumentId: "",
        dataSource: [],
        usableDataSource: []
      }), c(w(e), "getOptionList", function () {
        var t,
          r = e.props,
          n = r.initResult.paymentMethodInfo,
          o = (void 0 === n ? {} : n).paymentInstruments,
          a = r.installmentCount,
          i = r.env,
          s = r.onListChange;
        if (null == o || !o.length) return e.setState({
          instrumentId: ""
        }), void (s && s({
          value: "",
          isPci: !0
        }));
        var c,
          u = [],
          l = [],
          p = nd(o);
        try {
          for (p.s(); !(c = p.n()).done;) {
            var d = c.value,
              f = Boolean(d.installmentPeriod && a && -1 === d.installmentPeriod.indexOf(a)),
              h = {
                value: d.instrumentId,
                label: "**** **** **** ".concat(d.instrumentCard.last),
                img: e.getIcon(d.instrumentCard.brand, i.imageHost),
                suffix: "",
                disabled: f
              };
            u.push(h), f || l.push(h);
          }
        } catch (e) {
          p.e(e);
        } finally {
          p.f();
        }
        if (u.push({
          value: iu,
          label: ""
        }), e.setState({
          dataSource: u,
          usableDataSource: l
        }), !l.length) return e.setState({
          instrumentId: ""
        }), void (s && s({
          value: "",
          isPci: !0
        }));
        if (e.state.instrumentId !== iu) {
          var v = null === (t = l[0]) || void 0 === t ? void 0 : t.value;
          e.setState({
            instrumentId: v
          }), s && s({
            value: v,
            isPci: !1
          });
        }
      }), c(w(e), "getIcon", function (e, t) {
        var r = "card",
          n = sp(e || r, t),
          o = sp(r, t),
          a = 0;
        return $t("img", {
          src: n,
          onError: function onError(e) {
            var t;
            ++a <= 3 ? e.target.setAttribute("src", o) : He(null === (t = e.target) || void 0 === t ? void 0 : t.parentNode);
          }
        });
      }), c(w(e), "onChange", function (t) {
        var r = e.props.onListChange;
        e.setState({
          instrumentId: t
        });
        var n = t === iu;
        r && r({
          value: n ? "" : t,
          isPci: n
        });
      }), c(w(e), "getLanguage", function (e, t) {
        return (e || []).map(function (e) {
          return e.disabled && (e.suffix = null == t ? void 0 : t.unsupportedCount), e.value === iu && (e.label = null == t ? void 0 : t.instrumentChoose), e;
        });
      }), c(w(e), "getList", function () {
        var t = e.props,
          r = t.theme,
          n = void 0 === r ? {} : r,
          o = t.language,
          a = void 0 === o ? {} : o,
          i = e.state,
          s = i.instrumentId,
          c = i.dataSource,
          u = i.usableDataSource;
        return null != c && c.length && null != u && u.length ? $t(Jp, {
          theme: n
        }, $t(rd, {
          theme: n,
          value: s,
          dataSource: e.getLanguage(c, a),
          onChange: e.onChange
        })) : null;
      }), c(w(e), "getSkeleton", function () {
        var t,
          r = e.props,
          n = r.theme,
          o = void 0 === n ? {} : n,
          a = r.initResult,
          i = r.initData,
          s = null == a || null === (t = a.paymentMethodInfo) || void 0 === t ? void 0 : t.paymentInstruments;
        if (null == s || !s.length) return null;
        if (nn(null == i ? void 0 : i.installmentCounts)) {
          var c,
            u,
            l = null == a || null === (c = a.installments) || void 0 === c || null === (u = c[Qr]) || void 0 === u ? void 0 : u.count;
          if (!s.filter(function (e) {
            return !Boolean(e.installmentPeriod && l && -1 === e.installmentPeriod.indexOf(l));
          }).length) return null;
        }
        var p,
          d = o.optionsHeight,
          f = o.optionsBorderRadius,
          h = parseFloat(d),
          v = /px/.test(d) && "number" == typeof (p = h) && window.isFinite(p) ? h : 52,
          y = (s.length + 1) * v;
        return $t(Jp, {
          theme: o
        }, $t($p, {
          height: y,
          radius: f
        }));
      }), e;
    }
    return s(r, [{
      key: "componentDidMount",
      value: function value() {
        this.getOptionList();
      }
    }, {
      key: "componentWillReceiveProps",
      value: function value(e) {
        this.props.installmentCount !== e.installmentCount && setTimeout(this.getOptionList, 0);
      }
    }, {
      key: "render",
      value: function value() {
        return this.props.isLoaded ? this.getList() : this.getSkeleton();
      }
    }]), r;
  }(),
  sd = "paymentSdk_wrap_6b4f8a9e",
  cd = "paymentSdk_checkbox_6b4f8a9e",
  ud = "paymentSdk_active_6b4f8a9e",
  ld = "paymentSdk_off_6b4f8a9e",
  pd = "paymentSdk_content_6b4f8a9e",
  dd = function dd(e) {
    return $t("svg", kr({}, e, {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }), $t("mask", {
      id: "path-1-inside-1_13143_5720",
      fill: "white"
    }, $t("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM12.0303 6.53033C12.3232 6.23744 12.3232 5.76256 12.0303 5.46967C11.7374 5.17678 11.2626 5.17678 10.9697 5.46967L7 9.43934L5.03033 7.46967C4.73744 7.17678 4.26256 7.17678 3.96967 7.46967C3.67678 7.76256 3.67678 8.23744 3.96967 8.53033L6.46967 11.0303C6.76256 11.3232 7.23744 11.3232 7.53033 11.0303L12.0303 6.53033Z"
    })), $t("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM12.0303 6.53033C12.3232 6.23744 12.3232 5.76256 12.0303 5.46967C11.7374 5.17678 11.2626 5.17678 10.9697 5.46967L7 9.43934L5.03033 7.46967C4.73744 7.17678 4.26256 7.17678 3.96967 7.46967C3.67678 7.76256 3.67678 8.23744 3.96967 8.53033L6.46967 11.0303C6.76256 11.3232 7.23744 11.3232 7.53033 11.0303L12.0303 6.53033Z",
      fill: "currentColor"
    }), $t("path", {
      d: "M12.0303 5.46967L12.7374 4.76256V4.76256L12.0303 5.46967ZM12.0303 6.53033L11.3232 5.82322L12.0303 6.53033ZM10.9697 5.46967L10.2626 4.76256L10.2626 4.76256L10.9697 5.46967ZM7 9.43934L6.29289 10.1464L7 10.8536L7.70711 10.1464L7 9.43934ZM3.96967 7.46967L4.67678 8.17678L3.96967 7.46967ZM3.96967 8.53033L3.26256 9.23744L3.26256 9.23744L3.96967 8.53033ZM6.46967 11.0303L5.76256 11.7374L5.76256 11.7374L6.46967 11.0303ZM7.53033 11.0303L8.23744 11.7374L8.23744 11.7374L7.53033 11.0303ZM1 2C1 1.44772 1.44772 1 2 1V-1C0.343146 -1 -1 0.343146 -1 2H1ZM1 14V2H-1V14H1ZM2 15C1.44772 15 1 14.5523 1 14H-1C-1 15.6569 0.343146 17 2 17V15ZM14 15H2V17H14V15ZM15 14C15 14.5523 14.5523 15 14 15V17C15.6569 17 17 15.6569 17 14H15ZM15 2V14H17V2H15ZM14 1C14.5523 1 15 1.44772 15 2H17C17 0.343146 15.6569 -1 14 -1V1ZM2 1H14V-1H2V1ZM11.3232 6.17678C11.2256 6.07915 11.2256 5.92085 11.3232 5.82322L12.7374 7.23744C13.4209 6.55402 13.4209 5.44598 12.7374 4.76256L11.3232 6.17678ZM11.6768 6.17678C11.5791 6.27441 11.4209 6.27441 11.3232 6.17678L12.7374 4.76256C12.054 4.07915 10.946 4.07915 10.2626 4.76256L11.6768 6.17678ZM7.70711 10.1464L11.6768 6.17678L10.2626 4.76256L6.29289 8.73223L7.70711 10.1464ZM4.32322 8.17678L6.29289 10.1464L7.70711 8.73223L5.73744 6.76256L4.32322 8.17678ZM4.67678 8.17678C4.57915 8.27441 4.42085 8.27441 4.32322 8.17678L5.73744 6.76256C5.05402 6.07915 3.94598 6.07915 3.26256 6.76256L4.67678 8.17678ZM4.67678 7.82323C4.77441 7.92085 4.77441 8.07914 4.67678 8.17678L3.26256 6.76256C2.57914 7.44598 2.57915 8.55402 3.26256 9.23744L4.67678 7.82323ZM7.17678 10.3232L4.67678 7.82322L3.26256 9.23744L5.76256 11.7374L7.17678 10.3232ZM6.82322 10.3232C6.92086 10.2256 7.07914 10.2256 7.17678 10.3232L5.76256 11.7374C6.44598 12.4209 7.55402 12.4209 8.23744 11.7374L6.82322 10.3232ZM11.3232 5.82322L6.82322 10.3232L8.23744 11.7374L12.7374 7.23744L11.3232 5.82322Z",
      fill: "currentColor",
      mask: "url(#path-1-inside-1_13143_5720)"
    }));
  },
  fd = function fd(e) {
    return $t("svg", kr({}, e, {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }), $t("path", {
      d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H14C14.8284 0.5 15.5 1.17157 15.5 2V14C15.5 14.8284 14.8284 15.5 14 15.5H2C1.17157 15.5 0.5 14.8284 0.5 14V2Z",
      stroke: "currentColor"
    }));
  };
function hd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? hd(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : hd(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function yd(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var md = function (e) {
    _(r, Yt);
    var t = yd(r);
    function r() {
      var e;
      n(this, r);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) {
        a[i] = arguments[i];
      }
      return c(w(e = t.call.apply(t, [this].concat(a))), "state", {
        value: !1
      }), c(w(e), "onChange", function () {
        var t = e.props.onChange;
        e.setState(function (e) {
          return vd(vd({}, e), {}, {
            value: !e.value
          });
        }, function () {
          t && t(e.state.value);
        });
      }), e;
    }
    return s(r, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.props.defaultChecked;
        "boolean" == typeof e && this.setState({
          value: e
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.theme,
          r = void 0 === t ? {} : t,
          n = e.children,
          o = this.state.value;
        return $t("div", {
          className: sd,
          onClick: this.onChange
        }, $t("span", {
          className: cd
        }, o ? $t("span", {
          className: ud,
          style: {
            color: r.checkboxActiveColor
          }
        }, $t(dd, null)) : $t("span", {
          className: ld,
          style: {
            color: r.checkboxOffColor
          }
        }, $t(fd, null))), $t("span", {
          className: pd
        }, n));
      }
    }]), r;
  }(),
  gd = "paymentSdk_line_3c6da75b",
  bd = "paymentSdk_footer_3c6da75b",
  kd = function kd(e) {
    return $t("svg", kr({}, e, {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }), $t("path", {
      d: "M3.63093 5.14499C4.63837 3.80183 6.23709 2.95872 8 2.95872C10.4382 2.95872 12.3691 4.46981 13.1245 6.57218H14.3838C13.6283 3.79823 11.1061 1.69946 7.9964 1.69946C5.80998 1.69946 3.87915 2.79079 2.62004 4.47341L1.27673 3.55001V7.75115L4.89019 5.9042L3.63093 5.14499ZM11.1098 10.861L12.453 11.7844C11.4455 13.1275 9.8468 13.9708 8.08389 13.9708C5.64566 13.9708 3.71482 12.4597 2.95935 10.3573H1.6162C2.37167 13.1313 4.89394 15.146 8.0036 15.146C10.1899 15.146 12.1208 14.0547 13.38 12.372L14.7231 13.2954V9.0943L11.1098 10.861Z",
      fill: "currentColor"
    }), $t("path", {
      d: "M7.58024 5.06104C7.24438 5.06104 7.0766 5.31286 7.0766 5.56468V9.17813C7.0766 9.34607 7.16049 9.514 7.24453 9.59789C7.32842 9.68178 7.49635 9.76582 7.66428 9.76582H11.2777C11.6136 9.76582 11.8654 9.514 11.8654 9.17813C11.8654 8.84227 11.6136 8.59045 11.2777 8.59045H8.25182V5.64872C8.25182 5.31286 7.91611 5.06104 7.58024 5.06104Z",
      fill: "currentColor"
    }));
  },
  wd = function wd(e) {
    return $t("svg", kr({}, e, {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }), $t("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.6 8C13.6 11.0928 11.0928 13.6 8 13.6C4.90721 13.6 2.4 11.0928 2.4 8C2.4 4.90721 4.90721 2.4 8 2.4C11.0928 2.4 13.6 4.90721 13.6 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.00005 4C8.44188 4 8.80005 4.35817 8.80005 4.8V9C8.80005 9.44183 8.44188 9.8 8.00005 9.8C7.55822 9.8 7.20005 9.44183 7.20005 9V4.8C7.20005 4.35817 7.55822 4 8.00005 4ZM7.99999 12.45C8.47998 12.45 8.89623 12.0471 8.89998 11.5463C8.89623 11.053 8.47998 10.65 7.99999 10.65C7.505 10.65 7.09625 11.053 7.1 11.5463C7.09625 12.0471 7.505 12.45 7.99999 12.45Z",
      fill: "#F04949"
    }));
  };
function Cd(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var _d = function (e) {
  _(o, Yt);
  var t,
    r = Cd(o);
  function o() {
    var e;
    n(this, o);
    for (var t = arguments.length, a = new Array(t), i = 0; i < t; i++) {
      a[i] = arguments[i];
    }
    return c(w(e = r.call.apply(r, [this].concat(a))), "state", {
      BindCardProtocolConfig: {},
      checked: !0,
      validateResult: !0
    }), c(w(e), "onCheckboxChange", function (t) {
      var r = e.props.onCheckboxChange,
        n = e.state.validateResult;
      e.setState({
        checked: t
      }), t && !n && e.setState({
        validateResult: !0
      }), r && r(t);
    }), e;
  }
  return s(o, [{
    key: "componentDidMount",
    value: function value() {
      this.getBindCardProtocolConfig();
    }
  }, {
    key: "getBindCardProtocolConfig",
    value: function value() {
      var e = pu(this.props.initData);
      this.setState({
        BindCardProtocolConfig: e,
        checked: e.defaultSwitchStatus
      });
    }
  }, {
    key: "validate",
    value: (t = l(b.mark(function e() {
      var t, r, n, o;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = this.state, r = t.BindCardProtocolConfig, n = t.checked, o = r.mustAccept && !n, this.setState({
                validateResult: !o
              }), e.abrupt("return", !o);
            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
        t = e.language,
        r = e.theme,
        n = void 0 === r ? {} : r,
        o = this.state,
        a = o.BindCardProtocolConfig,
        i = o.validateResult,
        s = n.formItemGutter,
        c = n.footerDividingLineColor,
        u = du(n);
      return $t("div", null, a.switchVisible ? $t(md, {
        defaultChecked: Boolean(a.defaultSwitchStatus),
        onChange: this.onCheckboxChange,
        theme: n
      }, $t(Eo, {
        icon: null,
        message: null == t ? void 0 : t.paymentAgreement,
        theme: u
      })) : $t(Eo, {
        icon: $t(kd, null),
        message: null == t ? void 0 : t.paymentAgreement,
        theme: u
      }), !i && $t(Eo, {
        icon: $t(wd, null),
        message: null == t ? void 0 : t.instrumentRequireTip,
        theme: {
          fontColor: "#f04949",
          linkColor: "#f04949"
        }
      }), $t("div", {
        className: gd,
        style: {
          marginTop: s,
          marginBottom: s,
          borderColor: c
        }
      }));
    }
  }]), o;
}();
function Od(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Pd = function (e) {
  _(r, Yt);
  var t = Od(r);
  function r() {
    return n(this, r), t.apply(this, arguments);
  }
  return s(r, [{
    key: "render",
    value: function value() {
      var e,
        t,
        r = this.props,
        n = r.i18n,
        o = r.initResult,
        a = r.theme,
        i = void 0 === a ? {} : a,
        s = du(i),
        c = null === (e = o.paymentMethodInfo) || void 0 === e || null === (t = e.cashierNotice) || void 0 === t ? void 0 : t.footerI18nKey;
      return $t("div", {
        className: bd,
        style: {
          marginBottom: i.formItemGutter
        }
      }, $t(jp, {
        i18n: n,
        footerKey: c,
        theme: s
      }));
    }
  }]), r;
}();
function xd(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Id = function (e) {
  _(r, Yt);
  var t = xd(r);
  function r() {
    return n(this, r), t.apply(this, arguments);
  }
  return s(r, [{
    key: "render",
    value: function value() {
      var e = this.props,
        t = e.message,
        r = e.theme,
        n = du(void 0 === r ? {} : r);
      return t ? $t(Eo, {
        icon: $t(kd, null),
        message: t,
        theme: n
      }) : null;
    }
  }]), r;
}();
function Sd(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Dd = function (e) {
  _(r, Yt);
  var t = Sd(r);
  function r() {
    return n(this, r), t.apply(this, arguments);
  }
  return s(r, [{
    key: "render",
    value: function value() {
      var e = this.props,
        t = e.language,
        r = e.currency,
        n = e.needAdaptive,
        o = e.installmentInfoList,
        a = e.installmentCapabilities,
        i = e.theme,
        s = void 0 === i ? {} : i,
        c = e.onChange;
      return $t("div", null, $t(Jp, {
        theme: null == s ? void 0 : s.bindCardProtocol
      }, $t(mn, {
        language: t,
        installmentInfoList: o,
        installmentCapabilities: a,
        currency: r,
        needAdaptive: n,
        isPci: !0,
        theme: null == s ? void 0 : s.installment
      })), $t(zp, {
        hide: (null == o ? void 0 : o.length) <= 1
      }, $t(Jp, {
        theme: null == s ? void 0 : s.bindCardProtocol
      }, $t(Vn, {
        installmentInfoList: o,
        language: t,
        currency: r,
        onChange: c,
        theme: null == s ? void 0 : s.installment
      }))));
    }
  }]), r;
}();
function Rd(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Ed = function (e) {
  _(r, Yt);
  var t = Rd(r);
  function r(e) {
    var o;
    return n(this, r), c(w(o = t.call(this, e)), "pciInstance", void 0), c(w(o), "isPciLoaded", void 0), c(w(o), "validate", l(b.mark(function e() {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (o.isPciLoaded) {
                e.next = 3;
                break;
              }
              return console.error("Warning: Can't call validate() if CreditCardForm is not loaded"), e.abrupt("return", !1);
            case 3:
              return e.abrupt("return", !0);
            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), c(w(o), "setFieldError", function (e, t) {
      ke.reportErrorData("CreditCardFormNoInput_setFieldError_error", {
        fieldName: e,
        message: t
      });
    }), o.pciInstance = o.props.pciInstance, o.mountPciInstance(), o;
  }
  return s(r, [{
    key: "mountPciInstance",
    value: function value() {
      var e = this;
      this.pciInstance.create({
        onInit: function onInit() {
          e.isPciLoaded = !0, e.checkIsLoaded();
        }
      });
    }
  }, {
    key: "checkIsLoaded",
    value: function value() {
      var e;
      this.isPciLoaded && "function" == typeof (null === (e = this.props) || void 0 === e ? void 0 : e.onLoad) && this.props.onLoad();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.pciInstance.destroy();
    }
  }, {
    key: "render",
    value: function value() {
      return null;
    }
  }]), r;
}();
function Td(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ad(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Td(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Td(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function Ld(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var jd = function (e) {
    _(a, Yt);
    var t,
      r,
      o = Ld(a);
    function a(e) {
      var t;
      return n(this, a), c(w(t = o.call(this, e)), "pciRef", {
        current: null
      }), c(w(t), "state", {
        isLoaded: !1,
        language: null,
        installmentCount: "",
        selectInstrumentId: "",
        isPci: t.props.isDefaultPci,
        isCardListExist: !t.props.hasCardToken
      }), c(w(t), "pciLoadedCache", {}), c(w(t), "onInstallmentChange", function (e) {
        t.setState({
          installmentCount: e.value
        }, function () {
          t.pciRef.current && t.props.pciInstance instanceof Jl && t.pciLoadedCache.promise.then(function () {
            var e;
            null === (e = t.pciRef.current) || void 0 === e || e.verifyCardInfo(t.getCardBinRequestParams());
          })["catch"](function (e) {
            throw ke.reportError(e, "onInstallmentChange_loadPci_error"), e;
          });
        });
      }), c(w(t), "onListChange", function (e) {
        var r = e.value,
          n = e.isPci;
        n !== t.state.isPci && t.props.onContentStateChange({
          isPci: n
        }), t.setState({
          selectInstrumentId: r,
          isPci: n
        });
      }), c(w(t), "setFieldError", function (e, r) {
        -1 !== $e.indexOf(e) && t.pciRef.current && t.pciRef.current.setFieldError(e, r);
      }), t.pciLoadedCache.promise = new Promise(function (e) {
        t.pciLoadedCache.resolveFn = e;
      }), t;
    }
    return s(a, [{
      key: "componentDidMount",
      value: function value() {
        this.getLanguage();
      }
    }, {
      key: "getLanguage",
      value: (r = l(b.mark(function e() {
        var t, r, n, o;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, Promise.all([uu(this.props.i18n), ln(this.props.i18n, fn(this.props.installmentCapabilities))]);
              case 2:
                t = e.sent, r = mt(t, 2), n = r[0], o = r[1], this.setState({
                  language: Ad(Ad({}, n), o),
                  isLoaded: !0
                });
              case 7:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "getCardBinRequestParams",
      value: function value() {
        var e = this.props.initData,
          t = this.state.installmentCount;
        return {
          merchantId: e.merchantId,
          paymentMethod: e.paymentMethod,
          currency: e.currency,
          installmentCount: t,
          amount: e.amount
        };
      }
    }, {
      key: "getCreditCardForm",
      value: function value() {
        var e,
          t,
          r = this,
          n = this.props,
          o = n.initResult,
          a = n.theme,
          i = n.initData,
          s = n.env,
          c = n.pciInstance,
          u = n.creditCardFields,
          l = {
            onLoad: function onLoad() {
              r.pciLoadedCache.resolveFn(), ke.reportData("credit_card_load_pci_finish");
            }
          };
        if (0 === u.length) return $t(Ed, Ad(Ad({}, l), {}, {
          pciInstance: c,
          ref: this.pciRef
        }));
        var p = Ad(Ad({}, l), {}, {
          theme: a.CreditCard,
          footerI18nKey: null === (e = o.paymentMethodInfo) || void 0 === e || null === (t = e.cashierNotice) || void 0 === t ? void 0 : t.footerI18nKey,
          pciInstance: c,
          fields: u,
          channelId: i.channelId,
          needAdaptive: i.needAdaptive,
          language: i.language,
          envConfig: s,
          isBindCard: i.isBindCard,
          requestHeader: Qe(i),
          cardBinVerificationParams: this.getCardBinRequestParams(),
          cdn: this.props.initData.cdn
        });
        return $t(Hp, Ad(Ad({}, p), {}, {
          ref: this.pciRef
        }));
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        var t, r, n, o, a, i, s;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (r = this.state, n = r.selectInstrumentId, o = r.isPci, a = r.installmentCount, i = r.isLoaded, s = this.props.isInstallmentExist, ke.reportData("credit_card_content_validate_state", {
                  isPci: o,
                  isSelectInstrument: !!n,
                  isInstallmentExist: s,
                  installmentCount: a,
                  isLoaded: i
                }), i) {
                  e.next = 6;
                  break;
                }
                return console.error("Warning: Can't call validate() if CreditCardForm is not loaded"), e.abrupt("return", !1);
              case 6:
                if (!s || a) {
                  e.next = 8;
                  break;
                }
                throw new Error("installmentCount is null");
              case 8:
                if (o) {
                  e.next = 12;
                  break;
                }
                if (n) {
                  e.next = 11;
                  break;
                }
                throw new Error("selectInstrumentId is null");
              case 11:
                return e.abrupt("return", !0);
              case 12:
                return e.abrupt("return", null === (t = this.pciRef.current) || void 0 === t ? void 0 : t.validate());
              case 13:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "getSelectPaymentInstrument",
      value: function value() {
        var e = this.state,
          t = e.selectInstrumentId;
        if (!e.isPci) for (var r = this.props.paymentInstruments || [], n = 0; n < r.length; n++) {
          if (r[n].instrumentId === t) return r[n];
        }
        return null;
      }
    }, {
      key: "getPayData",
      value: function value() {
        var e,
          t,
          r,
          n,
          o = this.state,
          a = o.selectInstrumentId,
          i = o.isPci,
          s = o.installmentCount,
          c = this.props,
          u = c.isInstallmentExist,
          l = c.isCustomerPaymentInstrument,
          p = {
            selectInstrumentId: a,
            isPci: i,
            isInstallmentExist: u,
            installmentCount: s,
            currentCardInfo: null !== (e = this.pciRef) && void 0 !== e && null !== (t = e.current) && void 0 !== t && t.getCurrentCardInfo ? null === (r = this.pciRef) || void 0 === r || null === (n = r.current) || void 0 === n ? void 0 : n.getCurrentCardInfo() : null,
            initData: this.props.initData,
            isCustomerPaymentInstrument: l
          },
          d = this.getSelectPaymentInstrument();
        return d && (p.selectInstrumentCardInfo = {
          bin: d.instrumentCard.first,
          brand: d.instrumentCard.brand,
          issuerBank: d.instrumentCard.issuingBank,
          cardType: d.instrumentCard.type,
          cardCategory: d.instrumentCard.cardCategory,
          issuerCountry: d.instrumentCard.countryCode
        }), p;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.initData,
          r = e.env,
          n = e.theme,
          o = e.isInstallmentExist,
          a = e.initResult,
          i = e.installmentCapabilities,
          s = e.installmentInfoList,
          c = this.state,
          u = c.isLoaded,
          l = c.language,
          p = c.isPci,
          d = c.isCardListExist,
          f = c.installmentCount;
        return $t(Xp, {
          isLoaded: u,
          theme: fu(n),
          initResult: a,
          header: !o && !p && $t(Up, {
            theme: null == n ? void 0 : n.bindCardProtocol,
            language: l
          }),
          installment: o && $t(Dd, {
            theme: n,
            language: l,
            currency: t.currency,
            needAdaptive: t.needAdaptive,
            installmentCapabilities: i,
            installmentInfoList: s,
            onChange: this.onInstallmentChange
          }),
          list: d && $t(id, {
            isLoaded: u,
            theme: null == n ? void 0 : n.bindCardProtocol,
            language: l,
            initData: t,
            installmentCount: f,
            env: r,
            initResult: a,
            onListChange: this.onListChange
          }),
          pci: $t(zp, {
            hide: !p
          }, (p || this.pciRef.current) && this.getCreditCardForm())
        });
      }
    }]), a;
  }(),
  Nd = function (e) {
    _(a, Yt);
    var t,
      r,
      o = Ld(a);
    function a() {
      var e;
      n(this, a);
      for (var t = arguments.length, r = new Array(t), i = 0; i < t; i++) {
        r[i] = arguments[i];
      }
      return c(w(e = o.call.apply(o, [this].concat(r))), "footerRef", {
        current: null
      }), c(w(e), "state", {
        isLoaded: !1,
        language: null,
        isPci: e.props.isDefaultPci,
        savePaymentInstrument: e.props.defaultSavePaymentInstrument
      }), c(w(e), "onCheckboxChange", function (t) {
        e.setState({
          savePaymentInstrument: t
        });
      }), e;
    }
    return s(a, [{
      key: "onContentStateChange",
      value: function value(e) {
        this.setState({
          isPci: e.isPci
        });
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        this.getLanguage();
      }
    }, {
      key: "getLanguage",
      value: (r = l(b.mark(function e() {
        var t, r;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, lu(this.props.i18n, null === (t = this.props.initResult.paymentMethodInfo) || void 0 === t ? void 0 : t.cashierNotice);
              case 2:
                r = e.sent, this.setState({
                  language: r,
                  isLoaded: !0
                });
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "getPayData",
      value: function value() {
        return {
          savePaymentInstrument: this.state.savePaymentInstrument
        };
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        var t, r, n, o, a, i;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (t = this.state, r = t.savePaymentInstrument, n = t.isPci, o = this.props, a = o.isPaymentAgreementExist, i = o.isSubscribeAgreementExist, ke.reportData("credit_card_footer_validate_state", {
                  isPaymentAgreementExist: a,
                  isPci: n,
                  savePaymentInstrument: r,
                  isSubscribeAgreementExist: i
                }), !n || !a) {
                  e.next = 7;
                  break;
                }
                if (!this.footerRef.current) {
                  e.next = 6;
                  break;
                }
                return e.abrupt("return", this.footerRef.current.validate());
              case 6:
                return e.abrupt("return", !1);
              case 7:
                return e.abrupt("return", !0);
              case 8:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.i18n,
          r = e.initData,
          n = e.theme,
          o = e.initResult,
          a = e.isPaymentAgreementExist,
          i = e.isSubscribeAgreementExist,
          s = this.state,
          c = s.isLoaded,
          u = s.language,
          l = s.isPci;
        return $t(Xp, {
          isLoaded: c,
          theme: fu(n),
          initResult: o,
          footer: $t("div", null, a && $t(zp, {
            hide: !l
          }, $t(_d, {
            initData: r,
            theme: null == n ? void 0 : n.bindCardProtocol,
            language: u,
            onCheckboxChange: this.onCheckboxChange,
            ref: this.footerRef
          })), $t(Pd, {
            theme: null == n ? void 0 : n.bindCardProtocol,
            i18n: t,
            initResult: o
          }), i && $t(Id, {
            theme: null == n ? void 0 : n.bindCardProtocol,
            message: null == u ? void 0 : u.subscribeAgreement
          }))
        });
      }
    }]), a;
  }();
function Bd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Md(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Bd(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Bd(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var Fd = function () {
  function e() {
    n(this, e), c(this, "contentRef", {
      current: null
    }), c(this, "footerRef", {
      current: null
    });
  }
  var t;
  return s(e, [{
    key: "getRenderer",
    value: function value(e, t) {
      var r = this,
        n = function n(e) {
          r.footerRef && r.footerRef.current.onContentStateChange(e);
        };
      return {
        content: function content(o) {
          var a = vu(o.initData, o.initResult);
          return $t(jd, Md(Md({
            ref: r.contentRef
          }, a), {}, {
            env: o.env,
            i18n: o.i18n,
            initData: o.initData,
            initResult: o.initResult,
            creditCardFields: t,
            pciInstance: e,
            onContentStateChange: n
          }));
        },
        footer: function footer(e) {
          var t = vu(e.initData, e.initResult);
          return $t(Nd, Md(Md({
            ref: r.footerRef
          }, t), {}, {
            env: e.env,
            i18n: e.i18n,
            initData: e.initData,
            initResult: e.initResult
          }));
        }
      };
    }
  }, {
    key: "validate",
    value: (t = l(b.mark(function e() {
      var t, r, n, o;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.contentRef.current && this.footerRef.current) {
                e.next = 2;
                break;
              }
              return e.abrupt("return", !1);
            case 2:
              return e.next = 4, Promise.all([this.contentRef.current.validate(), this.footerRef.current.validate()]);
            case 4:
              return t = e.sent, r = mt(t, 2), n = r[0], o = r[1], e.abrupt("return", n && o);
            case 9:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "getPayData",
    value: function value() {
      var e = this.contentRef.current.getPayData(),
        t = this.footerRef.current.getPayData();
      return Md(Md({}, e), t);
    }
  }, {
    key: "setFieldError",
    value: function value(e) {
      return this.contentRef.current.setFieldError(e.field, e.message);
    }
  }]), e;
}();
function Hd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Vd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Hd(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Hd(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var Wd = function Wd(e) {
    return "ExchangeTicket" === e.data.nextAction.type;
  },
  Ud = function Ud(t) {
    var r,
      n,
      o,
      a,
      i,
      s,
      c = JSON.parse(JSON.stringify(t)),
      u = c.data,
      l = u.nextAction,
      p = u.tradeOrderId,
      d = null == l || null === (r = l.data) || void 0 === r ? void 0 : r.useCache,
      f = null == l || null === (n = l.data) || void 0 === n ? void 0 : n.ticket,
      h = {
        ticketUrl: null == l || null === (o = l.data) || void 0 === o ? void 0 : o.ticketUrl,
        failedReturnUrl: null == l || null === (a = l.data) || void 0 === a ? void 0 : a.failedReturnUrl,
        language: null == l || null === (i = l.data) || void 0 === i ? void 0 : i.language,
        __pvId: e,
        __orderId: p
      };
    if (d && function () {
      try {
        var e = "payment-test";
        return window.localStorage.setItem(e, "1"), "1" === window.localStorage.getItem(e) && (window.localStorage.removeItem(e), !0);
      } catch (e) {
        return !1;
      }
    }() && (s = navigator.userAgent, !(/Safari/.test(s) && !/Chrome/.test(s)))) {
      var v = p || Math.floor(1e6 * Math.random()),
        y = "".concat("payment_ticket", "_").concat(v);
      window.localStorage.setItem(y, f), l.url = xt(l.url, Vd({
        key: y
      }, h));
    } else l.url = xt(l.url, Vd({
      ticket: f
    }, h));
    return delete l.data, c.data = Vd(Vd({}, c.data), {}, {
      nextAction: l
    }), c;
  };
function Gd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Kd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Gd(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Gd(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var qd,
  zd,
  Zd = function () {
    function e(t, r) {
      var o = this;
      n(this, e), c(this, "creditCardUI", new Fd()), c(this, "pciInstance", void 0), c(this, "creditCardFields", void 0), c(this, "getNewConfirmParams", function () {
        var e = l(b.mark(function e(t, r) {
          var n, a, i, s, c, u, l;
          return b.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (a = null === (n = r.initData.paymentInstrument) || void 0 === n ? void 0 : n.CreditCard, i = yu(t, r), s = {
                    customerToken: i.customerToken,
                    paymentInstrument: Kd(Kd({}, i.paymentInstrumentExtraData), {}, {
                      paymentMethod: i.paymentMethod
                    }),
                    paymentMethodOptions: i.paymentMethodOptions
                  }, c = {
                    partnerId: Rl.SLP,
                    pciHost: t.pciInfo.host
                  }, null == a || !a.cardToken) {
                    e.next = 14;
                    break;
                  }
                  if (null == a || !a.authenticate) {
                    e.next = 8;
                    break;
                  }
                  return e.next = 8, o.pciInstance.updateCardToken(c);
                case 8:
                  return e.next = 10, o.pciInstance.getCardTokenInfoByCardToken(c);
                case 10:
                  u = e.sent, s.paymentInstrument.card = u, e.next = 19;
                  break;
                case 14:
                  return e.next = 16, o.pciInstance.getCardToken(Kd(Kd({}, c), {}, {
                    resourceId: t.pciInfo.resourceId,
                    paymentMethod: r.initData.paymentMethod
                  }));
                case 16:
                  l = e.sent, s.paymentInstrument.card = S(l, ["token", "cardIndex", "firstName", "bin", "expiryMonth", "expiryYear", "last4", "binInfo"]), s.risk = {
                    channelMsg: l.statisticsInfo
                  };
                case 19:
                  return e.abrupt("return", s);
                case 20:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (t, r) {
          return e.apply(this, arguments);
        };
      }()), this.checkInitData(r), this.initPCI(t, r);
    }
    var t, r, o, a;
    return s(e, [{
      key: "checkInitData",
      value: function value(e) {
        Xe(e) && this.checkCustomerPaymentInstrumentInitData(e);
      }
    }, {
      key: "checkCustomerPaymentInstrumentInitData",
      value: function value(e) {
        var t = pu(e),
          r = (null == t ? void 0 : t.mustAccept) && !(null != t && t.switchVisible) && !(null != t && t.defaultSwitchStatus),
          n = (null == t ? void 0 : t.switchVisible) && !t.textType.paymentAgreement;
        if (r || n) {
          var o = new T(y.InvalidPaymentInstrumentParams);
          throw o.setAPIErrorData({
            code: v.InnerSDKError,
            msg: y.AbnormalInstrumentParams
          }), o;
        }
      }
    }, {
      key: "initPCI",
      value: function value(e, t) {
        var r, n;
        this.creditCardFields = function (e) {
          var t, r, n, o;
          return null !== (t = e.paymentInstrument) && void 0 !== t && null !== (r = t.CreditCard) && void 0 !== r && r.cardToken ? !1 === (null === (n = e.paymentInstrument) || void 0 === n || null === (o = n.CreditCard) || void 0 === o ? void 0 : o.authenticate) ? [] : [Ve.Cvc] : $e;
        }(t);
        var o = {
          env: e.env,
          channelId: t.channelId,
          eventTrackingConfig: ke.getEventTrackingConfig(t.eventTrackingConfig),
          cardToken: null === (r = t.paymentInstrument) || void 0 === r || null === (n = r.CreditCard) || void 0 === n ? void 0 : n.cardToken,
          cdn: t.cdn,
          merchantId: t.merchantId
        };
        this.pciInstance = 0 === this.creditCardFields.length ? new Jl.ApiOnly(o) : new Jl(o);
      }
    }, {
      key: "needRenderWidget",
      value: (a = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !0);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function () {
        return a.apply(this, arguments);
      })
    }, {
      key: "needUserAction",
      value: function value() {
        return !0;
      }
    }, {
      key: "getRenderer",
      value: function value() {
        return this.creditCardUI.getRenderer(this.pciInstance, this.creditCardFields);
      }
    }, {
      key: "validate",
      value: (o = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.creditCardUI.validate()["catch"](function (e) {
                  return ke.handleError(e, "credit_card_validate_error");
                }));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return o.apply(this, arguments);
      })
    }, {
      key: "extendPreCheckParams",
      value: (r = l(b.mark(function e() {
        var t;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return t = this.creditCardUI.getPayData(), e.abrupt("return", {
                  paymentInstrument: {
                    paymentInstrumentId: t.isPci ? "" : t.selectInstrumentId,
                    savePaymentInstrument: t.savePaymentInstrument,
                    installmentCount: t.installmentCount,
                    card: {
                      binInfo: t.isPci ? t.currentCardInfo : t.selectInstrumentCardInfo
                    }
                  }
                });
              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "getPayHooks",
      value: function value() {
        var e = this,
          t = this.creditCardUI.getPayData();
        ke.reportData("credit_card_pay_state", {
          isAddCard: t.isPci,
          isSelectInstrument: !!t.selectInstrumentId,
          savePaymentInstrument: t.savePaymentInstrument,
          isInstallmentExist: t.isInstallmentExist,
          installmentCount: t.installmentCount,
          isCustomerPaymentInstrument: t.isCustomerPaymentInstrument
        });
        var r,
          n,
          o = {
            extendConfirmParams: (n = l(b.mark(function r(n, o) {
              var a, i, s, c, u;
              return b.wrap(function (r) {
                for (;;) {
                  switch (r.prev = r.next) {
                    case 0:
                      if (!1 !== (i = o.savePaymentInstrument) && !0 !== i || (null !== (s = t.initData.paymentInstrument) && void 0 !== s && null !== (c = s.bindCard) && void 0 !== c && null !== (u = c.protocol) && void 0 !== u && u.switchVisible && ke.reportErrorData("paymentInstrument_pay_warning", {
                        savePaymentInstrument: i
                      }), t.savePaymentInstrument = i), !t.isPci || !0 !== (null === (a = n.sdkSwitch) || void 0 === a ? void 0 : a.newSwitch)) {
                        r.next = 4;
                        break;
                      }
                      return r.abrupt("return", e.getNewConfirmParams(n, t));
                    case 4:
                      return r.abrupt("return", yu(n, t));
                    case 5:
                    case "end":
                      return r.stop();
                  }
                }
              }, r);
            })), function (e, t) {
              return n.apply(this, arguments);
            }),
            handlePayError: (r = l(b.mark(function t(r) {
              return b.wrap(function (t) {
                for (;;) {
                  switch (t.prev = t.next) {
                    case 0:
                      e.creditCardUI.setFieldError(r);
                    case 1:
                    case "end":
                      return t.stop();
                  }
                }
              }, t);
            })), function (e) {
              return r.apply(this, arguments);
            })
          };
        return t.isPci && (o.confirmOrderPay = function () {
          var t = l(b.mark(function t(r, n, o) {
            var a, i;
            return b.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (!0 !== (null === (a = r.sdkSwitch) || void 0 === a ? void 0 : a.newSwitch)) {
                      t.next = 6;
                      break;
                    }
                    return t.next = 3, ma(r, n, o);
                  case 3:
                    return i = t.sent, Wd(i) && (i = Ud(i)), t.abrupt("return", i);
                  case 6:
                    return t.abrupt("return", e.pciInstance.pay(r, n));
                  case 7:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          }));
          return function (e, r, n) {
            return t.apply(this, arguments);
          };
        }()), o;
      }
    }, {
      key: "destroy",
      value: function value() {
        this.pciInstance && this.pciInstance.destroy(), this.creditCardUI = null, this.pciInstance = null;
      }
    }, {
      key: "getCurrentCardInfo",
      value: (t = l(b.mark(function e() {
        var t;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (null == (t = this.creditCardUI.getPayData()) || !t.isPci) {
                  e.next = 5;
                  break;
                }
                if (!(this.pciInstance instanceof Jl)) {
                  e.next = 4;
                  break;
                }
                return e.abrupt("return", this.pciInstance.getCurrentCardInfo());
              case 4:
                return e.abrupt("return", null);
              case 5:
                return e.abrupt("return", t.selectInstrumentCardInfo || null);
              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }]), e;
  }();
!function (e) {
  e.Dev = "https://ct-auth.np-pay.com/v1/aftee.js", e.Prod = "https://auth.aftee.tw/v1/aftee.js";
}(qd || (qd = {})), function (e) {
  e.Fail = "fail", e.Error = "error";
}(zd || (zd = {}));
var $d = function () {
    function e() {
      n(this, e), c(this, "payOptions", void 0);
    }
    var t, r, o, a;
    return s(e, [{
      key: "reportData",
      value: function value(e, t) {
        ke.reportData("aftee_pay_client_".concat(e), t);
      }
    }, {
      key: "triggerPayOptions",
      value: function value(e) {
        var t = this,
          r = this.payOptions[e];
        if (this.reportData(e), "function" == typeof r) {
          var n = function () {
            var e = l(b.mark(function e() {
              return b.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      return e.abrupt("return", r());
                    case 1:
                    case "end":
                      return e.stop();
                  }
                }
              }, e);
            }));
            return function () {
              return e.apply(this, arguments);
            };
          }();
          n().then(function () {
            t.reportData("".concat(e, "_after"));
          })["catch"](function (r) {
            t.reportData("".concat(e, "_error"), {
              error: r
            });
          });
        }
      }
    }, {
      key: "pay",
      value: (a = l(b.mark(function e(t, r) {
        var n = this;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return this.payOptions = r, e.abrupt("return", new Promise(function () {
                  var e = l(b.mark(function e(r, o) {
                    var a, i, s, c, u;
                    return b.wrap(function (e) {
                      for (;;) {
                        switch (e.prev = e.next) {
                          case 0:
                            if (a = t.url, i = t.data, s = function s(e) {
                              o({
                                data: e
                              });
                            }, a && D(i)) {
                              e.next = 4;
                              break;
                            }
                            return e.abrupt("return", s({
                              code: v.InvalidNextAction,
                              msg: y.InvalidNextAction
                            }));
                          case 4:
                            c = i.paymentDataRequest, u = i.publicKey, n.triggerPayOptions("onPayClientCreate");
                          case 6:
                            if (window.Aftee.loaded()) {
                              e.next = 12;
                              break;
                            }
                            return n.reportData("not_loaded"), e.next = 10, Ne(1e3);
                          case 10:
                            e.next = 6;
                            break;
                          case 12:
                            n.reportData("waitForIframeToLoad_start"), window.Aftee.waitForIframeToLoad(2e3, 2e3).then(function () {
                              var e, t, o;
                              n.reportData("merge_start"), window.Aftee.merge({
                                pub_key: u,
                                payment: c,
                                cancelled: (o = l(b.mark(function e() {
                                  var t;
                                  return b.wrap(function (e) {
                                    for (;;) {
                                      switch (e.prev = e.next) {
                                        case 0:
                                          return e.next = 2, n.uploadCancel(a);
                                        case 2:
                                          t = e.sent, n.reportData("uploadCancel_success"), s(t);
                                        case 5:
                                        case "end":
                                          return e.stop();
                                      }
                                    }
                                  }, e);
                                })), function () {
                                  return o.apply(this, arguments);
                                }),
                                failed: (t = l(b.mark(function e(t) {
                                  var r;
                                  return b.wrap(function (e) {
                                    for (;;) {
                                      switch (e.prev = e.next) {
                                        case 0:
                                          return t || ke.reportErrorData("Empty failed callback arguments"), e.next = 3, n.uploadError(a, {
                                            errors: t,
                                            errorType: zd.Fail
                                          });
                                        case 3:
                                          r = e.sent, n.reportData("failed_uploadError_success"), s(r);
                                        case 6:
                                        case "end":
                                          return e.stop();
                                      }
                                    }
                                  }, e);
                                })), function (e) {
                                  return t.apply(this, arguments);
                                }),
                                succeeded: function succeeded(e) {
                                  n.uploadSuccess(a, {
                                    actionType: "uploadPaymentSuccess",
                                    data: e
                                  }).then(function () {
                                    n.reportData("upload_success_with_redirect"), r();
                                  })["catch"](function (e) {
                                    n.reportData("upload_success_error", {
                                      errorMsg: e.message,
                                      error: e
                                    }), s(e.data);
                                  });
                                },
                                error: (e = l(b.mark(function e(t, r, o) {
                                  var i;
                                  return b.wrap(function (e) {
                                    for (;;) {
                                      switch (e.prev = e.next) {
                                        case 0:
                                          return e.next = 2, n.uploadError(a, {
                                            name: t,
                                            message: r,
                                            errors: o,
                                            errorType: zd.Error
                                          });
                                        case 2:
                                          i = e.sent, n.reportData("error_uploadError_success"), s(i);
                                        case 5:
                                        case "end":
                                          return e.stop();
                                      }
                                    }
                                  }, e);
                                })), function (t, r, n) {
                                  return e.apply(this, arguments);
                                })
                              }), n.reportData("merge_end"), n.reportData("sync_start"), window.Aftee.sync(), n.reportData("sync_end"), n.reportData("open_popup_start"), window.Aftee.start(), n.reportData("open_popup_end");
                            })["catch"](function (e) {
                              return ke.reportError(e, "aftee_create_payClient_fail"), s({
                                code: v.CreatePayClientFail,
                                msg: y.CreatePayClientFail
                              });
                            });
                          case 14:
                          case "end":
                            return e.stop();
                        }
                      }
                    }, e);
                  }));
                  return function (t, r) {
                    return e.apply(this, arguments);
                  };
                }()));
              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t) {
        return a.apply(this, arguments);
      })
    }, {
      key: "uploadError",
      value: (o = l(b.mark(function e(t, r) {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", na(t, r)["catch"](function (e) {
                  return ke.reportError(e, "aftee_pay_client_uploadError_failed"), T.handleAPIErrorData(null == e ? void 0 : e.data, {
                    code: v.AbnormalTrade,
                    msg: y.AbnormalTrade
                  });
                }));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function (e, t) {
        return o.apply(this, arguments);
      })
    }, {
      key: "uploadCancel",
      value: (r = l(b.mark(function e(t) {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", oa(t)["catch"](function (e) {
                  return ke.reportError(e, "aftee_pay_client_uploadCancel_failed"), T.handleAPIErrorData(null == e ? void 0 : e.data, {
                    code: v.AbnormalTrade,
                    msg: y.AbnormalTrade
                  });
                }));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function (e) {
        return r.apply(this, arguments);
      })
    }, {
      key: "uploadSuccess",
      value: (t = l(b.mark(function e(t, r, n) {
        var o;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, ia(t, r);
              case 2:
                return o = e.sent, this.reportData("upload_order_success", {
                  url: t,
                  response: o
                }), e.abrupt("return", Ua(o, n));
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, r, n) {
        return t.apply(this, arguments);
      })
    }]), e;
  }(),
  Jd = function () {
    function e(t) {
      n(this, e), c(this, "simpleRender", new lo()), c(this, "payClient", void 0), c(this, "isValid", !1), c(this, "flag", void 0), c(this, "loadPromise", void 0), this.loadPromise = this.loadAfteeJs(t);
    }
    var t, r, o, a;
    return s(e, [{
      key: "loadAfteeJs",
      value: (a = l(b.mark(function e(t) {
        var r;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = t.env === Ot.Prod || t.env === Ot.Alpha ? qd.Prod : qd.Dev, e.abrupt("return", qe(r, {
                  maxCount: 3,
                  interval: 100
                }));
              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function (e) {
        return a.apply(this, arguments);
      })
    }, {
      key: "afterInit",
      value: (o = l(b.mark(function e() {
        var t = this;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.loadPromise.then(function () {
                  window.Aftee ? (t.isValid = !0, t.flag || (window.Aftee.config({}), t.flag = !0), ke.reportData("load_aftee_js_success")) : ke.handleError(new T("empty Aftee"), "load_aftee_js_error");
                })["catch"](function (e) {
                  ke.handleError(e, "load_aftee_js_error");
                });
              case 2:
                this.payClient = new $d();
              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return o.apply(this, arguments);
      })
    }, {
      key: "needRenderWidget",
      value: (r = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !0);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "needUserAction",
      value: function value() {
        return !1;
      }
    }, {
      key: "getRenderer",
      value: function value() {
        return this.simpleRender.getRenderer();
      }
    }, {
      key: "validate",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.isValid);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "getPayHooks",
      value: function value() {
        var e = this;
        return {
          handlePayAction: function handlePayAction(t, r) {
            if (t.type === ot.CreatePayClient) return e.payClient.pay(t, r);
            throw new T(y.InvalidNextAction, v.InvalidNextAction);
          }
        };
      }
    }, {
      key: "destroy",
      value: function value() {
        this.payClient = null, this.simpleRender = null;
      }
    }]), e;
  }(),
  Xd = [/Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/, /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/, /MSIE\s(7\.0)/];
function Yd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Qd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Yd(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Yd(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var ef = function () {
  function e(t, r, o) {
    n(this, e), c(this, "env", void 0), c(this, "initData", void 0), c(this, "reporter", void 0), c(this, "initPromise", void 0), this.env = t, this.initData = r, this.reporter = o, this.initPromise = this.cashierCheck();
  }
  var t, r, o;
  return s(e, [{
    key: "getRequestData",
    value: (o = l(b.mark(function e() {
      var t, r, n, o, a, i, s, c, u, l, p, d;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = this.initData, r = t.merchantId, n = t.countryCode, o = t.paymentMethod, a = t.currency, i = t.channelId, s = t.installmentCounts, c = t.amount, u = t.customerToken, e.next = 4, vo();
            case 4:
              return l = e.sent, p = {
                merchantId: r,
                countryCode: n,
                paymentMethod: o,
                currency: a,
                channelId: i,
                amount: c,
                payEnv: l,
                deviceType: je()
              }, d = nn(t.installmentCounts), Xe(t) && (p.customerToken = u), d && (p.installmentCounts = s), e.abrupt("return", p);
            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "getInitApiUrl",
    value: function value() {
      var e = Xe(this.initData),
        t = this.env.host;
      return e && this.env.localHost && (t = this.env.localHost), "".concat(t, "/v1/api/cashier/init");
    }
  }, {
    key: "cashierCheck",
    value: (r = l(b.mark(function e() {
      var t,
        r,
        n,
        o = this;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = this.getInitApiUrl(), e.next = 3, this.getRequestData();
            case 3:
              return r = e.sent, n = ke.formatReportData(r), this.reporter.reportData("cashier_check_start", {
                url: t
              }), e.abrupt("return", Se.post(t, r, {
                headers: Qe(this.initData)
              }).then(function (e) {
                return o.reporter.reportData("cashier_check_success", {
                  url: t,
                  request: {
                    params: n
                  },
                  response: e
                }), e.data;
              })["catch"](function (e) {
                var r = T.handleAPIErrorData(null == e ? void 0 : e.data, {
                  code: v.AbnormalTrade,
                  msg: y.AbnormalTrade
                });
                return o.reporter.handleError(e, "cashier_check_error", Qd({
                  url: t,
                  request: {
                    params: n
                  },
                  response: {
                    error: e
                  }
                }, r));
              }));
            case 7:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return r.apply(this, arguments);
    })
  }, {
    key: "checkInit",
    value: (t = l(b.mark(function e() {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.initPromise);
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();
function tf(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? tf(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : tf(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
var nf = function () {
    function e(t) {
      var r,
        o = this;
      n(this, e), c(this, "env", void 0), c(this, "initData", void 0), c(this, "initChecker", void 0), c(this, "paySession", void 0), c(this, "isNotSupportBrowser", void 0), c(this, "reporter", void 0), c(this, "metaData", void 0), c(this, "handlePaySession", function () {
        var e = l(b.mark(function e(t) {
          var r, n, a, i;
          return b.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (e.prev = 0, o.reporter.reportData("handlePaySession_start"), r = {}, null == t || !t.extendPaySession) {
                    e.next = 7;
                    break;
                  }
                  return e.next = 6, t.extendPaySession()["catch"](function (e) {
                    return o.reporter.handleError(e, "handlePaySession_extendPaySession_error");
                  });
                case 6:
                  r = e.sent;
                case 7:
                  return e.next = 9, o.paySession;
                case 9:
                  return n = e.sent, e.next = 12, o.initChecker.checkInit()["catch"](function (e) {
                    return o.reporter.handleError(e, "handlePaySession_checkInit_error");
                  });
                case 12:
                  return (a = e.sent).recommendSubPaymentMethod && (n.recommendSubPaymentMethod = a.recommendSubPaymentMethod), i = JSON.stringify(Object.assign({}, r, n)), o.reporter.reportData("handlePaySession_end", {
                    paySession: i
                  }), e.abrupt("return", i);
                case 19:
                  e.prev = 19, e.t0 = e["catch"](0), o.reporter.handleError(e.t0, "handlePaySession_error");
                case 22:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[0, 19]]);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }()), this.initReporter(t);
      try {
        this.reporter.reportData("constructor_start", t);
        var a = rf({}, t);
        if (this.env = function (e) {
          e.env = e.env && Et[e.env] ? e.env : Dt;
          var t = St(St({}, Et[e.env]), {}, {
            localHost: Lt(e.env, e.customerToken)
          });
          return e.env === Dt ? e.host = void 0 : t && (t.host = e.host || t.host, e.host = t.host), e.cdn === rt.CN && (t.imageHost = e.env === Ot.Prod ? Ct.Prod : Ct.Dev), Object.freeze(t);
        }(a), de.setTag("host", this.env.host), a.channelId && a.channelId !== Ze) throw new T("channelId = ".concat(a.channelId, " is not support"), v.InitDataError, "InitDataError");
        a.channelId = Ze, de.setTag("channelId", a.channelId), a.host = Je(a.host), this.initData = Object.freeze(a), this.metaData = Ye(t), this.isNotSupportBrowser = (r = navigator.userAgent, Xd.every(function (e) {
          var t = e.exec(r);
          return !!(t && Number(t[1]) < 11);
        })), this.check(), this.initChecker = new ef(this.env, this.initData, this.reporter);
      } catch (e) {
        this.reporter.handleError(e, "constructor_error");
      }
    }
    var t;
    return s(e, [{
      key: "check",
      value: function value() {
        if (this.isNotSupportBrowser) throw new T(y.NotSupportBrowser, v.NotSupportBrowser, "NotSupportBrowser");
        if ([et.CreditCard, et.FPX].indexOf(this.initData.paymentMethod) > -1 && (e = navigator.userAgent, t = -1 !== e.indexOf("MSIE"), r = /Windows\sNT ([0-9\.]+).*?Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/.exec(e), n = r ? Number(r[1]) : null, o = r ? Number(r[2]) : null, t || r && o <= 11 && n <= 7)) throw this.reporter.reportData("init_not_support_browser"), new T(y.NotSupportBrowser, v.NotSupportBrowser, "NotSupportBrowser");
        var e, t, r, n, o;
      }
    }, {
      key: "initReporter",
      value: function value(e) {
        try {
          ke.init(e), this.reporter = new we(e);
        } catch (e) {
          ke.handleError(e, "init_reporter_error");
        }
      }
    }, {
      key: "parseLanguage",
      value: function value() {
        var e = this.initData.language,
          t = void 0 === e ? ze : e;
        return "string" == typeof t ? t : (null == t ? void 0 : t.extend) || ze;
      }
    }, {
      key: "initRisk",
      value: function value() {
        var e = this;
        return this.reporter.reportData("init_risk_start"), this.paySession = new lt(this.env, this.initData.host).init(this.initData).then(function (t) {
          e.reporter.addReportData({
            sessionId: t.sessionId
          });
          var r = rf(rf({}, t), {}, {
            paymentMethod: e.initData.paymentMethod,
            channelId: e.initData.channelId,
            language: e.parseLanguage(),
            sdkVersion: "payment-sdk_v3.17.1"
          });
          return e.reporter.reportData("init_risk_end", {
            paySession: r
          }), r;
        })["catch"](function (t) {
          return e.reporter.handleError(t, "initRisk_error");
        }), this.paySession;
      }
    }, {
      key: "getPayReportData",
      value: function value(e, t) {
        var r = function (e) {
          var t = null == e ? void 0 : e.url;
          return t && "string" == typeof t ? (null == e ? void 0 : e.type) === ot.Confirm ? Us(t) : function (e) {
            if (!e || "string" != typeof e) return "";
            var t = e.match(/tradeOrderId(=|%3D)\d+/);
            if (t && t[0]) {
              var r = t[0];
              return r.indexOf("=") > -1 ? r.split("=")[1] : r.split("%3D")[1];
            }
            return "";
          }(t) : "";
        }(e);
        return this.reporter.addReportData({
          orderId: r
        }), {
          nextAction: ke.formatReportData(e),
          savePaymentInstrument: null == t ? void 0 : t.savePaymentInstrument
        };
      }
    }, {
      key: "getPayOptions",
      value: (t = l(b.mark(function e(t) {
        var r,
          n = this;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.paySession;
              case 2:
                return r = e.sent, e.abrupt("return", rf(rf({}, t), {}, {
                  beforeRedirect: function () {
                    var e = l(b.mark(function e(r) {
                      return b.wrap(function (e) {
                        for (;;) {
                          switch (e.prev = e.next) {
                            case 0:
                              if (n.reporter.reportData("call_pay_end_with_redirect", {
                                target: r
                              }), !t || null == t || !t.beforeRedirect) {
                                e.next = 3;
                                break;
                              }
                              return e.abrupt("return", t.beforeRedirect(r));
                            case 3:
                            case "end":
                              return e.stop();
                          }
                        }
                      }, e);
                    }));
                    return function (t) {
                      return e.apply(this, arguments);
                    };
                  }(),
                  sessionId: r.sessionId,
                  language: this.parseLanguage(),
                  paymentMethod: this.initData.paymentMethod,
                  env: this.env,
                  cdn: this.initData.cdn,
                  APIRequestHeader: Qe(this.initData),
                  deepLinkImmediately: this.initData.deepLinkImmediately
                }));
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "handlePayError",
      value: function value(e, t) {
        var r = "call_pay_end_with_error",
          n = {
            paymentError: T.handleAPIErrorData(t.data)
          };
        return this.reporter.reportData(r, {
          payResult: n
        }), this.reporter.reportError(t, r, {
          payResult: n,
          nextAction: ke.formatReportData(e)
        }), n;
      }
    }]), e;
  }(),
  of = function of(e) {
    return $t("svg", kr({}, e, {
      width: "200",
      height: "113",
      viewBox: "0 0 200 113",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }), $t("path", {
      d: "M151 70.0171C151 67.5027 152.704 66 154.704 66C156.703 66 158.407 67.5027 158.407 70.0171C158.407 70.9936 157.942 71.9062 157.125 72.6701C156.29 73.4516 155.231 73.9322 154.406 74.0565C153.427 74.204 152.704 75.0447 152.704 76.0342V78.6658C152.704 79.7705 153.599 80.6667 154.704 80.6667C155.808 80.6667 156.704 79.7712 156.704 78.6666V77.558C157.829 77.1301 158.932 76.4571 159.857 75.5915C161.269 74.2717 162.407 72.3637 162.407 70.0171C162.407 65.3862 159.004 62 154.704 62C150.403 62 147 65.3862 147 70.0171C147 71.1217 147.895 72.0171 149 72.0171C150.105 72.0171 151 71.1217 151 70.0171Z",
      fill: "currentColor"
    }), $t("path", {
      d: "M154.5 88C155.881 88 157 86.8807 157 85.5C157 84.1193 155.881 83 154.5 83C153.119 83 152 84.1193 152 85.5C152 86.8807 153.119 88 154.5 88Z",
      fill: "currentColor"
    }), $t("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25 13.219C25 12.1144 25.8954 11.219 27 11.219H64.022C68.8042 11.219 73.3899 13.122 76.7669 16.508L90.3001 30.0773H154.24C159.763 30.0773 164.24 34.5544 164.24 40.0773V54.2006L172.334 56.0079C173.248 56.2119 173.898 57.0229 173.898 57.9595L173.9 69.8512C173.9 72.8249 173.9 75.7995 173.9 78.0324C173.9 79.1488 173.9 80.0799 173.899 80.7328L173.899 81.6964L173.898 81.7537L173.898 81.777L173.898 81.7984L173.897 81.8294C173.896 81.8515 173.887 81.9744 173.874 82.0747C173.866 82.125 173.856 82.175 173.844 82.2246C171.338 92.7681 161.454 97.3662 157.263 98.8897C155.45 99.549 153.511 99.4864 151.773 98.8716C150.089 98.2761 148.567 97.6263 147.191 96.9382H69.4814C63.9586 96.9382 59.4814 92.4611 59.4814 86.9382V66.8548H54.4261C50.2409 66.8548 46.2278 65.1894 43.2723 62.2261C41.0674 60.0152 38.0732 58.7727 34.9508 58.7727H28.791C27.6864 58.7727 26.791 57.8773 26.791 56.7727C26.791 55.6681 27.6864 54.7727 28.791 54.7727H34.9508C39.1359 54.7727 43.1491 56.4381 46.1045 59.4014C48.3095 61.6123 51.3036 62.8548 54.4261 62.8548H59.4814V52.1721C53.7323 50.0648 49.6299 44.5436 49.6299 38.0642C49.6299 36.9596 50.5253 36.0642 51.6299 36.0642C52.7345 36.0642 53.6299 36.9596 53.6299 38.0642C53.6299 44.151 58.5642 49.0854 64.6511 49.0854H69.9975C72.4759 49.0854 74.8529 50.0697 76.6057 51.8219L82.4235 57.6377C84.0397 59.2533 86.2314 60.1609 88.5166 60.1609C91.465 60.1609 92.9414 56.5958 90.8561 54.5113L67.5836 31.2469C66.8024 30.4659 66.8022 29.1996 67.5831 28.4184C68.364 27.6372 69.6303 27.637 70.4115 28.4179L72.0714 30.0773H84.6508L73.9347 19.3327C71.3081 16.6991 67.7415 15.219 64.022 15.219H27C25.8954 15.219 25 14.3236 25 13.219ZM141.086 92.9382C139.585 91.6448 138.415 90.3244 137.505 89.0513C136.653 87.8588 136.041 86.7235 135.602 85.7129H63.4814V86.9382C63.4814 90.2519 66.1677 92.9382 69.4814 92.9382H141.086ZM134.495 81.7129C134.481 81.5365 134.48 81.3835 134.48 81.2737V71.3447H63.4814V81.7129H134.495ZM134.48 67.3447V57.96C134.48 57.0176 135.138 56.2031 136.059 56.0048L152.379 52.4923C153.791 52.1884 155.252 52.194 156.662 52.5087L160.24 53.3075V40.0773C160.24 36.7636 157.553 34.0773 154.24 34.0773H76.0728L93.6841 51.6824C98.2898 56.2866 95.029 64.1609 88.5166 64.1609C85.1707 64.1609 81.9619 62.832 79.5956 60.4666L73.7778 54.6508C72.7751 53.6485 71.4153 53.0854 69.9975 53.0854H64.6511C64.2575 53.0854 63.8674 53.0702 63.4814 53.0405V67.3447H134.48ZM169.898 59.5625L155.791 56.4126C154.945 56.2238 154.068 56.2204 153.221 56.4028L138.48 59.5754V81.2737C138.48 81.3715 138.482 81.396 138.483 81.4037C138.525 81.8111 138.835 84.0307 140.76 86.7262C142.673 89.4047 146.275 92.684 153.107 95.1005C154.053 95.4352 155.034 95.4443 155.897 95.1305C159.872 93.6852 167.813 89.7797 169.899 81.5182L169.899 80.7311C169.9 80.0789 169.9 79.1483 169.9 78.032C169.9 75.7996 169.9 72.8252 169.9 69.8515L169.898 59.5625Z",
      fill: "currentColor"
    }));
  },
  af = "paymentSdk_blockContainer_690ba59b",
  sf = "paymentSdk_blockImg_690ba59b",
  cf = "paymentSdk_blockDescription_690ba59b";
function uf(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var lf = function (e) {
  _(r, Yt);
  var t = uf(r);
  function r() {
    return n(this, r), t.apply(this, arguments);
  }
  return s(r, [{
    key: "componentDidCatch",
    value: function value(e) {
      ke.reportError(e, "ErrorResult_componentDidCatch_error");
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
        t = e.description,
        r = e.theme;
      return $t("div", {
        className: af
      }, $t("div", {
        className: sf,
        style: {
          color: null == r ? void 0 : r.imgColor
        }
      }, $t(of, null)), t && $t("div", {
        className: cf
      }, $t(Vr, {
        text: t,
        theme: r
      })));
    }
  }]), r;
}();
function pf(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var df = function (e) {
    _(o, xa);
    var t,
      r = pf(o);
    function o() {
      var e;
      n(this, o);
      for (var t = arguments.length, a = new Array(t), i = 0; i < t; i++) {
        a[i] = arguments[i];
      }
      return c(w(e = r.call.apply(r, [this].concat(a))), "component", null), e;
    }
    return s(o, [{
      key: "updateRenderer",
      value: (t = l(b.mark(function e(t) {
        var r, n, o, a;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = t.initData, n = t.description, o = t.theme, a = t.error, e.next = 3, so({
                  initData: r,
                  render: $t(lf, {
                    description: n,
                    theme: o
                  }),
                  status: nt.FAIL,
                  error: a
                });
              case 3:
                this.component = e.sent;
              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }]), o;
  }(),
  ff = function () {
    function e() {
      n(this, e), c(this, "reporter", void 0), c(this, "blockUI", void 0), c(this, "getText", function () {
        var e = l(b.mark(function e(t, r) {
          var n;
          return b.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (null == r || !r.code) {
                    e.next = 6;
                    break;
                  }
                  return e.next = 3, t.get("blockText.".concat(r.code));
                case 3:
                  if (!(n = e.sent)) {
                    e.next = 6;
                    break;
                  }
                  return e.abrupt("return", n);
                case 6:
                  return e.abrupt("return", t.get("paymentMethodNotSupported"));
                case 7:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (t, r) {
          return e.apply(this, arguments);
        };
      }());
    }
    var t;
    return s(e, [{
      key: "mount",
      value: (t = l(b.mark(function e(t, r) {
        var n,
          o,
          a = this;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (t) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return");
              case 2:
                return e.next = 4, this.getText(r.i18n, r.error)["catch"](function (e) {
                  return a.reporter.handleError(e, "blockRenderer_render_error");
                });
              case 4:
                return o = e.sent, this.blockUI = new df(), e.next = 8, this.blockUI.updateRenderer({
                  description: o,
                  theme: null === (n = r.initData.theme) || void 0 === n ? void 0 : n.block,
                  initData: r.initData,
                  error: r.error
                });
              case 8:
                return e.next = 10, this.blockUI.render(t);
              case 10:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, r) {
        return t.apply(this, arguments);
      })
    }, {
      key: "destroy",
      value: function value() {
        this.blockUI && this.blockUI.destroy();
      }
    }]), e;
  }(),
  hf = {
    idCardContainer: "paymentSdk_idCardContainer_9d177ab3",
    header: "paymentSdk_header_9d177ab3",
    hidden: "paymentSdk_hidden_9d177ab3",
    idCardPcStyle: "paymentSdk_idCardPcStyle_9d177ab3",
    numberAndDate: "paymentSdk_numberAndDate_9d177ab3",
    locationAndCategory: "paymentSdk_locationAndCategory_9d177ab3",
    idCardMobileStyle: "paymentSdk_idCardMobileStyle_9d177ab3",
    line: "paymentSdk_line_9d177ab3"
  };
function vf(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function yf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? vf(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vf(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function mf(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var gf = Wr.bind(hf),
  bf = function (e) {
    _(r, Yt);
    var t = mf(r);
    function r() {
      var e;
      n(this, r);
      for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++) {
        a[i] = arguments[i];
      }
      return c(w(e = t.call.apply(t, [this].concat(a))), "state", {
        isBigSizeView: !1
      }), c(w(e), "handleResize", function (t) {
        e.setState({
          isBigSizeView: t
        });
      }), e;
    }
    return s(r, [{
      key: "getSkeleton",
      value: function value(e) {
        var t;
        return $t(Gn, {
          theme: yf(yf({}, (null === (t = this.props.theme) || void 0 === t ? void 0 : t.skeleton) || {}), {}, {
            height: e
          })
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.state.isBigSizeView,
          t = this.props,
          r = t.theme,
          n = t.show,
          o = t.needAdaptive,
          a = t.isLoaded,
          i = t.inputIdNumber,
          s = t.inputIssueDate,
          c = t.selectIssueLocation,
          u = t.header,
          l = t.selectReplacementCategory,
          p = t.showBottomLine;
        return $t(br, {
          triggerSize: o,
          onResize: this.handleResize
        }, $t("div", {
          className: gf({
            idCardContainer: !0,
            hidden: !n,
            idCardPcStyle: e,
            idCardMobileStyle: !e
          })
        }, $t("div", {
          className: hf.header,
          style: {
            marginBottom: null == r ? void 0 : r.formItemGutter
          }
        }, a ? u : this.getSkeleton("18px")), $t("div", {
          className: hf.numberAndDate
        }, $t("div", {
          style: {
            marginBottom: null == r ? void 0 : r.formItemGutter,
            marginRight: e ? null == r ? void 0 : r.formItemGutter : void 0
          }
        }, a ? i : this.getSkeleton(null == r ? void 0 : r.inputHeight)), $t("div", {
          style: {
            marginBottom: null == r ? void 0 : r.formItemGutter
          }
        }, a ? s : this.getSkeleton(null == r ? void 0 : r.inputHeight))), $t("div", {
          className: hf.locationAndCategory
        }, $t("div", {
          style: {
            marginBottom: null == r ? void 0 : r.formItemGutter,
            marginRight: e ? null == r ? void 0 : r.formItemGutter : void 0
          }
        }, a ? c : this.getSkeleton(null == r ? void 0 : r.inputHeight)), $t("div", {
          style: {
            marginBottom: null == r ? void 0 : r.formItemGutter
          }
        }, a ? l : this.getSkeleton(null == r ? void 0 : r.inputHeight))), p ? $t("div", {
          className: hf.line
        }) : null));
      }
    }]), r;
  }(),
  kf = function kf(e) {
    return $t("svg", kr({}, e, {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }), $t("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8.00005 4C8.44188 4 8.80005 4.35817 8.80005 4.8V9C8.80005 9.44183 8.44188 9.8 8.00005 9.8C7.55822 9.8 7.20005 9.44183 7.20005 9V4.8C7.20005 4.35817 7.55822 4 8.00005 4ZM7.99999 12.45C8.47998 12.45 8.89623 12.0471 8.89998 11.5463C8.89623 11.053 8.47998 10.65 7.99999 10.65C7.505 10.65 7.09625 11.053 7.1 11.5463C7.09625 12.0471 7.505 12.45 7.99999 12.45Z",
      fill: "currentColor"
    }));
  },
  wf = "paymentSdk_header_6233b818",
  Cf = "paymentSdk_noticeIcon_6233b818",
  _f = "paymentSdk_tooltipIcon_6233b818",
  Of = "paymentSdk_title_6233b818";
function Pf(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var xf = function (e) {
  _(r, Yt);
  var t = Pf(r);
  function r(e) {
    var o;
    return n(this, r), c(w(o = t.call(this, e)), "headerRef", void 0), c(w(o), "state", {
      isBigSizeView: !1
    }), c(w(o), "handleResize", function (e) {
      o.setState({
        isBigSizeView: e
      });
    }), o.headerRef = {
      current: null
    }, o;
  }
  return s(r, [{
    key: "render",
    value: function value() {
      var e = this.props,
        t = e.title,
        r = e.validateNotice,
        n = e.needAdaptive,
        o = e.theme,
        a = void 0 === o ? {} : o,
        i = this.state.isBigSizeView,
        s = this.headerRef.current ? this.headerRef.current.getBoundingClientRect() : null;
      return $t(br, {
        triggerSize: n,
        onResize: this.handleResize
      }, $t("div", {
        ref: this.headerRef,
        className: wf,
        style: {
          color: null == a ? void 0 : a.headerFontColor,
          fontSize: null == a ? void 0 : a.headerFontSize
        }
      }, $t("span", {
        className: Cf,
        style: {
          color: null == a ? void 0 : a.headerInfoIconColor
        }
      }, $t(kf, null)), $t("span", {
        className: Of
      }, t), $t(Yr, {
        placement: "bottom",
        title: r,
        theme: {
          width: "430px",
          padding: "16px 20px",
          linkColor: "rgb(24, 144, 255)",
          strongTextAlign: "center",
          strongDisplay: "block",
          lineHeight: "14px",
          extend: zr.White
        },
        isAutoCenter: !i,
        containerAbsPos: s,
        isAutoInsideContainer: !0
      }, $t("span", {
        className: _f,
        style: {
          color: null == a ? void 0 : a.headerQuestionIconColor
        }
      }, $t(wr, null)))));
    }
  }]), r;
}();
function If(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Sf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? If(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : If(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function Df(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Rf = function (e) {
  _(a, Yt);
  var t,
    r,
    o = Df(a);
  function a() {
    var e;
    n(this, a);
    for (var t = arguments.length, r = new Array(t), i = 0; i < t; i++) {
      r[i] = arguments[i];
    }
    return c(w(e = o.call.apply(o, [this].concat(r))), "selectRef", {
      current: null
    }), c(w(e), "state", {
      selectedOption: null
    }), e;
  }
  return s(a, [{
    key: "validate",
    value: (r = l(b.mark(function e() {
      var t, r;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return (r = !(null === (t = this.state.selectedOption) || void 0 === t || !t.value)) ? this.selectRef.current.removeError() : this.selectRef.current.showError(this.props.errorTips), e.abrupt("return", r);
            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return r.apply(this, arguments);
    })
  }, {
    key: "getValue",
    value: (t = l(b.mark(function e() {
      var t;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", null === (t = this.state.selectedOption) || void 0 === t ? void 0 : t.value);
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "setError",
    value: function value(e) {
      var t;
      null === (t = this.selectRef.current) || void 0 === t || t.showError(e);
    }
  }, {
    key: "handleValueChange",
    value: function value(e) {
      this.setState({
        selectedOption: e
      });
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
        t = this.props,
        r = t.label,
        n = t.optionList,
        o = t.theme,
        a = void 0 === o ? {} : o,
        i = t.needAdaptive;
      return $t(Fn, {
        ref: this.selectRef,
        optionList: n,
        placeholder: r,
        onChange: function onChange(t) {
          return e.handleValueChange(t);
        },
        theme: Sf({
          selectPlaceholderFontColor: "rgba(44, 44, 44, 0.75)",
          selectFontColor: "#2c2c2c",
          selectDropdownMaxHeight: "172px"
        }, a),
        needAdaptive: i
      });
    }
  }]), a;
}();
function Ef(e) {
  if (!e || !/^[A-Z]\d{9}$/.test(e)) return !1;
  var t = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1],
    r = ({
      A: 10,
      B: 11,
      C: 12,
      D: 13,
      E: 14,
      F: 15,
      G: 16,
      H: 17,
      I: 34,
      J: 18,
      K: 19,
      L: 20,
      M: 21,
      N: 22,
      O: 35,
      P: 23,
      Q: 24,
      R: 25,
      S: 26,
      T: 27,
      U: 28,
      V: 29,
      W: 32,
      X: 30,
      Y: 31,
      Z: 33
    }[e[0]].toString() + e.slice(1)).split(""),
    n = 0;
  return r.forEach(function (e, r) {
    n += parseInt(e) * t[r];
  }), n % 10 == 0;
}
function Tf(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Af = function (e) {
    _(a, Yt);
    var t,
      r,
      o = Tf(a);
    function a(e) {
      var t;
      return n(this, a), c(w(t = o.call(this, e)), "inputRef", void 0), c(w(t), "state", {
        value: ""
      }), t.inputRef = {
        current: null
      }, t;
    }
    return s(a, [{
      key: "validate",
      value: (r = l(b.mark(function e() {
        var t;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return (t = Ef(this.state.value)) ? this.inputRef.current.removerError() : this.setError(), e.abrupt("return", t);
              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "getValue",
      value: (t = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.state.value);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "setError",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.errorTips;
        this.inputRef.current && this.inputRef.current.setError(e);
      }
    }, {
      key: "handleBlur",
      value: function value(e) {
        var t = Ef(e);
        e && !t && this.setError();
      }
    }, {
      key: "handleInputValue",
      value: function value(e) {
        var t = e.trim().replace(/[^\dA-Za-z]/g, "").slice(0, 10);
        return this.setState({
          value: t
        }), t;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
          t = this.props,
          r = t.label,
          n = t.theme;
        return $t(Ic, {
          ref: this.inputRef,
          label: r,
          theme: n,
          onInput: function onInput(t) {
            return e.handleInputValue(t);
          },
          onBlur: function onBlur(t) {
            return e.handleBlur(t);
          }
        });
      }
    }]), a;
  }(),
  Lf = "paymentSdk_issueDateContainer_03645348",
  jf = "paymentSdk_inputContainer_03645348",
  Nf = "paymentSdk_delimiter_03645348",
  Bf = "paymentSdk_yearInput_03645348",
  Mf = "paymentSdk_dayInput_03645348";
function Ff(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Hf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ff(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ff(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function Vf(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Wf,
  Uf = {
    year: 3,
    month: 2,
    day: 2
  };
!function (e) {
  e.Year = "year", e.Month = "month", e.Day = "day";
}(Wf || (Wf = {}));
var Gf,
  Kf,
  qf = function (e) {
    _(a, Yt);
    var t,
      r,
      o = Vf(a);
    function a(e) {
      var t;
      return n(this, a), c(w(t = o.call(this, e)), "dateRefs", void 0), c(w(t), "isOnComposition", !1), c(w(t), "state", {
        dateValue: {
          year: "",
          month: "",
          day: ""
        },
        isFocused: {
          year: !1,
          month: !1,
          day: !1
        },
        isError: !1,
        errorMessage: t.props.errorTips || ""
      }), c(w(t), "handleComposition", function (e, r, n) {
        t.isOnComposition = e, e || t.handleInputEvent(n, r);
      }), c(w(t), "handleInputEvent", function (e, r) {
        t.isOnComposition || t.handleInputValue(e.target.value || "", r);
      }), t.dateRefs = {
        year: {
          current: null
        },
        month: {
          current: null
        },
        day: {
          current: null
        }
      }, t;
    }
    return s(a, [{
      key: "validate",
      value: (r = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.checkValues(!1));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "checkValues",
      value: function value() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
          t = this.state.dateValue,
          r = t.year,
          n = t.month,
          o = t.day,
          a = !1;
        if (!e || r || n || o) {
          var i = /^\d{3}$/.test(r),
            s = /^(0[1-9]|1[0-2])$/.test(n),
            c = /^(0[1-9]|[1-2][0-9]|3[0-1])$/.test(o);
          a = i && s && c;
        } else a = !0;
        return this.setState({
          isError: !a,
          errorMessage: a ? "" : this.props.errorTips
        }), a;
      }
    }, {
      key: "getValue",
      value: (t = l(b.mark(function e() {
        var t, r, n, o;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return t = this.state.dateValue, r = t.year, n = t.month, o = t.day, e.abrupt("return", "".concat(r).concat(n).concat(o));
              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "setError",
      value: function value(e) {
        this.setState({
          isError: !0,
          errorMessage: e
        });
      }
    }, {
      key: "changeInputValue",
      value: function value(e, t, r) {
        this.setState(function (r) {
          return {
            dateValue: Hf(Hf({}, r.dateValue), {}, c({}, "".concat(e), t))
          };
        }, r);
      }
    }, {
      key: "changeFocusStatus",
      value: function value(e, t) {
        this.setState(function (r) {
          return {
            isFocused: Hf(Hf({}, r.isFocused), {}, c({}, "".concat(e), t))
          };
        });
      }
    }, {
      key: "handleInputValue",
      value: function value(e, t) {
        var r = this,
          n = yc(e);
        n = n.replace(/[^\d]/g, "").slice(0, Uf[t]), this.changeInputValue(t, n, function () {
          t === Wf.Year ? n.length === Uf.year && r.dateRefs.month.current.focus() : t === Wf.Month && n.length === Uf.month && r.dateRefs.day.current.focus();
        });
      }
    }, {
      key: "handleFocus",
      value: function value(e) {
        this.setState({
          isError: !1,
          errorMessage: ""
        }), this.changeFocusStatus(e, !0);
      }
    }, {
      key: "handleBlur",
      value: function value(e, t) {
        var r = e.target.value || "",
          n = r.length;
        t !== Wf.Year || 1 !== n && 2 !== n ? [Wf.Month, Wf.Day].indexOf(t) > -1 && 1 === n ? (r = "0".concat(r), this.changeInputValue(t, r, this.checkValues)) : this.checkValues() : (r = 1 === n ? "00".concat(r) : "0".concat(r), this.changeInputValue(t, r, this.checkValues)), this.changeFocusStatus(t, !1);
      }
    }, {
      key: "getCompositionEvent",
      value: function value(e) {
        var t = this;
        return {
          oncompositionstart: function oncompositionstart() {
            return t.handleComposition(!0);
          },
          oncompositionupdate: function oncompositionupdate() {
            return t.handleComposition(!0);
          },
          oncompositionend: function oncompositionend(r) {
            return t.handleComposition(!1, e, r);
          }
        };
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
          t = this.props,
          r = t.label,
          n = t.theme,
          o = this.state,
          a = o.isError,
          i = o.errorMessage,
          s = o.isFocused,
          c = o.dateValue,
          u = Object.keys(s).some(function (e) {
            return !!s[e];
          }),
          l = {
            color: null == n ? void 0 : n.inputFontColor
          };
        return $t(vc, {
          label: r,
          theme: n,
          errorMessage: i,
          isFocused: u,
          isError: a,
          shouldLabelStepAside: !1
        }, $t("div", {
          className: Lf
        }, $t("div", {
          className: jf
        }, $t("input", Hf(Hf({
          className: Bf,
          ref: this.dateRefs.year,
          value: c.year,
          style: l,
          type: "text",
          inputMode: "numeric",
          placeholder: "YYY"
        }, this.getCompositionEvent(Wf.Year)), {}, {
          onInput: function onInput(t) {
            return e.handleInputEvent(t, Wf.Year);
          },
          onFocus: function onFocus() {
            return e.handleFocus(Wf.Year);
          },
          onBlur: function onBlur(t) {
            return e.handleBlur(t, Wf.Year);
          }
        })), $t("span", {
          className: Nf,
          style: {
            color: null == n ? void 0 : n.inputLabelColor
          }
        }, "/"), $t("input", Hf(Hf({
          ref: this.dateRefs.month,
          value: c.month,
          style: l,
          type: "text",
          inputMode: "numeric",
          placeholder: "MM"
        }, this.getCompositionEvent(Wf.Month)), {}, {
          onInput: function onInput(t) {
            return e.handleInputEvent(t, Wf.Month);
          },
          onFocus: function onFocus() {
            return e.handleFocus(Wf.Month);
          },
          onBlur: function onBlur(t) {
            return e.handleBlur(t, Wf.Month);
          }
        })), $t("span", {
          className: Nf,
          style: {
            color: null == n ? void 0 : n.inputLabelColor
          }
        }, "/"), $t("input", Hf(Hf({
          className: Mf,
          ref: this.dateRefs.day,
          value: c.day,
          style: Hf(Hf({}, l), {}, {
            paddingRight: null == n ? void 0 : n.inputPaddingRight
          }),
          type: "text",
          inputMode: "numeric",
          placeholder: "DD"
        }, this.getCompositionEvent(Wf.Day)), {}, {
          onInput: function onInput(t) {
            return e.handleInputEvent(t, Wf.Day);
          },
          onFocus: function onFocus() {
            return e.handleFocus(Wf.Day);
          },
          onBlur: function onBlur(t) {
            return e.handleBlur(t, Wf.Day);
          }
        })))));
      }
    }]), a;
  }();
function zf(e) {
  return (null == e ? void 0 : e.formType) === at.IdCard && "TW" === (null == e ? void 0 : e.occursLocation);
}
function Zf(e) {
  if (!e) return null;
  var t = e.idNumber,
    r = e.issueDate,
    n = e.issueLocation,
    o = e.replacementCategory;
  return {
    formType: at.IdCard,
    additionalIdCardValidate: {
      idCardNo: t,
      idCardReceiveTypeCode: o,
      issuingAddressCode: n,
      issuingRepublicDateStr: r
    }
  };
}
!function (e) {
  e.InvalidCardNumber = "4455", e.InvalidCard = "3001", e.InvalidExpDate = "4459", e.InvalidCVC = "4453";
}(Kf || (Kf = {}));
var $f = (c(Gf = {}, Kf.InvalidCardNumber, {
  field: Ve.Number,
  i18nKey: "pleaseEnterValidCardNumber"
}), c(Gf, Kf.InvalidCard, {
  field: Ve.Number,
  i18nKey: "pleaseChangeAnotherCard"
}), c(Gf, Kf.InvalidExpDate, {
  field: Ve.ExpDate,
  i18nKey: "pleaseEnterExpired"
}), c(Gf, Kf.InvalidCVC, {
  field: Ve.Cvc,
  i18nKey: "pleaseEnterCVV"
}), Gf);
function Jf(e, t) {
  return Xf.apply(this, arguments);
}
function Xf() {
  return (Xf = l(b.mark(function e(t, r) {
    var n, o, a, i, s, c;
    return b.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (t) {
              e.next = 2;
              break;
            }
            return e.abrupt("return", null);
          case 2:
            if (!((n = Number(t)) >= 43100 && n < 43200)) {
              e.next = 12;
              break;
            }
            return e.next = 6, r.get("TWIdCard.idNumber.".concat(t));
          case 6:
            if (o = e.sent) {
              e.next = 11;
              break;
            }
            return e.next = 10, r.get("TWIdCard.idNumber.errorTips");
          case 10:
            o = e.sent;
          case 11:
            return e.abrupt("return", {
              field: We.IdNumber,
              message: o
            });
          case 12:
            if ($f[t]) {
              e.next = 14;
              break;
            }
            return e.abrupt("return", null);
          case 14:
            return a = $f[t], i = a.field, s = a.i18nKey, e.next = 17, r.get(s);
          case 17:
            return c = e.sent, e.abrupt("return", {
              field: i,
              message: c
            });
          case 19:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}
function Yf(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Qf = function (e) {
  _(f, Yt);
  var t,
    r,
    o,
    a,
    i,
    u,
    p,
    d = Yf(f);
  function f() {
    var e;
    n(this, f);
    for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++) {
      r[o] = arguments[o];
    }
    return c(w(e = d.call.apply(d, [this].concat(r))), "idCardItemRefs", {
      idNumber: {
        current: null
      },
      issueDate: {
        current: null
      },
      issueLocation: {
        current: null
      },
      replacementCategory: {
        current: null
      }
    }), c(w(e), "state", {
      isLoaded: !1,
      language: null,
      issueLocationOptions: [],
      replacementCategoryOptions: []
    }), e;
  }
  return s(f, [{
    key: "componentDidCatch",
    value: function value(e) {
      ke.reportError(e, "TwIdCard_componentDidCatch_error");
    }
  }, {
    key: "componentDidMount",
    value: (p = l(b.mark(function e() {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              this.initData();
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return p.apply(this, arguments);
    })
  }, {
    key: "initData",
    value: (u = l(b.mark(function e() {
      var t, r, n, o, a, i, s;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return r = (null === (t = this.props.additionalOption) || void 0 === t ? void 0 : t.additionalIdCardValidate) || {}, n = r.issuingAddressCodeEnums, o = r.idCardReceiveTypeEnums, e.next = 3, this.getLanguage();
            case 3:
              return a = e.sent, e.next = 6, this.getI18nOptionList(n, "issueLocationOptions");
            case 6:
              return i = e.sent, e.next = 9, this.getI18nOptionList(o, "replacementCategoryOptions");
            case 9:
              s = e.sent, this.setState({
                isLoaded: !0,
                language: a,
                issueLocationOptions: i,
                replacementCategoryOptions: s
              });
            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return u.apply(this, arguments);
    })
  }, {
    key: "getLanguage",
    value: (i = l(b.mark(function e() {
      var t, r, n, o, a, i, s, c, u, l, p, d;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.props.i18n.get(["TWIdCard.title", this.props.validateNoticeI18nKey, "TWIdCard.idNumber.errorTips", "TWIdCard.idNumber.labelTitle", "TWIdCard.issueDate.errorTips", "TWIdCard.issueDate.labelTitle", "TWIdCard.issueLocation.errorTips", "TWIdCard.issueLocation.labelTitle", "TWIdCard.replacementCategory.errorTips", "TWIdCard.replacementCategory.labelTitle"]);
            case 2:
              return t = e.sent, r = mt(t, 10), n = r[0], o = r[1], a = r[2], i = r[3], s = r[4], c = r[5], u = r[6], l = r[7], p = r[8], d = r[9], e.abrupt("return", {
                title: n,
                validateNotice: o,
                idNumber: {
                  errorTips: a,
                  labelTitle: i
                },
                issueDate: {
                  errorTips: s,
                  labelTitle: c
                },
                issueLocation: {
                  errorTips: u,
                  labelTitle: l
                },
                replacementCategory: {
                  errorTips: p,
                  labelTitle: d
                }
              });
            case 15:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return i.apply(this, arguments);
    })
  }, {
    key: "getI18nnMap",
    value: (a = l(b.mark(function e(t, r) {
      var n,
        o = this;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return n = {}, e.next = 3, Promise.all(t.map(function () {
                var e = l(b.mark(function e(t) {
                  var a, i;
                  return b.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          if (a = t.code, !(i = t.i18nKey)) {
                            e.next = 7;
                            break;
                          }
                          return e.next = 4, o.props.i18n.get("TWIdCard.".concat(r, ".").concat(i));
                        case 4:
                          e.t0 = e.sent, e.next = 8;
                          break;
                        case 7:
                          e.t0 = "";
                        case 8:
                          n[a] = e.t0;
                        case 9:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e);
                }));
                return function (t) {
                  return e.apply(this, arguments);
                };
              }()));
            case 3:
              return e.abrupt("return", n);
            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function (e, t) {
      return a.apply(this, arguments);
    })
  }, {
    key: "getI18nOptionList",
    value: (o = l(b.mark(function e(t, r) {
      var n;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (null != t && t.length) {
                e.next = 3;
                break;
              }
              return ke.reportError(new T("invalid ".concat(r)), "get_TWIdCard_optionList_error"), e.abrupt("return", []);
            case 3:
              return e.next = 5, this.getI18nnMap(t, r);
            case 5:
              return n = e.sent, e.abrupt("return", t.map(function (e) {
                return {
                  value: e.code,
                  label: n[e.code]
                };
              }));
            case 7:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return o.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (r = l(b.mark(function e() {
      var t,
        r,
        n,
        o,
        a,
        i,
        s,
        c,
        u,
        l,
        p,
        d,
        f,
        h,
        v = this;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.props.show) {
                e.next = 2;
                break;
              }
              return e.abrupt("return", !0);
            case 2:
              if (this.state.isLoaded) {
                e.next = 5;
                break;
              }
              return console.error("Warning: Can't call validate() if TWIdCard is not loaded"), e.abrupt("return", !1);
            case 5:
              return e.next = 8, Promise.all(Object.keys(this.idCardItemRefs).map(function (e) {
                return v.idCardItemRefs[e].current.validate();
              }));
            case 8:
              if (e.sent.every(function (e) {
                return !!e;
              })) {
                e.next = 12;
                break;
              }
              return e.abrupt("return", !1);
            case 12:
              return e.next = 14, this.getValues();
            case 14:
              return n = e.sent, o = this.props.initData, a = o.merchantId, i = o.paymentMethod, s = o.currency, c = o.amount, e.next = 18, Np(this.props.host, {
                merchantId: a,
                paymentMethod: i,
                currency: s,
                amount: c,
                additionalOption: Zf(n)
              }, Qe(this.props.initData))["catch"](function () {
                return {
                  verifyResult: {
                    result: !0,
                    errorCode: null
                  }
                };
              });
            case 18:
              if (u = e.sent, l = !(null === (t = u.verifyResult) || void 0 === t || !t.result), p = null === (r = u.verifyResult) || void 0 === r ? void 0 : r.errorCode, l) {
                e.next = 27;
                break;
              }
              return h = null, e.next = 25, Jf(p, this.props.i18n);
            case 25:
              h = e.sent, this.setFieldError((null === (d = h) || void 0 === d ? void 0 : d.field) || We.IdNumber, (null === (f = h) || void 0 === f ? void 0 : f.message) || this.state.language.idNumber.errorTips);
            case 27:
              return e.abrupt("return", l);
            case 28:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return r.apply(this, arguments);
    })
  }, {
    key: "getValues",
    value: (t = l(b.mark(function e() {
      var t,
        r,
        n,
        o,
        a,
        i,
        s,
        c = this;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.props.show && this.state.isLoaded) {
                e.next = 3;
                break;
              }
              return console.error("Warning: Can't call getValues() if TWIdCard is not loaded"), e.abrupt("return", null);
            case 3:
              return t = [We.IdNumber, We.IssueDate, We.IssueLocation, We.ReplacementCategory], e.next = 6, Promise.all(t.map(function (e) {
                return c.idCardItemRefs[e].current.getValue();
              }));
            case 6:
              return r = e.sent, n = mt(r, 4), o = n[0], a = n[1], i = n[2], s = n[3], e.abrupt("return", {
                idNumber: o,
                issueDate: a,
                issueLocation: i,
                replacementCategory: s
              });
            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "setFieldError",
    value: function value(e, t) {
      this.state.isLoaded ? this.idCardItemRefs[e] && (this.idCardItemRefs.idNumber.current.setError(t), this.idCardItemRefs.issueDate.current.setError(""), this.idCardItemRefs.issueLocation.current.setError(""), this.idCardItemRefs.replacementCategory.current.setError("")) : console.error("Warning: Can't call setFieldError() if TWIdCard is not loaded");
    }
  }, {
    key: "render",
    value: function value() {
      var e,
        t,
        r,
        n,
        o,
        a,
        i,
        s,
        c = this.props,
        u = c.needAdaptive,
        l = c.showBottomLine,
        p = c.theme,
        d = void 0 === p ? {} : p,
        f = c.show,
        h = this.state,
        v = h.isLoaded,
        y = h.language,
        m = h.issueLocationOptions,
        g = h.replacementCategoryOptions,
        b = {
          formItemGutter: null == d ? void 0 : d.formItemGutter,
          inputHeight: (null == d ? void 0 : d.inputHeight) || "46px",
          skeleton: {
            background: null == d ? void 0 : d.inputSkeletonBackground,
            borderRadius: null == d ? void 0 : d.inputBorderRadius
          }
        };
      return $t(bf, {
        theme: b,
        show: f,
        isLoaded: v,
        needAdaptive: u,
        showBottomLine: l,
        header: $t(xf, {
          title: null == y ? void 0 : y.title,
          validateNotice: null == y ? void 0 : y.validateNotice,
          needAdaptive: u,
          theme: d
        }),
        inputIdNumber: $t(Af, {
          ref: this.idCardItemRefs.idNumber,
          label: null == y || null === (e = y.idNumber) || void 0 === e ? void 0 : e.labelTitle,
          errorTips: null == y || null === (t = y.idNumber) || void 0 === t ? void 0 : t.errorTips,
          theme: d
        }),
        inputIssueDate: $t(qf, {
          ref: this.idCardItemRefs.issueDate,
          label: null == y || null === (r = y.issueDate) || void 0 === r ? void 0 : r.labelTitle,
          errorTips: null == y || null === (n = y.issueDate) || void 0 === n ? void 0 : n.errorTips,
          theme: d
        }),
        selectIssueLocation: $t(Rf, {
          ref: this.idCardItemRefs.issueLocation,
          label: null == y || null === (o = y.issueLocation) || void 0 === o ? void 0 : o.labelTitle,
          optionList: m,
          errorTips: null == y || null === (a = y.issueLocation) || void 0 === a ? void 0 : a.errorTips,
          theme: d,
          needAdaptive: u
        }),
        selectReplacementCategory: $t(Rf, {
          ref: this.idCardItemRefs.replacementCategory,
          label: null == y || null === (i = y.replacementCategory) || void 0 === i ? void 0 : i.labelTitle,
          optionList: g,
          errorTips: null == y || null === (s = y.replacementCategory) || void 0 === s ? void 0 : s.errorTips,
          theme: d,
          needAdaptive: u
        })
      });
    }
  }]), f;
}();
c(Qf, "defaultProps", {
  needAdaptive: !0,
  showBottomLine: !0
});
var eh = "paymentSdk_paymentLayout_2707964c";
function th(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? th(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : th(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function nh(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var oh = function (e) {
  _(u, Yt);
  var t,
    r,
    o,
    a,
    i = nh(u);
  function u(e) {
    var t, r;
    n(this, u), c(w(r = i.call(this, e)), "TWIdCardRef", {
      current: null
    }), c(w(r), "handlePayError", function (e) {
      r.TWIdCardRef.current && r.TWIdCardRef.current.setFieldError(e.field, e.message);
    });
    var o = zf(null === (t = e.initResult) || void 0 === t ? void 0 : t.additionalOption);
    return e.reporter.reportData("PaymentLayout_constructor_".concat(o ? "" : "no_", "need_render_TW_idCard")), r.state = {
      env: e.env,
      hasTWIdCard: o,
      showTWIdCard: o,
      i18n: e.i18n,
      initResult: e.initResult,
      initData: e.initData
    }, r;
  }
  return s(u, [{
    key: "componentDidMount",
    value: function value() {
      this.props.reporter.reportData("PaymentLayout_componentDidMount_".concat(this.state.hasTWIdCard ? "" : "no_", "need_render_TW_idCard"));
    }
  }, {
    key: "componentDidCatch",
    value: function value(e) {
      this.props.reporter.reportError(e, "PaymentLayout_componentDidCatch_error");
    }
  }, {
    key: "needUserAction",
    value: function value() {
      return zf(this.state.initResult.additionalOption);
    }
  }, {
    key: "update",
    value: (a = l(b.mark(function e(t) {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!t.initData && !t.initResult) {
                e.next = 3;
                break;
              }
              return e.next = 3, this.updateInitResult(t.initData, t.initResult);
            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return a.apply(this, arguments);
    })
  }, {
    key: "updateInitResult",
    value: (o = l(b.mark(function e(t, r) {
      var n;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              n = zf(null == r ? void 0 : r.additionalOption), this.setState({
                showTWIdCard: n,
                hasTWIdCard: this.state.hasTWIdCard || n,
                initResult: r,
                initData: t
              });
            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return o.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (r = l(b.mark(function e() {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.state.hasTWIdCard) {
                e.next = 2;
                break;
              }
              return e.abrupt("return", !0);
            case 2:
              return e.abrupt("return", this.TWIdCardRef.current.validate());
            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return r.apply(this, arguments);
    })
  }, {
    key: "getConfirmParams",
    value: (t = l(b.mark(function e() {
      var t;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.state.hasTWIdCard && this.TWIdCardRef.current && this.state.showTWIdCard) {
                e.next = 2;
                break;
              }
              return e.abrupt("return", null);
            case 2:
              return e.next = 4, this.TWIdCardRef.current.getValues();
            case 4:
              return t = e.sent, e.abrupt("return", {
                additionalData: {
                  additionalOption: Zf(t)
                }
              });
            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "render",
    value: function value() {
      var e,
        t,
        r,
        n = this.props.renderer,
        o = this.state,
        a = o.env,
        i = o.i18n,
        s = o.initData,
        c = o.hasTWIdCard,
        u = o.initResult,
        l = o.showTWIdCard;
      return $t("div", {
        className: eh
      }, (null == n ? void 0 : n.content) && n.content({
        env: a,
        i18n: i,
        initData: s,
        initResult: u
      }), c && $t(Qf, {
        ref: this.TWIdCardRef,
        i18n: i,
        host: a.host,
        show: l,
        needAdaptive: null == s ? void 0 : s.needAdaptive,
        additionalOption: null == u ? void 0 : u.additionalOption,
        validateNoticeI18nKey: null == u || null === (e = u.paymentMethodInfo) || void 0 === e || null === (t = e.cashierNotice) || void 0 === t ? void 0 : t.additionalTWIdCardValidateNotice,
        theme: rh({}, null === (r = s.theme) || void 0 === r ? void 0 : r["default"]),
        initData: s,
        showBottomLine: !(null == n || !n.footer)
      }), (null == n ? void 0 : n.footer) && n.footer({
        env: a,
        i18n: i,
        initData: s,
        initResult: u
      }));
    }
  }]), u;
}();
function ah(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ih(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var sh = function (e) {
    _(i, xa);
    var t,
      r,
      o,
      a = ih(i);
    function i(e) {
      var t;
      return n(this, i), c(w(t = a.call(this)), "componentRef", {
        current: null
      }), c(w(t), "component", null), t.component = $t(oh, function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ah(Object(r), !0).forEach(function (t) {
            c(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ah(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }({
        ref: t.componentRef
      }, e)), t;
    }
    return s(i, [{
      key: "validate",
      value: (o = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.componentRef.current.validate());
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return o.apply(this, arguments);
      })
    }, {
      key: "getConfirmParams",
      value: (r = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.componentRef.current.getConfirmParams());
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "needUserAction",
      value: function value() {
        return this.componentRef.current.needUserAction();
      }
    }, {
      key: "update",
      value: (t = l(b.mark(function e(t) {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.componentRef.current.update(t));
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "handlePayError",
      value: function value(e) {
        this.componentRef.current.handlePayError(e);
      }
    }]), i;
  }(),
  ch = function () {
    function e(t, r, o) {
      n(this, e), c(this, "env", void 0), c(this, "blockRender", void 0), c(this, "layoutRenderer", void 0), c(this, "i18n", void 0), c(this, "reporter", void 0), this.env = t, this.reporter = o, this.i18n = new Ms(r.language, {
        env: t.slI18nEnv,
        cdn: r.cdn
      });
    }
    var t, r, o, a, i;
    return s(e, [{
      key: "needRenderWidget",
      value: (i = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !0);
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function () {
        return i.apply(this, arguments);
      })
    }, {
      key: "needUserAction",
      value: function value() {
        return !!this.layoutRenderer && this.layoutRenderer.needUserAction();
      }
    }, {
      key: "getRenderElement",
      value: function value(e) {
        var t = null;
        return (t = "string" == typeof e ? document.querySelector(e) : e) || this.reporter.reportError(new T(y.ElementNotExist), "getRenderElement_error"), t;
      }
    }, {
      key: "render",
      value: (a = l(b.mark(function e(t, r, n, o) {
        var a;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (a = this.getRenderElement(t)) {
                  e.next = 3;
                  break;
                }
                return e.abrupt("return");
              case 3:
                if (this.destroyBlock(), !this.layoutRenderer) {
                  e.next = 8;
                  break;
                }
                return e.next = 7, this.layoutRenderer.update({
                  initData: r,
                  initResult: n
                });
              case 7:
                return e.abrupt("return");
              case 8:
                return this.layoutRenderer = new sh({
                  initResult: n,
                  env: this.env,
                  initData: r,
                  renderer: o,
                  i18n: this.i18n,
                  reporter: this.reporter
                }), e.next = 11, this.layoutRenderer.render(a);
              case 11:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t, r, n) {
        return a.apply(this, arguments);
      })
    }, {
      key: "validate",
      value: (o = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (!this.blockRender) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return", !1);
              case 2:
                if (this.layoutRenderer) {
                  e.next = 4;
                  break;
                }
                return e.abrupt("return", !0);
              case 4:
                return e.abrupt("return", this.layoutRenderer.validate());
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return o.apply(this, arguments);
      })
    }, {
      key: "getConfirmParams",
      value: (r = l(b.mark(function e() {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.layoutRenderer.getConfirmParams());
              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "handlePayError",
      value: function value(e) {
        this.layoutRenderer.handlePayError(e);
      }
    }, {
      key: "renderFail",
      value: (t = l(b.mark(function e(t, r, n) {
        var o,
          a = this;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return this.destroyLayout(), this.blockRender ? this.blockRender.destroy() : this.blockRender = new ff(), o = this.getRenderElement(t), e.next = 5, this.blockRender.mount(o, {
                  initData: r,
                  i18n: this.i18n,
                  error: n
                })["catch"](function (e) {
                  a.reporter.handleError(e, "render_fail_error");
                });
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, r, n) {
        return t.apply(this, arguments);
      })
    }, {
      key: "destroyLayout",
      value: function value() {
        this.layoutRenderer && (this.reporter.reportData("destroy_layoutRenderer"), this.layoutRenderer.destroy(), this.layoutRenderer = null);
      }
    }, {
      key: "destroyBlock",
      value: function value() {
        this.blockRender && (this.reporter.reportData("destroy_blockRender"), this.blockRender.destroy(), this.blockRender = null);
      }
    }, {
      key: "destroy",
      value: function value() {
        this.destroyLayout(), this.destroyBlock();
      }
    }]), e;
  }();
var uh = function () {
    var e = l(b.mark(function e(t, r) {
      var n;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return n = "".concat(t, "/v1/api/cashier/preCheck"), ke.reportData("pre_check_start", {
                url: n,
                requestParams: r
              }), e.abrupt("return", Se.post(n, r).then(function (e) {
                return ke.reportData("pre_check_success", {
                  url: n,
                  request: {
                    requestParams: r
                  },
                  response: {
                    res: e
                  }
                }), e.data || {};
              })["catch"](function (e) {
                ke.handleError(e, "pre_check_error", {
                  url: n,
                  response: {
                    error: e
                  },
                  request: {
                    requestParams: r
                  }
                });
              }));
            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r) {
      return e.apply(this, arguments);
    };
  }(),
  lh = function () {
    var e = l(b.mark(function e(t, r) {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", uh(t, r)["catch"](function (e) {
                return ke.reportData("pre_check_return_default", {
                  code: e.code,
                  message: e.message
                }), {};
              }));
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t, r) {
      return e.apply(this, arguments);
    };
  }();
function ph(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function dh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ph(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ph(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function fh(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var hh = function (e) {
  _(a, nf);
  var t,
    r,
    o = fh(a);
  function a(e, t, r) {
    var i;
    n(this, a), c(w(i = o.call(this, e)), "element", void 0), c(w(i), "scene", void 0), c(w(i), "initResultPromise", void 0), c(w(i), "layout", void 0), c(w(i), "init", l(b.mark(function e() {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, i.reporter.reportData("init_start"), e.next = 4, i.initResultPromise["catch"](function (e) {
                if (!i.element) throw e;
              });
            case 4:
              if (e.t0 = i.element, !e.t0) {
                e.next = 8;
                break;
              }
              return e.next = 8, i.renderWidget(i.element);
            case 8:
              return i.reporter.reportData("init_end"), e.abrupt("return", w(i));
            case 12:
              e.prev = 12, e.t1 = e["catch"](0), i.reporter.handleError(e.t1, "init_error");
            case 15:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 12]]);
    }))), c(w(i), "needUserAction", l(b.mark(function e() {
      var t;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, i.layout && i.scene) {
                e.next = 3;
                break;
              }
              return e.abrupt("return", !1);
            case 3:
              return i.reporter.reportData("needUserAction_start"), e.next = 6, i.initResultPromise;
            case 6:
              return t = i.scene.needUserAction() || i.layout.needUserAction(), i.reporter.reportData("needUserAction_end", {
                needUserAction: t
              }), e.abrupt("return", t);
            case 11:
              e.prev = 11, e.t0 = e["catch"](0), i.reporter.handleError(e.t0, "needUserAction_error");
            case 14:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 11]]);
    }))), c(w(i), "renderWidget", function () {
      var e = l(b.mark(function e(t) {
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (e.prev = 0, i.element = t, i.scene) {
                  e.next = 4;
                  break;
                }
                return e.abrupt("return");
              case 4:
                if (i.reporter.reportData("renderWidget_start"), !i.isNotSupportBrowser) {
                  e.next = 8;
                  break;
                }
                return i.reporter.reportData("renderWidget_notSupportBrowser_end"), e.abrupt("return");
              case 8:
                return e.next = 10, i.scene.needRenderWidget()["catch"](function (e) {
                  return i.reporter.handleError(e, "renderWidget_needRenderWidget_error");
                });
              case 10:
                if (!e.sent) {
                  e.next = 16;
                  break;
                }
                return e.next = 14, i.render(t);
              case 14:
                e.next = 17;
                break;
              case 16:
                console.warn('"'.concat(i.initData.paymentMethod, '" no render widget'));
              case 17:
                i.reporter.reportData("renderWidget_end"), e.next = 23;
                break;
              case 20:
                e.prev = 20, e.t0 = e["catch"](0), i.reporter.handleError(e.t0, "renderWidget_error");
              case 23:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[0, 20]]);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), c(w(i), "needRenderWidget", l(b.mark(function e() {
      var t, r, n, o, a;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, i.layout && i.scene) {
                e.next = 3;
                break;
              }
              return e.abrupt("return", !1);
            case 3:
              return i.reporter.reportData("needRenderWidget_start"), e.next = 6, i.initResultPromise["catch"](function () {
                return i.reporter.reportData("needRenderWidget_checkResult_fail_end"), !0;
              });
            case 6:
              if (!i.isNotSupportBrowser) {
                e.next = 9;
                break;
              }
              return i.reporter.reportData("needRenderWidget_notSupportBrowser_fail_end"), e.abrupt("return", !1);
            case 9:
              return e.next = 11, Promise.all([i.layout.needRenderWidget(), i.scene.needRenderWidget()]);
            case 11:
              return t = e.sent, r = mt(t, 2), n = r[0], o = r[1], a = n && o, i.reporter.reportData("needRenderWidget_end", {
                needRenderWidget: a,
                layoutResult: n,
                sceneResult: o
              }), e.abrupt("return", a);
            case 20:
              e.prev = 20, e.t0 = e["catch"](0), i.reporter.handleError(e.t0, "needRenderWidget_error");
            case 23:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 20]]);
    }))), c(w(i), "update", function () {
      var e = l(b.mark(function e(t) {
        var r;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (e.prev = 0, i.reporter.reportData("update_start", t), i.layout) {
                  e.next = 4;
                  break;
                }
                return e.abrupt("return");
              case 4:
                if (r = !1, "number" != typeof (null == t ? void 0 : t.amount)) {
                  e.next = 9;
                  break;
                }
                return e.next = 8, i.updateAmount(t.amount);
              case 8:
                r = !0;
              case 9:
                if (r) {
                  e.next = 11;
                  break;
                }
                throw new T("Update data error", v.InitDataError);
              case 11:
                e.next = 16;
                break;
              case 13:
                e.prev = 13, e.t0 = e["catch"](0), i.reporter.handleError(e.t0, "update_error");
              case 16:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[0, 13]]);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), c(w(i), "afterSubmit", l(b.mark(function e() {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, i.reporter.reportData("afterSubmit_start"), i.scene) {
                e.next = 4;
                break;
              }
              return e.abrupt("return");
            case 4:
              if (!i.scene.afterSubmit) {
                e.next = 7;
                break;
              }
              return e.next = 7, i.scene.afterSubmit();
            case 7:
              i.reporter.reportData("afterSubmit_end"), e.next = 13;
              break;
            case 10:
              e.prev = 10, e.t0 = e["catch"](0), i.reporter.handleError(e.t0, "afterSubmit_error");
            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 10]]);
    }))), c(w(i), "validate", l(b.mark(function e() {
      var t, r, n, o, a;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, i.layout && i.scene) {
                e.next = 3;
                break;
              }
              return e.abrupt("return", !1);
            case 3:
              return i.reporter.reportData("validate_start"), e.next = 6, i.initResultPromise["catch"](function () {
                return i.reporter.reportData("validate_checkResult_fail_end"), !1;
              });
            case 6:
              if (e.sent) {
                e.next = 9;
                break;
              }
              return e.abrupt("return", !1);
            case 9:
              return e.next = 11, Promise.all([i.layout.validate(), i.scene.validate()]);
            case 11:
              return t = e.sent, r = mt(t, 2), n = r[0], o = r[1], a = n && o, i.reporter.reportData("validate_end", {
                validateResult: a,
                layoutResult: n,
                sceneResult: o
              }), e.abrupt("return", a);
            case 20:
              e.prev = 20, e.t0 = e["catch"](0), i.reporter.handleError(e.t0, "validate_error");
            case 23:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 20]]);
    }))), c(w(i), "getExtendPaySession", l(b.mark(function e() {
      var t, r, n;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, i.initResultPromise;
            case 2:
              if (!e.sent.paymentMethodInfo.preCheckSwitch) {
                e.next = 15;
                break;
              }
              if (t = {
                merchantId: i.initData.merchantId,
                paymentMethod: i.initData.paymentMethod,
                currency: i.initData.currency,
                amount: i.initData.amount
              }, !i.scene.extendPreCheckParams) {
                e.next = 10;
                break;
              }
              return e.next = 8, i.scene.extendPreCheckParams();
            case 8:
              r = e.sent, Object.assign(t, r);
            case 10:
              return e.next = 12, lh(i.env.host, t);
            case 12:
              if (null == (n = e.sent) || !n.suggestConfirmInfo) {
                e.next = 15;
                break;
              }
              return e.abrupt("return", {
                suggestConfirmInfo: n.suggestConfirmInfo
              });
            case 15:
              return e.abrupt("return", {});
            case 16:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), c(w(i), "getPaySession", l(b.mark(function e() {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", i.handlePaySession({
                extendPaySession: i.getExtendPaySession
              }));
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), c(w(i), "pay", function () {
      var e = l(b.mark(function e(t, r) {
        var n, o, a, s;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (i.scene && i.layout) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return");
              case 2:
                return e.prev = 2, o = i.getPayReportData(t, r), i.reporter.reportData("call_pay_start", o), e.next = 7, i.getPayOptions(r);
              case 7:
                return a = e.sent, s = null !== (n = i.scene) && void 0 !== n && n.getPayHooks ? i.scene.getPayHooks(t) : {}, e.next = 11, za(t, dh(dh({}, a), {}, {
                  hooks: dh(dh({}, s), {}, {
                    extendConfirmParams: function () {
                      var e = l(b.mark(function e(t) {
                        var r, n, o, c, u;
                        return b.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                return e.next = 2, Promise.all([s.extendConfirmParams ? s.extendConfirmParams(t, {
                                  savePaymentInstrument: null == a ? void 0 : a.savePaymentInstrument
                                }) : Promise.resolve({}), null === (r = i.layout) || void 0 === r ? void 0 : r.getConfirmParams()]);
                              case 2:
                                return n = e.sent, o = mt(n, 2), c = o[0], u = o[1], e.abrupt("return", ga(c, u));
                              case 7:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e);
                      }));
                      return function (t) {
                        return e.apply(this, arguments);
                      };
                    }()
                  })
                }))["catch"](function () {
                  var e = l(b.mark(function e(t) {
                    var r, n, o;
                    return b.wrap(function (e) {
                      for (;;) {
                        switch (e.prev = e.next) {
                          case 0:
                            if (400 !== t.statusCode) {
                              e.next = 6;
                              break;
                            }
                            return n = new Ms(i.initData.language, {
                              env: i.env.slI18nEnv,
                              cdn: i.initData.cdn
                            }), e.next = 4, Jf(null === (r = t.data) || void 0 === r ? void 0 : r.code, n);
                          case 4:
                            (o = e.sent) && (i.layout.handlePayError(o), s.handlePayError && s.handlePayError(o));
                          case 6:
                            i.reporter.handleError(t, "call_pay_catch_error");
                          case 7:
                          case "end":
                            return e.stop();
                        }
                      }
                    }, e);
                  }));
                  return function (t) {
                    return e.apply(this, arguments);
                  };
                }());
              case 11:
                i.reporter.reportData("call_pay_end_no_error"), e.next = 17;
                break;
              case 14:
                return e.prev = 14, e.t0 = e["catch"](2), e.abrupt("return", i.handlePayError(t, e.t0));
              case 17:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[2, 14]]);
      }));
      return function (t, r) {
        return e.apply(this, arguments);
      };
    }()), c(w(i), "getCurrentCardInfo", l(b.mark(function e() {
      var t;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, i.scene) {
                e.next = 3;
                break;
              }
              return e.abrupt("return");
            case 3:
              if (i.reporter.reportData("getCurrentCardInfo_start"), i.initData.paymentMethod === et.CreditCard) {
                e.next = 6;
                break;
              }
              throw new T("The API does not support the payment method", v.NotSupportApi, "NotSupportApi");
            case 6:
              return e.next = 8, i.scene.getCurrentCardInfo()["catch"](function (e) {
                return i.reporter.handleError(e, "getCurrentCardInfo_error");
              });
            case 8:
              return t = e.sent, i.reporter.reportData("getCurrentCardInfo_end", {
                cardInfo: t
              }), e.abrupt("return", t);
            case 13:
              e.prev = 13, e.t0 = e["catch"](0), i.reporter.handleError(e.t0, "getCurrentCardInfo_error");
            case 16:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 13]]);
    }))), c(w(i), "destroy", function () {
      try {
        var e;
        i.reporter.reportData("destroy_start"), i.layout && i.layout.destroy(), (null === (e = i.scene) || void 0 === e ? void 0 : e.destroy) && i.scene.destroy(), i.scene = null, i.layout = null, i.reporter.reportData("destroy_end");
      } catch (e) {
        i.reporter.handleError(e, "destroy_error");
      }
    });
    try {
      i.element = r, r && i.reporter.reportData("constructor_element", {
        element: "string" == typeof r ? r : {
          id: r.id,
          className: r.className
        }
      }), i.scene = new t(i.env, i.initData), i.layout = new ch(i.env, i.initData, i.reporter), i.updateInitResultPromise(), i.reporter.reportData("constructor_end", i.initData);
    } catch (e) {
      i.reporter.handleError(e, "constructor_error");
    }
    return i;
  }
  return s(a, [{
    key: "updateInitResultPromise",
    value: function value() {
      var e = this;
      this.initResultPromise = Promise.all([this.initRisk(), this.initChecker.checkInit().then(function () {
        var t = l(b.mark(function t(r) {
          return b.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (t.t0 = e.scene.afterInit, !t.t0) {
                    t.next = 4;
                    break;
                  }
                  return t.next = 4, e.scene.afterInit(e.initData, r);
                case 4:
                  return t.abrupt("return", r);
                case 5:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }));
        return function (e) {
          return t.apply(this, arguments);
        };
      }())]).then(function (e) {
        return e[1];
      });
    }
  }, {
    key: "render",
    value: (r = l(b.mark(function e(t) {
      var r,
        n,
        o,
        a,
        i = this;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, this.initResultPromise;
            case 3:
              if (n = e.sent, null === (r = this.scene) || void 0 === r || !r.getRenderer) {
                e.next = 10;
                break;
              }
              return e.next = 7, this.scene.getRenderer();
            case 7:
              e.t0 = e.sent, e.next = 11;
              break;
            case 10:
              e.t0 = null;
            case 11:
              return o = e.t0, e.next = 14, this.layout.render(t, this.initData, n, o)["catch"](function (e) {
                return i.reporter.handleError(e, "scene_render_error");
              });
            case 14:
              this.reporter.reportData("render_success"), e.next = 25;
              break;
            case 17:
              return e.prev = 17, e.t1 = e["catch"](0), (a = new A(e.t1.message, v.RenderFail, "RenderFail")).setAPIErrorData(e.t1.data), e.next = 23, this.layout.renderFail(t, this.initData, e.t1.data)["catch"](function (e) {
                return i.reporter.handleError(e, "this.layout.renderFail_error");
              });
            case 23:
              throw this.reporter.reportData("render_fail"), a;
            case 25:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[0, 17]]);
    })), function (e) {
      return r.apply(this, arguments);
    })
  }, {
    key: "updateAmount",
    value: (t = l(b.mark(function e(t) {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t !== this.initData.amount) {
                e.next = 2;
                break;
              }
              return e.abrupt("return");
            case 2:
              return this.initData = dh(dh({}, this.initData), {}, {
                amount: t
              }), this.initChecker = new ef(this.env, this.initData, this.reporter), this.updateInitResultPromise(), e.next = 7, this.init();
            case 7:
              this.reporter.reportData("update_amount_end", {
                amount: t
              });
            case 8:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }]), a;
}();
function vh(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var yh = function (e) {
  _(r, hh);
  var t = vh(r);
  function r(e, o) {
    n(this, r);
    var a = function (e) {
      var t;
      switch (e.paymentMethod) {
        case et.ChaileaseBNPL:
          t = io;
          break;
        case et.CreditCard:
          t = Zd;
          break;
        case et.FPX:
          t = Zo;
          break;
        case et.GooglePay:
          t = zs;
          break;
        case et.ApplePay:
          t = $s;
          break;
        case et.OVO:
          t = Vc;
          break;
        case et.VirtualAccount:
        case et.Ideal:
          t = ou;
          break;
        case et.AfteeBNPL:
          t = Jd;
          break;
        default:
          t = Oo;
      }
      return t;
    }(e);
    return t.call(this, e, a, o);
  }
  return s(r);
}();
function mh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function gh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? mh(Object(r), !0).forEach(function (t) {
      c(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : mh(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function bh(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var kh = function (e) {
  _(u, nf);
  var t,
    r,
    o,
    a,
    i = bh(u);
  function u(e) {
    var t;
    n(this, u), c(w(t = i.call(this, e)), "pciInstance", void 0), c(w(t), "isEnableCardToken", !1), c(w(t), "isEnableBindCard", !1), c(w(t), "updatableInitData", {}), c(w(t), "isPciLoaded", void 0), c(w(t), "initPromise", void 0), c(w(t), "init", l(b.mark(function e() {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, t.reporter.reportData("api_only_init_start"), t.check(), e.next = 5, t.initPromise["catch"](function (e) {
                return t.reporter.handleError(e, "api_only_init_promise_error");
              });
            case 5:
              return t.reporter.reportData("api_only_init_end"), e.abrupt("return", w(t));
            case 9:
              e.prev = 9, e.t0 = e["catch"](0), t.pciInstance && t.pciInstance.destroy(), t.reporter.handleError(e.t0, "api_only_init_error");
            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 9]]);
    }))), c(w(t), "getPaySession", l(b.mark(function e() {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", t.handlePaySession());
            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), c(w(t), "pay", function () {
      var e = l(b.mark(function e(r, n) {
        var o, a, i, s;
        return b.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return o = r, e.prev = 1, a = t.getPayReportData(o, n), t.reporter.reportData("api_only_call_pay_start", a), e.next = 6, t.getPayOptions(n);
              case 6:
                if (i = e.sent, !t.pciInstance || t.updatableInitData.paymentInstrumentId) {
                  e.next = 13;
                  break;
                }
                if (t.isPciLoaded) {
                  e.next = 10;
                  break;
                }
                throw new T(y.PCINotLoaded);
              case 10:
                s = t.getPCIPayHooks(), e.next = 14;
                break;
              case 13:
                s = t.getPaymentPayHooks();
              case 14:
                return e.next = 16, za(o, gh(gh({}, i), {}, {
                  hooks: gh(gh({}, i.hooks), s)
                }));
              case 16:
                t.reporter.reportData("api_only_call_pay_end_no_error"), e.next = 22;
                break;
              case 19:
                return e.prev = 19, e.t0 = e["catch"](1), e.abrupt("return", t.handlePayError(o, e.t0));
              case 22:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[1, 19]]);
      }));
      return function (t, r) {
        return e.apply(this, arguments);
      };
    }()), c(w(t), "destroy", function () {
      try {
        t.reporter.reportData("destroy_start"), t.pciInstance && t.pciInstance.destroy(), t.reporter.reportData("destroy_end");
      } catch (e) {
        t.reporter.handleError(e, "destroy_error");
      }
    });
    try {
      var r, o, a;
      if (e.paymentMethod === et.CreditCard) {
        var s,
          p,
          d,
          f = e.paymentInstrument;
        t.isEnableCardToken = null == f || null === (s = f.CreditCard) || void 0 === s ? void 0 : s.enable, t.isEnableBindCard = null == f || null === (p = f.bindCard) || void 0 === p ? void 0 : p.enable, t.updatableInitData.paymentInstrumentId = null == f || null === (d = f.bindCard) || void 0 === d ? void 0 : d.paymentInstrumentId;
      }
      t.updatableInitData.customerToken = e.customerToken;
      var h = R(t.initData),
        v = null === (r = t.initData) || void 0 === r || null === (o = r.paymentInstrument) || void 0 === o || null === (a = o.CreditCard) || void 0 === a ? void 0 : a.cardToken;
      v && (delete h.paymentInstrument.CreditCard.cardToken, h.cardToken = v), t.initPromise = Promise.all([t.initRisk(), t.initChecker.checkInit(), t.initPci()]), t.reporter.reportData("api_only_constructor_end", gh({}, h));
    } catch (e) {
      t.reporter.handleError(e, "api_only_constructor_error");
    }
    return t;
  }
  return s(u, [{
    key: "initPci",
    value: (a = l(b.mark(function e() {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!this.isEnableCardToken) {
                e.next = 2;
                break;
              }
              return e.abrupt("return", this.loadPciApiOnly());
            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return a.apply(this, arguments);
    })
  }, {
    key: "loadPciApiOnly",
    value: (o = l(b.mark(function e() {
      var t,
        r,
        n,
        o,
        a = this;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = this.initData, r = t.paymentInstrument, n = t.channelId, o = t.eventTrackingConfig, e.abrupt("return", new Promise(function (e, t) {
                var i;
                a.pciInstance = new Jl.ApiOnly({
                  env: a.env.env,
                  channelId: n,
                  eventTrackingConfig: o,
                  cardToken: null == r || null === (i = r.CreditCard) || void 0 === i ? void 0 : i.cardToken,
                  merchantId: a.initData.merchantId
                }), a.pciInstance.create({
                  onInit: function onInit() {
                    a.reporter.reportData("api_only_pci_onInit"), a.isPciLoaded = !0, e();
                  },
                  onError: function onError() {
                    a.reporter.reportData("api_only_pci_onFail"), t(new T(y.InitTimeout, v.InitTimeout));
                  }
                });
              }));
            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "update",
    value: (r = l(b.mark(function e() {
      var t,
        r,
        n,
        o,
        a,
        i = arguments;
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t = i.length > 0 && void 0 !== i[0] ? i[0] : {}, e.prev = 1, this.reporter.reportData("api_only_update_start"), r = t.paymentInstrumentId, n = t.cardToken, o = t.customerToken, a = ke.formatReportData(t), r || n || o) {
                e.next = 8;
                break;
              }
              return this.reporter.reportErrorData("api_only_update_not_support_data_error", a), e.abrupt("return");
            case 8:
              if (o && (this.updatableInitData.customerToken = o), r && (this.isEnableBindCard ? this.updatableInitData.paymentInstrumentId = r : this.reporter.reportErrorData("api_only_update_paymentInstrumentId_error", a)), !n) {
                e.next = 18;
                break;
              }
              if (!this.isEnableCardToken) {
                e.next = 17;
                break;
              }
              return this.updatableInitData.paymentInstrumentId = "", e.next = 15, this.updateCardToken(n);
            case 15:
              e.next = 18;
              break;
            case 17:
              this.reporter.reportErrorData("api_only_update_cardToken_error", a);
            case 18:
              this.reporter.reportData("api_only_update_end"), e.next = 24;
              break;
            case 21:
              e.prev = 21, e.t0 = e["catch"](1), this.reporter.handleError(e.t0, "api_only_update_error");
            case 24:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[1, 21]]);
    })), function () {
      return r.apply(this, arguments);
    })
  }, {
    key: "updateCardToken",
    value: (t = l(b.mark(function e(t) {
      return b.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, this.reporter.reportData("api_only_updateCardToken_start", {
                cardToken: t
              }), !this.isEnableCardToken) {
                e.next = 7;
                break;
              }
              if (this.isPciLoaded) {
                e.next = 5;
                break;
              }
              throw new T(y.PCINotLoaded);
            case 5:
              return e.next = 7, this.pciInstance.update({
                cardToken: t
              });
            case 7:
              this.reporter.reportData("api_only_updateCardToken_end"), e.next = 13;
              break;
            case 10:
              e.prev = 10, e.t0 = e["catch"](0), this.reporter.handleError(e.t0, "api_only_updateCardToken_error");
            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[0, 10]]);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }, {
    key: "getPCIPayHooks",
    value: function value() {
      var e,
        t,
        r = this;
      return {
        confirmOrderPay: (t = l(b.mark(function e(t, n, o) {
          var a;
          return b.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!0 !== (null === (a = t.sdkSwitch) || void 0 === a ? void 0 : a.newSwitch)) {
                    e.next = 2;
                    break;
                  }
                  return e.abrupt("return", ma(t, n, o));
                case 2:
                  return e.abrupt("return", r.pciInstance.pay(t, n));
                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function (e, r, n) {
          return t.apply(this, arguments);
        }),
        extendConfirmParams: (e = l(b.mark(function e(t) {
          var n, o, a, i;
          return b.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (o = yu(t, {
                    savePaymentInstrument: !0,
                    isCustomerPaymentInstrument: Xe(r.initData),
                    initData: r.initData
                  }), !0 !== (null === (n = t.sdkSwitch) || void 0 === n ? void 0 : n.newSwitch)) {
                    e.next = 9;
                    break;
                  }
                  if (!r.isEnableCardToken) {
                    e.next = 9;
                    break;
                  }
                  return a = {
                    customerToken: o.customerToken,
                    paymentInstrument: gh(gh({}, o.paymentInstrumentExtraData), {}, {
                      paymentMethod: o.paymentMethod
                    })
                  }, e.next = 6, r.pciInstance.getCardTokenInfoByCardToken({
                    partnerId: Rl.SLP,
                    pciHost: t.pciInfo.host
                  });
                case 6:
                  return i = e.sent, a.paymentInstrument.card = i, e.abrupt("return", a);
                case 9:
                  return e.abrupt("return", o);
                case 10:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function (t) {
          return e.apply(this, arguments);
        })
      };
    }
  }, {
    key: "getPaymentPayHooks",
    value: function value() {
      var e,
        t = this;
      return {
        extendConfirmParams: (e = l(b.mark(function e(r) {
          var n, o, a;
          return b.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return n = {}, o = r.customerToken || t.updatableInitData.customerToken, (a = t.updatableInitData.paymentInstrumentId) && t.isEnableBindCard && (o ? n = {
                    customerToken: o,
                    paymentInstrumentId: a
                  } : t.reporter.reportErrorData("api_only_pay_warning_miss_customerToken")), e.abrupt("return", n);
                case 5:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function (t) {
          return e.apply(this, arguments);
        })
      };
    }
  }]), u;
}();
function wh(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      n = P(e);
    if (t) {
      var o = P(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return O(this, r);
  };
}
var Ch = function (e) {
  _(r, kh);
  var t = wh(r);
  function r() {
    return n(this, r), t.apply(this, arguments);
  }
  return s(r);
}();
function _h(e) {
  return Oh.apply(this, arguments);
}
function Oh() {
  return (Oh = l(b.mark(function e(t) {
    var r;
    return b.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            ke.reportData("isSupportPaymentMethod_start", {
              paymentMethod: t
            }), r = !0, e.t0 = t, e.next = e.t0 === et.WeChatPay ? 5 : e.t0 === et.ApplePay ? 7 : e.t0 === et.GooglePay ? 11 : 15;
            break;
          case 5:
            return r = Co(), e.abrupt("break", 16);
          case 7:
            return e.next = 9, ko();
          case 9:
          case 13:
            return r = e.sent, e.abrupt("break", 16);
          case 11:
            return e.next = 13, _o();
          case 15:
            return e.abrupt("break", 16);
          case 16:
            return ke.reportData("isSupportPaymentMethod_end", {
              paymentMethod: t,
              result: r
            }), e.abrupt("return", r);
          case 18:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}
export { Ot as EnvNameEnum, yh as Payment, Ch as PaymentApiOnly, et as PaymentMethod, Wt as initRisk, _h as isSupportPaymentMethod, r as version };